/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  proto: {
    options: {
      go_package: "./proto"
    },
    nested: {
      TSUser: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          sex: {
            type: "string",
            id: 3
          },
          avatarHDImg: {
            type: "string",
            id: 4
          },
          weiboID: {
            type: "string",
            id: 5
          },
          wechatID: {
            type: "string",
            id: 6
          },
          appleID: {
            type: "string",
            id: 7
          },
          userId: {
            type: "string",
            id: 8
          }
        }
      },
      TSLoginType: {
        values: {
          UnKnownType: 0,
          Phone: 1,
          WeiXin: 2,
          WXMiniApp: 3,
          AppleID: 4,
          OneClickLogin: 5,
          LoginTypeBaiDuMiniApp: 6,
          LoginTypeByteDanceMiniApp: 7,
          LoginTypeALiPayMiniApp: 8,
          LoginTypeKSMiniApp: 9
        }
      },
      TSSendSMSCodeV2Request: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          countryCode: {
            type: "string",
            id: 2
          }
        }
      },
      TSSendSMSCodeV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          code: {
            type: "int32",
            id: 3
          }
        }
      },
      TSPhoneSignInV2Request: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          },
          inviteKey: {
            type: "string",
            id: 3
          },
          businessId: {
            type: "string",
            id: 4
          },
          advertisement: {
            type: "FromAdvertisement",
            id: 5
          },
          countryCode: {
            type: "string",
            id: 6
          }
        }
      },
      TSPhoneSignInV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "TSUser",
            id: 4
          },
          code: {
            type: "int32",
            id: 5
          },
          isNewUser: {
            type: "bool",
            id: 6
          },
          newGiftCouponAmount: {
            type: "int32",
            id: 7
          }
        }
      },
      TSThirdPartyLoginV2Request: {
        fields: {
          loginType: {
            type: "TSLoginType",
            id: 1
          },
          openId: {
            type: "string",
            id: 2
          },
          accessToken: {
            type: "string",
            id: 3
          },
          inviteKey: {
            type: "string",
            id: 4
          },
          businessId: {
            type: "string",
            id: 5
          }
        }
      },
      TSThirdPartyLoginV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "TSUser",
            id: 4
          },
          code: {
            type: "int32",
            id: 5
          }
        }
      },
      TSMiniAppLoginV2Request: {
        fields: {
          loginType: {
            type: "TSLoginType",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          },
          avatarUrl: {
            type: "string",
            id: 3
          },
          nickname: {
            type: "string",
            id: 4
          }
        }
      },
      TSMiniAppLoginV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "TSUser",
            id: 4
          },
          openId: {
            type: "string",
            id: 5
          },
          code: {
            type: "int32",
            id: 6
          }
        }
      },
      TSBindMiniAppPhoneRequest: {
        fields: {
          encryptedData: {
            type: "string",
            id: 1
          },
          iv: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          businessId: {
            type: "string",
            id: 4
          },
          inviteKey: {
            type: "string",
            id: 5
          },
          phoneCode: {
            type: "string",
            id: 6
          }
        }
      },
      TSBindMiniAppPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "TSUser",
            id: 4
          },
          code: {
            type: "int32",
            id: 6
          },
          isNewUser: {
            type: "bool",
            id: 7
          },
          newGiftCouponAmount: {
            type: "int32",
            id: 8
          }
        }
      },
      TSBindUserPhoneV2Request: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          businessId: {
            type: "string",
            id: 4
          },
          inviteKey: {
            type: "string",
            id: 5
          }
        }
      },
      TSBindUserPhoneV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "TSUser",
            id: 4
          },
          code: {
            type: "int32",
            id: 5
          },
          isNewUser: {
            type: "bool",
            id: 6
          },
          newGiftCouponAmount: {
            type: "int32",
            id: 7
          }
        }
      },
      TSMiniAppPhoneLoginV2Request: {
        fields: {
          encryptedData: {
            type: "string",
            id: 1
          },
          iv: {
            type: "string",
            id: 2
          },
          code: {
            type: "string",
            id: 3
          },
          inviteKey: {
            type: "string",
            id: 4
          },
          businessId: {
            type: "string",
            id: 5
          },
          loginType: {
            type: "TSLoginType",
            id: 6
          },
          phoneCode: {
            type: "string",
            id: 7
          }
        }
      },
      TSMiniAppPhoneLoginV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "TSUser",
            id: 4
          },
          code: {
            type: "int32",
            id: 5
          },
          isNewUser: {
            type: "bool",
            id: 6
          },
          newGiftCouponAmount: {
            type: "int32",
            id: 7
          }
        }
      },
      ImageInfo: {
        fields: {
          HDImage: {
            type: "string",
            id: 1
          },
          normalImage: {
            type: "string",
            id: 2
          },
          thumbImage: {
            type: "string",
            id: 3
          }
        }
      },
      StockProductDetailImgListInfo: {
        fields: {
          HDImage: {
            type: "string",
            id: 1
          },
          normalImage: {
            type: "string",
            id: 2
          },
          thumbImage: {
            type: "string",
            id: 3
          }
        }
      },
      User: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          userType: {
            type: "UserType",
            id: 3
          },
          sex: {
            type: "string",
            id: 4
          },
          location: {
            type: "string",
            id: 5
          },
          imageInfo: {
            type: "ImageInfo",
            id: 6
          },
          weiboID: {
            type: "string",
            id: 7
          },
          wechatID: {
            type: "string",
            id: 8
          },
          appleID: {
            type: "string",
            id: 9
          },
          inviteID: {
            type: "string",
            id: 10
          },
          inviteKey: {
            type: "string",
            id: 11
          },
          isAppraiser: {
            type: "bool",
            id: 12
          },
          countryCode: {
            type: "string",
            id: 13
          },
          countryName: {
            type: "string",
            id: 14
          },
          countryEnName: {
            type: "string",
            id: 15
          },
          email: {
            type: "string",
            id: 16
          },
          appraiserPageType: {
            type: "int32",
            id: 17
          }
        }
      },
      WallMaster: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          imageInfo: {
            type: "ImageInfo",
            id: 2
          }
        }
      },
      SingleWallStyle: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          image: {
            type: "ImageInfo",
            id: 2
          },
          styleID: {
            type: "int32",
            id: 3
          },
          positionList: {
            rule: "repeated",
            type: "WallPosition",
            id: 4
          }
        }
      },
      Wall: {
        fields: {
          wid: {
            type: "string",
            id: 1
          },
          likeCount: {
            type: "int32",
            id: 2
          },
          wallStyle: {
            type: "SingleWallStyle",
            id: 3
          },
          master: {
            type: "WallMaster",
            id: 4
          }
        }
      },
      WallPosition: {
        fields: {
          x: {
            type: "int32",
            id: 1
          },
          y: {
            type: "int32",
            id: 2
          },
          w: {
            type: "int32",
            id: 3
          },
          h: {
            type: "int32",
            id: 4
          }
        }
      },
      UserAddress: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          },
          recipient: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          province: {
            type: "string",
            id: 4
          },
          city: {
            type: "string",
            id: 5
          },
          regions: {
            type: "string",
            id: 6
          },
          detailAddress: {
            type: "string",
            id: 7
          },
          isDefault: {
            type: "bool",
            id: 8
          }
        }
      },
      CategoryInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          imageInfo: {
            type: "ImageInfo",
            id: 2
          },
          key: {
            type: "string",
            id: 3
          },
          categoryID: {
            type: "int32",
            id: 4
          },
          status: {
            type: "bool",
            id: 5
          },
          isLast: {
            type: "bool",
            id: 6
          }
        }
      },
      KindInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          }
        }
      },
      BrandInitial: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          brand: {
            rule: "repeated",
            type: "CategoryInfo",
            id: 2
          }
        }
      },
      NewsInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          newsID: {
            type: "int32",
            id: 2
          },
          detail: {
            type: "string",
            id: 3
          },
          brief: {
            type: "string",
            id: 4
          }
        }
      },
      SizeInfo: {
        fields: {
          sizeID: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      ColorInfo: {
        fields: {
          colorID: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          hexValue: {
            type: "string",
            id: 3
          }
        }
      },
      BuyerBriefOrderInfo: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          },
          buyerOrderListStateEnum: {
            type: "BuyerOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          },
          productTitle: {
            type: "string",
            id: 5
          },
          image: {
            type: "string",
            id: 6
          },
          price: {
            type: "int32",
            id: 7
          },
          color: {
            type: "string",
            id: 8
          },
          size: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          news: {
            type: "string",
            id: 11
          },
          orderButton: {
            rule: "repeated",
            type: "OrderButton",
            id: 12
          },
          isSeckillOrder: {
            type: "bool",
            id: 13
          },
          orderPrice: {
            type: "int32",
            id: 14
          },
          isOfficial: {
            type: "bool",
            id: 15
          }
        }
      },
      SellerBriefOrderInfo: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          },
          sellerOrderListStateEnum: {
            type: "SellerOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          },
          productTitle: {
            type: "string",
            id: 5
          },
          image: {
            type: "string",
            id: 6
          },
          price: {
            type: "int32",
            id: 7
          },
          color: {
            type: "string",
            id: 8
          },
          size: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          news: {
            type: "string",
            id: 11
          },
          orderButton: {
            rule: "repeated",
            type: "OrderButton",
            id: 12
          },
          coldTimeLeft: {
            type: "string",
            id: 13
          },
          isSeckillOrder: {
            type: "bool",
            id: 14
          },
          orderPrice: {
            type: "int32",
            id: 15
          }
        }
      },
      SellerBriefProductInfo: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          sellerProductStateEnum: {
            type: "SellerProductStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          productTitle: {
            type: "string",
            id: 4
          },
          image: {
            type: "string",
            id: 5
          },
          price: {
            type: "int32",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          news: {
            type: "string",
            id: 10
          },
          orderButton: {
            rule: "repeated",
            type: "OrderButton",
            id: 11
          },
          relatedOAID: {
            type: "string",
            id: 12
          },
          appraisalGenuine: {
            type: "bool",
            id: 13
          },
          appraisalType: {
            type: "AppraisalType",
            id: 14
          },
          isSeckillProduct: {
            type: "bool",
            id: 15
          },
          seckillPrice: {
            type: "uint32",
            id: 16
          },
          seckillState: {
            type: "TimeState",
            id: 17
          },
          seckillEndLeft: {
            type: "string",
            id: 18
          }
        }
      },
      SellerProductDetailInfo: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          sellerProductStateEnum: {
            type: "SellerProductStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          productTitle: {
            type: "string",
            id: 4
          },
          image: {
            type: "string",
            id: 5
          },
          price: {
            type: "int32",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          news: {
            type: "string",
            id: 10
          },
          relatedOAID: {
            type: "string",
            id: 11
          },
          appraisalGenuine: {
            type: "bool",
            id: 12
          },
          returnAddress: {
            type: "UserAddress",
            id: 13
          },
          serviceChargeRate: {
            type: "string",
            id: 14
          },
          transferFeeRate: {
            type: "string",
            id: 15
          },
          serviceCharge: {
            type: "int32",
            id: 16
          },
          transferFee: {
            type: "int32",
            id: 17
          },
          description: {
            type: "string",
            id: 18
          },
          creatTime: {
            type: "string",
            id: 19
          },
          orderButton: {
            rule: "repeated",
            type: "OrderButton",
            id: 20
          },
          appraisalType: {
            type: "AppraisalType",
            id: 21
          }
        }
      },
      ShootImageInfo: {
        fields: {
          position: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          required: {
            type: "bool",
            id: 3
          },
          imageID: {
            type: "int32",
            id: 4
          }
        }
      },
      ProductOnSalePublishInfo: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          imageList: {
            rule: "repeated",
            type: "ShootImageInfo",
            id: 2
          },
          productCover: {
            type: "string",
            id: 3
          },
          productName: {
            type: "string",
            id: 4
          },
          attribute: {
            type: "string",
            id: 5
          },
          sku: {
            type: "string",
            id: 6
          },
          newDegree: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          sendWord: {
            type: "string",
            id: 9
          },
          sellPrice: {
            type: "int32",
            id: 10
          },
          serviceFeeRate: {
            type: "string",
            id: 11
          },
          serviceFee: {
            type: "int32",
            id: 12
          },
          transferFeeRate: {
            type: "string",
            id: 13
          },
          transferFee: {
            type: "int32",
            id: 14
          },
          actualIncome: {
            type: "int32",
            id: 15
          },
          address: {
            type: "UserAddress",
            id: 16
          },
          brandID: {
            type: "int32",
            id: 17
          }
        }
      },
      SellerOrderDetailInfo: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          },
          sellerOrderListStateEnum: {
            type: "SellerOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          stateIntroduction: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          creatTime: {
            type: "string",
            id: 6
          },
          productTitle: {
            type: "string",
            id: 7
          },
          image: {
            type: "string",
            id: 8
          },
          price: {
            type: "int32",
            id: 9
          },
          color: {
            type: "string",
            id: 10
          },
          size: {
            type: "string",
            id: 11
          },
          measurement: {
            type: "string",
            id: 12
          },
          news: {
            type: "string",
            id: 13
          },
          returnAddress: {
            type: "UserAddress",
            id: 14
          },
          serviceCharge: {
            type: "int32",
            id: 15
          },
          serviceChargeRate: {
            type: "string",
            id: 16
          },
          transferFee: {
            type: "int32",
            id: 17
          },
          transferFeeRate: {
            type: "string",
            id: 18
          },
          record: {
            type: "ExpressRecord",
            id: 19
          },
          expressNo: {
            type: "string",
            id: 20
          },
          income: {
            type: "int32",
            id: 21
          },
          orderButton: {
            rule: "repeated",
            type: "OrderButton",
            id: 22
          },
          canModifyAddr: {
            type: "bool",
            id: 23
          },
          buyerPayTimeout: {
            type: "string",
            id: 24
          },
          coldTimeLeft: {
            type: "string",
            id: 25
          },
          deliverTimeout: {
            type: "string",
            id: 26
          }
        }
      },
      BuyerOrderDetailInfo: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          },
          buyerOrderListStateEnum: {
            type: "BuyerOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          stateIntroduction: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          creatTime: {
            type: "string",
            id: 6
          },
          productTitle: {
            type: "string",
            id: 7
          },
          image: {
            type: "string",
            id: 8
          },
          price: {
            type: "int32",
            id: 9
          },
          freight: {
            type: "int32",
            id: 10
          },
          cost: {
            type: "int32",
            id: 11
          },
          color: {
            type: "string",
            id: 12
          },
          size: {
            type: "string",
            id: 13
          },
          measurement: {
            type: "string",
            id: 14
          },
          news: {
            type: "string",
            id: 15
          },
          receivingAddress: {
            type: "UserAddress",
            id: 16
          },
          orderButton: {
            rule: "repeated",
            type: "OrderButton",
            id: 17
          },
          canModifyAddr: {
            type: "bool",
            id: 18
          },
          payTimeout: {
            type: "string",
            id: 19
          },
          payType: {
            type: "string",
            id: 20
          },
          coldTimeLeft: {
            type: "string",
            id: 21
          },
          record: {
            type: "ExpressRecord",
            id: 22
          },
          expressNo: {
            type: "string",
            id: 23
          },
          isPostage: {
            type: "bool",
            id: 24
          },
          isOfficial: {
            type: "bool",
            id: 25
          },
          bargainAmount: {
            type: "int32",
            id: 26
          },
          orderType: {
            type: "ProductOriginalType",
            id: 27
          }
        }
      },
      Banner: {
        fields: {
          bannerUrl: {
            type: "string",
            id: 1
          },
          link: {
            type: "string",
            id: 2
          }
        }
      },
      BrandRate: {
        fields: {
          brandName: {
            type: "string",
            id: 1
          },
          rate: {
            type: "int32",
            id: 2
          }
        }
      },
      SelectedAppraisalRecord: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          avatar: {
            type: "string",
            id: 2
          },
          creatTime: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          authenticity: {
            type: "bool",
            id: 5
          },
          image: {
            rule: "repeated",
            type: "ImageInfo",
            id: 6
          },
          isCCIC: {
            type: "bool",
            id: 7
          }
        }
      },
      BriefAppraisalResult: {
        fields: {
          authenticity: {
            type: "bool",
            id: 1
          },
          oaid: {
            type: "string",
            id: 2
          },
          brand: {
            type: "string",
            id: 3
          },
          exteriorUrl: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          }
        }
      },
      BiasedInfo: {
        fields: {
          grade: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      SingleAppraisalResult: {
        fields: {
          authenticity: {
            type: "bool",
            id: 1
          },
          grade: {
            type: "string",
            id: 2
          },
          imageInfo: {
            type: "ImageInfo",
            id: 3
          },
          biasedInfo: {
            rule: "repeated",
            type: "BiasedInfo",
            id: 4
          },
          pointKey: {
            type: "string",
            id: 5
          },
          pointName: {
            type: "string",
            id: 6
          }
        }
      },
      PointInfo: {
        fields: {
          necessity: {
            type: "bool",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          pointKey: {
            type: "string",
            id: 3
          },
          photoGuide: {
            type: "string",
            id: 4
          },
          exampleImg: {
            type: "string",
            id: 5
          },
          stickFigureImg: {
            type: "string",
            id: 6
          },
          bigStickFigureImg: {
            type: "string",
            id: 7
          }
        }
      },
      AIServiceCategoryInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          imageInfo: {
            type: "ImageInfo",
            id: 2
          },
          categoryID: {
            type: "int32",
            id: 3
          },
          isRelated: {
            type: "bool",
            id: 4
          },
          hotSequence: {
            type: "int32",
            id: 5
          },
          isEnd: {
            type: "bool",
            id: 6
          },
          brandCnName: {
            type: "string",
            id: 7
          },
          isByteDance: {
            type: "bool",
            id: 8
          },
          appraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 9
          },
          isSupportClassify: {
            type: "bool",
            id: 10
          },
          price: {
            type: "int32",
            id: 11
          }
        }
      },
      AIServiceTagCategoryItem: {
        fields: {
          tagId: {
            type: "int32",
            id: 1
          },
          tagName: {
            type: "string",
            id: 2
          },
          categoryInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 3
          }
        }
      },
      AIServiceCategoryInitial: {
        fields: {
          letter: {
            type: "string",
            id: 1
          },
          categoryInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 2
          }
        }
      },
      AIBDServiceCategoryInitial: {
        fields: {
          letter: {
            type: "string",
            id: 1
          },
          categoryInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 2
          }
        }
      },
      AIServiceAppraisalBox: {
        fields: {
          x: {
            type: "string",
            id: 1
          },
          y: {
            type: "string",
            id: 2
          },
          width: {
            type: "string",
            id: 3
          },
          height: {
            type: "string",
            id: 4
          },
          radius: {
            type: "string",
            id: 5
          }
        }
      },
      AIServicePointInfo: {
        fields: {
          necessity: {
            type: "bool",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          pointType: {
            type: "int32",
            id: 9
          },
          pointId: {
            type: "int32",
            id: 3
          },
          photoGuide: {
            type: "string",
            id: 4
          },
          exampleImg: {
            type: "string",
            id: 5
          },
          stickFigureImg: {
            type: "string",
            id: 6
          },
          bigStickFigureImg: {
            type: "string",
            id: 7
          },
          must: {
            type: "int32",
            id: 8
          }
        }
      },
      ManualAppraisalResultItem: {
        fields: {
          pointId: {
            type: "int32",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      AIJadeAppraisalItem: {
        fields: {
          jadeGenuine: {
            type: "string",
            id: 1
          },
          jadeGenuineName: {
            type: "string",
            id: 2
          },
          seedWater: {
            type: "string",
            id: 3
          },
          density: {
            type: "string",
            id: 4
          },
          polarizingInspection: {
            type: "string",
            id: 5
          },
          refractiveIndex: {
            type: "string",
            id: 6
          },
          zoomIn: {
            type: "string",
            id: 7
          },
          jadeEvaluateInfo: {
            rule: "repeated",
            type: "JadeEvaluateInfo",
            id: 8
          },
          evaluateColumnsList: {
            rule: "repeated",
            type: "string",
            id: 9
          }
        }
      },
      JadeEvaluateInfo: {
        fields: {
          coverArea: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          kindPriceArea: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      AIServiceOrder: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          OAID: {
            type: "string",
            id: 2
          },
          imageURL: {
            type: "string",
            id: 3
          },
          totalAmount: {
            type: "int32",
            id: 4
          },
          time: {
            type: "string",
            id: 5
          },
          hierarchy: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          },
          kindName: {
            type: "string",
            id: 8
          },
          brandID: {
            type: "int32",
            id: 9
          },
          brandName: {
            type: "string",
            id: 10
          },
          seriesID: {
            type: "int32",
            id: 11
          },
          seriesName: {
            type: "string",
            id: 12
          },
          state: {
            type: "AIServiceAppraisalOrderStateEnum",
            id: 13
          },
          cardNo: {
            type: "string",
            id: 14
          },
          appraisalType: {
            type: "AIAppraisalType",
            id: 15
          },
          createTime: {
            type: "string",
            id: 16
          },
          appraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 17
          },
          aiToManualAppraisalResult: {
            type: "AIToManualAppraisalResult",
            id: 18
          },
          reportUrl: {
            type: "string",
            id: 20
          },
          result: {
            type: "AppraisalResultEnum",
            id: 21
          },
          genuine: {
            type: "string",
            id: 22
          },
          timestamp: {
            type: "string",
            id: 23
          },
          isToManualRealTimeOrder: {
            type: "bool",
            id: 24
          }
        }
      },
      AIServiceAppraisalReportSAItem: {
        fields: {
          SAID: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          grade: {
            type: "string",
            id: 4
          },
          detection: {
            type: "bool",
            id: 5
          },
          originalBox: {
            type: "AIServiceAppraisalBox",
            id: 6
          },
          detectionBox: {
            type: "AIServiceAppraisalBox",
            id: 7
          },
          showFake: {
            type: "bool",
            id: 8
          },
          fakePoints: {
            rule: "repeated",
            type: "AIServiceAppraisalBox",
            id: 9
          },
          croppedImageURL: {
            type: "string",
            id: 10
          },
          description: {
            type: "string",
            id: 11
          },
          aiJadeAppraisalItem: {
            type: "AIJadeAppraisalItem",
            id: 12
          }
        }
      },
      ClassifiedObject: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          price: {
            type: "string",
            id: 3
          },
          imageUrl: {
            type: "string",
            id: 4
          },
          content: {
            type: "string",
            id: 5
          },
          itemID: {
            type: "string",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          sizeID: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          sku: {
            type: "string",
            id: 11
          }
        }
      },
      CoordinateInfo: {
        fields: {
          x: {
            type: "string",
            id: 1
          },
          y: {
            type: "string",
            id: 2
          },
          w: {
            type: "string",
            id: 3
          },
          h: {
            type: "string",
            id: 4
          }
        }
      },
      CarouselItem: {
        fields: {
          image: {
            type: "string",
            id: 1
          },
          link: {
            type: "string",
            id: 2
          }
        }
      },
      SelectedProductInfo: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          image: {
            type: "string",
            id: 3
          },
          news: {
            type: "string",
            id: 4
          },
          cost: {
            type: "int32",
            id: 5
          },
          brand: {
            type: "string",
            id: 6
          },
          price: {
            type: "int32",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          relatedOaID: {
            type: "string",
            id: 10
          },
          appraisalType: {
            type: "AppraisalType",
            id: 11
          },
          isSeckillProduct: {
            type: "bool",
            id: 12
          },
          seckillPrice: {
            type: "uint32",
            id: 13
          },
          seckillState: {
            type: "TimeState",
            id: 14
          },
          seckillEndLeft: {
            type: "string",
            id: 15
          },
          selfRun: {
            type: "bool",
            id: 16
          }
        }
      },
      ProductUserUpload: {
        fields: {
          imageInfo: {
            rule: "repeated",
            type: "ImageInfo",
            id: 1
          },
          cost: {
            type: "int32",
            id: 2
          },
          price: {
            type: "int32",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          news: {
            type: "string",
            id: 5
          },
          oaid: {
            type: "string",
            id: 6
          },
          story: {
            type: "string",
            id: 7
          },
          appraisalType: {
            type: "AppraisalType",
            id: 8
          }
        }
      },
      ProductBasicInfo: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          brand: {
            type: "string",
            id: 2
          },
          itemID: {
            type: "string",
            id: 3
          },
          releaseTime: {
            type: "string",
            id: 4
          },
          releasePrice: {
            type: "int32",
            id: 5
          },
          color: {
            type: "string",
            id: 6
          },
          sizeInfo: {
            type: "string",
            id: 7
          },
          material: {
            type: "string",
            id: 8
          },
          imageInfo: {
            rule: "repeated",
            type: "ImageInfo",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          kindID: {
            type: "int32",
            id: 11
          },
          kindName: {
            type: "string",
            id: 12
          },
          styleName: {
            type: "string",
            id: 13
          },
          isSeckillProduct: {
            type: "bool",
            id: 14
          },
          seckillPrice: {
            type: "uint32",
            id: 15
          },
          seckillState: {
            type: "TimeState",
            id: 16
          },
          seckillEndLeft: {
            type: "string",
            id: 17
          },
          skc: {
            type: "string",
            id: 18
          },
          mainPic: {
            type: "string",
            id: 19
          },
          seckillProductId: {
            type: "uint32",
            id: 20
          },
          seckillDate: {
            type: "string",
            id: 21
          },
          seckillStartTime: {
            type: "string",
            id: 22
          },
          seckillEndTime: {
            type: "string",
            id: 23
          },
          bargainPrice: {
            type: "uint32",
            id: 24
          },
          isBargain: {
            type: "bool",
            id: 25
          }
        }
      },
      SkcInfo: {
        fields: {
          brandName: {
            type: "string",
            id: 1
          },
          mainPic: {
            type: "string",
            id: 2
          },
          brandID: {
            type: "int32",
            id: 3
          },
          releasePrice: {
            type: "int32",
            id: 4
          },
          proCount: {
            type: "int32",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          skc: {
            type: "string",
            id: 7
          },
          sku: {
            type: "string",
            id: 8
          },
          newsDetails: {
            rule: "repeated",
            type: "NewPriceResult",
            id: 14
          }
        }
      },
      PersonCenterIcon: {
        fields: {
          iconTitle: {
            type: "string",
            id: 1
          },
          iconImage: {
            type: "string",
            id: 2
          },
          number: {
            type: "int32",
            id: 3
          }
        }
      },
      ExpressRecord: {
        fields: {
          updateTime: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          comment: {
            type: "string",
            id: 3
          }
        }
      },
      ExpressItem: {
        fields: {
          itemTitle: {
            type: "string",
            id: 1
          },
          itemState: {
            type: "bool",
            id: 2
          },
          hasDetail: {
            type: "bool",
            id: 3
          },
          expressCompany: {
            type: "string",
            id: 4
          },
          expressNumber: {
            type: "string",
            id: 5
          },
          records: {
            rule: "repeated",
            type: "ExpressRecord",
            id: 6
          },
          isTitleHide: {
            type: "bool",
            id: 7
          }
        }
      },
      OrderButton: {
        fields: {
          buttonEnum: {
            type: "OrderButtonEnum",
            id: 1
          },
          buttonTitle: {
            type: "string",
            id: 2
          }
        }
      },
      RunningCount: {
        fields: {
          flowType: {
            type: "WalletRunningCountTypeEnum",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          dateTime: {
            type: "string",
            id: 3
          },
          amount: {
            type: "int32",
            id: 4
          },
          orderID: {
            type: "string",
            id: 5
          },
          reportID: {
            type: "string",
            id: 6
          }
        }
      },
      HotBrandInfo: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          },
          brandName: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      ProductUtilsItem: {
        fields: {
          serialNumber: {
            type: "int32",
            id: 1
          },
          skc: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          mainPic: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandEnName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          colorName: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          adaptCrowd: {
            type: "string",
            id: 10
          },
          oldNew: {
            type: "string",
            id: 11
          },
          provenance: {
            type: "string",
            id: 12
          },
          styleName: {
            type: "string",
            id: 13
          },
          materialName: {
            type: "string",
            id: 14
          },
          sizeName: {
            type: "string",
            id: 15
          },
          releasePrice: {
            type: "string",
            id: 16
          },
          inStoreTime: {
            type: "string",
            id: 17
          },
          itemID: {
            type: "string",
            id: 18
          },
          status: {
            type: "string",
            id: 19
          },
          brandID: {
            type: "int32",
            id: 20
          },
          currentSkc: {
            type: "string",
            id: 21
          },
          account: {
            type: "string",
            id: 22
          },
          updateTime: {
            type: "string",
            id: 23
          },
          kindID: {
            type: "int32",
            id: 24
          },
          pid: {
            type: "string",
            id: 25
          },
          source: {
            type: "string",
            id: 26
          },
          sku: {
            type: "string",
            id: 27
          }
        }
      },
      SearchMallPublishItem: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          mainPic: {
            type: "string",
            id: 2
          },
          colorName: {
            type: "string",
            id: 3
          },
          measurement: {
            type: "string",
            id: 4
          },
          brandEnName: {
            type: "string",
            id: 5
          },
          productName: {
            type: "string",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          sizeName: {
            type: "string",
            id: 8
          },
          skc: {
            type: "string",
            id: 9
          }
        }
      },
      NewClassifiedObject: {
        fields: {
          mainPic: {
            type: "string",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          releasePrice: {
            type: "string",
            id: 4
          },
          sku: {
            type: "string",
            id: 5
          },
          sizeName: {
            type: "string",
            id: 6
          },
          colorName: {
            type: "string",
            id: 7
          },
          measurement: {
            type: "string",
            id: 8
          },
          brandID: {
            type: "string",
            id: 9
          },
          kindID: {
            type: "string",
            id: 10
          }
        }
      },
      ProductPidObject: {
        fields: {
          cover: {
            type: "string",
            id: 1
          },
          newsName: {
            type: "string",
            id: 2
          },
          brandEnName: {
            type: "string",
            id: 3
          },
          productName: {
            type: "string",
            id: 4
          },
          releasePrice: {
            type: "string",
            id: 5
          },
          actualPrice: {
            type: "string",
            id: 6
          },
          sku: {
            type: "string",
            id: 7
          },
          pid: {
            type: "string",
            id: 8
          }
        }
      },
      LotteryPoolItem: {
        fields: {
          lotteryPoolId: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          lotteryPoolPic: {
            type: "string",
            id: 3
          },
          startTime: {
            type: "string",
            id: 4
          },
          endTime: {
            type: "string",
            id: 5
          },
          lotteryStatus: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          createTime: {
            type: "string",
            id: 8
          },
          lotteryNum: {
            type: "int32",
            id: 9
          }
        }
      },
      UserPoolItem: {
        fields: {
          userPoolId: {
            type: "int32",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          status: {
            type: "string",
            id: 3
          }
        }
      },
      FingerprintItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          mainPic: {
            type: "string",
            id: 3
          },
          numberIDCard: {
            type: "string",
            id: 4
          },
          createTime: {
            type: "string",
            id: 5
          }
        }
      },
      CheckItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          mainPic: {
            type: "string",
            id: 3
          },
          numberIDCard: {
            type: "string",
            id: 4
          },
          checkTime: {
            type: "string",
            id: 5
          },
          status: {
            type: "string",
            id: 6
          }
        }
      },
      AppraisalCouponItem: {
        fields: {
          couponNo: {
            type: "string",
            id: 1
          },
          validTerm: {
            type: "string",
            id: 2
          },
          OAID: {
            type: "string",
            id: 4
          },
          dueSoon: {
            type: "bool",
            id: 5
          },
          channel: {
            type: "CouponChannel",
            id: 6
          },
          validTermStamp: {
            type: "string",
            id: 7
          }
        }
      },
      UserInfo: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          nickName: {
            type: "string",
            id: 2
          },
          uid: {
            type: "int32",
            id: 3
          },
          createTime: {
            type: "string",
            id: 4
          },
          appOrigin: {
            type: "string",
            id: 5
          },
          activityOrigin: {
            type: "string",
            id: 6
          },
          sellOrderNum: {
            type: "int32",
            id: 7
          },
          buyOrderNum: {
            type: "int32",
            id: 8
          },
          authenticateNum: {
            type: "int32",
            id: 9
          },
          isJoinCommunity: {
            type: "string",
            id: 10
          },
          sex: {
            type: "string",
            id: 11
          },
          location: {
            type: "string",
            id: 12
          },
          addressDetail: {
            type: "string",
            id: 13
          },
          wx: {
            type: "string",
            id: 14
          },
          inviterPhone: {
            type: "string",
            id: 15
          },
          inviteNum: {
            type: "uint32",
            id: 16
          },
          thirdLevelNum: {
            type: "uint32",
            id: 17
          },
          inviteCode: {
            type: "string",
            id: 18
          },
          country: {
            type: "string",
            id: 19
          },
          email: {
            type: "string",
            id: 20
          }
        }
      },
      AuthenticateInfo: {
        fields: {
          authNum: {
            type: "string",
            id: 1
          },
          freeAuthNum: {
            type: "string",
            id: 2
          },
          payAuthNum: {
            type: "string",
            id: 3
          },
          cumulativeConsumption: {
            type: "int32",
            id: 4
          }
        }
      },
      ExpertAppraisalInfo: {
        fields: {
          authNum: {
            type: "string",
            id: 1
          },
          cumulativeConsumption: {
            type: "int32",
            id: 4
          }
        }
      },
      AIClassify: {
        fields: {
          matchOk: {
            type: "int32",
            id: 1
          },
          matchFail: {
            type: "int32",
            id: 2
          },
          checkFail: {
            type: "int32",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        }
      },
      RecycleStat: {
        fields: {
          tradeOkCount: {
            type: "int32",
            id: 1
          },
          detail: {
            type: "string",
            id: 2
          },
          totalMoney: {
            type: "int32",
            id: 3
          }
        }
      },
      ConsignStat: {
        fields: {
          tradeOkCount: {
            type: "int32",
            id: 1
          },
          detail: {
            type: "string",
            id: 2
          },
          totalMoney: {
            type: "int32",
            id: 3
          }
        }
      },
      BuyInfo: {
        fields: {
          success: {
            type: "int32",
            id: 1
          },
          consume: {
            type: "int32",
            id: 3
          },
          averagePrice: {
            type: "int32",
            id: 4
          },
          details: {
            type: "BuyDetails",
            id: 5
          }
        }
      },
      BuyDetails: {
        fields: {
          unpay: {
            type: "int32",
            id: 1
          },
          unreceive: {
            type: "int32",
            id: 2
          },
          success: {
            type: "int32",
            id: 3
          },
          fatal: {
            type: "int32",
            id: 4
          }
        }
      },
      SellInfo: {
        fields: {
          success: {
            type: "int32",
            id: 1
          },
          details: {
            type: "SellDetails",
            id: 2
          },
          consume: {
            type: "int32",
            id: 3
          }
        }
      },
      SellDetails: {
        fields: {
          unpay: {
            type: "int32",
            id: 1
          },
          unreceive: {
            type: "int32",
            id: 2
          },
          success: {
            type: "int32",
            id: 3
          },
          fatal: {
            type: "int32",
            id: 4
          }
        }
      },
      Manage: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          createTime: {
            type: "int64",
            id: 3
          }
        }
      },
      BulletinReport: {
        fields: {
          username: {
            type: "string",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          brandName: {
            type: "string",
            id: 3
          },
          seriesName: {
            type: "string",
            id: 4
          },
          result: {
            type: "AppraisalResultEnum",
            id: 5
          },
          reportID: {
            type: "string",
            id: 6
          },
          appraisalType: {
            type: "AppraisalType",
            id: 7
          },
          avatar: {
            type: "string",
            id: 8
          },
          isCCIC: {
            type: "bool",
            id: 9
          },
          timeInterval: {
            type: "int32",
            id: 10
          }
        }
      },
      HolmesResult: {
        fields: {
          mainPic: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          seriesName: {
            type: "string",
            id: 3
          },
          productName: {
            type: "string",
            id: 4
          },
          onSaleCount: {
            type: "int32",
            id: 5
          },
          newsDetails: {
            rule: "repeated",
            type: "NewPriceResult",
            id: 6
          },
          skc: {
            type: "string",
            id: 7
          },
          colorName: {
            type: "string",
            id: 8
          },
          productCode: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          releasePrice: {
            type: "string",
            id: 11
          },
          releaseDate: {
            type: "string",
            id: 12
          },
          origin: {
            type: "string",
            id: 13
          },
          forPeople: {
            type: "string",
            id: 14
          },
          materialStr: {
            type: "string",
            id: 15
          },
          overflowPrice: {
            type: "string",
            id: 16
          },
          worldPriceItem: {
            rule: "repeated",
            type: "WorldPriceItem",
            id: 19
          },
          productNewsItem: {
            rule: "repeated",
            type: "ProductNewsItem",
            id: 20
          },
          skcList: {
            rule: "repeated",
            type: "string",
            id: 21
          },
          kindId: {
            type: "int32",
            id: 22
          },
          brandId: {
            type: "int32",
            id: 23
          },
          description: {
            type: "string",
            id: 24
          },
          seriesId: {
            type: "string",
            id: 25
          },
          sku: {
            type: "string",
            id: 26
          },
          brandLogo: {
            type: "string",
            id: 27
          },
          size: {
            type: "string",
            id: 28
          },
          newsPrice: {
            rule: "repeated",
            type: "NewsPrice",
            id: 29
          }
        }
      },
      NewPriceResult: {
        fields: {
          newOld: {
            type: "string",
            id: 1
          },
          price: {
            type: "string",
            id: 2
          }
        }
      },
      SimilarItem: {
        fields: {
          mainPic: {
            type: "string",
            id: 1
          },
          saleCount: {
            type: "int32",
            id: 2
          },
          skc: {
            type: "string",
            id: 3,
            options: {
              deprecated: true
            }
          },
          newsDetails: {
            rule: "repeated",
            type: "NewPriceResult",
            id: 4
          },
          brandEnName: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          productName: {
            type: "string",
            id: 7
          },
          sizeName: {
            type: "string",
            id: 8
          },
          kindId: {
            type: "int32",
            id: 23
          },
          brandId: {
            type: "int32",
            id: 24
          },
          sku: {
            type: "string",
            id: 11
          }
        }
      },
      WorldPriceItem: {
        fields: {
          country: {
            type: "string",
            id: 1
          },
          websitePrice: {
            type: "string",
            id: 2
          },
          rmbPrice: {
            type: "string",
            id: 3
          }
        }
      },
      ProductNewsItem: {
        fields: {
          graphPrice: {
            rule: "repeated",
            type: "GraphPriceItem",
            id: 1
          },
          networkPrice: {
            rule: "repeated",
            type: "NetworkPriceItem",
            id: 2
          },
          newsName: {
            type: "string",
            id: 3
          },
          sevenDayCompare: {
            type: "string",
            id: 4
          },
          newsNetWorkNum: {
            type: "string",
            id: 5
          },
          netPrice: {
            type: "string",
            id: 6
          },
          isNone: {
            type: "bool",
            id: 7
          }
        }
      },
      GraphPriceItem: {
        fields: {
          time: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          price: {
            type: "string",
            id: 3
          }
        }
      },
      NetworkPriceItem: {
        fields: {
          salePrice: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          productNum: {
            type: "string",
            id: 3
          }
        }
      },
      SeckillProduct: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          cover: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          sellPrice: {
            type: "uint32",
            id: 4
          },
          seckillPrice: {
            type: "uint32",
            id: 5
          },
          newDegree: {
            type: "string",
            id: 6
          },
          button: {
            type: "SeckillButton",
            id: 7
          },
          seckillProductId: {
            type: "uint32",
            id: 8
          },
          oaid: {
            type: "string",
            id: 9
          },
          brand: {
            type: "string",
            id: 10
          },
          selfRun: {
            type: "bool",
            id: 11
          }
        }
      },
      SeckillSingleRound: {
        fields: {
          state: {
            type: "TimeState",
            id: 1
          },
          itemList: {
            rule: "repeated",
            type: "SeckillProduct",
            id: 2
          },
          startTime: {
            type: "string",
            id: 3
          },
          endTime: {
            type: "string",
            id: 4
          },
          timeLeft: {
            type: "string",
            id: 5
          },
          roundId: {
            type: "uint32",
            id: 6
          }
        }
      },
      ConfirmOrderProduct: {
        fields: {
          image: {
            type: "string",
            id: 1
          },
          newDegree: {
            type: "string",
            id: 2
          },
          color: {
            type: "string",
            id: 3
          },
          size: {
            type: "string",
            id: 4
          },
          measure: {
            type: "string",
            id: 5
          },
          name: {
            type: "string",
            id: 6
          },
          sellPrice: {
            type: "int32",
            id: 7
          },
          releasePrice: {
            type: "string",
            id: 8
          },
          isOfficial: {
            type: "bool",
            id: 9
          },
          bargainAmount: {
            type: "int32",
            id: 10
          },
          orderType: {
            type: "ProductOriginalType",
            id: 11
          }
        }
      },
      BargainProductItem: {
        fields: {
          BasicInfo: {
            type: "BargainBasicItem",
            id: 1
          }
        }
      },
      BargainBasicItem: {
        fields: {
          mainPic: {
            type: "string",
            id: 1
          },
          releasePrice: {
            type: "int32",
            id: 2
          },
          actualPrice: {
            type: "int32",
            id: 3
          },
          isOfficial: {
            type: "bool",
            id: 4
          },
          skc: {
            type: "string",
            id: 5
          },
          id: {
            type: "uint32",
            id: 6
          },
          endTime: {
            type: "string",
            id: 7
          },
          name: {
            type: "string",
            id: 8
          },
          sortTime: {
            type: "string",
            id: 9
          },
          flowStatus: {
            type: "int32",
            id: 10
          },
          productStatus: {
            type: "BargainLimitType",
            id: 11
          },
          productMyStatus: {
            type: "BargainLimitState",
            id: 12
          },
          newsName: {
            type: "string",
            id: 13
          },
          bargainPrice: {
            type: "int32",
            id: 14
          },
          joinActivityCount: {
            type: "int32",
            id: 15
          },
          countDown: {
            type: "int32",
            id: 16
          },
          payTime: {
            type: "int32",
            id: 17
          },
          pidStr: {
            type: "string",
            id: 18
          },
          orderNo: {
            type: "string",
            id: 19
          },
          productStatusInt: {
            type: "int32",
            id: 20
          },
          productMyStatusInt: {
            type: "int32",
            id: 21
          },
          distancePrice: {
            type: "int32",
            id: 22
          },
          reductionPrice: {
            type: "int32",
            id: 23
          },
          reductionOrderPrice: {
            type: "int32",
            id: 24
          },
          costPrice: {
            type: "int32",
            id: 25
          },
          isSub: {
            type: "bool",
            id: 26
          },
          remainderNum: {
            type: "int32",
            id: 27
          },
          newPrice: {
            type: "int32",
            id: 28
          },
          isAddProSub: {
            type: "bool",
            id: 29
          }
        }
      },
      MyBargainProductItem: {
        fields: {
          BasicInfo: {
            type: "BargainBasicItem",
            id: 1
          }
        }
      },
      BargainDetailItem: {
        fields: {
          endTime: {
            type: "string",
            id: 1
          },
          mainPic: {
            type: "string",
            id: 2
          },
          releasePrice: {
            type: "int32",
            id: 3
          },
          actualPrice: {
            type: "int32",
            id: 4
          },
          remainderNum: {
            type: "int32",
            id: 5
          },
          saleNum: {
            type: "int32",
            id: 6
          },
          bargainRange: {
            type: "string",
            id: 7
          },
          helpBargainInfo: {
            rule: "repeated",
            type: "HelpBargainItem",
            id: 8
          },
          payMethods: {
            type: "BargainPayMethods",
            id: 9
          },
          activityId: {
            type: "uint32",
            id: 10
          },
          pidStr: {
            type: "string",
            id: 11
          },
          countDown: {
            type: "int32",
            id: 12
          },
          uid: {
            type: "int32",
            id: 13
          },
          distancePrice: {
            type: "int32",
            id: 14
          },
          reductionPrice: {
            type: "int32",
            id: 15
          },
          bargainPrice: {
            type: "int32",
            id: 16
          },
          isFirst: {
            type: "bool",
            id: 17
          },
          userImage: {
            type: "string",
            id: 18
          },
          name: {
            type: "string",
            id: 19
          },
          isOfficial: {
            type: "bool",
            id: 20
          },
          newsName: {
            type: "string",
            id: 21
          },
          bargainInfoId: {
            type: "uint32",
            id: 22
          },
          like: {
            type: "bool",
            id: 23
          },
          kindID: {
            type: "int32",
            id: 24
          },
          newPrice: {
            type: "int32",
            id: 25
          }
        }
      },
      HelpBargainItem: {
        fields: {
          userImage: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          helpPrice: {
            type: "int32",
            id: 3
          }
        }
      },
      BroadcastItem: {
        fields: {
          avatar: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          }
        }
      },
      PromptMessageItem: {
        fields: {
          bargainId: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          mainPic: {
            type: "string",
            id: 3
          },
          bargainPrice: {
            type: "int32",
            id: 4
          },
          distancePrice: {
            type: "int32",
            id: 5
          },
          reductionPrice: {
            type: "int32",
            id: 6
          },
          completeBargainTime: {
            type: "string",
            id: 7
          },
          userName: {
            type: "string",
            id: 8
          },
          countDown: {
            type: "int32",
            id: 9
          },
          userPic: {
            type: "string",
            id: 10
          },
          pidStr: {
            type: "string",
            id: 11
          }
        }
      },
      FromAdvertisement: {
        fields: {
          clientId: {
            type: "string",
            id: 1
          },
          idfa: {
            type: "string",
            id: 2
          },
          channel: {
            type: "Channels",
            id: 3
          },
          advertId: {
            type: "string",
            id: 4
          }
        },
        nested: {
          Channels: {
            values: {
              UnKnown: 0,
              ByteDanceChannel: 1,
              GDTChannel: 2,
              KSChannel: 3
            }
          }
        }
      },
      CompetitionUser: {
        fields: {
          uid: {
            type: "int32",
            id: 1
          },
          baoGoUid: {
            type: "int32",
            id: 2
          },
          nickName: {
            type: "string",
            id: 3
          },
          avatar: {
            type: "string",
            id: 4
          },
          phone: {
            type: "string",
            id: 5
          },
          userType: {
            type: "CompetitionUserType",
            id: 6
          },
          challengeNum: {
            type: "int32",
            id: 7
          },
          shareNum: {
            type: "int32",
            id: 8
          },
          rewardAmount: {
            type: "int32",
            id: 9
          },
          couponNum: {
            type: "int32",
            id: 10
          }
        }
      },
      Competition: {
        fields: {
          cid: {
            type: "int32",
            id: 1
          },
          type: {
            type: "CompetitionType",
            id: 2
          },
          phase: {
            type: "int32",
            id: 3
          },
          questionType: {
            rule: "repeated",
            type: "int32",
            id: 4
          },
          freeNum: {
            type: "int32",
            id: 5
          },
          extraNum: {
            type: "int32",
            id: 6
          },
          timeLimit: {
            type: "int32",
            id: 7
          },
          questionLimit: {
            type: "int32",
            id: 8
          },
          bonusConfig: {
            rule: "repeated",
            type: "BonusConfig",
            id: 9
          },
          giveCoupon: {
            type: "bool",
            id: 10
          },
          startTime: {
            type: "string",
            id: 11
          },
          endTime: {
            type: "string",
            id: 12
          },
          status: {
            type: "int32",
            id: 13
          },
          imgUrl: {
            type: "string",
            id: 14
          },
          simpleRules: {
            type: "string",
            id: 15
          },
          addPoints: {
            type: "int32",
            id: 17
          },
          minusPoints: {
            type: "int32",
            id: 18
          },
          copywriterConfig: {
            type: "CopywriterConfig",
            id: 19
          },
          cardCopywriter: {
            type: "string",
            id: 20
          },
          cardImg: {
            type: "string",
            id: 21
          }
        }
      },
      BonusConfig: {
        fields: {
          bonusType: {
            type: "int32",
            id: 1
          },
          totalBonusAmount: {
            type: "int32",
            id: 2
          },
          bonusInfo: {
            rule: "repeated",
            type: "BonusInfo",
            id: 3
          }
        },
        nested: {
          BonusInfo: {
            fields: {
              rankingFrom: {
                type: "int32",
                id: 1
              },
              rankingTo: {
                type: "int32",
                id: 2
              },
              bonus: {
                type: "int32",
                id: 4
              }
            }
          }
        }
      },
      CopywriterConfig: {
        fields: {
          CopyWriting: {
            type: "string",
            id: 1
          },
          scoreInterval: {
            rule: "repeated",
            type: "ScoreInterval",
            id: 2
          }
        },
        nested: {
          ScoreInterval: {
            fields: {
              upperLimit: {
                type: "int32",
                id: 1
              },
              lowerLimit: {
                type: "int32",
                id: 2
              },
              percentage: {
                type: "int32",
                id: 3
              }
            }
          }
        }
      },
      TSServiceSatisfaction: {
        values: {
          ServiceSatisfactionInit: 0,
          ServiceSatisfactionUnsatisfied: 1,
          ServiceSatisfactionCommon: 2,
          ServiceSatisfactionSatisfied: 3
        }
      },
      CardRating: {
        fields: {
          point: {
            type: "CardPoint",
            id: 1
          },
          grade: {
            type: "int32",
            id: 2
          }
        }
      },
      AppraisalAttributeDetail: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          label: {
            type: "string",
            id: 2
          },
          value: {
            type: "string",
            id: 3
          },
          type: {
            type: "int32",
            id: 4
          }
        }
      },
      AdminButtonEnum: {
        values: {
          CancelOrder: 0,
          ConfirmReceive: 1,
          StartCheck: 2,
          CheckPass: 3,
          CheckFail: 4,
          AppraisalPass: 5,
          AppraisalFail: 6,
          AppraisalRefused: 7,
          SendBackSeller: 8,
          SendToBuyer: 9,
          Refund: 10,
          Remit: 11,
          Detail: 12,
          GoToAdd: 13,
          NoProcess: 14,
          RemitAgain: 15,
          RemitManually: 16
        }
      },
      AdminPublishFeedbackEnum: {
        values: {
          Default: 0,
          ToBeProcessed: 1,
          AlreadyProcessed: 2,
          NotProcessTemporarily: 3
        }
      },
      AskEnum: {
        values: {
          All: 0,
          PRE_SALE: 1,
          POST_SALE: 2
        }
      },
      Source: {
        values: {
          SourceAny: 0,
          SourceWechat: 1,
          SourceDouyin: 2,
          SourceTuringApp: 3
        }
      },
      AdminBargainStatus: {
        values: {
          AdminBargainAny: 0,
          AdminBargainStop: 1,
          AdminBargainNotStart: 2,
          AdminBargainNotStarting: 3,
          AdminBargainNotOver: 4,
          AdminBargainEndStart: 5
        }
      },
      AdminSellerProductStateEnum: {
        values: {
          AdminSellerProductStateEnum_ToBeBid: 0,
          AdminSellerProductStateEnum_OnSale: 1,
          AdminSellerProductStateEnum_SoldOut: 2,
          AdminSellerProductStateEnum_TemporaryClosed: 3,
          AdminSellerProductStateEnum_FavoriteClosed: 4
        }
      },
      WhiteListType: {
        values: {
          WhiteListTypeAny: 0,
          WhiteListTypeOnlineAppraisal: 1,
          WhiteListTypeOfflineAppraisal: 2,
          WhiteListTypeProductMarket: 3,
          WhiteListTypeGroundPromotion: 4,
          WhiteListTypeCCICAppraisal: 5
        }
      },
      EfficientState: {
        values: {
          EfficientStateAny: 0,
          EfficientStateToBeEfficient: 1,
          EfficientStateEfficient: 2,
          EfficientStateExpired: 3
        }
      },
      GroundPromotionEvent: {
        values: {
          GroundPromotionEventAny: 0,
          GroundPromotionEventConsignEvaluate: 1,
          GroundPromotionEventRecycleEvaluate: 2,
          GroundPromotionEventConsignRegister: 3,
          GroundPromotionEventRecycleRegister: 4
        }
      },
      AdminOpLog: {
        values: {
          AdminOpLogAny: 0,
          AdminOpLogSpu: 1,
          AdminOpLogSkc: 2,
          AdminOpLogSku: 3,
          AdminOpLogKind: 4,
          AdminOpLogBrand: 5,
          AdminOpLogSeries: 6,
          AdminOpLogColor: 7,
          AdminOpLogSize: 8,
          AdminOpLogMaterial: 9,
          AdminOpLogStyle: 10,
          AdminOpLogNews: 11,
          AdminOpLogService: 12
        }
      },
      PurchaseOrderState: {
        values: {
          PurchaseOrderStateAny: 0,
          PurchaseOrderStateToSubmit: 1,
          PurchaseOrderStateToAudit: 2,
          PurchaseOrderStateToReceive: 3,
          PurchaseOrderStateWarehousing: 4,
          PurchaseOrderStateEnd: 5
        }
      },
      PurchaseType: {
        values: {
          PurchaseTypeAny: 0,
          PurchaseTypeCOffline: 1,
          PurchaseTypeBOffline: 2,
          PurchaseTypeCRecycle: 3,
          PurchaseTypeCConsign: 4
        }
      },
      ProductPurchaseOfflineState: {
        values: {
          ProductPurchaseOfflineStateAny: 0,
          ProductPurchaseOfflineStateInit: 1,
          ProductPurchaseOfflineStateToAppraisal: 2,
          ProductPurchaseOfflineStateSkuToAudit: 3,
          ProductPurchaseOfflineStateToEvaluate: 4,
          ProductPurchaseOfflineStateToAudit: 5,
          ProductPurchaseOfflineStateToConfirm: 6,
          ProductPurchaseOfflineStateBack: 7,
          ProductPurchaseOfflineStateWarehouse: 8
        }
      },
      PurchaseOrderAction: {
        values: {
          PurchaseOrderActionAny: 0,
          PurchaseOrderActionSubmit: 1,
          PurchaseOrderActionAuditYes: 2,
          PurchaseOrderActionAuditNo: 3,
          PurchaseOrderActionReceive: 4,
          PurchaseOrderActionRemit: 5
        }
      },
      ProductPurchaseOfflineAction: {
        values: {
          ProductPurchaseOfflineActionAny: 0,
          ProductPurchaseOfflineActionAppraisalYes: 1,
          ProductPurchaseOfflineActionAppraisalNo: 2,
          ProductPurchaseOfflineActionSkuAuditYes: 3,
          ProductPurchaseOfflineActionEvaluation: 4,
          ProductPurchaseOfflineActionAuditYes: 5,
          ProductPurchaseOfflineActionAuditNo: 6,
          ProductPurchaseOfflineActionAgreeRecycle: 7,
          ProductPurchaseOfflineActionRefuseRecycle: 8
        }
      },
      SaleType: {
        values: {
          SaleTypeAny: 0,
          SaleTypeCOffline: 1,
          SaleTypeBOffline: 2,
          SaleTypeCOnline: 3
        }
      },
      SaleOrderState: {
        values: {
          SaleOrderStateAny: 0,
          SaleOrderStateToSubmit: 1,
          SaleOrderStateToAudit: 2,
          SaleOrderStateWarehouseOuting: 3,
          SaleOrderStateToDeliver: 4,
          SaleOrderStateEnd: 5
        }
      },
      ExpressPayType: {
        values: {
          ExpressPayTypeAny: 0,
          ExpressPayTypeConsignee: 1,
          ExpressPayTypeShipper: 2
        }
      },
      SaleOrderAction: {
        values: {
          SaleOrderActionAny: 0,
          SaleOrderActionSubmit: 1,
          SaleOrderActionAuditYes: 2,
          SaleOrderActionAuditNo: 3,
          SaleOrderActionWarehouseOut: 4,
          SaleOrderActionDeliver: 5
        }
      },
      ProductSaleState: {
        values: {
          ProductSaleStateAny: 0,
          ProductSaleStateSell: 1,
          ProductSaleStateSellLock: 2,
          ProductSaleStateSold: 3
        }
      },
      WarehouseInState: {
        values: {
          WarehouseInStateAny: 0,
          WarehouseInStateWait: 1,
          WarehouseInStateProcessing: 2,
          WarehouseInStateFinish: 3
        }
      },
      WarehouseOutType: {
        values: {
          WarehouseOutTypeAny: 0,
          WarehouseOutTypeCOnlineRecycle: 1,
          WarehouseOutTypeCOnlineConsign: 2,
          WarehouseOutTypeCOnlineSale: 3,
          WarehouseOutTypeCOfflineSale: 4,
          WarehouseOutTypeBOfflineSale: 5
        }
      },
      WarehouseOutState: {
        values: {
          WarehouseOutStateAny: 0,
          WarehouseOutStateProcessing: 1,
          WarehouseOutStateFinish: 2
        }
      },
      WarehouseProductState: {
        values: {
          WarehouseProductStateAny: 0,
          WarehouseProductStateStore: 1,
          WarehouseProductStateSelling: 2,
          WarehouseProductStateLock: 3,
          WarehouseProductStateSold: 4
        }
      },
      OnlineAppraisalType: {
        values: {
          TypeAny: 0,
          TypeQuick: 1,
          TypeCCIC: 2
        }
      },
      TSAdminTagUseState: {
        values: {
          TSAdminTagUseStateAny: 0,
          TSAdminTagUseStateUsed: 1,
          TSAdminTagUseStateUnUsed: 2
        }
      },
      TSAdminTaggedOrderSource: {
        values: {
          TaggedOrderSourceAny: 0,
          TaggedOrderSourceBusiness: 1
        }
      },
      TSAdminTaggedOrderBindState: {
        values: {
          TSAdminTaggedOrderBindStateAny: 0,
          TSAdminTaggedOrderBindStateBind: 1,
          TSAdminTaggedOrderBindStateNotBind: 2
        }
      },
      TSAdminTaggedOrderResult: {
        values: {
          TSAdminTaggedOrderResultAny: 0,
          TSAdminTaggedOrderResultSuccess: 1,
          TSAdminTaggedOrderResultFail: 2,
          TSAdminTaggedOrderRefuse: 3
        }
      },
      TSAppraisalPayWay: {
        values: {
          PayWayAny: 0,
          PayWayWechat: 1,
          PayWayAli: 2,
          PayWayCoupon: 3,
          PayWayPlatform: 4,
          PayWayWhiteList: 5,
          PayWayCard: 6,
          PayWayIosAppStore: 7,
          PayWayFirstOrder: 8,
          PayWayFamilyCard: 9,
          PayWayGooglePay: 10,
          PayWayPayPal: 11
        }
      },
      AdminPackageType: {
        values: {
          PTAny: 0,
          PTMonthly: 1,
          PTLimited: 2
        }
      },
      AdminAPIKind: {
        values: {
          KindAny: 0,
          KindAppraisal: 1,
          KindNewOrOld: 2,
          KindClassify: 3,
          KindCCIC: 4,
          KindInsureAppraisal: 5,
          KindPsVerify: 6
        }
      },
      AIServiceAppraisalSourceEnum: {
        values: {
          source_enum_init: 0,
          turing_appraisal: 1,
          zhier: 2,
          openplatform: 3,
          xianyu: 4,
          magic_cube_box: 5,
          cloud_storage: 6,
          bytedance: 7,
          openplatform_insure: 8,
          turing_appraisal_insure: 9,
          offline_appraisal: 10,
          gallery_review: 11,
          sign_system: 12,
          wei_ping_hui: 13,
          jd_shop: 14,
          customs: 15,
          xian_yu_yhb: 16,
          iva: 17,
          experience: 18,
          tusee: 19,
          douyin: 20,
          hotmax: 21
        }
      },
      TSOPAdminManualAppraisalOrderStatus: {
        values: {
          MAOS_Any: 0,
          MAOS_Positive: 1,
          MAOS_Nagetive: 2,
          MAOS_Failed: 3,
          MAOS_WaitAppraisal: 4
        }
      },
      TSOPPayMode: {
        values: {
          DefaultMode: 0,
          ModePrePay: 1,
          ModePostPay: 2,
          ModeBalancePay: 3
        }
      },
      TSOPInsureStatus: {
        values: {
          InsureStatusDefault: 0,
          InsureStatusSucceed: 1,
          InsureStatusFailed: 2,
          InsureStatusInProcess: 3
        }
      },
      TSCommonStatusEnum: {
        values: {
          CommonStatusAll: 0,
          CommonStatusEnable: 1,
          CommonStatusDisable: 2
        }
      },
      TSTagUseStateEnum: {
        values: {
          TagUseStateAll: 0,
          TagUseStateUsed: 1,
          TagUseStateUnuse: 2,
          TagUseStateWait: 3,
          TagUseStateAbandoned: 4
        }
      },
      TSTagMaterialStateEnum: {
        values: {
          TagMaterialStateAll: 0,
          TagMaterialStateWaitPrint: 1,
          TagMaterialStatePrinted: 2,
          TagMaterialStateShipped: 3
        }
      },
      TSTagTypeEnum: {
        values: {
          TagTypeAll: 0,
          TagTypeManualBind: 1,
          TagTypeAI: 2,
          TagTypeManual: 3
        }
      },
      TSTagBatchActionEnum: {
        values: {
          BatchActionAll: 0,
          BatchActionAbandon: 1,
          BatchActionPrint: 2,
          BatchActionShip: 3
        }
      },
      TSDoubleCheckGenuineEnum: {
        values: {
          DCG_All: 0,
          DCG_True: 1,
          DCG_False: 2,
          DCG_Unknow: 3,
          DCG_AddImage: 4
        }
      },
      NeedCheckOverallAppraisal: {
        values: {
          NeedCheckNone: 0,
          NeedCheckNo: 1,
          NeedCheckYes: 2
        }
      },
      AIToManualAppraisalResult: {
        values: {
          AIToManualAppraisalResultNot: 0,
          AIToManualAppraisalResultTrue: 1,
          AIToManualAppraisalResultFalse: 2,
          AIToManualAppraisalResultUnable: 3,
          AIToManualAppraisalResultNoNeed: 4,
          AIToManualAppraisalResultComplementImage: 5
        }
      },
      AIToManualAppraisalStatus: {
        values: {
          AIToManualAppraisalStatusInit: 0,
          AIToManualAppraisalStatusChecking: 1,
          AIToManualAppraisalStatusPass: 2,
          AIToManualAppraisalStatusNoPass: 3,
          AIToManualAppraisalStatusUnable: 4,
          AIToManualAppraisalStatusNone: 5,
          AIToManualAppraisalStatusComplementImage: 6
        }
      },
      ManualEvaluateStatus: {
        values: {
          ManualEvaluateStatusInit: 0,
          ManualEvaluateStatusChecking: 1,
          ManualEvaluateStatusPass: 2,
          ManualEvaluateStatusNoPass: 3
        }
      },
      OpenPackageType: {
        values: {
          OpenPkgTypeAny: 0,
          OpenPkgTypeMonthly: 1,
          OpenPkgTypeLimited: 2
        }
      },
      OpenAPIKind: {
        values: {
          OpenAPIKindAny: 0,
          OpenAPIKindAppraisal: 1,
          OpenAPIKindNewOrOld: 2,
          OpenAPIKindClassify: 3,
          OpenAPIKindCCICAppraisal: 4,
          OpenAPIKindInsureAppraisal: 5,
          OpenAPIKindPsVerify: 6
        }
      },
      OverallAppraisalReviewFinalResult: {
        values: {
          FinalResultNone: 0,
          FinalResultFalse: 1,
          FinalResultTrue: 2
        }
      },
      OverallAppraisalReviewDoubtStatus: {
        values: {
          OVERALL_APPRAISAL_REVIEW_DOUBT_STATUS_NONE: 0,
          OVERALL_APPRAISAL_REVIEW_DOUBT_STATUS_TRUE: 1,
          OVERALL_APPRAISAL_REVIEW_DOUBT_STATUS_FALSE: 2
        }
      },
      PsVerifyResult: {
        values: {
          PS_VERIFY_RESULT_DEFAULT: 0,
          PS_VERIFY_RESULT_NO_TAMPERING: 1,
          PS_VERIFY_RESULT_TAMPERED: 2,
          PS_VERIFY_RESULT_UNKNOWN: 3
        }
      },
      PsVerifyCategory: {
        values: {
          PS_VERIFY_CATEGORY_DEFAULT: 0,
          PS_VERIFY_CATEGORY_DOORWAY_PHOTO: 1,
          PS_VERIFY_CATEGORY_SPECIAL_QUALIFICATION: 2,
          PS_VERIFY_CATEGORY_OTHER: 3
        }
      },
      MembershipRenewWay: {
        values: {
          MEMBERSHIP_RENEW_WAY_DEFAULT: 0,
          MEMBERSHIP_RENEW_WAY_CONTINUOUS: 1,
          MEMBERSHIP_RENEW_WAY_NO_CONTINUOUS: 2
        }
      },
      MembershipCardType: {
        values: {
          MEMBERSHIP_CARD_TYPE_DEFAULT: 0,
          MEMBERSHIP_CARD_TYPE_MONTHLY: 1,
          MEMBERSHIP_CARD_TYPE_ANNUAL: 2,
          MEMBERSHIP_CARD_TYPE_EXPERIENCE: 3,
          MEMBERSHIP_CARD_TYPE_SEASON: 4,
          MEMBERSHIP_CARD_TYPE_SEMIANNUAL: 5,
          MEMBERSHIP_CARD_TYPE_PERIODIC: 6
        }
      },
      CommonConfigState: {
        values: {
          COMMON_CONFIG_STATE_DEFAULT: 0,
          COMMON_CONFIG_STATE_ENABLE: 1,
          COMMON_CONFIG_STATE_DISABLE: 2,
          COMMON_CONFIG_STATE_DELETE: 3
        }
      },
      MembershipCardState: {
        values: {
          MEMBERSHIP_CARD_STATE_DEFAULT: 0,
          MEMBERSHIP_CARD_STATE_NOT_VALID: 1,
          MEMBERSHIP_CARD_STATE_IN_EFFECT: 2,
          MEMBERSHIP_CARD_STATE_INVALID: 3
        }
      },
      MembershipRightType: {
        values: {
          MEMBERSHIP_RIGHT_TYPE_DEFAULT: 0,
          MEMBERSHIP_RIGHT_TYPE_APPRAISAL_DISCOUNT: 1,
          MEMBERSHIP_RIGHT_TYPE_APPRAISAL_FIX_PRICE: 2
        }
      },
      SupportAppraisalType: {
        values: {
          SUPPORT_APPRAISAL_TYPE_DEFAULT: 0,
          SUPPORT_APPRAISAL_TYPE_ALL: 1,
          SUPPORT_APPRAISAL_TYPE_AI_AND_MANUAL: 2,
          SUPPORT_APPRAISAL_TYPE_EXPERT: 3
        }
      },
      PayWay: {
        values: {
          PAY_WAY_DEFAULT: 0,
          PAY_WAY_WECHAT: 1,
          PAY_WAY_ALI: 2
        }
      },
      PayState: {
        values: {
          PAY_STATE_DEFAULT: 0,
          PAY_STATE_WAITED: 1,
          PAY_STATE_SUCCESS: 2,
          PAY_STATE_FAIL: 3,
          PAY_STATE_CANCEL: 4
        }
      },
      PayType: {
        values: {
          PAY_TYPE_DEFAULT: 0,
          PAY_TYPE_FIRST_PURCHASE: 1,
          PAY_TYPE_BUY_AGAIN: 2,
          PAY_TYPE_AUTO: 3
        }
      },
      AppraisalOrderType: {
        values: {
          APPRAISAL_ORDER_TYPE_DEFAULT: 0,
          APPRAISAL_ORDER_TYPE_AI: 1,
          APPRAISAL_ORDER_TYPE_MANUAL: 2,
          APPRAISAL_ORDER_TYPE_EXPERT: 3
        }
      },
      AppraisalResult: {
        values: {
          APPRAISAL_RESULT_DEFAULT: 0,
          APPRAISAL_RESULT_WAITING: 1,
          APPRAISAL_RESULT_TRUE: 2,
          APPRAISAL_RESULT_FALSE: 3,
          APPRAISAL_RESULT_UNKNOWN: 4
        }
      },
      AppraisalPayWay: {
        values: {
          APPRAISAL_PAY_WAY_DEFAULT: 0,
          APPRAISAL_PAY_WAY_FREE: 1,
          APPRAISAL_PAY_WAY_WECHAT: 2,
          APPRAISAL_PAY_WAY_ALIPAY: 3,
          APPRAISAL_PAY_WAY_COUPON: 4,
          APPRAISAL_PAY_WAY_WHITELIST: 5,
          APPRAISAL_PAY_WAY_CARD: 6
        }
      },
      AppraisalDiscountWay: {
        values: {
          APPRAISAL_DISCOUNT_WAY_DEFAULT: 0,
          APPRAISAL_DISCOUNT_WAY_CARD: 1,
          APPRAISAL_DISCOUNT_WAY_COUPON: 2,
          APPRAISAL_DISCOUNT_WAY_MEMBERSHIP: 3
        }
      },
      SkcMatchStatus: {
        values: {
          SKC_MATCH_STATUS_DEFAULT: 0,
          SKC_MATCH_STATUS_MATCHED: 1,
          SKC_MATCH_STATUS_NOT_MATCHED: 2,
          SKC_MATCH_STATUS_NO_NEED_TO_MATCH: 3
        }
      },
      ComplementImageStatus: {
        values: {
          COMPLEMENT_IMAGE_STATUS_DEFAULT: 0,
          COMPLEMENT_IMAGE_STATUS_NO: 1,
          COMPLEMENT_IMAGE_STATUS_YES: 2
        }
      },
      FamilyCardChannel: {
        values: {
          FAMILY_CARD_CHANNEL_DEFAULT: 0,
          FAMILY_CARD_CHANNEL_TURING: 1,
          FAMILY_CARD_CHANNEL_DOU_YIN: 2,
          FAMILY_CARD_CHANNEL_XIAO_HONG_SHU: 3
        }
      },
      FamilyCardExchangeStatus: {
        values: {
          FAMILY_CARD_EXCHANGE_STATUS_DEFAULT: 0,
          FAMILY_CARD_EXCHANGE_STATUS_YES: 1,
          FAMILY_CARD_EXCHANGE_STATUS_NO: 2
        }
      },
      FamilyCardEffectStatus: {
        values: {
          FAMILY_CARD_EFFECT_STATUS_DEFAULT: 0,
          FAMILY_CARD_EFFECT_STATUS_NOT_EFFECT: 1,
          FAMILY_CARD_EFFECT_STATUS_IN_EFFECT: 2,
          FAMILY_CARD_EFFECT_STATUS_IS_EXPIRED: 3
        }
      },
      Modified: {
        values: {
          MODIFIED_DEFAULT: 0,
          MODIFIED_YES: 1,
          MODIFIED_NO: 2
        }
      },
      SkinCheckScoreRange: {
        values: {
          SKIN_CHECK_SCORE_RANGE_DEFAULT: 0,
          SKIN_CHECK_SCORE_RANGE_1: 1,
          SKIN_CHECK_SCORE_RANGE_2: 2,
          SKIN_CHECK_SCORE_RANGE_3: 3
        }
      },
      SkinCheckResult: {
        values: {
          SKIN_CHECK_RESULT_DEFAULT: 0,
          SKIN_CHECK_RESULT_SUCCESS: 1,
          SKIN_CHECK_RESULT_FAIL: 2
        }
      },
      SkinCheckSource: {
        values: {
          SKIN_CHECK_SOURCE_DEFAULT: 0,
          SKIN_CHECK_SOURCE_TURING: 1,
          SKIN_CHECK_SOURCE_EXPERIENCE_CENTER: 2
        }
      },
      QueryDuration: {
        values: {
          CUSTOM: 0,
          TODAY: 1,
          YESTODAY: 2,
          TWO_DAYS_AGO: 3,
          SINCE_MONTH_BEGIN: 4,
          LAST_SEVEN_DAYS: 5,
          LAST_FIFTEEN_DAYS: 6,
          LAST_THIRTY_DAYS: 7,
          LAST_SIXTY_DAYS: 8,
          LAST_WEEK: 9,
          LAST_MONTH: 10
        }
      },
      UserType: {
        values: {
          ORDINARYUSER: 0,
          SMALLBUSSINESS: 1,
          ENTERPRISE: 2,
          STAFF: 3,
          TESTUSER: 4
        }
      },
      LoginType: {
        values: {
          WECHAT: 0,
          WEIBO: 1,
          APPLE: 2
        }
      },
      SelectedProductListEnum: {
        values: {
          SelectedProductListEnum_Default: 0,
          SelectedProductListEnum_PriceAscending: 1,
          SelectedProductListEnum_PriceDescending: 2,
          SelectedProductListEnum_NewProductFirst: 3
        }
      },
      SellerProductStateEnum: {
        values: {
          SellerProductStateEnum_ToBeBid: 0,
          SellerProductStateEnum_OnSale: 1,
          SellerProductStateEnum_SoldOut: 2,
          SellerProductStateEnum_TemporaryClosed: 3,
          SellerProductStateEnum_FavoriteClosed: 4
        }
      },
      CategoryEnum: {
        values: {
          CategoryEnum_Kind: 0,
          CategoryEnum_Brand: 1,
          CategoryEnum_Series: 2
        }
      },
      BuyerOrderStateEnum: {
        values: {
          BuyerOrderStateEnum_ToBePaid: 0,
          BuyerOrderStateEnum_ToBeDelivered: 1,
          BuyerOrderStateEnum_ToBeReceived: 2,
          BuyerOrderStateEnum_SuccessfulTrade: 3,
          BuyerOrderStateEnum_FailedTrade: 4
        }
      },
      BuyerOrderListStateEnum: {
        values: {
          BuyerOrderListStateEnum_ToBePaid: 0,
          BuyerOrderListStateEnum_SellerToDeliver: 1,
          BuyerOrderListStateEnum_DeliverToPlatform: 2,
          BuyerOrderListStateEnum_PlatformReceived: 3,
          BuyerOrderListStateEnum_PlatformAppraisal: 4,
          BuyerOrderListStateEnum_PlatformToDeliver: 5,
          BuyerOrderListStateEnum_PlatformHaDelivered: 6,
          BuyerOrderListStateEnum_SuccessfulTrade: 7,
          BuyerOrderListStateEnum_FailedTrade: 8
        }
      },
      SellerOrderStateEnum: {
        values: {
          SellerOrderStateEnum_OnSale: 0,
          SellerOrderStateEnum_ToBeDelivered: 1,
          SellerOrderStateEnum_HadDelivered: 2,
          SellerOrderStateEnum_SuccessfulTrade: 3,
          SellerOrderStateEnum_FailedTrade: 4
        }
      },
      SellerOrderListStateEnum: {
        values: {
          SellerOrderListStateEnum_ToBePaid: 0,
          SellerOrderListStateEnum_ToBeDeliver: 1,
          SellerOrderListStateEnum_DeliverToPlatform: 2,
          SellerOrderListStateEnum_PlatformReceived: 3,
          SellerOrderListStateEnum_PlatformAppraisal: 4,
          SellerOrderListStateEnum_SuccessfulTrade: 5,
          SellerOrderListStateEnum_FailedTrade: 6
        }
      },
      ProductSellStateEnum: {
        values: {
          ProductionSellStateEnum_Default: 0,
          ProductionSellStateEnum_InTransaction: 1,
          ProductionSellStateEnum_SoldOut: 2
        }
      },
      OrderButtonEnum: {
        values: {
          OrderButtonEnum_Closed: 0,
          OrderButtonEnum_AddOAID: 1,
          OrderButtonEnum_RenewOAID: 2,
          OrderButtonEnum_Offer: 3,
          OrderButtonEnum_PutOnShelf: 4,
          OrderButtonEnum_Delete: 5,
          OrderButtonEnum_Detail: 6,
          OrderButtonEnum_WannaDeliver: 7,
          OrderButtonEnum_NotSell: 8,
          OrderButtonEnum_Express: 9,
          OrderButtonEnum_Pay: 10,
          OrderButtonEnum_CancelOrder: 11,
          OrderButtonEnum_ConfirmAddress: 12,
          OrderButtonEnum_Edit: 13,
          OrderButtonEnum_Recycle: 14
        }
      },
      WalletRunningCountTypeEnum: {
        values: {
          WalletRunningCountTypeEnum_All: 0,
          WalletRunningCountTypeEnum_Income: 1,
          WalletRunningCountTypeEnum_Withdraw: 2,
          WalletRunningCountTypeEnum_EARecycle: 3,
          WalletRunningCountTypeEnum_Consign: 4,
          WalletRunningCountTypeEnum_ConsignAdvancePayment: 5,
          WalletRunningCountTypeEnum_Exchange: 6,
          WalletRunningCountTypeEnum_CloudStorageBuy: 7,
          WalletRunningCountTypeEnum_LotteryCash: 8,
          WalletRunningCountTypeEnum_DistributionCommission: 9,
          WalletRunningCountTypeEnum_ExpertAppraisal: 10
        }
      },
      AIServiceAppraisalOrderStateEnum: {
        values: {
          AIServiceAppraisalOrderStateEnum_All: 0,
          AIServiceAppraisalOrderStateEnum_Unpaid: 1,
          AIServiceAppraisalOrderStateEnum_True: 2,
          AIServiceAppraisalOrderStateEnum_False: 3,
          AIServiceAppraisalOrderStateEnum_Unknown: 4,
          AIServiceAppraisalOrderStateEnum_Wait: 5,
          AIServiceAppraisalOrderStateEnum_ComplementImage: 6
        }
      },
      RegisterType: {
        values: {
          WECAHT_DEFAULT: 0,
          WECAHT_WAVE_SISTER: 1,
          WECHAT_APPRAISAL_WELCOME: 2,
          WECHAT_DOUBLE_SEVENTH_WELCOME: 3,
          WECHAT_ZHIER: 4,
          WECHAT_SECKILL_WELCOME: 5,
          WECHAT_BYTE_WELCOME: 6,
          WECHAT_BARGAIN_WELCOME: 7
        }
      },
      ExpertAppraisalOrderStateEnum: {
        values: {
          ExpertAppraisalOrderStateEnum_ALL: 0,
          ExpertAppraisalOrderStateEnum_Unpaid: 1,
          ExpertAppraisalOrderStateEnum_True: 2,
          ExpertAppraisalOrderStateEnum_False: 3
        }
      },
      AppraisalType: {
        values: {
          AppraisalType_Unknown: 0,
          AppraisalType_AI: 1,
          AppraisalType_EA: 2
        }
      },
      EnableState: {
        values: {
          EnableState_All: 0,
          EnableState_Enabled: 1,
          EnableState_Disabled: 2
        }
      },
      IsSeckill: {
        values: {
          IsSeckill_All: 0,
          IsSeckill_Yes: 1,
          IsSeckill_No: 2
        }
      },
      AppraisalResultEnum: {
        values: {
          AppraisalResultEnum_None: 0,
          AppraisalResultEnum_True: 1,
          AppraisalResultEnum_False: 2,
          AppraisalResultEnum_Unknown: 3,
          AppraisalResultEnum_ComplementImage: 4
        }
      },
      SeckillButton: {
        values: {
          SeckillButtonAll: 0,
          GrapAtOnce: 1,
          SoldOut: 2,
          AlarmMe: 3,
          CancelAlarm: 4,
          SeckillClose: 5
        }
      },
      TimeState: {
        values: {
          TimeStateAll: 0,
          TimeStateUnderWay: 1,
          TimeStateBeforeStart: 2,
          TimeStateEnded: 3
        }
      },
      ServiceTypeEnum: {
        values: {
          ST_Mall: 0,
          ST_AIAppraisal: 1,
          ST_AIClassify: 2,
          ST_AIEvaluate: 3,
          ST_ExpertAppraisal: 4,
          ST_Consign: 5,
          ST_Recycle: 6,
          ST_Exchange: 7,
          ST_CCIC: 8,
          ST_Appraiser: 9,
          ST_ManualAppraisal: 10,
          ST_LargeModel: 11
        }
      },
      ProductDetailButton: {
        values: {
          ProductAny: 0,
          ProductSell: 1,
          ProductSold: 2,
          ProductTemporaryDown: 3,
          ProductPermanentDown: 4
        }
      },
      SubscribeState: {
        values: {
          SubscribeAny: 0,
          SubscribeYes: 1,
          SubscribeNo: 2
        }
      },
      AppPlatform: {
        values: {
          PlatformAny: 0,
          PlatformWechat: 1,
          PlatformByteDance: 2
        }
      },
      AppSource: {
        values: {
          AppSourceAny: 0,
          AppSourceWechatBXJ: 1,
          AppSourceByteDanceBXJ: 2,
          AppSourceH5: 3,
          AppSourceCloudStorage: 4,
          AppSourceTuringApp: 5,
          AppSourceTuringBaiDuMiniApp: 6,
          AppSourceTuringKuaiShouMiniApp: 7,
          AppSourceTuringWeiPingHui: 8,
          AppSourceJD: 9,
          APPSourceTuSee: 10,
          APPSourceOverseasH5: 11
        }
      },
      thirdSourcePlatform: {
        values: {
          PlatformBao: 0,
          PlatformFeiYu: 1,
          PlatformHongBuLin: 2,
          PlatformChenZhen: 3,
          PlatformSiKu: 4,
          PlatformXinShang: 5,
          PlatformZhiEr: 6,
          PlatformPangHu: 7,
          PlatformYiErSan: 8,
          PlatformMingJian: 9,
          PlatformBaiGe: 10
        }
      },
      OrderType: {
        values: {
          OrderTypeAny: 0,
          OrderTypeProduct: 1,
          OrderTypeAiAppraisal: 2,
          OrderTypeExpertAppraisal: 3,
          OrderTypeConsign: 4,
          OrderTypeRecycle: 5
        }
      },
      PersonalBuyState: {
        values: {
          BuyOrderListStateEnum_ToPay: 0,
          BuyOrderListStateEnum_ToDeliver: 1,
          BuyOrderListStateEnum_ToReceive: 2,
          BuyOrderListStateEnum_Complete: 3
        }
      },
      PersonalRecycleState: {
        values: {
          RecycleOrderListStateEnum_ToDeliver: 0,
          RecycleOrderListStateEnum_PlatformCheck: 1,
          RecycleOrderListStateEnum_ConfirmPrice: 2,
          RecycleOrderListStateEnum_Complete: 3
        }
      },
      PersonalConsignState: {
        values: {
          ConsignOrderListStateEnum_ToDeliver: 0,
          ConsignOrderListStateEnum_PlatformCheck: 1,
          ConsignOrderListStateEnum_ConfirmPrice: 2,
          ConsignOrderListStateEnum_PlatformSale: 3
        }
      },
      PersonalSaleState: {
        values: {
          SaleOrderListStateEnum_OnSale: 0,
          SaleOrderListStateEnum_ToDeliver: 1,
          SaleOrderListStateEnum_Received: 2,
          SaleOrderListStateEnum_Complete: 3
        }
      },
      PageEnum: {
        values: {
          PageEnum_Mall: 0,
          PageEnum_Live: 1,
          PageEnum_Sale: 2,
          PageEnum_Appraisal: 3,
          PageEnum_Homepage: 4,
          PageEnum_Exchange: 5
        }
      },
      YesOrNoChoice: {
        values: {
          YesOrNoChoiceAny: 0,
          YesOrNoChoiceYes: 1,
          YesOrNoChoiceNo: 2
        }
      },
      BargainMessage: {
        values: {
          BargainMessageAny: 0,
          BargainMessageNoSuccess: 1,
          BargainMessageOne: 2,
          BargainMessageSale: 3
        }
      },
      BargainLimitType: {
        values: {
          BargainLimitTypeAny: 0,
          BargainLimitTypeNotJoin: 1,
          BargainLimitTypeJoin: 2,
          BargainLimitTypeGlare: 3,
          BargainLimitTypeOver: 4
        }
      },
      BargainLimitState: {
        values: {
          BargainLimitStateAny: 0,
          BargainNOAndNotOrderAndStart: 1,
          BargainNOAndNotOrderAndEnd: 2,
          BargainNOAndNotOrderAndOver: 3,
          BargainNOAndOrderNotPayAndStart: 4,
          BargainNOAndOrderNotPayAndOver: 5,
          BargainNOAndOrderPayAndStart: 6,
          BargainNOAndOrderPayAndEnd: 7,
          BargainNOAndOrderPayAndOver: 8,
          BargainOKAndNotOrderAndStart: 9,
          BargainOKAndNotOrderAndEnd: 10,
          BargainOKAndNotOrderAndOver: 11,
          BargainOKAndOrderNotPayAndStart: 12,
          BargainOKAndOrderNotPayAndOver: 13,
          BargainOKAndOrderPayAndStart: 14,
          BargainOKAndOrderPayAndEnd: 15,
          BargainOKAndOrderPayAndOver: 16,
          BargainAgain: 17,
          BargainAllOkUser: 18,
          BargainAllOkUserOver: 19
        }
      },
      BargainPayMethods: {
        values: {
          BargainPayMethodsAny: 0,
          BargainPayMethodsOriginalPay: 1,
          BargainPayMethodsDiscountPay: 2,
          BargainPayMethodsAnonPay: 3,
          BargainPayMethodsPay: 4
        }
      },
      BargainOpMethods: {
        values: {
          BargainOpMethodsAny: 0,
          BargainOpMethodsSystem: 1,
          BargainOpMethodsUser: 2
        }
      },
      ProductOriginalType: {
        values: {
          BargainOpProductTypeAny: 0,
          BargainOpProductTypeSystem: 1,
          BargainOpProductTypeSeckill: 2,
          BargainOpProductTypeBargain: 3
        }
      },
      RecycleRegisterType: {
        values: {
          RecycleRegisterType_Default: 0,
          RecycleRegisterType_Recycle: 1,
          RecycleRegisterType_Consign: 2,
          RecycleRegisterType_OldForNew: 3
        }
      },
      ContactTime: {
        values: {
          ContactTime_Default: 0,
          ContactTime_AnyTime: 1,
          ContactTime_10to12: 2,
          ContactTime_13to15: 3,
          ContactTime_15to17: 4,
          ContactTime_17to19: 5,
          ContactTime_Weekend: 6
        }
      },
      BargainOpShare: {
        values: {
          BargainOpShareAny: 0,
          BargainOpShareCard: 1,
          BargainOpSharePoster: 2
        }
      },
      BaoOrderButtonEnum: {
        values: {
          BaoOrder_CancelOrder: 0,
          BaoOrder_ConfirmReceive: 1,
          BaoOrder_StartCheck: 2,
          BaoOrder_CheckPass: 3,
          BaoOrder_CheckFail: 4,
          BaoOrder_AppraisalPass: 5,
          BaoOrder_AppraisalFail: 6,
          BaoOrder_AppraisalRefused: 7,
          BaoOrder_SendBackSeller: 8,
          BaoOrder_SendToBuyer: 9,
          BaoOrder_Refund: 10,
          BaoOrder_Remit: 11,
          BaoOrder_Detail: 12,
          BaoOrder_GoToAdd: 13,
          BaoOrder_NoProcess: 14,
          BaoOrder_RemitAgain: 15,
          BaoOrder_RemitManually: 16
        }
      },
      IsActEnum: {
        values: {
          SecKill_BarGain: 0,
          SecKill_Act: 1,
          BarGain_Act: 2,
          SecKill_BarGain_NotReady: 3
        }
      },
      ExchangeProductStatusEnum: {
        values: {
          EPS_Init: 0,
          EPS_ToEvaluatePrice: 1,
          EPS_ConfirmPrice: 2,
          EPS_Matching: 3,
          EPS_Exchanging: 4,
          EPS_ExchangeSuccess: 5,
          EPS_ExchangeFailed: 6,
          EPS_ProductDown: 7,
          EPS_RejectConfirmPrice: 8
        }
      },
      PreShelveStatus: {
        values: {
          EPSS_UnKnow: 0,
          EPSS_ToEvaluatePrice: 1,
          EPSS_ConfirmPrice: 2,
          EPSS_CanNotEvaluatePrice: 3,
          EPSS_NotAgreeEvaluatePrice: 4,
          EPSS_CanNotAppraisal: 5
        }
      },
      UnShelveStatus: {
        values: {
          EPS_UnKnow: 0,
          EPS_Delete: 1,
          EPS_AdminDelete: 2,
          EPS_FailedAppraisal: 3
        }
      },
      ExchangeProductPayStatusEnum: {
        values: {
          EPPS_Init: 0,
          EPPS_ToEvaluatePrice: 1,
          EPPS_ConfirmPrice: 2,
          EPPS_Matching: 3
        }
      },
      ExchangeOrderBigStatusEnum: {
        values: {
          EOBS_Init: 0,
          EOBS_UserDeliver: 1,
          EOBS_Check: 2,
          EOBS_receive: 3,
          EOBS_Success: 4,
          EOBS_Fatal: 5
        }
      },
      ExchangeSbOrderStatusEnum: {
        values: {
          EOS_Init: 0,
          EOS_ToBeDeliver: 1,
          EOS_ToReceive: 2,
          EOS_Checking: 3,
          EOS_CheckYes: 4,
          EOS_Delivering: 5,
          EOSDelivered: 6,
          EOS_ExchangeFail: 7,
          EOS_ReceiveSuccess: 8,
          EOS_HasReturn: 9
        }
      },
      ExchangeStatus: {
        values: {
          ExchangeStatus_Default: 0,
          ExchangeStatus_Product: 1,
          ExchangeStatus_MatchOrder: 2,
          ExchangeStatus_Order: 3
        }
      },
      MatchOrderStatusEnum: {
        values: {
          MatchOrderStatus_Default: 0,
          MatchOrderStatus_Confirm: 1,
          MatchOrderStatus_Confirmed: 2,
          MatchOrderStatus_MyRefused: 3,
          MatchOrderStatus_OtherRefused: 4,
          MatchOrderStatus_Matching: 5
        }
      },
      MatchBigOrderStatusEnum: {
        values: {
          MatchBigOrderStatus_Default: 0,
          MatchBigOrderStatus_Confirm: 1,
          MatchBigOrderStatus_OtherConfirmed: 2,
          MatchBigOrderStatus_Success: 3,
          MatchBigOrderStatus_Matching: 4
        }
      },
      AdminMatchOrderListStatusEnum: {
        values: {
          MatchOrderListStatus_Default: 0,
          MatchOrderListStatus_EMOSToPay: 1,
          MatchOrderListStatus_EMOSHasPay: 2,
          MatchOrderListStatus_Refused: 3
        }
      },
      AdminMatchBigOrderListStatusEnum: {
        values: {
          MatchBigOrderListStatus_Default: 0,
          MatchBigOrderListStatus_EMToPay: 1,
          MatchBigOrderListStatus_EMAllPay: 2,
          MatchBigOrderListStatus_Failed: 3
        }
      },
      AIAppraisalType: {
        values: {
          OATAny: 0,
          OATQuick: 1,
          OATCCIC: 2
        }
      },
      PaymentType: {
        values: {
          PaymentType_Init: 0,
          PaymentType_WechatPay: 1,
          PaymentType_AliPay: 2
        }
      },
      PaySource: {
        values: {
          PaySource_Init: 0,
          PaySource_appraisalCard: 1,
          PaySource_appraisal: 2
        }
      },
      CouponChannel: {
        values: {
          CouponChannel_Init: 0,
          CouponChannel_Common: 1,
          CouponChannel_MiniPrograms: 2,
          CouponChannel_App: 3
        }
      },
      KindEnum: {
        values: {
          kindInit: 0,
          fashionPlay: 1,
          clothes: 2,
          accessories: 3,
          shoes: 4,
          bag: 5,
          wine: 6
        }
      },
      DBAppraisalResultEnum: {
        values: {
          DBAppraisalInit: 0,
          DBAppraisalWait: 1,
          DBAppraisalPass: 2,
          DBAppraisalFailed: 3,
          DBAppraisalRefuse: 4,
          DBAppraisalAddImage: 5,
          DBAppraisalAIPass: 6,
          DBAppraisalAIFailed: 7,
          DBAppraisalAIRefuse: 8
        }
      },
      AppraisalTypeEnum: {
        values: {
          AppraisalTypeEnum_Init: 0,
          AppraisalTypeEnum_AI: 1,
          AppraisalTypeEnum_Manual: 2
        }
      },
      AppraisalListReqEnum: {
        values: {
          AppraisalListReqEnum_Init: 0,
          AppraisalListReqEnum_Manual: 1,
          AppraisalListReqEnum_All: 2
        }
      },
      AIServiceAppraisalSourceH5Enum: {
        values: {
          H5source_enum_init: 0,
          H5turing_appraisal: 1,
          H5zhier: 2,
          H5openplatform: 3,
          H5xianyu: 4,
          H5magic_cube_box: 5,
          H5cloud_storage: 6,
          H5bytedance: 7
        }
      },
      CompetitionUserType: {
        values: {
          DEFAULT_COMPETITION_USER_TYPE: 0,
          COMMON_COMPETITION_USER: 1,
          Add_WHITELIST_COMPETITION_USER: 2,
          NEW_WHITELIST_COMPETITION_USER: 3,
          BLACKLIST_COMPETITION_USER: 4
        }
      },
      CompetitionType: {
        values: {
          DEFAULT_COMPETITION_TYPE: 0,
          PK_COMPETITION: 1,
          WEEK_COMPETITION: 2,
          SEASON_COMPETITION: 3,
          YEAR_COMPETITION: 4
        }
      },
      TSClassifyCheckResult: {
        values: {
          TSCCRInit: 0,
          TSCCRChecking: 1,
          TSCCRPass: 2,
          TSCCRNone: 3,
          TSCCRNotAccurateAndAll: 4,
          TSCCRAccurateButAll: 5,
          TSCCRAccurateIncorrect: 6
        }
      },
      TSTagType: {
        values: {
          TS_TAG_TYPE_DEFAULT: 0,
          TS_TAG_TYPE_NO: 1,
          TS_TAG_TYPE_AI: 2,
          TS_TAG_TYPE_MANUAL: 3
        }
      },
      AppraisalReportType: {
        values: {
          ReportTypeDefault: 0,
          ReportTypeWood: 1,
          ReportTypeYanHuoBao: 2,
          ReportTypeCoins: 3,
          ReportTypePorcelain: 4,
          ReportTypeCrab: 5,
          ReportTypeCard: 6,
          ReportTypeCardRating: 7
        }
      },
      CenterAddressType: {
        values: {
          CenterAddressTypeHome: 0,
          CenterAddressTypeExpertAppraisal: 1,
          CenterAddressTypeCardExpert: 2
        }
      },
      AINATResultEnum: {
        values: {
          AINATResultInit: 0,
          AINATResultYin: 1,
          AINATResultYangGuang: 2,
          AINATResultYangBao: 3,
          AINATResultNone: 4
        }
      },
      SoreThroatEnum: {
        values: {
          SoreThroatInit: 0,
          SoreThroatTrue: 1,
          SoreThroatFalse: 2
        }
      },
      SimilarSymptomsEnum: {
        values: {
          SimilarSymptomsInit: 0,
          SimilarSymptomsTrue: 1,
          SimilarSymptomsFalse: 2
        }
      },
      AISAppraiserLevel: {
        values: {
          AIS_APPRAISER_LEVEL_DEFAULT: 0,
          AIS_APPRAISER_LEVEL_JUNIOR: 1,
          AIS_APPRAISER_LEVEL_INTERMEDIATE: 2,
          AIS_APPRAISER_LEVEL_ADVANCED: 3,
          AIS_APPRAISER_LEVEL_PROFESSIONAL: 4,
          AIS_APPRAISER_LEVEL_CHIEF: 5
        }
      },
      ExternalLinkType: {
        values: {
          ExternalLinkTypeNone: 0,
          ExternalLinkTypeWeixin: 1,
          ExternalLinkTypeH5: 2,
          ExternalLinkTypeApp: 3
        }
      },
      ShowAppraiserInfo: {
        values: {
          ShowAppraiserInfoInit: 0,
          ShowAppraiserInfoTrue: 1,
          ShowAppraiserInfoFalse: 2
        }
      },
      ResponseTime: {
        values: {
          ResponseTimeNone: 0,
          ResponseTimeHalfHour: 1,
          ResponseTimeOneHour: 2,
          ResponseTimeThreeHours: 3,
          ResponseTimeSixHours: 4
        }
      },
      AppraisalProgressEnum: {
        values: {
          AppraisalProgressInit: 0,
          AppraisalProgressWait: 1,
          AppraisalProgressEnd: 2
        }
      },
      ArtificialFakeDisplayEnum: {
        values: {
          ArtificialFakeDisplayInit: 0,
          ArtificialFakeDisplayTrue: 1,
          ArtificialFakeDisplayEnumFalse: 2
        }
      },
      CardPoint: {
        values: {
          CARD_POINT_DEFAULT: 0,
          CARD_POINT_TOTAL: 1,
          CARD_POINT_CENTERING: 2,
          CARD_POINT_CORNERS: 3,
          CARD_POINT_EDGES: 4,
          CARD_POINT_SURFACE: 5
        }
      },
      FeedbackQuestionTypeEnum: {
        values: {
          FeedbackQuestionTypeInit: 0,
          FeedbackQuestionResultsSlow: 1,
          FeedbackQuestionExpensive: 2,
          FeedbackQuestionResultsInaccurate: 3,
          FeedbackQuestionDifficulty: 4,
          FeedbackQuestionVague: 5,
          FeedbackQuestionDiffToContact: 6,
          FeedbackQuestionCustomQuestions: 7
        }
      },
      UserChooseToManualStatus: {
        values: {
          USER_CHOOSE_TO_MANUAL_STATUS_DEFAULT: 0,
          USER_CHOOSE_TO_MANUAL_STATUS_YES: 1,
          USER_CHOOSE_TO_MANUAL_STATUS_NO: 2
        }
      },
      ExpertAppraisalType: {
        values: {
          EXPERT_APPRAISAL_TYPE_DEFAULT: 0,
          EXPERT_APPRAISAL_TYPE_COMMON: 1,
          EXPERT_APPRAISAL_TYPE_CARD: 2
        }
      },
      CardExpertAppraisalStatus: {
        values: {
          CARD_EXPERT_APPRAISAL_STATUS_DEFAULT: 0,
          CARD_EXPERT_APPRAISAL_STATUS_WAIT_USER_PAY: 1,
          CARD_EXPERT_APPRAISAL_STATUS_WAIT_USER_SEND: 2,
          CARD_EXPERT_APPRAISAL_STATUS_USER_SENT: 3,
          CARD_EXPERT_APPRAISAL_STATUS_PLATFORM_RECEIVED: 4,
          CARD_EXPERT_APPRAISAL_STATUS_PLATFORM_CHECKING: 5,
          CARD_EXPERT_APPRAISAL_STATUS_PLATFORM_CHECKED: 6,
          CARD_EXPERT_APPRAISAL_STATUS_PLATFORM_SEND_BACK: 7
        }
      },
      FamilyCardType: {
        values: {
          FAMILY_CARD_TYPE_DEFAULT: 0,
          FAMILY_CARD_TYPE_MONTHLY: 1,
          FAMILY_CARD_TYPE_SEASON: 2,
          FAMILY_CARD_TYPE_YEAR: 3
        }
      },
      PayStatus: {
        values: {
          PAY_STATUS_DEFAULT: 0,
          PAY_STATUS_YES: 1,
          PAY_STATUS_NO: 2
        }
      },
      FamilyCardStatus: {
        values: {
          FAMILY_CARD_STATUS_DEFAULT: 0,
          FAMILY_CARD_STATUS_IS_ACTIVE: 1,
          FAMILY_CARD_STATUS_IS_INVALID: 2
        }
      },
      FamilyCardOwnership: {
        values: {
          FAMILY_CARD_OWNERSHIP_DEFAULT: 0,
          FAMILY_CARD_OWNERSHIP_OWNER: 1,
          FAMILY_CARD_OWNERSHIP_SHARED_TO: 2
        }
      },
      FeedBackList: {
        fields: {
          userID: {
            type: "int32",
            id: 1
          },
          userName: {
            type: "string",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          productName: {
            type: "string",
            id: 5
          },
          productNum: {
            type: "int32",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          }
        }
      },
      StockList: {
        fields: {
          skc: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          productUrl: {
            type: "string",
            id: 3
          },
          colorName: {
            type: "string",
            id: 4
          },
          productNum: {
            type: "string",
            id: 5
          },
          kindName: {
            type: "string",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          status: {
            type: "string",
            id: 8
          },
          inventoryAvailableForSale: {
            type: "int32",
            id: 9
          },
          thirdPartyCountForSale: {
            type: "int32",
            id: 10
          },
          selfRunCountForSale: {
            type: "int32",
            id: 11
          },
          spu: {
            type: "string",
            id: 12
          },
          sku: {
            type: "string",
            id: 13
          }
        }
      },
      StockKindList: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      StockBrandList: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      StockSkuInfo: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          mainPic: {
            type: "string",
            id: 2
          },
          productCode: {
            type: "string",
            id: 3
          },
          sizeName: {
            type: "string",
            id: 4
          },
          measurement: {
            type: "string",
            id: 5
          },
          status: {
            type: "string",
            id: 6
          },
          sellPrice: {
            type: "int32",
            id: 7
          },
          serviceFee: {
            type: "int32",
            id: 8
          },
          thirdPartyCountForSale: {
            type: "int32",
            id: 9
          },
          selfRunCountForSale: {
            type: "int32",
            id: 10
          },
          pid: {
            type: "string",
            id: 11
          },
          skc: {
            type: "string",
            id: 12
          }
        }
      },
      StockDetailInfo: {
        fields: {
          productID: {
            type: "string",
            id: 1
          },
          sizeBriefName: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          newsName: {
            type: "string",
            id: 4
          },
          sellerPhone: {
            type: "string",
            id: 5
          },
          sellerName: {
            type: "string",
            id: 6
          },
          sellPrice: {
            type: "int32",
            id: 7
          },
          serviceFee: {
            type: "int32",
            id: 8
          },
          transferFee: {
            type: "int32",
            id: 9
          },
          arrivalPrice: {
            type: "int32",
            id: 10
          },
          identifyCode: {
            type: "string",
            id: 11
          },
          state: {
            type: "string",
            id: 12
          },
          creatTime: {
            type: "string",
            id: 13
          },
          cover: {
            type: "string",
            id: 14
          },
          selfRun: {
            type: "bool",
            id: 15
          },
          colorName: {
            type: "string",
            id: 16
          }
        }
      },
      StockDetailSize: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      StockDetailColour: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      StockDetailProductHandleRecord: {
        fields: {
          time: {
            type: "string",
            id: 1
          },
          operator: {
            type: "string",
            id: 2
          },
          event: {
            type: "string",
            id: 3
          }
        }
      },
      KindItem: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          kindCoverUrl: {
            type: "string",
            id: 3
          },
          sequence: {
            type: "int32",
            id: 4
          },
          state: {
            type: "int32",
            id: 5
          },
          serviceMall: {
            type: "string",
            id: 6
          },
          serviceAiAuthenticate: {
            type: "string",
            id: 7
          },
          serviceAiReadMap: {
            type: "string",
            id: 8
          },
          serviceAiEvaluate: {
            type: "string",
            id: 9
          },
          serviceExpertAppraisal: {
            type: "string",
            id: 10
          },
          serviceRecycle: {
            type: "string",
            id: 11
          },
          serviceSecondSell: {
            type: "string",
            id: 12
          },
          serviceCloudStock: {
            type: "string",
            id: 13
          },
          kindEnName: {
            type: "string",
            id: 14
          },
          serviceManualAuthenticate: {
            type: "string",
            id: 15
          },
          serviceCommunity: {
            type: "string",
            id: 16
          },
          serviceAppraiser: {
            type: "string",
            id: 17
          },
          serviceWph: {
            type: "string",
            id: 18
          },
          serviceJD: {
            type: "string",
            id: 19
          },
          serviceCustoms: {
            type: "string",
            id: 20
          },
          serviceIVA: {
            type: "string",
            id: 21
          },
          overseasKindCoverUrl: {
            type: "string",
            id: 22
          }
        }
      },
      SecondKindItem: {
        fields: {
          secondKindID: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          secondKindName: {
            type: "string",
            id: 3
          },
          sequence: {
            type: "int32",
            id: 4
          },
          state: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          }
        }
      },
      ThirdKindItem: {
        fields: {
          thirdKindID: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          secondKindName: {
            type: "string",
            id: 3
          },
          thirdKindName: {
            type: "string",
            id: 4
          },
          sequence: {
            type: "int32",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          },
          secondKindID: {
            type: "int32",
            id: 8
          }
        }
      },
      BrandTagItem: {
        fields: {
          tagId: {
            type: "int32",
            id: 1
          },
          tagName: {
            type: "string",
            id: 2
          },
          categoryId: {
            type: "int32",
            id: 3
          },
          categoryName: {
            type: "string",
            id: 4
          },
          order: {
            type: "int32",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          }
        }
      },
      BrandItem: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          brandName: {
            type: "string",
            id: 3
          },
          brandLogoUrl: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          },
          brandIntroduction: {
            type: "string",
            id: 8
          },
          serviceMall: {
            type: "string",
            id: 9
          },
          serviceAiAuthenticate: {
            type: "string",
            id: 10
          },
          serviceAiReadMap: {
            type: "string",
            id: 11
          },
          serviceAiEvaluate: {
            type: "string",
            id: 12
          },
          hotMall: {
            type: "string",
            id: 13
          },
          hotAiAuthenticate: {
            type: "string",
            id: 14
          },
          hotAiReadMap: {
            type: "string",
            id: 15
          },
          hotAiEvaluate: {
            type: "string",
            id: 16
          },
          hotSequence: {
            type: "int32",
            id: 17
          },
          serviceExpertAppraisal: {
            type: "string",
            id: 18
          },
          hotExpertAppraisal: {
            type: "string",
            id: 19
          },
          brandCoverUrl: {
            type: "string",
            id: 20
          },
          serviceRecycle: {
            type: "string",
            id: 21
          },
          serviceSecondSell: {
            type: "string",
            id: 22
          },
          hotRecycle: {
            type: "string",
            id: 23
          },
          hotSecondSell: {
            type: "string",
            id: 24
          },
          serviceManualAuthenticate: {
            type: "string",
            id: 25
          },
          hotManualAuthenticate: {
            type: "string",
            id: 26
          },
          tagList: {
            rule: "repeated",
            type: "BrandTagItem",
            id: 27
          },
          serviceWph: {
            type: "string",
            id: 28
          },
          mixedName: {
            type: "string",
            id: 29
          },
          serviceJD: {
            type: "string",
            id: 30
          },
          serviceCustoms: {
            type: "string",
            id: 31
          },
          serviceIVA: {
            type: "string",
            id: 32
          },
          overseasBrandCoverUrl: {
            type: "string",
            id: 33
          },
          serviceHotMax: {
            type: "string",
            id: 34
          },
          serviceEsteeLauder: {
            type: "string",
            id: 35
          }
        }
      },
      BrandDetail: {
        fields: {
          kindName: {
            type: "string",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          brandName: {
            type: "string",
            id: 3
          },
          brandCoverUrl: {
            type: "string",
            id: 4
          },
          state: {
            type: "string",
            id: 5
          },
          brandIntroduction: {
            type: "string",
            id: 6
          }
        }
      },
      SeriesItem: {
        fields: {
          seriesID: {
            type: "int32",
            id: 1
          },
          seriesName: {
            type: "string",
            id: 2
          },
          seriesCoverUrl: {
            type: "string",
            id: 3
          },
          brandEnName: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          },
          seriesIntroduction: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          brandID: {
            type: "int32",
            id: 9
          },
          serviceMall: {
            type: "string",
            id: 10
          },
          serviceAiAuthenticate: {
            type: "string",
            id: 11
          },
          serviceAiReadMap: {
            type: "string",
            id: 12
          },
          serviceAiEvaluate: {
            type: "string",
            id: 13
          },
          hotMall: {
            type: "string",
            id: 14
          },
          hotAiAuthenticate: {
            type: "string",
            id: 15
          },
          hotAiReadMap: {
            type: "string",
            id: 16
          },
          hotAiEvaluate: {
            type: "string",
            id: 17
          },
          sequence: {
            type: "int32",
            id: 18
          },
          hotSequence: {
            type: "int32",
            id: 19
          },
          serviceExpertAppraisal: {
            type: "string",
            id: 20
          },
          hotExpertAppraisal: {
            type: "string",
            id: 21
          },
          serviceRecycle: {
            type: "string",
            id: 22
          },
          serviceSecondSell: {
            type: "string",
            id: 23
          },
          hotRecycle: {
            type: "string",
            id: 24
          },
          hotSecondSell: {
            type: "string",
            id: 25
          },
          kindEnName: {
            type: "string",
            id: 26
          },
          serviceManualAuthenticate: {
            type: "string",
            id: 27
          },
          hotManualAuthenticate: {
            type: "string",
            id: 28
          },
          serviceWph: {
            type: "string",
            id: 29
          },
          createTime: {
            type: "string",
            id: 30
          },
          serviceJD: {
            type: "string",
            id: 31
          },
          serviceCustoms: {
            type: "string",
            id: 32
          },
          serviceIVA: {
            type: "string",
            id: 33
          },
          seriesEnName: {
            type: "string",
            id: 34
          },
          overseasSeriesCoverUrl: {
            type: "string",
            id: 35
          },
          serviceHotMax: {
            type: "string",
            id: 36
          },
          serviceEsteeLauder: {
            type: "string",
            id: 37
          }
        }
      },
      SeriesDetail: {
        fields: {
          kindName: {
            type: "string",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          seriesName: {
            type: "string",
            id: 3
          },
          seriesCoverUrl: {
            type: "string",
            id: 4
          },
          state: {
            type: "string",
            id: 5
          },
          seriesIntroduction: {
            type: "string",
            id: 6
          },
          seriesEnName: {
            type: "string",
            id: 7
          }
        }
      },
      ColorItem: {
        fields: {
          colorID: {
            type: "int32",
            id: 1
          },
          colorName: {
            type: "string",
            id: 2
          },
          colorValue: {
            type: "string",
            id: 3
          },
          state: {
            type: "string",
            id: 4
          }
        }
      },
      SizeItem: {
        fields: {
          sizeID: {
            type: "int32",
            id: 1
          },
          sizeName: {
            type: "string",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          sequence: {
            type: "int32",
            id: 4
          },
          state: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          }
        }
      },
      MaterialItem: {
        fields: {
          materialID: {
            type: "int32",
            id: 1
          },
          materialName: {
            type: "string",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          }
        }
      },
      StyleItem: {
        fields: {
          styleItemID: {
            type: "int32",
            id: 1
          },
          styleName: {
            type: "string",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          }
        }
      },
      NewsItem: {
        fields: {
          newsID: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          newsAbbreviation: {
            type: "string",
            id: 3
          },
          newsDescription: {
            type: "string",
            id: 4
          },
          newsName: {
            type: "string",
            id: 5
          },
          sequence: {
            type: "int32",
            id: 6
          },
          state: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          }
        }
      },
      ProductItem: {
        fields: {
          skcID: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          productMainImgUrl: {
            type: "string",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          productCode: {
            type: "string",
            id: 6
          },
          state: {
            type: "string",
            id: 7
          },
          productID: {
            type: "int32",
            id: 8
          },
          brandEnName: {
            type: "string",
            id: 9
          },
          serviceMall: {
            type: "string",
            id: 10
          },
          serviceAiAuthenticate: {
            type: "string",
            id: 11
          },
          serviceAiReadMap: {
            type: "string",
            id: 12
          },
          serviceAiEvaluate: {
            type: "string",
            id: 13
          },
          AiReadMapSetCount: {
            type: "int32",
            id: 14
          },
          skuStatus: {
            type: "string",
            id: 15
          },
          middleAges: {
            type: "string",
            id: 16
          },
          seriesName: {
            type: "string",
            id: 17
          },
          account: {
            type: "string",
            id: 18
          },
          updateTime: {
            type: "string",
            id: 19
          },
          serviceRecycle: {
            type: "string",
            id: 20
          },
          serviceSecondSell: {
            type: "string",
            id: 21
          }
        }
      },
      CountryPrice: {
        fields: {
          countryCode: {
            type: "string",
            id: 1
          },
          price: {
            type: "int32",
            id: 2
          }
        }
      },
      NewsPrice: {
        fields: {
          newsId: {
            type: "string",
            id: 1
          },
          price: {
            type: "int32",
            id: 2
          },
          minPrice: {
            type: "int32",
            id: 3
          },
          newsName: {
            type: "string",
            id: 4
          }
        }
      },
      ProductBasicInformation: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          secondKindID: {
            type: "int32",
            id: 2
          },
          thirdKindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          productName: {
            type: "string",
            id: 5
          },
          produceNum: {
            type: "string",
            id: 6
          },
          releaseDate: {
            type: "string",
            id: 7
          },
          releasePrice: {
            type: "int32",
            id: 8
          },
          colorID: {
            type: "int32",
            id: 9
          },
          colorName: {
            type: "string",
            id: 10
          },
          skuList: {
            rule: "repeated",
            type: "SkuList",
            id: 11
          },
          imgsInfo: {
            rule: "repeated",
            type: "ImgsInfo",
            id: 12
          },
          kindName: {
            type: "string",
            id: 13
          },
          secondKindName: {
            type: "string",
            id: 14
          },
          thirdKindName: {
            type: "string",
            id: 15
          },
          brandName: {
            type: "string",
            id: 16
          },
          skcID: {
            type: "string",
            id: 17
          },
          serviceMall: {
            type: "string",
            id: 18
          },
          serviceAiAuthenticate: {
            type: "string",
            id: 19
          },
          serviceAiReadMap: {
            type: "string",
            id: 20
          },
          serviceAiEvaluate: {
            type: "string",
            id: 21
          },
          aiReadMapSet: {
            rule: "repeated",
            type: "AiImgsSetInfo",
            id: 22
          },
          brandEnName: {
            type: "string",
            id: 23
          },
          countryPrice: {
            rule: "repeated",
            type: "CountryPrice",
            id: 24
          },
          description: {
            type: "string",
            id: 25
          },
          serviceRecycle: {
            type: "string",
            id: 26
          },
          serviceSecondSell: {
            type: "string",
            id: 27
          },
          newsPrice: {
            rule: "repeated",
            type: "NewsPrice",
            id: 28
          }
        }
      },
      ProductAccessoryInformation: {
        fields: {
          seriesID: {
            type: "int32",
            id: 1
          },
          origin: {
            type: "string",
            id: 2
          },
          forPeople: {
            type: "string",
            id: 3
          },
          materialStr: {
            type: "string",
            id: 4
          },
          styleStr: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          materialStrID: {
            type: "string",
            id: 7
          },
          styleStrID: {
            type: "string",
            id: 8
          },
          middleAges: {
            type: "string",
            id: 9
          }
        }
      },
      SkuList: {
        fields: {
          sizeID: {
            type: "int32",
            id: 1
          },
          measurement: {
            type: "string",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          isCreate: {
            type: "bool",
            id: 4
          },
          skcID: {
            type: "string",
            id: 5
          },
          sizeName: {
            type: "string",
            id: 6
          },
          ID: {
            type: "int32",
            id: 7
          },
          skuCode: {
            type: "string",
            id: 8
          }
        }
      },
      ImgsInfo: {
        fields: {
          url: {
            type: "string",
            id: 1
          },
          checked: {
            type: "int32",
            id: 2
          },
          isCreate: {
            type: "bool",
            id: 3
          },
          imgID: {
            type: "int32",
            id: 4
          },
          skcID: {
            type: "string",
            id: 5
          }
        }
      },
      AiImgsSetInfo: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          },
          skcID: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          isCreate: {
            type: "bool",
            id: 4
          }
        }
      },
      KindSelectItem: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          status: {
            type: "int32",
            id: 3
          }
        }
      },
      SecondKindSelectItem: {
        fields: {
          secondKindID: {
            type: "int32",
            id: 1
          },
          secondKindName: {
            type: "string",
            id: 2
          }
        }
      },
      ThirdKindSelectItem: {
        fields: {
          thirdKindID: {
            type: "int32",
            id: 1
          },
          thirdKindName: {
            type: "string",
            id: 2
          }
        }
      },
      BrandSelectItem: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          mixedName: {
            type: "string",
            id: 3
          }
        }
      },
      SeriesSelectItem: {
        fields: {
          seriesID: {
            type: "int32",
            id: 1
          },
          seriesName: {
            type: "string",
            id: 2
          }
        }
      },
      SizeSelectItem: {
        fields: {
          sizeID: {
            type: "int32",
            id: 1
          },
          sizeName: {
            type: "string",
            id: 2
          }
        }
      },
      ComprehensiveInfoItem: {
        fields: {
          sizeList: {
            rule: "repeated",
            type: "SizeItem",
            id: 1
          },
          styleList: {
            rule: "repeated",
            type: "StyleItem",
            id: 2
          },
          materialList: {
            rule: "repeated",
            type: "MaterialItem",
            id: 3
          },
          colorList: {
            rule: "repeated",
            type: "ColorItem",
            id: 4
          }
        }
      },
      ForPeopleItem: {
        fields: {
          forPeopleID: {
            type: "int32",
            id: 1
          },
          forPeopleName: {
            type: "string",
            id: 2
          }
        }
      },
      AdminOrderBrief: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          buyerPhone: {
            type: "string",
            id: 2
          },
          buyerNickname: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          },
          productName: {
            type: "string",
            id: 5
          },
          productPrice: {
            type: "int32",
            id: 6
          },
          actualPrice: {
            type: "int32",
            id: 7
          },
          state: {
            type: "string",
            id: 8
          },
          orderTime: {
            type: "string",
            id: 9
          },
          sellerExpressNo: {
            type: "string",
            id: 10
          },
          stateText: {
            type: "string",
            id: 11
          },
          buttonList: {
            rule: "repeated",
            type: "AdminButton",
            id: 12
          },
          isSeckill: {
            type: "bool",
            id: 13
          },
          avatarHDImage: {
            type: "string",
            id: 14
          },
          newsName: {
            type: "string",
            id: 15
          },
          appSource: {
            type: "AppSource",
            id: 16
          },
          orderType: {
            type: "string",
            id: 17
          }
        }
      },
      AdminBaseOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          productPrice: {
            type: "int32",
            id: 3
          },
          sellerDeliverTime: {
            type: "string",
            id: 4
          },
          platformReceiveTime: {
            type: "string",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          },
          payType: {
            type: "string",
            id: 7
          },
          deliverFee: {
            type: "int32",
            id: 8
          },
          sellerExpressNo: {
            type: "string",
            id: 9
          },
          platformDeliverTime: {
            type: "string",
            id: 10
          },
          orderTime: {
            type: "string",
            id: 11
          },
          payTime: {
            type: "string",
            id: 12
          },
          actualPay: {
            type: "int32",
            id: 13
          },
          platformExpressNo: {
            type: "string",
            id: 14
          },
          stateText: {
            type: "string",
            id: 15
          }
        }
      },
      BuyerAddressInfo: {
        fields: {
          buyerPhone: {
            type: "string",
            id: 1
          },
          nickname: {
            type: "string",
            id: 2
          },
          addressee: {
            type: "string",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          },
          address: {
            type: "string",
            id: 5
          }
        }
      },
      ProductBaseInfo: {
        fields: {
          skc: {
            type: "string",
            id: 1
          },
          itemID: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          kind: {
            type: "string",
            id: 4
          },
          brand: {
            type: "string",
            id: 5
          },
          name: {
            type: "string",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          series: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          people: {
            type: "string",
            id: 11
          },
          material: {
            type: "string",
            id: 12
          },
          style: {
            type: "string",
            id: 13
          },
          releasePrice: {
            type: "int32",
            id: 14
          },
          releaseTime: {
            type: "string",
            id: 15
          },
          kindId: {
            type: "int32",
            id: 16
          }
        }
      },
      ProductImageInfo: {
        fields: {
          recordId: {
            type: "int32",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          position: {
            type: "string",
            id: 3
          },
          required: {
            type: "bool",
            id: 4
          }
        }
      },
      SellerProductInfo: {
        fields: {
          quality: {
            type: "string",
            id: 1
          },
          sellPrice: {
            type: "int32",
            id: 2
          },
          arrivalPrice: {
            type: "int32",
            id: 3
          },
          serviceFee: {
            type: "int32",
            id: 4
          },
          transferFee: {
            type: "int32",
            id: 5
          },
          sendWord: {
            type: "string",
            id: 6
          },
          imageList: {
            rule: "repeated",
            type: "string",
            id: 7
          },
          imgList: {
            rule: "repeated",
            type: "ProductImageInfo",
            id: 8
          },
          serviceFeeRate: {
            type: "string",
            id: 9
          },
          transferFeeRate: {
            type: "string",
            id: 10
          },
          selfRun: {
            type: "bool",
            id: 11
          }
        }
      },
      SellerBackAddressInfo: {
        fields: {
          username: {
            type: "string",
            id: 1
          },
          nickname: {
            type: "string",
            id: 2
          },
          addressee: {
            type: "string",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          },
          address: {
            type: "string",
            id: 5
          }
        }
      },
      AdminButton: {
        fields: {
          buttonText: {
            type: "string",
            id: 1
          },
          buttonEnum: {
            type: "AdminButtonEnum",
            id: 2
          }
        }
      },
      AdminLogInfo: {
        fields: {
          createTime: {
            type: "string",
            id: 1
          },
          operator: {
            type: "string",
            id: 2
          },
          event: {
            type: "string",
            id: 3
          }
        }
      },
      WalletDetailItem: {
        fields: {
          userPhone: {
            type: "string",
            id: 1
          },
          tradeTime: {
            type: "string",
            id: 3
          },
          money: {
            type: "string",
            id: 4
          },
          balance: {
            type: "int32",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          },
          orderNum: {
            type: "string",
            id: 7
          },
          productName: {
            type: "string",
            id: 9
          },
          runningType: {
            type: "WalletRunningCountTypeEnum",
            id: 12
          },
          tradeSerial: {
            type: "string",
            id: 13
          }
        },
        reserved: [
          [
            2,
            2
          ],
          [
            8,
            8
          ],
          [
            10,
            10
          ],
          [
            11,
            11
          ]
        ]
      },
      TradeFlowItem: {
        fields: {
          flowNum: {
            type: "string",
            id: 1
          },
          tradeType: {
            type: "string",
            id: 2
          },
          tradeTime: {
            type: "string",
            id: 3
          },
          tradeMoney: {
            type: "string",
            id: 4
          },
          tradeChannel: {
            type: "string",
            id: 5
          },
          merchantAccount: {
            type: "string",
            id: 6
          },
          serialNumOfPaymentChannel: {
            type: "string",
            id: 7
          },
          userPhone: {
            type: "string",
            id: 8
          },
          orderNum: {
            type: "string",
            id: 9
          },
          tradeState: {
            type: "string",
            id: 10
          },
          changeType: {
            type: "string",
            id: 11
          },
          button: {
            rule: "repeated",
            type: "AdminButton",
            id: 12
          },
          tradeTypeNo: {
            type: "string",
            id: 13
          },
          appSource: {
            type: "AppSource",
            id: 14
          },
          email: {
            type: "string",
            id: 15
          }
        }
      },
      HotItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          hotName: {
            type: "string",
            id: 2
          },
          sequence: {
            type: "int32",
            id: 3
          },
          state: {
            type: "string",
            id: 4
          },
          startTime: {
            type: "string",
            id: 5
          },
          endTime: {
            type: "string",
            id: 6
          },
          createTime: {
            type: "string",
            id: 7
          },
          isDefault: {
            type: "string",
            id: 8
          },
          type: {
            type: "string",
            id: 9
          }
        }
      },
      SearchItem: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          },
          mainPic: {
            type: "string",
            id: 3
          },
          newsName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          brandEnName: {
            type: "string",
            id: 7
          },
          productName: {
            type: "string",
            id: 8
          },
          actualPrice: {
            type: "string",
            id: 9
          },
          releasePrice: {
            type: "string",
            id: 10
          },
          cover: {
            type: "string",
            id: 11
          },
          relatedOaID: {
            type: "string",
            id: 12
          },
          isSeckillProduct: {
            type: "bool",
            id: 13
          },
          seckillPrice: {
            type: "uint32",
            id: 14
          },
          seckillState: {
            type: "TimeState",
            id: 15
          },
          seckillEndLeft: {
            type: "string",
            id: 16
          },
          skc: {
            type: "string",
            id: 17
          },
          typeProduct: {
            type: "ProductOriginalType",
            id: 18
          },
          activityId: {
            type: "uint32",
            id: 19
          },
          isOfficial: {
            type: "bool",
            id: 20
          }
        }
      },
      AdminPublishFeedback: {
        fields: {
          feedbackNum: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          nickname: {
            type: "string",
            id: 3
          },
          kind: {
            type: "string",
            id: 4
          },
          brand: {
            type: "string",
            id: 5
          },
          productName: {
            type: "string",
            id: 6
          },
          attribute: {
            type: "string",
            id: 7
          },
          state: {
            type: "string",
            id: 8
          },
          buttonList: {
            rule: "repeated",
            type: "AdminButton",
            id: 12
          },
          createTime: {
            type: "int64",
            id: 13
          }
        }
      },
      FeedbackProductBaseInfo: {
        fields: {
          kind: {
            type: "string",
            id: 1
          },
          brand: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          attribute: {
            type: "string",
            id: 4
          },
          newDegree: {
            type: "string",
            id: 5
          },
          sellPrice: {
            type: "int32",
            id: 6
          },
          account: {
            type: "string",
            id: 7
          },
          description: {
            type: "string",
            id: 8
          }
        }
      },
      SelectItem: {
        fields: {
          itemID: {
            type: "int32",
            id: 1
          },
          itemName: {
            type: "string",
            id: 2
          }
        }
      },
      PointItem: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          hierarchy: {
            type: "string",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesID: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          sequence: {
            type: "int32",
            id: 10
          },
          important: {
            type: "string",
            id: 11
          },
          status: {
            type: "string",
            id: 12
          },
          exampleImage: {
            type: "string",
            id: 13
          },
          must: {
            type: "int32",
            id: 14
          },
          pointType: {
            type: "int32",
            id: 15
          },
          seriousType: {
            type: "int32",
            id: 16
          }
        }
      },
      ManualPointItem: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          hierarchy: {
            type: "string",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesID: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          sequence: {
            type: "int32",
            id: 10
          },
          important: {
            type: "string",
            id: 11
          },
          status: {
            type: "string",
            id: 12
          },
          exampleImage: {
            type: "string",
            id: 13
          },
          must: {
            type: "int32",
            id: 14
          },
          seriousType: {
            type: "int32",
            id: 15
          }
        }
      },
      PointComment: {
        fields: {
          commentId: {
            type: "int32",
            id: 1
          },
          comment: {
            type: "string",
            id: 2
          }
        }
      },
      OverallAppraisalRecordItem: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          },
          OAID: {
            type: "string",
            id: 2
          },
          genuine: {
            type: "string",
            id: 3
          },
          hierarchy: {
            type: "string",
            id: 4
          },
          kindID: {
            type: "int32",
            id: 5
          },
          kindName: {
            type: "string",
            id: 6
          },
          brandID: {
            type: "int32",
            id: 7
          },
          brandName: {
            type: "string",
            id: 8
          },
          seriesID: {
            type: "int32",
            id: 9
          },
          seriesName: {
            type: "string",
            id: 10
          },
          appraisalTime: {
            type: "string",
            id: 11
          },
          source: {
            type: "string",
            id: 12
          },
          grade: {
            type: "string",
            id: 13
          },
          note: {
            type: "string",
            id: 14
          },
          aiSource: {
            type: "AIServiceAppraisalSourceEnum",
            id: 15
          },
          reAppraisalResult: {
            type: "int32",
            id: 16
          },
          needCheck: {
            type: "NeedCheckOverallAppraisal",
            id: 17
          },
          manualAppraisalStatus: {
            type: "AIToManualAppraisalStatus",
            id: 18
          },
          manualEvaluateStatus: {
            type: "ManualEvaluateStatus",
            id: 19
          },
          classifyCheckResult: {
            type: "TSClassifyCheckResult",
            id: 20
          },
          recheckH5Url: {
            type: "string",
            id: 21,
            options: {
              deprecated: true
            }
          },
          appraisalAdminUrl: {
            type: "string",
            id: 22
          },
          isFinalResult: {
            type: "bool",
            id: 23
          },
          isImport: {
            type: "bool",
            id: 24
          },
          doubtStatus: {
            type: "OverallAppraisalReviewDoubtStatus",
            id: 25
          },
          skcMatchStatus: {
            type: "SkcMatchStatus",
            id: 26
          },
          matchSkc: {
            type: "string",
            id: 27
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 28
          },
          appraisalSourceName: {
            type: "string",
            id: 29
          }
        }
      },
      AppraisalKindItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalBrandItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalSeriesItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalPriceItem: {
        fields: {
          priceID: {
            type: "int32",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          status: {
            type: "string",
            id: 4
          },
          price: {
            type: "int32",
            id: 5
          },
          buttonText: {
            type: "string",
            id: 6
          }
        }
      },
      AppraisalActivityItem: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          jumpURL: {
            type: "string",
            id: 2
          },
          imageURL: {
            type: "string",
            id: 3
          },
          status: {
            type: "string",
            id: 4
          },
          activityID: {
            type: "int32",
            id: 5
          },
          description: {
            type: "string",
            id: 6
          }
        }
      },
      AppraisalOrderItem: {
        fields: {
          orderID: {
            type: "int32",
            id: 1
          },
          appraisalTime: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          OAID: {
            type: "string",
            id: 4
          },
          userAccount: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          brandID: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesID: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          },
          exteriorImg: {
            type: "string",
            id: 12
          },
          totalAmount: {
            type: "int32",
            id: 13
          },
          payWay: {
            type: "string",
            id: 14
          },
          payState: {
            type: "string",
            id: 15
          },
          result: {
            type: "string",
            id: 16
          },
          feedback: {
            type: "string",
            id: 17
          },
          registerTime: {
            type: "string",
            id: 18
          },
          source: {
            type: "string",
            id: 19
          },
          UID: {
            type: "int32",
            id: 20
          },
          grade: {
            type: "string",
            id: 21
          },
          appraisalSource: {
            type: "Source",
            id: 22
          },
          appSource: {
            type: "AppSource",
            id: 23
          },
          CardNo: {
            type: "string",
            id: 24
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 25
          },
          rating: {
            type: "int32",
            id: 26
          },
          commentary: {
            type: "string",
            id: 27
          },
          remark: {
            type: "string",
            id: 28
          },
          manualAppraisalStatus: {
            type: "AIToManualAppraisalStatus",
            id: 29
          },
          feedbackTime: {
            type: "string",
            id: 30
          },
          serviceSatisfaction: {
            type: "string",
            id: 31
          },
          countryCode: {
            type: "string",
            id: 32
          },
          isArtificialFakeDisplay: {
            type: "ArtificialFakeDisplayEnum",
            id: 33
          },
          email: {
            type: "string",
            id: 34
          },
          chooseToManual: {
            type: "UserChooseToManualStatus",
            id: 35
          }
        }
      },
      TagAppraisalOrder: {
        fields: {
          orderID: {
            type: "int32",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          },
          appSource: {
            type: "AppSource",
            id: 3
          },
          oaid: {
            type: "string",
            id: 4
          },
          phone: {
            type: "string",
            id: 5
          },
          registerTime: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          },
          kindName: {
            type: "string",
            id: 8
          },
          brandID: {
            type: "int32",
            id: 9
          },
          brandName: {
            type: "string",
            id: 10
          },
          seriesID: {
            type: "int32",
            id: 11
          },
          seriesName: {
            type: "string",
            id: 12
          },
          exteriorImg: {
            type: "string",
            id: 13
          },
          totalAmount: {
            type: "int32",
            id: 14
          },
          payWay: {
            type: "string",
            id: 15
          },
          payState: {
            type: "string",
            id: 16
          },
          genuine: {
            type: "string",
            id: 17
          },
          appraisalTime: {
            type: "string",
            id: 18
          },
          bindPlatform: {
            type: "string",
            id: 19
          },
          serialNum: {
            type: "string",
            id: 20
          },
          grade: {
            type: "string",
            id: 21
          },
          tagType: {
            type: "TSTagType",
            id: 22
          },
          manualResult: {
            type: "int32",
            id: 23
          }
        }
      },
      ManualAppraisalOrderItem: {
        fields: {
          appSource: {
            type: "AppSource",
            id: 1
          },
          appraisalTime: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          OAID: {
            type: "string",
            id: 4
          },
          userPhone: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          brandID: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesID: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          },
          exteriorImg: {
            type: "string",
            id: 12
          },
          totalAmount: {
            type: "int32",
            id: 13
          },
          payWay: {
            type: "string",
            id: 14
          },
          payState: {
            type: "string",
            id: 15
          },
          result: {
            type: "DBAppraisalResultEnum",
            id: 16
          },
          feedback: {
            type: "string",
            id: 17
          },
          registerTime: {
            type: "string",
            id: 18
          },
          grade: {
            type: "string",
            id: 21
          },
          CardNo: {
            type: "string",
            id: 24
          },
          rating: {
            type: "int32",
            id: 26
          },
          remark: {
            type: "string",
            id: 27
          },
          appraiser: {
            type: "string",
            id: 28
          },
          classify: {
            type: "string",
            id: 29
          },
          commentary: {
            type: "string",
            id: 30
          },
          countryCode: {
            type: "string",
            id: 31
          },
          isArtificialFakeDisplay: {
            type: "ArtificialFakeDisplayEnum",
            id: 32
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 33
          },
          email: {
            type: "string",
            id: 34
          },
          items: {
            rule: "repeated",
            type: "AdminAppraisalAttributeDetail",
            id: 35
          }
        }
      },
      OnlineAppraisalOrderItem: {
        fields: {
          appSource: {
            type: "AppSource",
            id: 1
          },
          appraisalTime: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          OAID: {
            type: "string",
            id: 4
          },
          userPhone: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          brandID: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesID: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          },
          exteriorImg: {
            type: "string",
            id: 12
          },
          totalAmount: {
            type: "int32",
            id: 13
          },
          payWay: {
            type: "string",
            id: 14
          },
          payState: {
            type: "string",
            id: 15
          },
          result: {
            type: "DBAppraisalResultEnum",
            id: 16
          },
          registerTime: {
            type: "string",
            id: 18
          },
          grade: {
            type: "string",
            id: 21
          },
          appraiser: {
            type: "string",
            id: 29
          },
          classify: {
            type: "AppraisalTypeEnum",
            id: 30
          },
          postStatus: {
            type: "int32",
            id: 31
          },
          expressDeliveryNo: {
            type: "string",
            id: 32
          },
          isMembershipOrder: {
            type: "bool",
            id: 33
          },
          countryCode: {
            type: "string",
            id: 34
          },
          isArtificialFakeDisplay: {
            type: "ArtificialFakeDisplayEnum",
            id: 35
          },
          aiToManualResult: {
            type: "AIToManualAppraisalResult",
            id: 36
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 37
          },
          email: {
            type: "string",
            id: 38
          }
        }
      },
      AdminSingleAppraisalRecordItem: {
        fields: {
          SAID: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          grade: {
            type: "string",
            id: 4
          }
        }
      },
      AdminDoubleSeventhScoreRecord: {
        fields: {
          operateType: {
            type: "string",
            id: 1
          },
          inviteUser: {
            type: "string",
            id: 2
          },
          updateScore: {
            type: "int32",
            id: 3
          },
          createTime: {
            type: "string",
            id: 4
          },
          score: {
            type: "int32",
            id: 5
          }
        }
      },
      AppraisalCouponOrderItem: {
        fields: {
          orderID: {
            type: "int32",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          },
          phoneNum: {
            type: "string",
            id: 3
          },
          nickName: {
            type: "string",
            id: 4
          },
          crouponNo: {
            type: "string",
            id: 5
          },
          count: {
            type: "uint32",
            id: 6
          },
          amount: {
            type: "int32",
            id: 7
          },
          state: {
            type: "string",
            id: 8
          },
          time: {
            type: "string",
            id: 9
          }
        }
      },
      TSAdminNodeItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          path: {
            type: "string",
            id: 3
          },
          level: {
            type: "int32",
            id: 4
          },
          isChoose: {
            type: "bool",
            id: 5
          },
          isDisable: {
            type: "bool",
            id: 6
          },
          sequence: {
            type: "int32",
            id: 7
          },
          allItem: {
            rule: "repeated",
            type: "TSAdminAuthItem",
            id: 8
          },
          authType: {
            type: "int32",
            id: 9
          },
          fatherName: {
            type: "string",
            id: 10
          },
          sourceCode: {
            type: "string",
            id: 11
          },
          parentNodes: {
            rule: "repeated",
            type: "int32",
            id: 12
          }
        }
      },
      TSAdminAuthItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          path: {
            type: "string",
            id: 3
          },
          level: {
            type: "int32",
            id: 4
          },
          isChoose: {
            type: "bool",
            id: 5
          },
          isDisable: {
            type: "bool",
            id: 6
          },
          sequence: {
            type: "int32",
            id: 7
          },
          allItem: {
            rule: "repeated",
            type: "TSAdminSecondAuthItem",
            id: 8
          },
          authType: {
            type: "int32",
            id: 9
          },
          fatherName: {
            type: "string",
            id: 10
          },
          sourceCode: {
            type: "string",
            id: 11
          },
          parentNodes: {
            rule: "repeated",
            type: "int32",
            id: 12
          }
        }
      },
      TSAdminSecondAuthItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          path: {
            type: "string",
            id: 3
          },
          level: {
            type: "int32",
            id: 4
          },
          isChoose: {
            type: "bool",
            id: 5
          },
          isDisable: {
            type: "bool",
            id: 6
          },
          sequence: {
            type: "int32",
            id: 7
          },
          allItem: {
            rule: "repeated",
            type: "TSAdminThAuthItem",
            id: 8
          },
          authType: {
            type: "int32",
            id: 9
          },
          fatherName: {
            type: "string",
            id: 10
          },
          sourceCode: {
            type: "string",
            id: 11
          },
          parentNodes: {
            rule: "repeated",
            type: "int32",
            id: 12
          }
        }
      },
      TSAdminThAuthItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          path: {
            type: "string",
            id: 3
          },
          level: {
            type: "int32",
            id: 4
          },
          isChoose: {
            type: "bool",
            id: 5
          },
          isDisable: {
            type: "bool",
            id: 6
          },
          sequence: {
            type: "int32",
            id: 7
          },
          authType: {
            type: "int32",
            id: 8
          },
          fatherName: {
            type: "string",
            id: 10
          },
          sourceCode: {
            type: "string",
            id: 11
          },
          parentNodes: {
            rule: "repeated",
            type: "int32",
            id: 12
          }
        }
      },
      AdminEABaseOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          state: {
            type: "string",
            id: 2
          },
          orderTime: {
            type: "string",
            id: 3
          },
          source: {
            type: "string",
            id: 4
          },
          payWay: {
            type: "string",
            id: 5
          },
          payTime: {
            type: "string",
            id: 6
          },
          orderPrice: {
            type: "int32",
            id: 7
          },
          sellerDeliverTime: {
            type: "string",
            id: 8
          },
          sellerExpressNo: {
            type: "string",
            id: 9
          },
          platformReceiveTime: {
            type: "string",
            id: 10
          },
          platformDeliverTime: {
            type: "string",
            id: 11
          },
          platformExpressNo: {
            type: "string",
            id: 12
          },
          recycle: {
            type: "bool",
            id: 13
          },
          hasRecycled: {
            type: "bool",
            id: 14
          },
          recyclePrice: {
            type: "int32",
            id: 15
          }
        }
      },
      AdminEAReportInfo: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          brandID: {
            type: "int32",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          result: {
            type: "string",
            id: 7
          },
          grade: {
            type: "string",
            id: 8
          },
          reportNo: {
            type: "string",
            id: 9
          },
          productID: {
            type: "string",
            id: 10
          },
          image: {
            type: "string",
            id: 11
          },
          appraiser: {
            type: "string",
            id: 12
          },
          appraisalTime: {
            type: "string",
            id: 13
          }
        }
      },
      WhiteListItem: {
        fields: {
          phoneNumber: {
            type: "string",
            id: 1
          },
          userName: {
            type: "string",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          startTime: {
            type: "string",
            id: 4
          },
          endTime: {
            type: "string",
            id: 5
          },
          whiteId: {
            type: "uint32",
            id: 6
          }
        }
      },
      BargainItem: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          pidStr: {
            type: "string",
            id: 2
          },
          mainPic: {
            type: "string",
            id: 3
          },
          sizeName: {
            type: "string",
            id: 4
          },
          newsName: {
            type: "string",
            id: 5
          },
          startTime: {
            type: "int64",
            id: 6
          },
          endTime: {
            type: "int64",
            id: 7
          },
          actualPrice: {
            type: "uint32",
            id: 8
          },
          bargainRange: {
            type: "string",
            id: 9
          },
          afterBargainPrice: {
            type: "uint32",
            id: 10
          },
          newOneBargain: {
            type: "string",
            id: 11
          },
          oldOneBargain: {
            type: "string",
            id: 12
          },
          baoOneBargain: {
            type: "string",
            id: 13
          },
          sequence: {
            type: "uint32",
            id: 14
          },
          productStatus: {
            type: "int32",
            id: 15
          },
          status: {
            type: "AdminBargainStatus",
            id: 16
          },
          ProductName: {
            type: "string",
            id: 17
          },
          saleNum: {
            type: "int32",
            id: 18
          },
          activityName: {
            type: "string",
            id: 19
          },
          activityEffect: {
            type: "int64",
            id: 20
          },
          createTime: {
            type: "int64",
            id: 21
          },
          level: {
            type: "string",
            id: 22
          },
          isOfficial: {
            type: "bool",
            id: 23
          },
          proCount: {
            type: "int32",
            id: 24
          },
          bargainCount: {
            type: "int32",
            id: 25
          },
          newUserCount: {
            type: "int32",
            id: 26
          },
          cardShareNum: {
            type: "string",
            id: 27
          },
          posterShareNum: {
            type: "string",
            id: 28
          },
          oldUserCount: {
            type: "int32",
            id: 29
          },
          payPrice: {
            type: "int32",
            id: 30
          },
          productCost: {
            type: "string",
            id: 31
          }
        }
      },
      BargainOperateLogItem: {
        fields: {
          operateTime: {
            type: "string",
            id: 1
          },
          operator: {
            type: "string",
            id: 2
          },
          event: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          }
        }
      },
      BargainLogItem: {
        fields: {
          phoneNumber: {
            type: "string",
            id: 1
          },
          cardShareNum: {
            type: "string",
            id: 2
          },
          posterShareNum: {
            type: "string",
            id: 3
          },
          totalBargainNum: {
            type: "string",
            id: 4
          },
          totalBargainPrice: {
            type: "uint32",
            id: 5
          },
          systemBargainTime: {
            type: "string",
            id: 6
          },
          completeBargainTime: {
            type: "string",
            id: 7
          },
          payStatus: {
            type: "int32",
            id: 8
          },
          uid: {
            type: "int32",
            id: 9
          },
          id: {
            type: "int32",
            id: 10
          },
          userName: {
            type: "string",
            id: 11
          }
        }
      },
      BargainUserItem: {
        fields: {
          phoneNumber: {
            type: "string",
            id: 1
          },
          bargainAmount: {
            type: "int32",
            id: 2
          },
          userType: {
            type: "int32",
            id: 3
          },
          bargainTime: {
            type: "string",
            id: 4
          },
          userName: {
            type: "string",
            id: 5
          }
        }
      },
      BargainProductOfficialItem: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          businessmanName: {
            type: "string",
            id: 2
          },
          title: {
            type: "string",
            id: 3
          },
          mainPic: {
            type: "string",
            id: 4
          },
          sizeName: {
            type: "string",
            id: 5
          },
          newsName: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          actualPrice: {
            type: "string",
            id: 8
          },
          businessmanPhone: {
            type: "string",
            id: 9
          },
          sku: {
            type: "string",
            id: 10
          },
          selfRun: {
            type: "bool",
            id: 11
          },
          spu: {
            type: "string",
            id: 12
          }
        }
      },
      BargainSkcItem: {
        fields: {
          kindName: {
            type: "string",
            id: 1
          },
          brandEnName: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          colorName: {
            type: "string",
            id: 4
          },
          sizeName: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          materialName: {
            type: "string",
            id: 7
          },
          forPeople: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          styleName: {
            type: "string",
            id: 10
          },
          releasePrice: {
            type: "int32",
            id: 11
          },
          releaseTime: {
            type: "string",
            id: 12
          },
          newsName: {
            type: "string",
            id: 13
          }
        }
      },
      BargainTopInfo: {
        fields: {
          activityName: {
            type: "string",
            id: 1
          },
          startTime: {
            type: "int64",
            id: 2
          },
          endTime: {
            type: "int64",
            id: 3
          },
          proCount: {
            type: "int32",
            id: 4
          },
          proSaleCount: {
            type: "int32",
            id: 5
          }
        }
      },
      PublishProductToSelect: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          image: {
            type: "string",
            id: 3
          },
          color: {
            type: "string",
            id: 4
          },
          size: {
            type: "string",
            id: 5
          },
          measure: {
            type: "string",
            id: 6
          },
          kind: {
            type: "string",
            id: 7
          },
          brand: {
            type: "string",
            id: 8
          },
          series: {
            type: "string",
            id: 9
          },
          spu: {
            type: "string",
            id: 10
          },
          kindID: {
            type: "int32",
            id: 11
          },
          brandID: {
            type: "int32",
            id: 12
          }
        }
      },
      CompetitveProduct: {
        fields: {
          recordId: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      CompetitiveProductNew: {
        fields: {
          recordId: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          competitiveProductId: {
            type: "int32",
            id: 3
          },
          competitiveProductName: {
            type: "string",
            id: 4
          },
          competitiveNew: {
            type: "string",
            id: 5
          },
          newDegree: {
            type: "string",
            id: 6
          },
          kindId: {
            type: "int32",
            id: 7
          },
          newDegreeId: {
            type: "int32",
            id: 8
          }
        }
      },
      ProBasicInformation: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          brandID: {
            type: "int32",
            id: 2
          },
          seriesID: {
            type: "int32",
            id: 3
          },
          productName: {
            type: "string",
            id: 4
          },
          productCode: {
            type: "string",
            id: 5
          },
          releaseDate: {
            type: "string",
            id: 6
          },
          skcInformation: {
            rule: "repeated",
            type: "SkcInformation",
            id: 7
          },
          newsPrice: {
            rule: "repeated",
            type: "NewsPrice",
            id: 8
          },
          countryPrice: {
            rule: "repeated",
            type: "CountryPrice",
            id: 9
          },
          imgsInfo: {
            rule: "repeated",
            type: "ImgsInfo",
            id: 10
          },
          aiReadMapSet: {
            rule: "repeated",
            type: "AiImgsSetInfo",
            id: 11
          },
          kindName: {
            type: "string",
            id: 13
          },
          brandName: {
            type: "string",
            id: 14
          },
          seriesName: {
            type: "string",
            id: 15
          },
          brandEnName: {
            type: "string",
            id: 16
          }
        }
      },
      ProAccessoryInformation: {
        fields: {
          origin: {
            type: "string",
            id: 1
          },
          forPeople: {
            type: "string",
            id: 2
          },
          materialStrID: {
            type: "string",
            id: 3
          },
          styleStrID: {
            type: "string",
            id: 4
          },
          middleAges: {
            type: "string",
            id: 5
          },
          service: {
            type: "string",
            id: 6
          },
          description: {
            type: "string",
            id: 7
          },
          materialStrName: {
            type: "string",
            id: 8
          },
          styleStrName: {
            type: "string",
            id: 9
          },
          serviceStrId: {
            type: "string",
            id: 10
          },
          serviceStrName: {
            type: "string",
            id: 11
          }
        }
      },
      SkcInformation: {
        fields: {
          colorID: {
            type: "int32",
            id: 1
          },
          aiReadMapSet: {
            rule: "repeated",
            type: "AiImgsSetInfo",
            id: 2
          },
          imgsInfo: {
            rule: "repeated",
            type: "ImgsInfo",
            id: 3
          },
          countryPrice: {
            rule: "repeated",
            type: "CountryPrice",
            id: 4
          },
          newsPrice: {
            rule: "repeated",
            type: "NewsPrice",
            id: 5
          },
          skuInformation: {
            rule: "repeated",
            type: "SkuInformation",
            id: 6
          },
          productCode: {
            type: "string",
            id: 7
          },
          colorName: {
            type: "string",
            id: 8
          },
          produceName: {
            type: "string",
            id: 9
          },
          skc: {
            type: "string",
            id: 10
          },
          enableCount: {
            type: "int32",
            id: 11
          },
          skuCount: {
            type: "int32",
            id: 12
          },
          status: {
            type: "int32",
            id: 13
          },
          aiPicCount: {
            type: "int32",
            id: 14
          },
          account: {
            type: "string",
            id: 15
          },
          updateTime: {
            type: "string",
            id: 16
          },
          mainPic: {
            type: "string",
            id: 17
          },
          spu: {
            type: "string",
            id: 18
          }
        }
      },
      SkuInformation: {
        fields: {
          sizeID: {
            type: "int32",
            id: 1
          },
          measurement: {
            type: "string",
            id: 2
          },
          productCode: {
            type: "string",
            id: 3
          },
          imgsInfo: {
            rule: "repeated",
            type: "ImgsInfo",
            id: 4
          },
          newsPrice: {
            rule: "repeated",
            type: "NewsPrice",
            id: 5
          },
          aiReadMapSet: {
            rule: "repeated",
            type: "AiImgsSetInfo",
            id: 6
          },
          countryPrice: {
            rule: "repeated",
            type: "CountryPrice",
            id: 7
          },
          isCreate: {
            type: "bool",
            id: 8
          },
          produceName: {
            type: "string",
            id: 9
          },
          colorNickName: {
            type: "string",
            id: 10
          },
          sku: {
            type: "string",
            id: 11
          },
          sizeName: {
            type: "string",
            id: 12
          },
          status: {
            type: "int32",
            id: 13
          }
        }
      },
      ProItem: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          productMainImgUrl: {
            type: "string",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          serviceStrName: {
            type: "string",
            id: 6
          },
          state: {
            type: "string",
            id: 7
          },
          brandEnName: {
            type: "string",
            id: 8
          },
          skcStatus: {
            type: "string",
            id: 9
          },
          seriesName: {
            type: "string",
            id: 10
          },
          account: {
            type: "string",
            id: 11
          },
          updateTime: {
            type: "string",
            id: 12
          },
          enableCount: {
            type: "int32",
            id: 13
          },
          skcCount: {
            type: "int32",
            id: 14
          },
          kindID: {
            type: "int32",
            id: 15
          },
          kindID2: {
            type: "int32",
            id: 16
          },
          kindName2: {
            type: "string",
            id: 17
          }
        }
      },
      ServiceInformation: {
        fields: {
          serviceID: {
            type: "int32",
            id: 1
          },
          serviceName: {
            type: "string",
            id: 2
          }
        }
      },
      SkcTopItem: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          spuStatus: {
            type: "int32",
            id: 2
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandEnName: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          productName: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          }
        }
      },
      SkuTopItem: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          spuStatus: {
            type: "int32",
            id: 2
          },
          skc: {
            type: "string",
            id: 3
          },
          skcStatus: {
            type: "int32",
            id: 4
          },
          productName: {
            type: "string",
            id: 5
          },
          colorName: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          }
        }
      },
      SkcItem: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          skc: {
            type: "string",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandEnName: {
            type: "string",
            id: 4
          },
          seriesName: {
            type: "string",
            id: 5
          },
          productMainImgUrl: {
            type: "string",
            id: 6
          },
          colorName: {
            type: "string",
            id: 7
          },
          productCode: {
            type: "string",
            id: 8
          },
          releasePrice: {
            type: "int32",
            id: 9
          },
          enableCount: {
            type: "int32",
            id: 10
          },
          skuCount: {
            type: "int32",
            id: 11
          },
          skcStatus: {
            type: "string",
            id: 12
          },
          AiReadMapSetCount: {
            type: "int32",
            id: 13
          },
          account: {
            type: "string",
            id: 14
          },
          updateTime: {
            type: "string",
            id: 15
          },
          kindID: {
            type: "int32",
            id: 16
          },
          productName: {
            type: "string",
            id: 17
          },
          brandID: {
            type: "int32",
            id: 18
          },
          seriesID: {
            type: "int32",
            id: 19
          }
        }
      },
      SkuItem: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          skc: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandEnName: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          productName: {
            type: "string",
            id: 7
          },
          productMainImgUrl: {
            type: "string",
            id: 8
          },
          sizeName: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          productCode: {
            type: "string",
            id: 11
          },
          skuStatus: {
            type: "string",
            id: 12
          },
          account: {
            type: "string",
            id: 13
          },
          updateTime: {
            type: "string",
            id: 14
          },
          releasePrice: {
            type: "int32",
            id: 15
          },
          kindID: {
            type: "int32",
            id: 16
          },
          colorName: {
            type: "string",
            id: 17
          }
        }
      },
      OpLogItem: {
        fields: {
          event: {
            type: "string",
            id: 1
          },
          account: {
            type: "string",
            id: 2
          },
          opTime: {
            type: "int64",
            id: 3
          }
        }
      },
      ServiceItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          code: {
            type: "string",
            id: 3
          }
        }
      },
      PurchaseProduct: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          kind: {
            type: "string",
            id: 2
          },
          brand: {
            type: "string",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          size: {
            type: "string",
            id: 5
          },
          sku: {
            type: "string",
            id: 6
          },
          newDegree: {
            type: "string",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          },
          price: {
            type: "uint32",
            id: 9
          },
          newDegreeId: {
            type: "int32",
            id: 10
          },
          state: {
            type: "ProductPurchaseOfflineState",
            id: 11
          },
          buttonList: {
            rule: "repeated",
            type: "ProductPurchaseOfflineAction",
            id: 12
          },
          kindId: {
            type: "int32",
            id: 13
          },
          position: {
            type: "string",
            id: 14
          },
          pid: {
            type: "string",
            id: 15
          },
          image: {
            type: "string",
            id: 16
          }
        }
      },
      PurchaseOrderInfo: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          purchaseTime: {
            type: "string",
            id: 2
          },
          purchaseNo: {
            type: "string",
            id: 3
          },
          totalPrice: {
            type: "uint32",
            id: 4
          },
          initiator: {
            type: "string",
            id: 5
          },
          supplier: {
            type: "string",
            id: 6
          },
          state: {
            type: "PurchaseOrderState",
            id: 7
          },
          purchaseType: {
            type: "PurchaseType",
            id: 8
          },
          expressNo: {
            type: "string",
            id: 9
          },
          expressFee: {
            type: "uint32",
            id: 10
          },
          prodcutList: {
            rule: "repeated",
            type: "PurchaseProduct",
            id: 11
          },
          remark: {
            type: "string",
            id: 12
          },
          supplierId: {
            type: "uint32",
            id: 13
          },
          buttonList: {
            rule: "repeated",
            type: "PurchaseOrderAction",
            id: 14
          },
          warehouseTotalPrice: {
            type: "uint32",
            id: 15
          },
          actualRemit: {
            type: "uint32",
            id: 16
          },
          bindOrderNo: {
            type: "string",
            id: 17
          },
          canRemit: {
            type: "bool",
            id: 18
          },
          finishTime: {
            type: "string",
            id: 19
          },
          supplierPhone: {
            type: "string",
            id: 20
          }
        }
      },
      SaleProduct: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          kind: {
            type: "string",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          sku: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          cost: {
            type: "uint32",
            id: 6
          },
          price: {
            type: "uint32",
            id: 7
          },
          margin: {
            type: "int32",
            id: 8
          },
          marginRate: {
            type: "string",
            id: 9
          },
          state: {
            type: "ProductSaleState",
            id: 10
          },
          image: {
            type: "string",
            id: 11
          }
        }
      },
      SaleOrderInfo: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          createDate: {
            type: "string",
            id: 2
          },
          saleNo: {
            type: "string",
            id: 3
          },
          totalPrice: {
            type: "uint32",
            id: 4
          },
          seller: {
            type: "string",
            id: 5
          },
          margin: {
            type: "int32",
            id: 6
          },
          saler: {
            type: "string",
            id: 7
          },
          state: {
            type: "SaleOrderState",
            id: 8
          },
          saleType: {
            type: "SaleType",
            id: 9
          },
          expressType: {
            type: "ExpressPayType",
            id: 10
          },
          expressFee: {
            type: "uint32",
            id: 11
          },
          extraFee: {
            type: "uint32",
            id: 12
          },
          feeRemark: {
            type: "string",
            id: 13
          },
          remark: {
            type: "string",
            id: 14
          },
          pList: {
            rule: "repeated",
            type: "SaleProduct",
            id: 15
          },
          salerPhone: {
            type: "string",
            id: 16
          },
          createTime: {
            type: "string",
            id: 17
          },
          express: {
            type: "string",
            id: 18
          },
          bindOrderNo: {
            type: "string",
            id: 19
          },
          finishTime: {
            type: "string",
            id: 20
          }
        }
      },
      WarehouseInOrder: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          },
          createTime: {
            type: "string",
            id: 3
          },
          purchaseType: {
            type: "PurchaseType",
            id: 4
          },
          state: {
            type: "WarehouseInState",
            id: 5
          },
          express: {
            type: "string",
            id: 6
          },
          bindOrderNo: {
            type: "string",
            id: 7
          },
          supplierPhone: {
            type: "string",
            id: 8
          },
          supplierName: {
            type: "string",
            id: 9
          },
          remark: {
            type: "string",
            id: 10
          },
          prodcutList: {
            rule: "repeated",
            type: "PurchaseProduct",
            id: 11
          },
          finishTime: {
            type: "string",
            id: 12
          }
        }
      },
      WarehouseOutProduct: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          },
          name: {
            type: "string",
            id: 5
          },
          size: {
            type: "string",
            id: 6
          },
          newDegree: {
            type: "string",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          },
          price: {
            type: "uint32",
            id: 9
          },
          shelf: {
            type: "string",
            id: 10
          },
          position: {
            type: "string",
            id: 11
          },
          out: {
            type: "bool",
            id: 12
          }
        }
      },
      WarehouseOutOrder: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          },
          createTime: {
            type: "string",
            id: 3
          },
          outType: {
            type: "WarehouseOutType",
            id: 4
          },
          state: {
            type: "WarehouseInState",
            id: 5
          },
          express: {
            type: "string",
            id: 6
          },
          bindOrderNo: {
            type: "string",
            id: 7
          },
          clientPhone: {
            type: "string",
            id: 8
          },
          clientName: {
            type: "string",
            id: 9
          },
          remark: {
            type: "string",
            id: 10
          },
          productList: {
            rule: "repeated",
            type: "WarehouseOutProduct",
            id: 11
          },
          finishTime: {
            type: "string",
            id: 12
          }
        }
      },
      Shelf: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          rows: {
            type: "uint32",
            id: 2
          },
          positionPerRow: {
            type: "uint32",
            id: 3
          },
          totalPosition: {
            type: "uint32",
            id: 4
          },
          positionWarn: {
            type: "uint32",
            id: 5
          },
          positionUsed: {
            type: "uint32",
            id: 6
          },
          positionLeft: {
            type: "uint32",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          }
        }
      },
      ShelfPosition: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          rowNo: {
            type: "string",
            id: 2
          },
          shelfId: {
            type: "uint32",
            id: 3
          },
          kind: {
            type: "string",
            id: 4,
            options: {
              deprecated: true
            }
          },
          brand: {
            type: "string",
            id: 5,
            options: {
              deprecated: true
            }
          },
          product: {
            type: "string",
            id: 6,
            options: {
              deprecated: true
            }
          },
          pid: {
            type: "string",
            id: 7,
            options: {
              deprecated: true
            }
          },
          positionNo: {
            type: "string",
            id: 8
          },
          productCount: {
            type: "uint32",
            id: 9
          },
          productList: {
            rule: "repeated",
            type: "ProductOnPosition",
            id: 10
          }
        }
      },
      ProductOnPosition: {
        fields: {
          kind: {
            type: "string",
            id: 1
          },
          brand: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          }
        }
      },
      StockBasicInfo: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          warehouseInTime: {
            type: "string",
            id: 2
          },
          spu: {
            type: "string",
            id: 3
          },
          skc: {
            type: "string",
            id: 4
          },
          sku: {
            type: "string",
            id: 5
          },
          kind: {
            type: "string",
            id: 6
          },
          brand: {
            type: "string",
            id: 7
          },
          series: {
            type: "string",
            id: 8
          },
          cost: {
            type: "uint32",
            id: 9
          },
          newDegree: {
            type: "string",
            id: 10
          },
          price: {
            type: "uint32",
            id: 11
          },
          imageList: {
            rule: "repeated",
            type: "StockProductImage",
            id: 12
          },
          kindId: {
            type: "uint32",
            id: 13
          },
          newDegreeId: {
            type: "uint32",
            id: 14
          },
          productName: {
            type: "string",
            id: 15
          },
          puOnTime: {
            type: "string",
            id: 16
          },
          onTime: {
            type: "int32",
            id: 17
          },
          supplier: {
            type: "string",
            id: 18
          },
          spares: {
            type: "string",
            id: 19
          },
          flaw: {
            type: "string",
            id: 20
          },
          putOn: {
            type: "bool",
            id: 21
          }
        }
      },
      StockPurchaseInfo: {
        fields: {
          purchaseType: {
            type: "PurchaseType",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          },
          express: {
            type: "string",
            id: 3
          },
          orderId: {
            type: "uint32",
            id: 4
          }
        }
      },
      StockWarehouseInfo: {
        fields: {
          shelfId: {
            type: "uint32",
            id: 1
          },
          rowNo: {
            type: "string",
            id: 2
          },
          positionNo: {
            type: "string",
            id: 3
          }
        }
      },
      StockSaleInfo: {
        fields: {
          saleType: {
            type: "SaleType",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          },
          express: {
            type: "string",
            id: 3
          },
          orderId: {
            type: "uint32",
            id: 4
          }
        }
      },
      StockOperateRecord: {
        fields: {
          operator: {
            type: "string",
            id: 1
          },
          event: {
            type: "string",
            id: 2
          },
          operateTime: {
            type: "string",
            id: 3
          }
        }
      },
      StockExchangeProcess: {
        fields: {
          exchangeDate: {
            type: "string",
            id: 1
          },
          recordList: {
            rule: "repeated",
            type: "StockOperateRecord",
            id: 2
          }
        }
      },
      StockProductImage: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          }
        }
      },
      StockProduct: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          purchaseType: {
            type: "PurchaseType",
            id: 2
          },
          saleType: {
            type: "SaleType",
            id: 3
          },
          cover: {
            type: "string",
            id: 4
          },
          size: {
            type: "string",
            id: 5
          },
          sku: {
            type: "string",
            id: 6
          },
          newDegree: {
            type: "string",
            id: 7
          },
          kind: {
            type: "string",
            id: 8
          },
          brand: {
            type: "string",
            id: 9
          },
          series: {
            type: "string",
            id: 10
          },
          shelfId: {
            type: "uint32",
            id: 11
          },
          positionNo: {
            type: "string",
            id: 12
          },
          state: {
            type: "ProductSaleState",
            id: 13
          },
          cost: {
            type: "uint32",
            id: 14
          },
          price: {
            type: "uint32",
            id: 15
          },
          imageList: {
            rule: "repeated",
            type: "StockProductImage",
            id: 16
          },
          productName: {
            type: "string",
            id: 17
          },
          putOnTime: {
            type: "string",
            id: 18
          },
          onTime: {
            type: "int32",
            id: 19
          },
          supplier: {
            type: "string",
            id: 20
          },
          remark: {
            type: "string",
            id: 21
          },
          spares: {
            type: "string",
            id: 22
          },
          putOn: {
            type: "int32",
            id: 23
          },
          flaw: {
            type: "string",
            id: 24
          }
        }
      },
      TSDailyFreeConfig: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          freeNum: {
            type: "int32",
            id: 2
          },
          enable: {
            type: "bool",
            id: 3
          },
          kind: {
            rule: "repeated",
            type: "TSKind",
            id: 4
          },
          bubbleText: {
            type: "string",
            id: 5
          },
          runOutText: {
            type: "string",
            id: 6
          },
          cornerText: {
            type: "string",
            id: 7
          },
          buttonText: {
            type: "string",
            id: 8
          },
          platformSource: {
            type: "Source",
            id: 9
          },
          isFullKind: {
            type: "bool",
            id: 10
          },
          buttonEnText: {
            type: "string",
            id: 11
          }
        }
      },
      TSKind: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          }
        }
      },
      CompetitionRecord: {
        fields: {
          cid: {
            type: "int32",
            id: 1
          },
          competitionType: {
            type: "CompetitionType",
            id: 2
          },
          phase: {
            type: "int32",
            id: 3
          },
          competitionStatus: {
            type: "int32",
            id: 4
          },
          questionType: {
            rule: "repeated",
            type: "int32",
            id: 5
          },
          answerNum: {
            type: "int32",
            id: 6
          },
          participantNum: {
            type: "int32",
            id: 7
          },
          shareNum: {
            type: "int32",
            id: 8
          },
          newComerNum: {
            type: "int32",
            id: 9
          },
          bonusAmount: {
            rule: "repeated",
            type: "int32",
            id: 10
          },
          bonusStatus: {
            type: "int32",
            id: 11
          },
          startTime: {
            type: "string",
            id: 12
          },
          endTime: {
            type: "string",
            id: 13
          }
        }
      },
      ChallengeRecord: {
        fields: {
          rid: {
            type: "int32",
            id: 1
          },
          cid: {
            type: "int32",
            id: 2
          },
          uid: {
            type: "int32",
            id: 3
          },
          nickName: {
            type: "string",
            id: 4
          },
          phone: {
            type: "string",
            id: 5
          },
          userType: {
            type: "CompetitionUserType",
            id: 6
          },
          challengeTime: {
            type: "string",
            id: 7
          },
          answerNum: {
            type: "int32",
            id: 8
          },
          correctNum: {
            type: "int32",
            id: 9
          },
          wrongNum: {
            type: "int32",
            id: 10
          },
          score: {
            type: "int32",
            id: 11
          },
          bonus: {
            type: "int32",
            id: 12
          },
          rewardType: {
            type: "int32",
            id: 13
          },
          totalBonusAmount: {
            type: "int32",
            id: 14
          },
          competitionType: {
            type: "CompetitionType",
            id: 15
          },
          phase: {
            type: "int32",
            id: 16
          },
          ranking: {
            type: "int32",
            id: 17
          },
          isCurrentCompetition: {
            type: "bool",
            id: 18
          },
          startTime: {
            type: "string",
            id: 19
          },
          endTime: {
            type: "string",
            id: 20
          }
        }
      },
      RewardRecord: {
        fields: {
          rid: {
            type: "int32",
            id: 1
          },
          cid: {
            type: "int32",
            id: 2
          },
          uid: {
            type: "int32",
            id: 3
          },
          nickName: {
            type: "string",
            id: 4
          },
          phone: {
            type: "string",
            id: 5
          },
          userType: {
            type: "CompetitionUserType",
            id: 6
          },
          challengeTime: {
            type: "string",
            id: 7
          },
          score: {
            type: "int32",
            id: 8
          },
          bonus: {
            type: "int32",
            id: 9
          },
          rewardType: {
            type: "int32",
            id: 10
          },
          ranking: {
            type: "int32",
            id: 11
          }
        }
      },
      AdminUser: {
        fields: {
          uid: {
            type: "int32",
            id: 1
          },
          userName: {
            type: "string",
            id: 2
          }
        }
      },
      SingleAppraisalInfo: {
        fields: {
          said: {
            type: "string",
            id: 1
          },
          pointId: {
            type: "int32",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          imgUrl: {
            type: "string",
            id: 4
          },
          grade: {
            type: "string",
            id: 5
          }
        }
      },
      ComplementImagePoint: {
        fields: {
          said: {
            type: "string",
            id: 1
          },
          pointId: {
            type: "int32",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          imgUrl: {
            type: "string",
            id: 4
          },
          grade: {
            type: "string",
            id: 5
          },
          batch: {
            type: "int32",
            id: 6
          }
        }
      },
      UserFeedbackCollectItem: {
        fields: {
          FeedbackQuestion: {
            type: "FeedbackQuestionTypeEnum",
            id: 1
          },
          FeedbackScreenshot: {
            type: "string",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          email: {
            type: "string",
            id: 4
          },
          feedbackTime: {
            type: "string",
            id: 5
          },
          remark: {
            type: "string",
            id: 6
          }
        }
      },
      OperationalRecord: {
        fields: {
          serialNumber: {
            type: "int32",
            id: 1
          },
          operationTime: {
            type: "string",
            id: 2
          },
          event: {
            type: "string",
            id: 3
          },
          operator: {
            type: "string",
            id: 4
          }
        }
      },
      AdminAppraisalAttributeDetail: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          label: {
            type: "string",
            id: 2
          },
          value: {
            type: "string",
            id: 3
          },
          type: {
            type: "int32",
            id: 4
          }
        }
      },
      NewGiftUserType: {
        values: {
          NewUser: 0,
          UserNotUse: 1,
          OldUser: 2
        }
      },
      TSGetNewGiftStateRequest: {
        fields: {}
      },
      TSGetNewGiftStateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          newGiftUserType: {
            type: "NewGiftUserType",
            id: 3
          },
          knownFrom: {
            type: "bool",
            id: 4
          },
          hasCoupon: {
            type: "bool",
            id: 5
          }
        }
      },
      EventType: {
        values: {
          DrawModalClose: 0,
          DrawModalClick: 1,
          AppraisalMadalClose: 2,
          AppraisalMadalClick: 3,
          DrawFloatClick: 4,
          AppraisalFloatClick: 5
        }
      },
      TSAddNewGiftRecordRequest: {
        fields: {
          eventType: {
            type: "EventType",
            id: 1
          }
        }
      },
      TSAddNewGiftRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSManagePageRequest: {
        fields: {}
      },
      TSManagePageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          manage: {
            rule: "repeated",
            type: "Manage",
            id: 3
          }
        }
      },
      TSHomePageSwitchRequest: {
        fields: {}
      },
      TSHomePageSwitchResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          show: {
            type: "bool",
            id: 3
          },
          imageUrl: {
            type: "string",
            id: 4
          },
          path: {
            type: "string",
            id: 5
          },
          type: {
            type: "int32",
            id: 6
          }
        }
      },
      TSDetailConfigRequest: {
        fields: {}
      },
      TSDetailConfigResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          demoImgUrl: {
            type: "string",
            id: 3
          },
          miniProgramCodeUrl: {
            type: "string",
            id: 4
          },
          publicCode: {
            type: "string",
            id: 5
          }
        }
      },
      TSSisterGenMatchResultRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          matchImg: {
            type: "string",
            id: 2
          },
          grade: {
            type: "int32",
            id: 3
          },
          num: {
            type: "int32",
            id: 4
          }
        }
      },
      TSSisterGenMatchResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchPerson: {
            type: "string",
            id: 3
          },
          grade: {
            type: "int32",
            id: 4
          },
          resultUrl: {
            type: "string",
            id: 5
          },
          famousQuotes: {
            type: "string",
            id: 6
          },
          styleDes: {
            type: "string",
            id: 7
          },
          matchBag: {
            type: "string",
            id: 8
          },
          faceDes: {
            type: "string",
            id: 9
          },
          matchImg: {
            type: "string",
            id: 10
          },
          num: {
            type: "int32",
            id: 11
          },
          bag: {
            type: "RecommendedBag",
            id: 12
          }
        },
        nested: {
          RecommendedBag: {
            fields: {
              brandName: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              releasePrice: {
                type: "string",
                id: 3
              },
              price: {
                type: "string",
                id: 4
              },
              pid: {
                type: "string",
                id: 5
              },
              imageUrl: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      TSAppraisalEventPageRequest: {
        fields: {}
      },
      TSAppraisalEventPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          joinCount: {
            type: "int32",
            id: 3
          },
          receivedCount: {
            type: "int32",
            id: 4
          },
          freeAppraisalCount: {
            type: "int32",
            id: 5
          },
          button: {
            type: "string",
            id: 6
          },
          friends: {
            rule: "repeated",
            type: "InvitedFriend",
            id: 7
          },
          friendCount: {
            type: "int32",
            id: 8
          },
          buttonType: {
            type: "string",
            id: 9
          },
          inviteKey: {
            type: "string",
            id: 10
          }
        },
        nested: {
          InvitedFriend: {
            fields: {
              avatar: {
                type: "string",
                id: 1
              },
              nickname: {
                type: "string",
                id: 2
              },
              registerTime: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      TSAppraisalEventReceiveRequest: {
        fields: {
          inviteKey: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalEventReceiveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAppraisalEventPosterRequest: {
        fields: {
          page: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalEventPosterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ownerAvatar: {
            type: "string",
            id: 3
          },
          shareText: {
            type: "string",
            id: 4
          },
          appletCode: {
            type: "bytes",
            id: 5
          },
          nickname: {
            type: "string",
            id: 6
          }
        }
      },
      TSAppraisalCouponOperateRecordListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAppraisalCouponOperateRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recordList: {
            rule: "repeated",
            type: "CouponOperateRecord",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          CouponOperateRecord: {
            fields: {
              content: {
                type: "string",
                id: 1
              },
              operateTime: {
                type: "string",
                id: 2
              },
              couponNo: {
                type: "string",
                id: 3
              },
              oaid: {
                type: "string",
                id: 4
              },
              friendNickname: {
                type: "string",
                id: 5
              },
              consumeCount: {
                type: "string",
                id: 6
              },
              canJump: {
                type: "bool",
                id: 7
              }
            }
          }
        }
      },
      TSDoubleSeventhEventPageRequest: {
        fields: {}
      },
      TSDoubleSeventhEventPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          joinCount: {
            type: "int32",
            id: 3
          },
          scoreboard: {
            rule: "repeated",
            type: "Score",
            id: 4
          },
          loggedIn: {
            type: "bool",
            id: 5
          },
          myScore: {
            type: "int32",
            id: 6
          },
          inviteKey: {
            type: "string",
            id: 7
          },
          myRank: {
            type: "string",
            id: 8
          },
          eventOn: {
            type: "bool",
            id: 9
          }
        },
        nested: {
          Score: {
            fields: {
              avatar: {
                type: "string",
                id: 1
              },
              nickname: {
                type: "string",
                id: 2
              },
              score: {
                type: "int32",
                id: 3
              },
              rank: {
                type: "int32",
                id: 4
              }
            }
          }
        }
      },
      TSDoubleSeventhScorePageRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          }
        }
      },
      TSDoubleSeventhScorePageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          score: {
            type: "int32",
            id: 3
          },
          inviteCount: {
            type: "int32",
            id: 4
          },
          scoreRecords: {
            rule: "repeated",
            type: "ScoreRecord",
            id: 5
          },
          isEnd: {
            type: "bool",
            id: 6
          },
          eventOn: {
            type: "bool",
            id: 7
          }
        },
        nested: {
          ScoreRecord: {
            fields: {
              avatar: {
                type: "string",
                id: 1
              },
              nickname: {
                type: "string",
                id: 2
              },
              changeTime: {
                type: "string",
                id: 3
              },
              changeScore: {
                type: "int32",
                id: 4
              },
              operateType: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      TSDoubleSeventhPrizePoolRequest: {
        fields: {}
      },
      TSDoubleSeventhPrizePoolResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          spendScore: {
            type: "int32",
            id: 3
          },
          prizePool: {
            rule: "repeated",
            type: "Prize",
            id: 7
          }
        },
        nested: {
          Prize: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              },
              amount: {
                type: "int32",
                id: 3
              },
              order: {
                type: "int32",
                id: 4
              }
            }
          }
        }
      },
      TSDoubleSeventhLotteryRequest: {
        fields: {}
      },
      TSDoubleSeventhLotteryPoolResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isWin: {
            type: "bool",
            id: 3
          },
          score: {
            type: "int32",
            id: 4
          },
          prizeName: {
            type: "string",
            id: 5
          },
          prizeImage: {
            type: "string",
            id: 6
          },
          order: {
            type: "int32",
            id: 7
          }
        }
      },
      TSDoubleSeventhBroadcastRequest: {
        fields: {}
      },
      TSDoubleSeventhBroadcastResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          broadcastList: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      TSGiftGenAppraisalCouponOrderRequest: {
        fields: {}
      },
      TSGiftGenAppraisalCouponOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSOldForNewOnRequest: {
        fields: {}
      },
      TSOldForNewOnResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isOn: {
            type: "bool",
            id: 3
          },
          link: {
            type: "string",
            id: 4
          }
        }
      },
      TSOldForNewClickRequest: {
        fields: {}
      },
      TSOldForNewClickResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSOldForNewH5ClickRequest: {
        fields: {
          phoneNum: {
            type: "string",
            id: 1
          },
          wechat: {
            type: "string",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          contactTime: {
            type: "string",
            id: 4
          },
          recycleType: {
            type: "string",
            id: 5
          },
          contactTimeEnum: {
            type: "ContactTime",
            id: 6
          }
        }
      },
      TSOldForNewH5ClickResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      GetCashbackActivityRequest: {
        fields: {}
      },
      GetCashbackActivityResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          enable: {
            type: "bool",
            id: 3
          },
          supportKinds: {
            rule: "repeated",
            type: "int32",
            id: 6
          }
        }
      },
      CheckCashbackChanceRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      CheckCashbackChanceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          enable: {
            type: "bool",
            id: 3
          }
        }
      },
      KindOrderStatisticsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          kindId: {
            type: "int32",
            id: 3
          },
          start: {
            type: "string",
            id: 4
          },
          end: {
            type: "string",
            id: 5
          },
          source: {
            type: "OrderStatisticsSource",
            id: 6
          }
        }
      },
      KindOrderStatisticsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          kinds: {
            rule: "repeated",
            type: "KindOrderStatistics",
            id: 4
          }
        },
        nested: {
          KindOrderStatistics: {
            fields: {
              source: {
                type: "OrderStatisticsSource",
                id: 1
              },
              kindName: {
                type: "string",
                id: 2
              },
              count: {
                type: "int32",
                id: 3
              },
              createTime: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      BrandOrderStatisticsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          kindId: {
            type: "int32",
            id: 3
          },
          brandId: {
            type: "int32",
            id: 4
          },
          start: {
            type: "string",
            id: 5
          },
          end: {
            type: "string",
            id: 6
          },
          source: {
            type: "OrderStatisticsSource",
            id: 7
          }
        }
      },
      BrandOrderStatisticsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          brands: {
            rule: "repeated",
            type: "BrandOrderStatistics",
            id: 4
          }
        },
        nested: {
          BrandOrderStatistics: {
            fields: {
              source: {
                type: "OrderStatisticsSource",
                id: 1
              },
              kindName: {
                type: "string",
                id: 2
              },
              brandName: {
                type: "string",
                id: 3
              },
              count: {
                type: "int32",
                id: 4
              },
              createTime: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      KindAverageOrderStatisticsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          kindId: {
            type: "int32",
            id: 3
          },
          source: {
            type: "OrderStatisticsSource",
            id: 4
          }
        }
      },
      KindAverageOrderStatisticsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          kinds: {
            rule: "repeated",
            type: "KindAverageOrderStatistics",
            id: 4
          }
        },
        nested: {
          KindAverageOrderStatistics: {
            fields: {
              source: {
                type: "OrderStatisticsSource",
                id: 1
              },
              kindName: {
                type: "string",
                id: 2
              },
              day7AverageCount: {
                type: "string",
                id: 3
              },
              day30AverageCount: {
                type: "string",
                id: 4
              },
              averageCount: {
                type: "string",
                id: 5
              },
              totalCount: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      OrderStatisticsSource: {
        values: {
          ORDER_STATISTICS_SOURCE_DEFAULT: 0,
          ORDER_STATISTICS_SOURCE_TURING: 1,
          ORDER_STATISTICS_SOURCE_XIAN_YU: 2
        }
      },
      TSUploadFIle2OssRequest: {
        fields: {}
      },
      TSUploadFIle2OssResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          fileUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSAINATRequest: {
        fields: {
          appSource: {
            type: "AppSource",
            id: 1
          },
          location: {
            type: "string",
            id: 2
          },
          heartbeat: {
            type: "int32",
            id: 3
          },
          temperature: {
            type: "float",
            id: 4
          },
          isSoreThroat: {
            type: "SoreThroatEnum",
            id: 5
          },
          isSimilarSymptoms: {
            type: "SimilarSymptomsEnum",
            id: 6
          },
          canthusImgUrl: {
            type: "string",
            id: 7
          },
          tongueImgUrl: {
            type: "string",
            id: 8
          },
          CoughUrl: {
            type: "string",
            id: 9
          },
          AhUrl: {
            type: "string",
            id: 10
          },
          SoundUrl: {
            type: "string",
            id: 11
          }
        }
      },
      TSAINATResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSAINATRecordRequest: {
        fields: {}
      },
      TSAINATRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          info: {
            rule: "repeated",
            type: "Info",
            id: 3
          }
        },
        nested: {
          Info: {
            fields: {
              AINATResult: {
                type: "AINATResultEnum",
                id: 1
              },
              heartbeat: {
                type: "int32",
                id: 2
              },
              temperature: {
                type: "string",
                id: 3
              },
              isSoreThroat: {
                type: "SoreThroatEnum",
                id: 4
              },
              appraisalNo: {
                type: "string",
                id: 5
              },
              appraisalTime: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      TSAINATReportRequest: {
        fields: {
          appraisalNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSAINATReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          AINATResult: {
            type: "AINATResultEnum",
            id: 3
          },
          temperature: {
            type: "string",
            id: 4
          },
          isSoreThroat: {
            type: "SoreThroatEnum",
            id: 5
          },
          appraisalNo: {
            type: "string",
            id: 6
          },
          appraisalTime: {
            type: "string",
            id: 7
          },
          tips: {
            type: "string",
            id: 8
          }
        }
      },
      TSAppraisalHomePageRequest: {
        fields: {}
      },
      TSAppraisalHomePageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          banner: {
            rule: "repeated",
            type: "CarouselItem",
            id: 3
          },
          appraisalCount: {
            type: "int32",
            id: 4
          },
          fakeRate: {
            type: "int32",
            id: 5
          },
          fakeRanks: {
            rule: "repeated",
            type: "BrandRate",
            id: 6
          },
          realRanks: {
            rule: "repeated",
            type: "BrandRate",
            id: 7
          }
        }
      },
      TSSelectedAppraisalRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSSelectedAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          selectedAppraisalRecord: {
            rule: "repeated",
            type: "SelectedAppraisalRecord",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSAIServiceServiceHomePageRequest: {
        fields: {}
      },
      TSAIServiceServiceHomePageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalCount: {
            type: "int32",
            id: 4
          },
          classifyCount: {
            type: "int32",
            id: 5
          },
          banner: {
            rule: "repeated",
            type: "CarouselItem",
            id: 6
          },
          CCICAppraisalPrice: {
            type: "int32",
            id: 7
          },
          kindName: {
            type: "string",
            id: 8
          },
          hasDailyFree: {
            type: "bool",
            id: 9
          },
          cornerText: {
            type: "string",
            id: 10
          }
        }
      },
      TSAIServiceAppraisalKindsRequest: {
        fields: {}
      },
      TSAIServiceAppraisalKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSAIServiceAppraisalBrandsRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAIServiceAppraisalBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotBrands: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSAIServiceAppraisalSeriesRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAIServiceAppraisalSeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotSeries: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSAIServiceAppraisalPointsRequest: {
        fields: {
          categoryEnum: {
            type: "CategoryEnum",
            id: 1
          },
          categoryID: {
            type: "int32",
            id: 2
          },
          appraisalType: {
            type: "int32",
            id: 3
          },
          source: {
            type: "CouponChannel",
            id: 4
          },
          appraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 9
          },
          fromYanHuoBao: {
            type: "bool",
            id: 10
          },
          fromIap: {
            type: "bool",
            id: 11
          },
          appraiserId: {
            type: "int32",
            id: 5
          }
        }
      },
      TSAIServiceAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointInfos: {
            rule: "repeated",
            type: "AIServicePointInfo",
            id: 3
          },
          nonPointInfos: {
            rule: "repeated",
            type: "AIServicePointInfo",
            id: 21
          },
          buttonText: {
            type: "string",
            id: 4
          },
          ticketActivity: {
            type: "bool",
            id: 5
          },
          activityURL: {
            type: "string",
            id: 6
          },
          activityName: {
            type: "string",
            id: 7
          },
          inWhiteList: {
            type: "bool",
            id: 8
          },
          whiteListStartTime: {
            type: "string",
            id: 9
          },
          whiteListEndTime: {
            type: "string",
            id: 10
          },
          kindId: {
            type: "int32",
            id: 11
          },
          hasDailyFree: {
            type: "bool",
            id: 12
          },
          freeNum: {
            type: "int32",
            id: 13
          },
          bubbleText: {
            type: "string",
            id: 14
          },
          runOutText: {
            type: "string",
            id: 15
          },
          showProtocol: {
            type: "bool",
            id: 16
          },
          mustNum: {
            type: "int32",
            id: 17
          },
          unusedCouponCount: {
            type: "int32",
            id: 18
          },
          unusedCardCount: {
            type: "int32",
            id: 19
          },
          AppraisalPrice: {
            type: "int32",
            id: 20
          },
          kindName: {
            type: "string",
            id: 22
          },
          firstOrderFree: {
            type: "bool",
            id: 23
          },
          unusedFamilyCardCount: {
            type: "int32",
            id: 24
          },
          aiTotalMustNum: {
            type: "int32",
            id: 25
          }
        }
      },
      TSAIServiceSinglePointAppraisalRequest: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          imgUrl: {
            type: "string",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          appraisalType: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAIServiceSinglePointAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          said: {
            type: "string",
            id: 3
          },
          originalBox: {
            type: "AIServiceAppraisalBox",
            id: 4
          },
          detectionBox: {
            type: "AIServiceAppraisalBox",
            id: 5
          }
        }
      },
      TSAIServiceGenAppraisalResultRequest: {
        fields: {
          saidList: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          payType: {
            type: "int32",
            id: 4
          },
          CardOrderId: {
            type: "int32",
            id: 5
          },
          CardOrderDetailId: {
            type: "int32",
            id: 6
          },
          appraisalType: {
            type: "int32",
            id: 7
          },
          couponChannel: {
            type: "CouponChannel",
            id: 8
          },
          appraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 9
          },
          advertisement: {
            type: "FromAdvertisement",
            id: 10
          },
          couponCode: {
            type: "string",
            id: 11
          },
          addressID: {
            type: "int32",
            id: 12
          },
          membershipPay: {
            type: "bool",
            id: 13
          },
          familyCardNo: {
            type: "string",
            id: 14
          }
        }
      },
      TSAIServiceGenAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          needJump: {
            type: "bool",
            id: 6
          },
          supportFamilyCard: {
            type: "bool",
            id: 7
          }
        }
      },
      TSAIServiceInsureAppraisalResultRequest: {
        fields: {
          saidList: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          },
          goodsName: {
            type: "string",
            id: 3
          },
          goodsPrice: {
            type: "int32",
            id: 4
          },
          serialNum: {
            type: "string",
            id: 5
          },
          cardOrderId: {
            type: "int32",
            id: 6
          },
          cardOrderDetailId: {
            type: "int32",
            id: 7
          },
          addressID: {
            type: "int32",
            id: 8
          }
        }
      },
      TSAIServiceInsureAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          oaid: {
            type: "string",
            id: 5
          },
          insureStatus: {
            type: "TSOPInsureStatus",
            id: 19
          },
          reportUrl: {
            type: "string",
            id: 6
          }
        }
      },
      TSAIServiceManualAppraisalResultRequest: {
        fields: {
          exteriorUrl: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          payType: {
            type: "int32",
            id: 3
          },
          CardOrderId: {
            type: "int32",
            id: 4
          },
          CardOrderDetailId: {
            type: "int32",
            id: 5
          },
          couponChannel: {
            type: "CouponChannel",
            id: 6
          },
          aiServicePointItem: {
            rule: "repeated",
            type: "ManualAppraisalResultItem",
            id: 7
          },
          advertisement: {
            type: "FromAdvertisement",
            id: 8
          },
          couponCode: {
            type: "string",
            id: 9
          },
          addressID: {
            type: "int32",
            id: 10
          },
          membershipPay: {
            type: "bool",
            id: 11
          },
          AppraiserId: {
            type: "int32",
            id: 12
          },
          familyCardNo: {
            type: "string",
            id: 13
          }
        }
      },
      TSAIServiceManualAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          supportFamilyCard: {
            type: "bool",
            id: 7
          }
        }
      },
      TSAIServiceTagAppraisalResultRequest: {
        fields: {
          appraisalType: {
            type: "AppraisalTypeEnum",
            id: 1
          },
          saidList: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          exteriorUrl: {
            type: "string",
            id: 3
          },
          serialNum: {
            type: "string",
            id: 4
          },
          cardOrderId: {
            type: "int32",
            id: 5
          },
          cardOrderDetailId: {
            type: "int32",
            id: 6
          },
          addressID: {
            type: "int32",
            id: 7
          },
          aiServicePointItem: {
            rule: "repeated",
            type: "ManualAppraisalResultItem",
            id: 8
          }
        }
      },
      TSAIServiceTagAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          reportUrl: {
            type: "string",
            id: 6
          }
        }
      },
      TSAIServiceTagBindRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          }
        }
      },
      TSAIServiceTagBindResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceAppraisalChanceRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAIServiceAppraisalChanceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          chance: {
            type: "bool",
            id: 4
          }
        }
      },
      TSAIServiceWechatProductPayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          },
          AppraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 3
          }
        }
      },
      TSAIServiceWechatProductPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSAIServiceGenAppraisalFeedbackListRequest: {
        fields: {}
      },
      TSAIServiceGenAppraisalFeedbackListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          feedbackList: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      TSAIServiceGenAppraisalFeedbackRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          feedback: {
            type: "string",
            id: 2
          },
          rating: {
            type: "int32",
            id: 3
          },
          commentary: {
            type: "string",
            id: 4
          }
        }
      },
      TSAIServiceGenAppraisalFeedbackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceTicketActivityBannerRequest: {
        fields: {}
      },
      TSAIServiceTicketActivityBannerResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ticketActivity: {
            type: "bool",
            id: 3
          },
          imageURL: {
            type: "string",
            id: 4
          },
          activityURL: {
            type: "string",
            id: 5
          },
          inWhiteList: {
            type: "bool",
            id: 6
          },
          whiteListStartTime: {
            type: "string",
            id: 7
          },
          whiteListEndTime: {
            type: "string",
            id: 8
          },
          limited: {
            type: "bool",
            id: 9
          },
          numLeft: {
            type: "uint32",
            id: 10
          },
          whiteListStartTimeStamp: {
            type: "string",
            id: 11
          },
          whiteListEndTimeStamp: {
            type: "string",
            id: 12
          }
        }
      },
      TSAIServiceGenAppraisalOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          state: {
            type: "AIServiceAppraisalOrderStateEnum",
            id: 3
          },
          source: {
            type: "string",
            id: 4
          },
          appraisalType: {
            type: "AIAppraisalType",
            id: 5
          }
        }
      },
      TSAIServiceGenAppraisalOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          order: {
            rule: "repeated",
            type: "AIServiceOrder",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSAIServiceGenAppraisalOrderListV3Request: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          state: {
            type: "DBAppraisalResultEnum",
            id: 3
          },
          source: {
            type: "string",
            id: 4
          },
          appraisalType: {
            type: "AIAppraisalType",
            id: 5
          },
          oaid: {
            type: "string",
            id: 6
          }
        }
      },
      TSAIServiceGenAppraisalOrderListV3Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          order: {
            rule: "repeated",
            type: "AIServiceOrder",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSAIServiceTagAppraisalOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          state: {
            type: "DBAppraisalResultEnum",
            id: 3
          },
          oaid: {
            type: "string",
            id: 6
          }
        }
      },
      TSAIServiceTagAppraisalOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          order: {
            rule: "repeated",
            type: "AIServiceOrder",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSAIServiceGenAppraisalReportRequest: {
        fields: {
          OAID: {
            type: "string",
            id: 1
          }
        }
      },
      TSAIServiceGenAppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exteriorUrl: {
            type: "string",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          hierarchy: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          appraisalTime: {
            type: "string",
            id: 14
          },
          description: {
            type: "string",
            id: 15
          },
          grade: {
            type: "string",
            id: 16
          },
          SARecordList: {
            rule: "repeated",
            type: "AIServiceAppraisalReportSAItem",
            id: 17
          },
          originalBox: {
            type: "AIServiceAppraisalBox",
            id: 18
          },
          detectionBox: {
            type: "AIServiceAppraisalBox",
            id: 19
          },
          rating: {
            type: "int32",
            id: 20
          }
        }
      },
      TSUpdateAppraisalPosterRequest: {
        fields: {
          OAID: {
            type: "string",
            id: 1
          },
          exteriorBase64: {
            type: "string",
            id: 2
          }
        }
      },
      TSUpdateAppraisalPosterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceGenAppraisalReportV3Request: {
        fields: {
          OAID: {
            type: "string",
            id: 1
          }
        }
      },
      TSAIServiceGenAppraisalReportV3Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exteriorUrl: {
            type: "string",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          hierarchy: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          appraisalTime: {
            type: "string",
            id: 14
          },
          description: {
            type: "string",
            id: 15
          },
          grade: {
            type: "string",
            id: 16
          },
          SARecordList: {
            rule: "repeated",
            type: "AIServiceAppraisalReportSAItem",
            id: 17
          },
          originalBox: {
            type: "AIServiceAppraisalBox",
            id: 18
          },
          detectionBox: {
            type: "AIServiceAppraisalBox",
            id: 19
          },
          rating: {
            type: "int32",
            id: 20
          },
          aiJadeAppraisalItem: {
            type: "AIJadeAppraisalItem",
            id: 21
          },
          aiToManualAppraisalResult: {
            type: "AIToManualAppraisalResult",
            id: 22
          },
          aiToManualDescription: {
            type: "string",
            id: 23
          },
          serviceSatisfaction: {
            type: "TSServiceSatisfaction",
            id: 24
          },
          material: {
            type: "string",
            id: 25
          },
          familyAndGenus: {
            type: "string",
            id: 26
          },
          mappingResult: {
            type: "string",
            id: 27
          },
          reportType: {
            type: "AppraisalReportType",
            id: 28
          },
          appraisalRemark: {
            type: "string",
            id: 32
          },
          appraisalValuation: {
            type: "string",
            id: 33
          },
          appraiser: {
            type: "string",
            id: 34
          },
          fromShouHuoBao: {
            type: "bool",
            id: 35
          },
          mappingNo: {
            type: "string",
            id: 36
          },
          appraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 37
          },
          appraisalProgress: {
            type: "AppraisalProgressEnum",
            id: 38
          },
          appraisalProgressBar: {
            type: "string",
            id: 39
          },
          isSpecialKind: {
            type: "bool",
            id: 40
          },
          specialKindResult: {
            type: "string",
            id: 41
          },
          createTime: {
            type: "string",
            id: 42
          },
          appraisalTimeStamp: {
            type: "string",
            id: 43
          },
          createTimeStamp: {
            type: "string",
            id: 44
          },
          cardRatings: {
            rule: "repeated",
            type: "CardRating",
            id: 45
          },
          items: {
            rule: "repeated",
            type: "AppraisalAttributeDetail",
            id: 46
          },
          appraisalposter: {
            type: "string",
            id: 47
          }
        }
      },
      TSAIServiceAppraisalReportWXACodeRequest: {
        fields: {
          scene: {
            type: "string",
            id: 1
          },
          page: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceAppraisalReportWXACodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imgData: {
            type: "bytes",
            id: 3
          }
        }
      },
      TSNumberFingerprintInfoRequest: {
        fields: {
          numberIDCard: {
            type: "string",
            id: 1
          }
        }
      },
      TSNumberFingerprintInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          fingerprintInfo: {
            rule: "repeated",
            type: "FingerprintInfo",
            id: 3
          },
          numberIDCard: {
            type: "string",
            id: 4
          },
          mainPic: {
            type: "string",
            id: 5
          },
          createTime: {
            type: "string",
            id: 6
          },
          phone: {
            type: "string",
            id: 7
          }
        }
      },
      FingerprintInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          index: {
            type: "string",
            id: 2
          },
          images: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      TSNumberFingerprintInfoListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          numberIDCard: {
            type: "string",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          }
        }
      },
      TSNumberFingerprintInfoListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          fingerprintItem: {
            rule: "repeated",
            type: "FingerprintItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSNumberFingerprintCheckInfoListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          numberIDCard: {
            type: "string",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          },
          status: {
            type: "string",
            id: 5
          }
        }
      },
      TSNumberFingerprintCheckInfoListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          checkItem: {
            rule: "repeated",
            type: "CheckItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSCreateNumberFingerprintInfoRequest: {
        fields: {
          mainPic: {
            type: "string",
            id: 1
          },
          fingerprintInfo: {
            rule: "repeated",
            type: "FingerprintInfo",
            id: 3
          }
        }
      },
      TSCreateNumberFingerprintInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          numberIDCard: {
            type: "string",
            id: 3
          }
        }
      },
      TSCheckFingerprintRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          numberIDCard: {
            type: "string",
            id: 2
          },
          index: {
            type: "string",
            id: 3
          }
        }
      },
      TSCheckFingerprintResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hasMatch: {
            type: "bool",
            id: 3
          }
        }
      },
      TSQueryAppraisalCouponCountRequest: {
        fields: {
          couponChannel: {
            type: "CouponChannel",
            id: 4
          }
        }
      },
      TSQueryAppraisalCouponCountResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          unusedCount: {
            type: "int32",
            id: 3
          },
          usedCount: {
            type: "int32",
            id: 4
          },
          expireCount: {
            type: "int32",
            id: 5
          }
        }
      },
      TSQueryAppraisalCouponRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          couponChannel: {
            type: "CouponChannel",
            id: 4
          }
        }
      },
      TSQueryAppraisalCouponResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isEnd: {
            type: "bool",
            id: 3
          },
          couponList: {
            rule: "repeated",
            type: "AppraisalCouponItem",
            id: 4
          },
          unusedCount: {
            type: "int32",
            id: 5
          },
          usedCount: {
            type: "int32",
            id: 6
          },
          expireCount: {
            type: "int32",
            id: 7
          },
          couponChannel: {
            type: "CouponChannel",
            id: 8
          }
        }
      },
      TSExchangeAppraisalCouponRequest: {
        fields: {
          couponCode: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeAppraisalCouponResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSNewOldRecognizeRequest: {
        fields: {
          images: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          isAll: {
            type: "bool",
            id: 2
          },
          bodyAffect: {
            type: "bool",
            id: 3
          },
          cornerAffect: {
            type: "bool",
            id: 4
          },
          beltAffect: {
            type: "bool",
            id: 5
          },
          insideAffect: {
            type: "bool",
            id: 6
          },
          hardwareAffect: {
            type: "bool",
            id: 7
          },
          haveMaintain: {
            type: "bool",
            id: 8
          }
        }
      },
      TSNewOldRecognizeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          newsGrades: {
            type: "string",
            id: 3
          },
          newsResults: {
            type: "string",
            id: 4
          },
          newsDetails: {
            rule: "repeated",
            type: "ImageResult",
            id: 5
          }
        },
        nested: {
          Result: {
            fields: {
              grade: {
                type: "string",
                id: 1
              },
              newsDescription: {
                type: "string",
                id: 2
              },
              newsResult: {
                type: "string",
                id: 3
              },
              position: {
                type: "string",
                id: 4
              }
            }
          },
          ImageResult: {
            fields: {
              image: {
                type: "string",
                id: 1
              },
              result: {
                type: "Result",
                id: 2
              }
            }
          }
        }
      },
      TSProductAiHolmesRequest: {
        fields: {
          imgB64: {
            type: "string",
            id: 1
          },
          brandId: {
            type: "int32",
            id: 2
          },
          skc: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 23
          },
          imageURL: {
            type: "string",
            id: 5
          }
        }
      },
      TSProductAiHolmesResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          holmesResult: {
            rule: "repeated",
            type: "HolmesResult",
            id: 3
          },
          hasMatch: {
            type: "bool",
            id: 4
          },
          logId: {
            type: "int32",
            id: 5
          }
        }
      },
      TSAIServiceClassifyRequest: {
        fields: {
          imageURL: {
            type: "string",
            id: 1
          },
          brandId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAIServiceClassifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hasMatch: {
            type: "bool",
            id: 3
          },
          logId: {
            type: "int32",
            id: 4
          },
          productInfoList: {
            rule: "repeated",
            type: "ProductInfo",
            id: 5
          }
        },
        nested: {
          SkuInfo: {
            fields: {
              image: {
                type: "string",
                id: 1
              },
              size: {
                type: "string",
                id: 2
              },
              measurement: {
                type: "string",
                id: 3
              },
              sku: {
                type: "string",
                id: 4
              },
              newsDetails: {
                rule: "repeated",
                type: "NewPriceResult",
                id: 5
              },
              brandName: {
                type: "string",
                id: 6
              },
              productName: {
                type: "string",
                id: 7
              },
              color: {
                type: "string",
                id: 8
              },
              brandId: {
                type: "int32",
                id: 9
              }
            }
          },
          ProductInfo: {
            fields: {
              brandName: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              color: {
                type: "string",
                id: 3
              },
              skuInfoList: {
                rule: "repeated",
                type: "SkuInfo",
                id: 4
              }
            }
          }
        }
      },
      TSAIServiceClassifyBaoRequest: {
        fields: {
          imageURL: {
            type: "string",
            id: 1
          },
          brandId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAIServiceClassifyBaoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hasMatch: {
            type: "bool",
            id: 3
          },
          logId: {
            type: "int32",
            id: 4
          },
          productInfo: {
            type: "ProductInfo",
            id: 5
          }
        },
        nested: {
          ProductInfo: {
            fields: {
              image: {
                type: "string",
                id: 1
              },
              size: {
                type: "string",
                id: 2
              },
              measurement: {
                type: "string",
                id: 3
              },
              sku: {
                type: "string",
                id: 4
              },
              brandName: {
                type: "string",
                id: 6
              },
              productName: {
                type: "string",
                id: 7
              },
              color: {
                type: "string",
                id: 8
              },
              brandId: {
                type: "int32",
                id: 9
              },
              seriesId: {
                type: "int32",
                id: 10
              },
              seriesName: {
                type: "string",
                id: 11
              }
            }
          }
        }
      },
      TSProductSimilarRequest: {
        fields: {
          skc: {
            type: "string",
            id: 1,
            options: {
              deprecated: true
            }
          },
          seriesId: {
            type: "int32",
            id: 2,
            options: {
              deprecated: true
            }
          },
          brandId: {
            type: "int32",
            id: 3
          },
          skcList: {
            rule: "repeated",
            type: "string",
            id: 4,
            options: {
              deprecated: true
            }
          },
          pageSize: {
            type: "int32",
            id: 5
          },
          source: {
            type: "string",
            id: 6
          }
        }
      },
      TSProductSimilarResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          skcSimilarItem: {
            rule: "repeated",
            type: "SimilarItem",
            id: 3
          },
          count: {
            type: "int32",
            id: 4
          }
        }
      },
      TSChooseBagStyleRequest: {
        fields: {
          imageURL: {
            type: "string",
            id: 1
          },
          kindID: {
            type: "uint32",
            id: 2
          },
          brandID: {
            type: "uint32",
            id: 3
          },
          serviceType: {
            type: "ServiceTypeEnum",
            id: 4
          }
        }
      },
      TSChooseBagStyleResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          BagStyleList: {
            rule: "repeated",
            type: "BagStyleItem",
            id: 3
          }
        },
        nested: {
          BagStyleItem: {
            fields: {
              skc: {
                type: "string",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              },
              productName: {
                type: "string",
                id: 3
              },
              color: {
                type: "string",
                id: 4
              },
              size: {
                type: "string",
                id: 5
              },
              measurement: {
                type: "string",
                id: 6
              },
              brandName: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSAppraisalOrderCloseRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalOrderCloseResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAppraisalOrderDelRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalOrderDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSNewComerGiftStateRequest: {
        fields: {}
      },
      TSNewComerGiftStateResponse: {
        fields: {
          isOn: {
            type: "bool",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          },
          amount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAppraisalOrderDetailRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderID: {
            type: "int32",
            id: 3
          },
          appraisalTime: {
            type: "string",
            id: 4
          },
          orderNo: {
            type: "string",
            id: 5
          },
          OAID: {
            type: "string",
            id: 6
          },
          userAccount: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          exteriorImg: {
            type: "string",
            id: 14
          },
          totalAmount: {
            type: "int32",
            id: 15
          },
          payWay: {
            type: "string",
            id: 16
          },
          payState: {
            type: "string",
            id: 17
          },
          result: {
            type: "string",
            id: 18
          },
          feedback: {
            type: "string",
            id: 19
          },
          SARecordList: {
            rule: "repeated",
            type: "TSSingleAppraisalRecordItem",
            id: 20
          },
          crouponNo: {
            type: "string",
            id: 21
          },
          description: {
            type: "string",
            id: 22
          },
          grade: {
            type: "string",
            id: 23
          }
        }
      },
      TSSingleAppraisalRecordItem: {
        fields: {
          SAID: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          grade: {
            type: "string",
            id: 4
          }
        }
      },
      TSAppraisalAppPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          },
          source: {
            type: "PaySource",
            id: 3
          }
        }
      },
      TSAppraisalAppPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          wechatOrderInfo: {
            type: "wechatObj",
            id: 3
          }
        },
        nested: {
          wechatObj: {
            fields: {
              appid: {
                type: "string",
                id: 1
              },
              noncestr: {
                type: "string",
                id: 2
              },
              "package": {
                type: "string",
                id: 3
              },
              partnerid: {
                type: "string",
                id: 4
              },
              prepayid: {
                type: "string",
                id: 5
              },
              timestamp: {
                type: "string",
                id: 6
              },
              sign: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSAppraisalAppPayV3Request: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          },
          source: {
            type: "PaySource",
            id: 3
          },
          platform: {
            type: "string",
            id: 4
          }
        }
      },
      TSAppraisalAppPayV3Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          wechatOrderInfo: {
            type: "wechatObj",
            id: 3
          },
          aliOrderInfo: {
            type: "string",
            id: 4
          }
        },
        nested: {
          wechatObj: {
            fields: {
              appid: {
                type: "string",
                id: 1
              },
              noncestr: {
                type: "string",
                id: 2
              },
              "package": {
                type: "string",
                id: 3
              },
              partnerid: {
                type: "string",
                id: 4
              },
              prepayid: {
                type: "string",
                id: 5
              },
              timestamp: {
                type: "string",
                id: 6
              },
              sign: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSAIServiceCommonReportRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          }
        }
      },
      TSAIServiceCommonReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exteriorUrl: {
            type: "string",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          hierarchy: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          appraisalTime: {
            type: "string",
            id: 14
          },
          description: {
            type: "string",
            id: 15
          },
          grade: {
            type: "string",
            id: 16
          },
          SARecordList: {
            rule: "repeated",
            type: "AIServiceAppraisalReportSAItem",
            id: 17
          },
          originalBox: {
            type: "AIServiceAppraisalBox",
            id: 18
          },
          detectionBox: {
            type: "AIServiceAppraisalBox",
            id: 19
          },
          rating: {
            type: "int32",
            id: 20
          },
          appraisalType: {
            type: "int32",
            id: 21
          },
          bytedanceImage: {
            rule: "repeated",
            type: "string",
            id: 22
          },
          tagType: {
            type: "int32",
            id: 23
          },
          isManual: {
            type: "bool",
            id: 24
          },
          suggestion: {
            type: "string",
            id: 25
          },
          channelId: {
            type: "int32",
            id: 26
          },
          aIToManualResult: {
            type: "AIToManualAppraisalResult",
            id: 27
          },
          muZuoResultName: {
            type: "string",
            id: 28
          },
          material: {
            type: "string",
            id: 29
          },
          familyAndGenus: {
            type: "string",
            id: 30
          },
          reportImageList: {
            rule: "repeated",
            type: "string",
            id: 31
          },
          appraisalRemark: {
            type: "string",
            id: 32
          },
          appraisalValuation: {
            type: "string",
            id: 33
          },
          appraiser: {
            type: "string",
            id: 34
          },
          cardRatings: {
            rule: "repeated",
            type: "CardRating",
            id: 35
          },
          reportType: {
            type: "AppraisalReportType",
            id: 36
          },
          isToManualRealTimeOrder: {
            type: "bool",
            id: 37
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 38
          },
          remark: {
            type: "string",
            id: 39
          }
        }
      },
      TSTagQueryInfo: {
        fields: {
          wxNickname: {
            type: "string",
            id: 1
          },
          wxAvatar: {
            type: "string",
            id: 2
          },
          checkDate: {
            type: "string",
            id: 3
          },
          ip: {
            type: "string",
            id: 4
          },
          address: {
            type: "string",
            id: 5
          }
        }
      },
      TagBriefInfo: {
        fields: {
          antiCounterfeitCode: {
            type: "string",
            id: 1
          },
          firstCheckDate: {
            type: "string",
            id: 2
          },
          queryTimes: {
            type: "int32",
            id: 3
          }
        }
      },
      GuideInfo: {
        fields: {
          isShow: {
            type: "bool",
            id: 1
          },
          guidePic: {
            type: "string",
            id: 2
          }
        }
      },
      TSTagCodeQueryRequest: {
        fields: {
          antiCounterfeitCode: {
            type: "string",
            id: 1
          },
          serialNum: {
            type: "string",
            id: 2
          },
          wxNickname: {
            type: "string",
            id: 3
          },
          wxAvatar: {
            type: "string",
            id: 4
          }
        }
      },
      TSTagCodeQueryResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isValid: {
            type: "bool",
            id: 3
          },
          queryList: {
            rule: "repeated",
            type: "TSTagQueryInfo",
            id: 4
          },
          briefInfo: {
            type: "TagBriefInfo",
            id: 5
          },
          guideInfo: {
            type: "GuideInfo",
            id: 6
          }
        }
      },
      TSTagCodeVerifyRequest: {
        fields: {
          antiCounterfeitCode: {
            type: "string",
            id: 1
          },
          serialNum: {
            type: "string",
            id: 2
          }
        }
      },
      TSTagCodeVerifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isValid: {
            type: "bool",
            id: 3
          }
        }
      },
      TSSubscribeAIToManualResultRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          }
        }
      },
      TSSubscribeAIToManualResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceV3GenAppraisalFeedbackRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          feedback: {
            type: "string",
            id: 2
          },
          serviceSatisfaction: {
            type: "TSServiceSatisfaction",
            id: 3
          },
          commentary: {
            type: "string",
            id: 4
          }
        }
      },
      TSAIServiceV3GenAppraisalFeedbackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMuZuoAppraisalReportGradeRequest: {
        fields: {
          btnNo: {
            type: "string",
            id: 1
          },
          oaId: {
            type: "string",
            id: 2
          }
        }
      },
      TSMuZuoAppraisalReportGradeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAppraisalPriceRequest: {
        fields: {
          appraisalType: {
            type: "AppraisalOrderType",
            id: 1
          },
          kindId: {
            type: "int32",
            id: 2
          },
          discountWay: {
            type: "AppraisalDiscountWay",
            id: 3
          },
          aiType: {
            type: "OnlineAppraisalType",
            id: 4
          }
        }
      },
      TsAppraisalPriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cardCount: {
            type: "int32",
            id: 3
          },
          couponCount: {
            type: "int32",
            id: 4
          },
          isMembership: {
            type: "bool",
            id: 5
          },
          canMembershipPay: {
            type: "bool",
            id: 6
          },
          appraisalPrice: {
            type: "int32",
            id: 7
          },
          payPrice: {
            type: "int32",
            id: 8
          },
          discountPrice: {
            type: "int32",
            id: 9
          },
          isWhitelist: {
            type: "bool",
            id: 10
          }
        }
      },
      TSSubscribeAppraisalResultRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          }
        }
      },
      TSSubscribeAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceUploadScreenCapRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          video: {
            type: "string",
            id: 2
          }
        }
      },
      TSAIServiceUploadScreenCapResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSIosInAppProductRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          cardId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSIosInAppProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productId: {
            type: "string",
            id: 3
          },
          price: {
            type: "int32",
            id: 4
          },
          enPrice: {
            type: "double",
            id: 5
          },
          enProductId: {
            type: "string",
            id: 6
          },
          tuseeAndroidProductId: {
            type: "string",
            id: 7
          },
          tuseeAndroidPrice: {
            type: "double",
            id: 8
          }
        }
      },
      TSIosInAppPayVerifyRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          receipt: {
            type: "string",
            id: 2
          },
          transactionId: {
            type: "string",
            id: 3
          },
          orderType: {
            type: "int32",
            id: 4
          }
        }
      },
      TSIosInAppPayVerifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSIosInAppPayMarkingRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSIosInAppPayMarkingResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSGooglePayVerifyRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          productId: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          }
        }
      },
      TSGooglePayVerifyReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPayPalGetOrderRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          cardId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSPayPalGetOrderReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfo: {
            type: "OrderInfo",
            id: 3
          }
        },
        nested: {
          OrderInfo: {
            fields: {
              clientId: {
                type: "string",
                id: 1
              },
              orderId: {
                type: "string",
                id: 2
              },
              userAction: {
                type: "string",
                id: 3
              },
              currency: {
                type: "string",
                id: 4
              },
              environment: {
                type: "string",
                id: 5
              },
              enProductId: {
                type: "string",
                id: 6
              },
              tuseeIosPrice: {
                type: "double",
                id: 7
              }
            }
          }
        }
      },
      TSPayPalVerifyRequest: {
        fields: {
          payPalOrderNo: {
            type: "string",
            id: 1
          },
          appraisalOrderNo: {
            type: "string",
            id: 2
          },
          orderType: {
            type: "int32",
            id: 3
          }
        }
      },
      TSPayPalVerifyReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAppraisalComplementImagesListRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      TsAppraisalComplementImagesListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraiserName: {
            type: "string",
            id: 3
          },
          appraiserAvatar: {
            type: "string",
            id: 4
          },
          categoryName: {
            type: "string",
            id: 5
          },
          categoryEnName: {
            type: "string",
            id: 6
          },
          categoryImage: {
            type: "string",
            id: 7
          },
          points: {
            rule: "repeated",
            type: "ComplementImagePoint",
            id: 8
          },
          kindId: {
            type: "int32",
            id: 9
          },
          categoryEnum: {
            type: "CategoryEnum",
            id: 10
          }
        },
        nested: {
          ComplementImagePoint: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              singleRecordImage: {
                type: "string",
                id: 2
              },
              pointType: {
                type: "int32",
                id: 3
              },
              pointId: {
                type: "int32",
                id: 4
              },
              photoGuide: {
                type: "string",
                id: 5
              },
              exampleImg: {
                type: "string",
                id: 6
              },
              stickFigureImg: {
                type: "string",
                id: 7
              },
              bigStickFigureImg: {
                type: "string",
                id: 8
              },
              must: {
                type: "int32",
                id: 9
              },
              necessity: {
                type: "bool",
                id: 10
              },
              isComplementImagePoint: {
                type: "bool",
                id: 11
              },
              reason: {
                type: "string",
                id: 12
              }
            }
          }
        }
      },
      TsAppraisalComplementImageRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          points: {
            rule: "repeated",
            type: "ComplementImagePoint",
            id: 2
          }
        },
        nested: {
          ComplementImagePoint: {
            fields: {
              pointId: {
                type: "int32",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TsAppraisalComplementImageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAppraisalAIComplementImageRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          saId: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TsAppraisalAIComplementImageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSubscribeManualResultRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          }
        }
      },
      TSSubscribeManualResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAOrderAIToManualCheckRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      TsAOrderAIToManualCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          toManual: {
            type: "bool",
            id: 3
          }
        }
      },
      TsAOrderAIToManualRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      TsAOrderAIToManualResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalOrderPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PayType",
            id: 2
          },
          cardId: {
            type: "int32",
            id: 3
          },
          couponCode: {
            type: "string",
            id: 4
          },
          familyCardNo: {
            type: "string",
            id: 5
          }
        },
        nested: {
          PayType: {
            values: {
              PAY_TYPE_DEFAULT: 0,
              PAY_TYPE_CARD: 1,
              PAY_TYPE_COUPON: 2,
              PAY_TYPE_FAMILY_CARD: 3
            }
          }
        }
      },
      AppraisalOrderPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      LLMsClassifyRequest: {
        fields: {
          image: {
            type: "string",
            id: 1
          }
        }
      },
      LLMsClassifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          match: {
            type: "bool",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandId: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesId: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          haveAppraisalPoints: {
            type: "bool",
            id: 10
          },
          categoryEnum: {
            type: "CategoryEnum",
            id: 11
          },
          appraisalTypeEnum: {
            type: "AppraisalTypeEnum",
            id: 12
          },
          jumpTo: {
            type: "JumpTo",
            id: 13
          },
          allSeriesId: {
            type: "int32",
            id: 14
          },
          allSeriesType: {
            type: "AppraisalTypeEnum",
            id: 15
          },
          result: {
            type: "Result",
            id: 16
          }
        },
        nested: {
          Result: {
            fields: {
              kind: {
                type: "string",
                id: 1
              },
              brand: {
                type: "string",
                id: 2
              },
              series: {
                type: "string",
                id: 3
              }
            }
          },
          JumpTo: {
            values: {
              JUMP_TO_DEFAULT: 0,
              JUMP_TO_KIND: 1,
              JUMP_TO_BRAND: 2,
              JUMP_TO_SERIES: 3,
              JUMP_TO_ALL_SERIES: 4
            }
          }
        }
      },
      AnnualAppraisalStatementHomeRequest: {
        fields: {}
      },
      AnnualAppraisalStatementHomeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          timeInterval: {
            type: "int32",
            id: 3
          },
          nickName: {
            type: "string",
            id: 4
          },
          registrationDate: {
            type: "string",
            id: 5
          },
          inviteKey: {
            type: "string",
            id: 6
          }
        }
      },
      AnnualAppraisalStatementOverviewRequest: {
        fields: {}
      },
      AnnualAppraisalStatementOverviewResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isZero: {
            type: "bool",
            id: 3
          },
          logoInfo: {
            rule: "repeated",
            type: "LogoInfo",
            id: 4
          },
          annualAppraisalCount: {
            rule: "repeated",
            type: "AnnualAppraisalCount",
            id: 5
          },
          appraisalRanking: {
            type: "string",
            id: 6
          },
          avoidedLoss: {
            type: "string",
            id: 7
          },
          currentBrand: {
            type: "BrandInfo",
            id: 8
          },
          firstBrand: {
            type: "BrandInfo",
            id: 9
          },
          totalValueTrue: {
            type: "string",
            id: 10
          },
          appreciatedPrice: {
            type: "int32",
            id: 11
          },
          appreciatedPriceRate: {
            type: "int32",
            id: 12
          },
          isShow: {
            type: "bool",
            id: 13
          },
          honoraryTitle: {
            type: "HonoraryTitle",
            id: 14
          },
          totalValue: {
            type: "string",
            id: 15
          },
          appraisalNum: {
            type: "int32",
            id: 16
          },
          quarterAppraisalNum: {
            rule: "repeated",
            type: "int32",
            id: 17
          },
          isMatch: {
            type: "bool",
            id: 18
          }
        },
        nested: {
          AnnualAppraisalCount: {
            fields: {
              trueNum: {
                type: "int32",
                id: 1
              },
              falseNum: {
                type: "int32",
                id: 2
              }
            }
          },
          LogoInfo: {
            fields: {
              image: {
                type: "string",
                id: 1
              },
              brandName: {
                type: "string",
                id: 3
              },
              brandID: {
                type: "int32",
                id: 4
              }
            }
          },
          BrandInfo: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              }
            }
          },
          HonoraryTitle: {
            values: {
              HonoraryTitleDefault: 0,
              HonoraryTitleLuxury: 1,
              HonoraryTitleHighQuality: 2,
              HonoraryTitleEntryLux: 3,
              HonoraryTitleTideway: 4,
              HonoraryTitleExquisite: 5,
              HonoraryTitleAccurateIdentification: 6
            }
          }
        }
      },
      TSAppraiserLoginRequest: {
        fields: {
          appraiserName: {
            type: "string",
            id: 1
          },
          oaid: {
            type: "string",
            id: 2
          }
        }
      },
      TSAppraiserLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          }
        }
      },
      TSAppraisalInfoRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          oaid: {
            type: "string",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          genuine: {
            type: "int32",
            id: 6
          },
          image: {
            type: "string",
            id: 7
          },
          appraisalPointItem: {
            rule: "repeated",
            type: "AppraisalPointItem",
            id: 8
          },
          appraisalResult: {
            type: "AIToManualAppraisalResult",
            id: 9
          }
        }
      },
      TSOverallAppraisalAI2ManualRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          appraisalResult: {
            type: "AIToManualAppraisalResult",
            id: 2
          }
        }
      },
      TSOverallAppraisalAI2ManualResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalPointItem: {
        fields: {
          image: {
            type: "string",
            id: 1
          },
          grade: {
            type: "int32",
            id: 2
          },
          pointId: {
            type: "int32",
            id: 3
          },
          pointName: {
            type: "string",
            id: 4
          }
        }
      },
      TSAppraiserLoginV2Request: {
        fields: {
          appraiserName: {
            type: "string",
            id: 1
          },
          appraiserPhone: {
            type: "string",
            id: 2
          }
        }
      },
      TSAppraiserLoginV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          }
        }
      },
      AISAppraiserListRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          pageNum: {
            type: "int32",
            id: 3
          }
        }
      },
      AISAppraiserListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraiserInfo: {
            rule: "repeated",
            type: "AppraiserInfo",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          AppraiserInfo: {
            fields: {
              avatarImg: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              level: {
                type: "AISAppraiserLevel",
                id: 3
              },
              description: {
                type: "string",
                id: 4
              },
              externalLink: {
                type: "string",
                id: 5,
                options: {
                  deprecated: true
                }
              },
              externalLinkType: {
                type: "ExternalLinkType",
                id: 6,
                options: {
                  deprecated: true
                }
              },
              linkInfo: {
                rule: "repeated",
                type: "LinkInfo",
                id: 7
              },
              orderCount: {
                type: "int32",
                id: 8
              },
              responseTime: {
                type: "ResponseTime",
                id: 9
              },
              IsShow: {
                type: "ShowAppraiserInfo",
                id: 10
              }
            },
            nested: {
              LinkInfo: {
                fields: {
                  externalLink: {
                    type: "string",
                    id: 1
                  },
                  externalLinkType: {
                    type: "ExternalLinkType",
                    id: 2
                  },
                  categoryId: {
                    type: "int32",
                    id: 3
                  },
                  categoryName: {
                    type: "string",
                    id: 4
                  },
                  categoryImg: {
                    type: "string",
                    id: 5
                  }
                }
              }
            }
          }
        }
      },
      AISAppraiserV2ListRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          pageNum: {
            type: "int32",
            id: 3
          },
          brandId: {
            type: "int32",
            id: 4
          },
          seriesId: {
            type: "int32",
            id: 5
          },
          appraiserName: {
            type: "string",
            id: 6
          }
        }
      },
      AISAppraiserV2ListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraiserInfo: {
            rule: "repeated",
            type: "AppraiserInfo",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          AppraiserInfo: {
            fields: {
              avatarImg: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              level: {
                type: "AISAppraiserLevel",
                id: 3
              },
              description: {
                type: "string",
                id: 4
              },
              orderCount: {
                type: "int32",
                id: 5
              },
              responseTime: {
                type: "ResponseTime",
                id: 6
              },
              IsShow: {
                type: "ShowAppraiserInfo",
                id: 7
              },
              id: {
                type: "int32",
                id: 8
              },
              kindInfos: {
                rule: "repeated",
                type: "AIServiceCategoryInfo",
                id: 9
              }
            }
          }
        }
      },
      AISAppraiserBrandRangeRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          appraiserId: {
            type: "int32",
            id: 2
          }
        }
      },
      AISAppraiserBrandRangeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotBrands: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          },
          tagBrands: {
            rule: "repeated",
            type: "AIServiceTagCategoryItem",
            id: 5
          }
        }
      },
      AISAppraiserSeriesRangeRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          brandId: {
            type: "int32",
            id: 2
          },
          appraiserId: {
            type: "int32",
            id: 3
          }
        }
      },
      AISAppraiserSeriesRangeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotSeries: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSBaiDuMiniAppHomePageTipRequest: {
        fields: {}
      },
      TSBaiDuMiniAppHomePageTipResponse: {
        fields: {
          tipText: {
            type: "string",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          }
        }
      },
      TSBaiDuMiniAppPageConfigRequest: {
        fields: {}
      },
      TSBaiDuMiniAppPageConfigResponse: {
        fields: {
          btnText: {
            type: "string",
            id: 1
          },
          timesUseUp: {
            type: "bool",
            id: 2
          },
          errorCode: {
            type: "int32",
            id: 3
          },
          errorMsg: {
            type: "string",
            id: 4
          }
        }
      },
      TSBaiDuMiniAppAppraisalResultRequest: {
        fields: {
          saidList: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          payType: {
            type: "int32",
            id: 4
          },
          CardOrderId: {
            type: "int32",
            id: 5
          },
          CardOrderDetailId: {
            type: "int32",
            id: 6
          },
          appraisalType: {
            type: "int32",
            id: 7
          },
          couponChannel: {
            type: "CouponChannel",
            id: 8
          }
        }
      },
      TSBaiDuMiniAppAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          }
        }
      },
      TSBDBrandsRequest: {
        fields: {
          kindEnum: {
            type: "KindEnum",
            id: 1
          }
        }
      },
      TSBDBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "AIBDServiceCategoryInitial",
            id: 3
          }
        }
      },
      TSBDAppraisalPointListRequest: {
        fields: {
          kindEnum: {
            type: "KindEnum",
            id: 1
          }
        }
      },
      TSBDAppraisalPointListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointInfo: {
            rule: "repeated",
            type: "AIServicePointInfo",
            id: 3
          }
        }
      },
      TSBDAppraisalRequest: {
        fields: {
          kindEnum: {
            type: "KindEnum",
            id: 1
          },
          brandName: {
            type: "string",
            id: 2
          },
          images: {
            rule: "repeated",
            type: "AppraisalImages",
            id: 3
          }
        },
        nested: {
          AppraisalImages: {
            fields: {
              pointInfo: {
                type: "AIServicePointInfo",
                id: 1
              },
              imageUrl: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSBDAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCardClassifyRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          }
        }
      },
      TSCardClassifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hasMatch: {
            type: "bool",
            id: 3
          },
          classifyId: {
            type: "string",
            id: 4
          },
          croppedImageUrl: {
            type: "string",
            id: 5
          },
          cards: {
            rule: "repeated",
            type: "CardProduct",
            id: 6
          }
        }
      },
      TSCardClassifySearchRequest: {
        fields: {
          cardName: {
            type: "string",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pageSize: {
            type: "int32",
            id: 3
          }
        }
      },
      TSCardClassifySearchResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cards: {
            rule: "repeated",
            type: "CardProduct",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          },
          isEnd: {
            type: "bool",
            id: 5
          }
        }
      },
      TSCardClassifyDetailRequest: {
        fields: {
          skc: {
            type: "string",
            id: 1
          }
        }
      },
      TSCardClassifyDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          card: {
            type: "CardProduct",
            id: 3
          },
          detail: {
            type: "CardProductDetail",
            id: 4
          },
          cardPrices: {
            rule: "repeated",
            type: "CardPrice",
            id: 5
          }
        },
        nested: {
          CardPrice: {
            fields: {
              date: {
                type: "string",
                id: 1
              },
              price: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      },
      TSCardClassifyFeedbackRequest: {
        fields: {
          classifyId: {
            type: "string",
            id: 4
          },
          feedback: {
            type: "string",
            id: 5
          }
        }
      },
      TSCardClassifyFeedbackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCardClassifyResultCheckRequest: {
        fields: {
          classifyId: {
            type: "string",
            id: 1
          },
          check: {
            type: "CardClassifyCheck",
            id: 2
          },
          skc: {
            type: "string",
            id: 3
          }
        }
      },
      TSCardClassifyResultCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMyCardClassifyListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSMyCardClassifyListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "CardClassifyRecord",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          CardClassifyRecord: {
            fields: {
              classifyId: {
                type: "string",
                id: 1
              },
              cardName: {
                type: "string",
                id: 2
              },
              kindName: {
                type: "string",
                id: 3
              },
              brandName: {
                type: "string",
                id: 4
              },
              seriesName: {
                type: "string",
                id: 5
              },
              image: {
                type: "string",
                id: 6
              },
              classifyTime: {
                type: "string",
                id: 7
              },
              check: {
                type: "CardClassifyCheck",
                id: 8
              },
              result: {
                type: "CardClassifyResult",
                id: 9
              }
            }
          }
        }
      },
      TSMyCardClassifyDetailRequest: {
        fields: {
          classifyId: {
            type: "string",
            id: 1
          }
        }
      },
      TSMyCardClassifyDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          classifyId: {
            type: "string",
            id: 3
          },
          card: {
            type: "CardProduct",
            id: 4
          },
          detail: {
            type: "CardProductDetail",
            id: 5
          }
        }
      },
      TSAdminCardClassifyListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          brandId: {
            type: "int32",
            id: 4
          },
          seriesId: {
            type: "int32",
            id: 5
          },
          cardName: {
            type: "string",
            id: 6
          },
          check: {
            type: "CardClassifyCheck",
            id: 7
          },
          result: {
            type: "CardClassifyResult",
            id: 8
          },
          skc: {
            type: "string",
            id: 9
          },
          sku: {
            type: "string",
            id: 10
          },
          startTime: {
            type: "string",
            id: 11
          },
          endTime: {
            type: "string",
            id: 12
          }
        }
      },
      TSAdminCardClassifyListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "CardClassifyRecord",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          CardClassifyRecord: {
            fields: {
              classifyId: {
                type: "string",
                id: 1
              },
              appSource: {
                type: "AppSource",
                id: 2
              },
              phone: {
                type: "string",
                id: 3
              },
              imageUrl: {
                type: "string",
                id: 4
              },
              brandName: {
                type: "string",
                id: 5
              },
              seriesName: {
                type: "string",
                id: 6
              },
              cardName: {
                type: "string",
                id: 7
              },
              check: {
                type: "CardClassifyCheck",
                id: 8
              },
              result: {
                type: "CardClassifyResult",
                id: 9
              },
              skc: {
                type: "string",
                id: 10
              },
              sku: {
                type: "string",
                id: 11
              },
              skcImage: {
                type: "string",
                id: 12
              },
              createTime: {
                type: "string",
                id: 13
              },
              feedback: {
                type: "string",
                id: 14
              }
            }
          }
        }
      },
      TSAdminCardClassifyDetailRequest: {
        fields: {
          classifyId: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminCardClassifyDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          classifyId: {
            type: "string",
            id: 3
          },
          appSource: {
            type: "AppSource",
            id: 4
          },
          phone: {
            type: "string",
            id: 5
          },
          imageUrl: {
            type: "string",
            id: 6
          },
          check: {
            type: "CardClassifyCheck",
            id: 7
          },
          result: {
            type: "CardClassifyResult",
            id: 8
          },
          createTime: {
            type: "string",
            id: 9
          },
          feedback: {
            type: "string",
            id: 10
          },
          card: {
            type: "CardProduct",
            id: 11
          },
          detail: {
            type: "CardProductDetail",
            id: 12
          }
        }
      },
      CardClassifyCheck: {
        values: {
          CARD_CLASSIFY_CHECK_DEFAULT: 0,
          CARD_CLASSIFY_CHECK_TRUE: 1,
          CARD_CLASSIFY_CHECK_FALSE: 2
        }
      },
      CardClassifyResult: {
        values: {
          CARD_CLASSIFY_RESULT_DEFAULT: 0,
          CARD_CLASSIFY_RESULT_TRUE: 1,
          CARD_CLASSIFY_RESULT_FALSE: 2
        }
      },
      CardProduct: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          skc: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          cardName: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          image: {
            type: "string",
            id: 8
          },
          serialNum: {
            type: "string",
            id: 9
          }
        }
      },
      PokemonCard: {
        fields: {
          cardType: {
            type: "string",
            id: 1
          },
          rarity: {
            type: "string",
            id: 2
          },
          hp: {
            type: "string",
            id: 3
          },
          property: {
            type: "string",
            id: 4
          },
          number: {
            type: "string",
            id: 5
          },
          pokemonType: {
            type: "string",
            id: 6
          },
          Height: {
            type: "string",
            id: 7
          },
          weight: {
            type: "string",
            id: 8
          },
          skill: {
            type: "string",
            id: 9
          },
          weakness: {
            type: "string",
            id: 10
          },
          resistance: {
            type: "string",
            id: 11
          },
          retreat: {
            type: "string",
            id: 12
          },
          language: {
            type: "string",
            id: 13
          }
        }
      },
      DigimonCard: {
        fields: {
          cardType: {
            type: "string",
            id: 1
          },
          rarity: {
            type: "string",
            id: 2
          },
          color: {
            type: "string",
            id: 3
          },
          level: {
            type: "string",
            id: 4
          },
          features: {
            type: "string",
            id: 5
          },
          cost: {
            type: "string",
            id: 6
          },
          evolutionEffect: {
            type: "string",
            id: 7
          },
          evolutionCondition: {
            type: "string",
            id: 8
          },
          dp: {
            type: "string",
            id: 9
          },
          effect: {
            type: "string",
            id: 10
          }
        }
      },
      OnePieceCard: {
        fields: {
          cardType: {
            type: "string",
            id: 1
          },
          rarity: {
            type: "string",
            id: 2
          },
          color: {
            type: "string",
            id: 3
          },
          features: {
            type: "string",
            id: 4
          },
          cost: {
            type: "string",
            id: 5
          },
          power: {
            type: "string",
            id: 6
          },
          counterattack: {
            type: "string",
            id: 7
          },
          ability: {
            type: "string",
            id: 8
          },
          trigger: {
            type: "string",
            id: 9
          }
        }
      },
      YuGiOhCard: {
        fields: {
          cardType: {
            type: "string",
            id: 1
          },
          rarity: {
            type: "string",
            id: 2
          },
          property: {
            type: "string",
            id: 3
          },
          star: {
            type: "string",
            id: 4
          },
          features: {
            type: "string",
            id: 5
          },
          effect: {
            type: "string",
            id: 6
          },
          atk: {
            type: "string",
            id: 7
          },
          def: {
            type: "string",
            id: 8
          },
          number: {
            type: "string",
            id: 9
          },
          produceYear: {
            type: "string",
            id: 10
          },
          link: {
            type: "string",
            id: 11
          }
        }
      },
      CardProductDetail: {
        oneofs: {
          card: {
            oneof: [
              "pokemonCard",
              "digimonCard",
              "onePieceCard",
              "yuGiOhCard"
            ]
          }
        },
        fields: {
          pokemonCard: {
            type: "PokemonCard",
            id: 1
          },
          digimonCard: {
            type: "DigimonCard",
            id: 2
          },
          onePieceCard: {
            type: "OnePieceCard",
            id: 3
          },
          yuGiOhCard: {
            type: "YuGiOhCard",
            id: 4
          }
        }
      },
      TSCardTopGetRequest: {
        fields: {}
      },
      TabItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          }
        }
      },
      TSCardTopGetResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ApiCardOrderBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 3
          },
          AvatarHDImage: {
            type: "string",
            id: 4
          },
          NickName: {
            type: "string",
            id: 5
          },
          PhoneNum: {
            type: "string",
            id: 6
          }
        }
      },
      TSCardTabListRequest: {
        fields: {}
      },
      TSCardTabListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          tabList: {
            rule: "repeated",
            type: "TabItem",
            id: 3
          }
        }
      },
      TSCardListGetRequest: {
        fields: {
          CardType: {
            type: "int32",
            id: 1
          },
          id: {
            type: "int32",
            id: 2
          }
        }
      },
      TSCardListGetResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ApiCardBase: {
            rule: "repeated",
            type: "ApiCardBase",
            id: 3
          }
        }
      },
      TSCardWechatProductPayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TSCardWechatProductPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSCardOrderCreateRequest: {
        fields: {
          Uid: {
            type: "int32",
            id: 2
          },
          Nickname: {
            type: "string",
            id: 4
          },
          PhoneNum: {
            type: "string",
            id: 6
          },
          CardBaseId: {
            type: "int32",
            id: 14
          },
          CardSource: {
            type: "int32",
            id: 1
          }
        }
      },
      TSCardOrderCreateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          CardOrderNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSCardOrderListRequest: {
        fields: {
          CardBaseStatus: {
            type: "int32",
            id: 11
          },
          OrderStatus: {
            type: "int32",
            id: 1
          },
          Uid: {
            type: "int32",
            id: 2
          }
        }
      },
      TSCardOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ApiCardOrderPkgBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 5
          },
          ApiCardOrderCardBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 6
          },
          ApiCardOrderFailureBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 7
          },
          ApiCardOrderBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 8
          }
        }
      },
      TSMyCardListRequest: {
        fields: {
          cardType: {
            type: "int32",
            id: 1
          },
          kindId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSMyCardListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ApiCardOrderCardBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 3
          },
          ApiCardOrderFailureBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 4
          }
        }
      },
      TSCardOrderListV2Request: {
        fields: {}
      },
      TSCardOrderListV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ApiCardOrderPkgBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 3
          },
          ApiCardOrderCardBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 4
          },
          ApiCardOrderFailureBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 5
          }
        }
      },
      TSCardOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSCardOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cardOrder: {
            type: "ApiCardOrderBase",
            id: 3
          }
        }
      },
      TSEntityCardPostRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          addressID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSEntityCardPostResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCardDeductionListRequest: {
        fields: {
          Uid: {
            type: "int32",
            id: 2
          },
          KindId: {
            type: "int32",
            id: 1
          },
          CardType: {
            type: "int32",
            id: 3
          }
        }
      },
      TSCardDeductionListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ApiCardOrderCanBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 3
          },
          ApiCardOrderNotCanBase: {
            rule: "repeated",
            type: "ApiCardOrderBase",
            id: 4
          }
        }
      },
      TSGetKindIdRequest: {
        fields: {
          KeyName: {
            type: "string",
            id: 1
          },
          ValName: {
            type: "string",
            id: 2
          }
        }
      },
      TSGetKindIdResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          KindId: {
            type: "int32",
            id: 3
          }
        }
      },
      TSCardGetAllStatusRequest: {
        fields: {}
      },
      TSCardGetAllStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          Status: {
            type: "int32",
            id: 3
          }
        }
      },
      ApiCardOrderBase: {
        fields: {
          Id: {
            type: "int32",
            id: 1
          },
          Uid: {
            type: "int32",
            id: 2
          },
          CardOrderNo: {
            type: "string",
            id: 3
          },
          CardNo: {
            type: "string",
            id: 16
          },
          Nickname: {
            type: "string",
            id: 4
          },
          CardName: {
            type: "string",
            id: 5
          },
          PhoneNum: {
            type: "string",
            id: 6
          },
          OrderPrice: {
            type: "int32",
            id: 7
          },
          PaymentType: {
            type: "int32",
            id: 8
          },
          OrderStatus: {
            type: "int32",
            id: 9
          },
          PayTime: {
            type: "string",
            id: 10
          },
          CardBaseStatus: {
            type: "int32",
            id: 11
          },
          ExpirationTime: {
            type: "string",
            id: 12
          },
          CreateTime: {
            type: "string",
            id: 13
          },
          UpdateTime: {
            type: "string",
            id: 14
          },
          CardType: {
            type: "int32",
            id: 18
          },
          ValiDays: {
            type: "int32",
            id: 19
          },
          ApiCardOrderDetail: {
            rule: "repeated",
            type: "ApiCardOrderDetail",
            id: 15
          },
          NoValidity: {
            type: "bool",
            id: 20
          },
          SurplusCount: {
            type: "int32",
            id: 21
          },
          SerialId: {
            type: "string",
            id: 23
          },
          backGroundImage: {
            type: "string",
            id: 24
          },
          fontColor: {
            type: "int32",
            id: 25
          },
          postStatus: {
            type: "int32",
            id: 26
          },
          PayTimeStamp: {
            type: "string",
            id: 27
          },
          ExpirationTimeStamp: {
            type: "string",
            id: 28
          },
          CreateTimeStamp: {
            type: "string",
            id: 29
          },
          UpdateTimeStamp: {
            type: "string",
            id: 30
          }
        }
      },
      ApiCardOrderDetail: {
        fields: {
          Id: {
            type: "int32",
            id: 1
          },
          KindId: {
            type: "int32",
            id: 2
          },
          VerifyCount: {
            type: "int32",
            id: 3
          },
          UseCount: {
            type: "int32",
            id: 4
          },
          KindName: {
            type: "string",
            id: 5
          }
        }
      },
      ApiCardOrderDetailList: {
        fields: {
          ApiCardOrderDetail: {
            rule: "repeated",
            type: "ApiCardOrderDetail",
            id: 3
          }
        }
      },
      ApiCardBaseDetail: {
        fields: {
          Id: {
            type: "int32",
            id: 1
          },
          KindId: {
            type: "int32",
            id: 2
          },
          VerifyCount: {
            type: "int32",
            id: 3
          },
          KindName: {
            type: "string",
            id: 5
          }
        }
      },
      ApiCardV2Module: {
        fields: {
          backgroundImage: {
            type: "string",
            id: 1
          },
          TotalRestrictCount: {
            type: "int32",
            id: 2
          },
          userCount: {
            type: "int32",
            id: 3
          },
          showZjLogo: {
            type: "bool",
            id: 4
          },
          isSupportAllKind: {
            type: "bool",
            id: 5
          },
          noValidity: {
            type: "bool",
            id: 6
          },
          TotalRestrictSurplusCount: {
            type: "int32",
            id: 7
          },
          IsTotalRestrictCount: {
            type: "int32",
            id: 8
          },
          fontColor: {
            type: "int32",
            id: 9
          }
        }
      },
      ApiCardBase: {
        fields: {
          CardName: {
            type: "string",
            id: 1
          },
          CardType: {
            type: "int32",
            id: 2
          },
          RestrictCount: {
            type: "int32",
            id: 3
          },
          ValidityDays: {
            type: "int32",
            id: 4
          },
          CardPrice: {
            type: "int32",
            id: 5
          },
          Status: {
            type: "int32",
            id: 6
          },
          CornerMark: {
            type: "string",
            id: 7
          },
          SortNum: {
            type: "int32",
            id: 8
          },
          IsRestrict: {
            type: "int32",
            id: 9
          },
          Id: {
            type: "int32",
            id: 11
          },
          ApiCardBaseDetail: {
            rule: "repeated",
            type: "ApiCardBaseDetail",
            id: 12
          },
          cardV2Module: {
            type: "ApiCardV2Module",
            id: 13
          },
          iamges: {
            type: "string",
            id: 14
          }
        }
      },
      ApiDetailList: {
        fields: {
          ApiCardBaseDetail: {
            rule: "repeated",
            type: "ApiCardBaseDetail",
            id: 3
          }
        }
      },
      TSCardExpertAppraisalPriceRequest: {
        fields: {
          cardNum: {
            type: "int32",
            id: 1
          }
        }
      },
      TSCardExpertAppraisalPriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          unitPrice: {
            type: "int32",
            id: 3
          },
          totalPrice: {
            type: "int32",
            id: 4
          },
          discount: {
            type: "int32",
            id: 5
          }
        }
      },
      TSCardExpertAppraisalOrderRequest: {
        fields: {
          images: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          },
          addressId: {
            type: "int32",
            id: 3
          },
          cardNum: {
            type: "int32",
            id: 4
          }
        }
      },
      TSCardExpertAppraisalOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          }
        }
      },
      TSExpertAppraisalOrderInfoRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSExpertAppraisalOrderInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          cardNum: {
            type: "int32",
            id: 4
          },
          orderTime: {
            type: "string",
            id: 5
          },
          payTime: {
            type: "string",
            id: 6
          },
          payWay: {
            type: "AppraisalPayWay",
            id: 7
          },
          payAmount: {
            type: "int32",
            id: 8
          },
          remark: {
            type: "string",
            id: 9
          },
          sender: {
            type: "string",
            id: 10
          },
          detailAddress: {
            type: "string",
            id: 11
          }
        }
      },
      CardExpertAppraisalProgressRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      CardExpertAppraisalProgressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          status: {
            type: "CardExpertAppraisalStatus",
            id: 3
          },
          mainTitle: {
            type: "string",
            id: 4
          },
          subTitle: {
            type: "string",
            id: 5
          },
          progress: {
            rule: "repeated",
            type: "Progress",
            id: 6
          },
          sendExpressCompany: {
            type: "string",
            id: 7
          },
          sendExpressNo: {
            type: "string",
            id: 8
          },
          backExpressCompany: {
            type: "string",
            id: 9
          },
          backExpressNo: {
            type: "string",
            id: 10
          }
        },
        nested: {
          Progress: {
            fields: {
              title: {
                type: "string",
                id: 1
              },
              time: {
                type: "string",
                id: 2
              },
              event: {
                type: "string",
                id: 3
              },
              highlight: {
                type: "bool",
                id: 4
              }
            }
          }
        }
      },
      CardExpertAppraisalReportRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          tagCode: {
            type: "string",
            id: 2
          }
        }
      },
      CardExpertAppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          report: {
            type: "CardExpertAppraisalReport",
            id: 3
          }
        }
      },
      CardExpertAppraisalReportsRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      CardExpertAppraisalReportsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          report: {
            rule: "repeated",
            type: "CardExpertAppraisalReport",
            id: 3
          }
        }
      },
      CardExpertAppraisalReport: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          tagCode: {
            type: "string",
            id: 2
          },
          result: {
            type: "AppraisalResult",
            id: 3
          },
          appraisalTime: {
            type: "string",
            id: 4
          },
          cardName: {
            type: "string",
            id: 5
          },
          ip: {
            type: "string",
            id: 6
          },
          language: {
            type: "string",
            id: 7
          },
          vintage: {
            type: "string",
            id: 8
          },
          rarity: {
            type: "string",
            id: 9
          },
          version: {
            type: "string",
            id: 10
          },
          serialNum: {
            type: "string",
            id: 11
          },
          totals: {
            type: "int32",
            id: 12
          },
          surface: {
            type: "int32",
            id: 13
          },
          centering: {
            type: "int32",
            id: 14
          },
          corners: {
            type: "int32",
            id: 15
          },
          edges: {
            type: "int32",
            id: 16
          },
          description: {
            type: "string",
            id: 17
          },
          ratingImage: {
            type: "string",
            id: 18
          },
          inStoreImage: {
            type: "string",
            id: 19
          },
          outStoreImage: {
            type: "string",
            id: 20
          },
          orderNo: {
            type: "string",
            id: 21
          },
          appraiserName: {
            type: "string",
            id: 22
          },
          avatarImg: {
            type: "string",
            id: 23
          },
          appraiserLevel: {
            type: "AISAppraiserLevel",
            id: 24
          }
        }
      },
      TSCashierDetailRequest: {
        fields: {
          cashierId: {
            type: "string",
            id: 1
          }
        }
      },
      TSCashierDetailResponse: {
        fields: {
          cashierId: {
            type: "string",
            id: 1
          },
          cashierName: {
            type: "string",
            id: 2
          },
          payUrl: {
            type: "string",
            id: 3
          },
          wxBrowserPayUrl: {
            type: "string",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          enable: {
            type: "bool",
            id: 6
          },
          errorCode: {
            type: "int32",
            id: 7
          },
          errorMsg: {
            type: "string",
            id: 8
          }
        }
      },
      TSWXAuthByCodeRequest: {
        fields: {
          appId: {
            type: "string",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          }
        }
      },
      TSWXAuthByCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          sessionKey: {
            type: "string",
            id: 4
          },
          unionId: {
            type: "string",
            id: 5
          }
        }
      },
      TSSaveCashierInfoRequest: {
        fields: {
          cashierId: {
            type: "string",
            id: 1
          },
          cashierName: {
            type: "string",
            id: 2
          },
          payUrl: {
            type: "string",
            id: 3
          },
          wxBrowserPayUrl: {
            type: "string",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          }
        }
      },
      TSSaveCashierInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSEnableCashierRequest: {
        fields: {
          cashierId: {
            type: "string",
            id: 1
          },
          enable: {
            type: "bool",
            id: 2
          }
        }
      },
      TSEnableCashierResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCashierListRequest: {
        fields: {}
      },
      TSCashierListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cashierList: {
            rule: "repeated",
            type: "Item",
            id: 3
          }
        },
        nested: {
          Item: {
            fields: {
              cashierId: {
                type: "string",
                id: 1
              },
              cashierName: {
                type: "string",
                id: 2
              },
              payUrl: {
                type: "string",
                id: 3
              },
              wxBrowserPayUrl: {
                type: "string",
                id: 4
              },
              remark: {
                type: "string",
                id: 5
              },
              enable: {
                type: "bool",
                id: 6
              }
            }
          }
        }
      },
      TSCloudStorageAppraisalResultRequest: {
        fields: {
          saidList: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          appraisalType: {
            type: "int32",
            id: 4
          }
        }
      },
      TSCloudStorageAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          brandID: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesID: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          }
        }
      },
      SCAIServiceManualAppraisalResultRequest: {
        fields: {
          exteriorUrl: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          aiServicePointItem: {
            rule: "repeated",
            type: "ManualAppraisalResultItem",
            id: 3
          }
        }
      },
      SCAIServiceManualAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          }
        }
      },
      TSGetCurrentCompetitionConfigsRequest: {
        fields: {}
      },
      TSGetCurrentCompetitionConfigsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          currentCompetition: {
            type: "Competition",
            id: 3
          },
          myFreeNum: {
            type: "int32",
            id: 4
          },
          myShareNum: {
            type: "int32",
            id: 5
          },
          myInviteKey: {
            type: "string",
            id: 6
          },
          myChallengeNum: {
            type: "int32",
            id: 7
          },
          isStartChallenge: {
            type: "bool",
            id: 8
          }
        }
      },
      TSCompetitionShareRequest: {
        fields: {}
      },
      TSCompetitionShareResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCompetitionPhaseRequest: {
        fields: {
          compType: {
            type: "CompetitionType",
            id: 1
          }
        }
      },
      TSCompetitionPhaseResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          typeInfo: {
            rule: "repeated",
            type: "TypeInfo",
            id: 3
          }
        },
        nested: {
          TypeInfo: {
            fields: {
              cid: {
                type: "int32",
                id: 1
              },
              phaseName: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSCompetitionRankRequest: {
        fields: {
          cid: {
            type: "int32",
            id: 1
          }
        }
      },
      TSCompetitionRankResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          myRank: {
            type: "int32",
            id: 3
          },
          myScore: {
            type: "int32",
            id: 4
          },
          myAvatar: {
            type: "string",
            id: 5
          },
          rankList: {
            rule: "repeated",
            type: "rank",
            id: 6
          },
          competitionStatus: {
            type: "int32",
            id: 7
          }
        },
        nested: {
          rank: {
            fields: {
              userName: {
                type: "string",
                id: 1
              },
              score: {
                type: "int32",
                id: 2
              },
              uid: {
                type: "int32",
                id: 3
              },
              avatar: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      CompetitionInfo: {
        fields: {
          type: {
            type: "string",
            id: 1
          },
          phase: {
            type: "int32",
            id: 2
          },
          status: {
            type: "int32",
            id: 3
          },
          questionType: {
            type: "string",
            id: 4
          },
          startTime: {
            type: "string",
            id: 5
          },
          endTime: {
            type: "string",
            id: 6
          }
        }
      },
      TSMyCompetitionRecordRequest: {
        fields: {}
      },
      TSMyCompetitionRecordResponse: {
        fields: {
          recordInfo: {
            rule: "repeated",
            type: "RecordInfo",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          }
        },
        nested: {
          myRecord: {
            fields: {
              score: {
                type: "int32",
                id: 1
              },
              time: {
                type: "string",
                id: 2
              }
            }
          },
          RecordInfo: {
            fields: {
              myRank: {
                type: "int32",
                id: 1
              },
              myScore: {
                type: "int32",
                id: 2
              },
              myRecordList: {
                rule: "repeated",
                type: "myRecord",
                id: 3
              },
              competitionInfo: {
                type: "CompetitionInfo",
                id: 4
              },
              competitionPhaseStr: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      TSMyCompetitionRewardRequest: {
        fields: {}
      },
      TSMyCompetitionRewardResponse: {
        fields: {
          rewardAmount: {
            type: "int32",
            id: 1
          },
          appraisalAmount: {
            type: "int32",
            id: 2
          },
          rewardInfo: {
            rule: "repeated",
            type: "RewardInfo",
            id: 3
          },
          errorCode: {
            type: "int32",
            id: 4
          },
          errorMsg: {
            type: "string",
            id: 5
          }
        },
        nested: {
          RewardInfo: {
            fields: {
              competitionInfo: {
                type: "CompetitionInfo",
                id: 1
              },
              reward: {
                type: "string",
                id: 2
              },
              challengeTime: {
                type: "string",
                id: 3
              },
              competitionPhaseStr: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      CurrentQuestion: {
        fields: {
          number: {
            type: "int32",
            id: 1
          },
          images: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TSMyCompetitionStartRequest: {
        fields: {
          compType: {
            type: "CompetitionType",
            id: 1
          }
        }
      },
      TSMyCompetitionStartResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          timeLimit: {
            type: "int32",
            id: 3
          },
          questionLimit: {
            type: "int32",
            id: 4
          },
          question: {
            type: "CurrentQuestion",
            id: 5
          },
          sequenceNo: {
            type: "string",
            id: 6
          },
          blackListUser: {
            type: "bool",
            id: 7
          }
        }
      },
      TSMyCompetitionCommitRequest: {
        fields: {
          number: {
            type: "int32",
            id: 1
          },
          genuine: {
            type: "bool",
            id: 2
          },
          sequenceNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSMyCompetitionCommitResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isEnd: {
            type: "bool",
            id: 3
          },
          showWarning: {
            type: "bool",
            id: 4
          },
          question: {
            type: "CurrentQuestion",
            id: 5
          },
          result: {
            type: "ChallengeResult",
            id: 6
          },
          copyWriting: {
            type: "string",
            id: 7
          }
        },
        nested: {
          ChallengeResult: {
            fields: {
              rid: {
                type: "int32",
                id: 1
              },
              challengeTime: {
                type: "string",
                id: 2
              },
              answerNum: {
                type: "int32",
                id: 3
              },
              correctNum: {
                type: "int32",
                id: 4
              },
              wrongNum: {
                type: "int32",
                id: 5
              },
              score: {
                type: "int32",
                id: 6
              },
              beatPercent: {
                type: "int32",
                id: 7
              }
            }
          }
        }
      },
      KnowledgeBaseAddRequest: {
        fields: {
          kind: {
            type: "int32",
            id: 1
          },
          brand: {
            type: "int32",
            id: 2
          },
          knowledgeBaseTitle: {
            type: "string",
            id: 3
          },
          knowledgeBaseContent: {
            type: "string",
            id: 4
          },
          knowledgeBaseLabel: {
            type: "string",
            id: 5
          },
          contentType: {
            type: "int32",
            id: 6
          }
        }
      },
      KnowledgeBaseAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          id: {
            type: "int32",
            id: 3
          }
        }
      },
      KnowledgeBaseUpdateRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          knowledgeBaseTitle: {
            type: "string",
            id: 3
          },
          knowledgeBaseContent: {
            type: "string",
            id: 4
          }
        }
      },
      KnowledgeBaseUpdateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      KnowledgeBaseSoftDelRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          }
        }
      },
      KnowledgeBaseSoftDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      KnowledgeBaseListRequest: {
        fields: {
          kind: {
            type: "int32",
            id: 1
          },
          brand: {
            type: "int32",
            id: 2
          },
          startTime: {
            type: "string",
            id: 3
          },
          endTime: {
            type: "string",
            id: 4
          },
          creator: {
            type: "string",
            id: 5
          },
          knowledgeBaseTitle: {
            type: "string",
            id: 6
          },
          knowledgeBaseContent: {
            type: "string",
            id: 7
          },
          pageSize: {
            type: "int32",
            id: 8
          },
          pageNum: {
            type: "int32",
            id: 9
          },
          contentType: {
            type: "int32",
            id: 10
          }
        }
      },
      KnowledgeBase: {
        fields: {
          kind: {
            type: "int32",
            id: 1
          },
          brand: {
            type: "int32",
            id: 2
          },
          createTime: {
            type: "string",
            id: 3
          },
          updateTime: {
            type: "string",
            id: 4
          },
          creator: {
            type: "string",
            id: 5
          },
          knowledgeBaseTitle: {
            type: "string",
            id: 6
          },
          knowledgeBaseContent: {
            type: "string",
            id: 7
          },
          knowledgeBaseLabel: {
            type: "string",
            id: 8
          },
          isSoftDelete: {
            type: "bool",
            id: 9
          },
          brandName: {
            type: "string",
            id: 10
          },
          kindName: {
            type: "string",
            id: 11
          },
          id: {
            type: "int32",
            id: 12
          },
          contentType: {
            type: "int32",
            id: 13
          }
        }
      },
      KnowledgeBaseListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          knowledgeBaseList: {
            rule: "repeated",
            type: "KnowledgeBase",
            id: 3
          },
          count: {
            type: "int32",
            id: 4
          }
        }
      },
      KnowledgeDetailRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          }
        }
      },
      KnowledgeDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kind: {
            type: "int32",
            id: 3
          },
          brand: {
            type: "int32",
            id: 4
          },
          creator: {
            type: "string",
            id: 5
          },
          createTime: {
            type: "string",
            id: 6
          },
          updateTime: {
            type: "string",
            id: 7
          },
          knowledgeBaseTitle: {
            type: "string",
            id: 8
          },
          knowledgeBaseContent: {
            type: "string",
            id: 9
          },
          knowledgeBaseLabel: {
            type: "string",
            id: 10
          },
          kindName: {
            type: "string",
            id: 11
          },
          brandName: {
            type: "string",
            id: 12
          },
          contentType: {
            type: "int32",
            id: 13
          }
        }
      },
      KnowledgeViewRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          }
        }
      },
      KnowledgeViewResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          knowledgeBaseContent: {
            type: "string",
            id: 3
          },
          createor: {
            type: "string",
            id: 4
          },
          createTime: {
            type: "string",
            id: 5
          },
          contentType: {
            type: "int32",
            id: 6
          }
        }
      },
      OperationRecordListRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          }
        }
      },
      OperationRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recordList: {
            rule: "repeated",
            type: "OperateRecord",
            id: 3
          }
        }
      },
      OperateRecord: {
        fields: {
          operator: {
            type: "string",
            id: 1
          },
          event: {
            type: "string",
            id: 2
          },
          operateTime: {
            type: "string",
            id: 3
          }
        }
      },
      ConsignOrderStateEnum: {
        values: {
          COS_Default: 0,
          COS_ToBeDelivered: 1,
          COS_HadDelivered: 2,
          COS_Check: 3,
          COS_ConfirmPrice: 4,
          COS_Consigning: 5,
          COS_SuccessfulTrade: 6,
          COS_FailedTrade: 7
        }
      },
      ConsignOrderListStateEnum: {
        values: {
          COLS_Default: 0,
          COLS_ToBeDeliver: 1,
          COLS_DeliverToPlatform: 2,
          COLS_ToCheck: 3,
          COLS_Checking: 4,
          COLS_CheckNo: 5,
          COLS_ToEvaluatePrice: 6,
          COLS_ToConfirmPrice: 7,
          COLS_ConfirmNo: 8,
          COLS_ConfirmOutTime: 9,
          COLS_Consigning: 10,
          COLS_SuccessfulTrade: 11,
          COLS_CancelTrade: 12,
          COLS_TradeOutTime: 13,
          COLS_HasSendBack: 14,
          COLS_ConsignToRecycle: 15,
          COLS_CancelDeliver: 16,
          COLS_ToEvaluate: 17,
          COLS_DeliverOutTime: 18,
          COLS_IsStandard: 19
        }
      },
      ConsignOrderButtonEnum: {
        values: {
          COB_Default: 0,
          COB_Deliver: 1,
          COB_Detail: 2,
          COB_AcceptPrice: 3,
          COB_RefusePrice: 4,
          COB_CancelDeliver: 5,
          COB_Edit: 6,
          COB_Details: 7
        }
      },
      ConsignOrderButton: {
        fields: {
          buttonEnum: {
            type: "ConsignOrderButtonEnum",
            id: 1
          },
          buttonTitle: {
            type: "string",
            id: 2
          }
        }
      },
      ConsignOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          consignOrderListStateEnum: {
            type: "ConsignOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          productTitle: {
            type: "string",
            id: 4
          },
          image: {
            type: "string",
            id: 5
          },
          price: {
            type: "uint32",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          news: {
            type: "string",
            id: 10
          },
          orderButton: {
            rule: "repeated",
            type: "ConsignOrderButton",
            id: 11
          },
          confirmTimeLeft: {
            type: "uint32",
            id: 12
          },
          finalPrice: {
            type: "uint32",
            id: 13
          },
          finalNews: {
            type: "string",
            id: 14
          },
          consignTimeLeft: {
            type: "uint32",
            id: 15
          },
          advancePayment: {
            type: "uint32",
            id: 16
          },
          balancePayment: {
            type: "uint32",
            id: 17
          },
          deliverTimeLeft: {
            type: "uint32",
            id: 18
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 19
          }
        }
      },
      ConsignOrderDetailInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          consignOrderListStateEnum: {
            type: "ConsignOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          stateIntroduction: {
            type: "string",
            id: 4
          },
          creatTime: {
            type: "string",
            id: 5
          },
          productTitle: {
            type: "string",
            id: 6
          },
          image: {
            type: "string",
            id: 7
          },
          price: {
            type: "uint32",
            id: 8
          },
          color: {
            type: "string",
            id: 9
          },
          size: {
            type: "string",
            id: 10
          },
          measurement: {
            type: "string",
            id: 11
          },
          news: {
            type: "string",
            id: 12
          },
          returnAddress: {
            type: "UserAddress",
            id: 13
          },
          record: {
            type: "ExpressRecord",
            id: 14
          },
          expressNo: {
            type: "string",
            id: 15
          },
          finalPrice: {
            type: "uint32",
            id: 16
          },
          finalNews: {
            type: "string",
            id: 17
          },
          confirmTimeLeft: {
            type: "uint32",
            id: 18
          },
          consignTimeLeft: {
            type: "uint32",
            id: 19
          },
          orderButton: {
            rule: "repeated",
            type: "ConsignOrderButton",
            id: 20
          },
          advancePayment: {
            type: "uint32",
            id: 21
          },
          balancePayment: {
            type: "uint32",
            id: 22
          },
          deliverTimeLeft: {
            type: "uint32",
            id: 23
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 24
          },
          description: {
            type: "string",
            id: 25
          }
        }
      },
      TSConsignAppraisalPointsRequest: {
        fields: {
          categoryEnum: {
            type: "CategoryEnum",
            id: 1
          },
          categoryID: {
            type: "uint32",
            id: 2
          }
        }
      },
      TSConsignAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointInfos: {
            rule: "repeated",
            type: "AIServicePointInfo",
            id: 3
          },
          buttonText: {
            type: "string",
            id: 4
          }
        }
      },
      TSConsignAppraisalResultRequest: {
        fields: {
          saidList: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          },
          newOldID: {
            type: "uint32",
            id: 3
          },
          kindID: {
            type: "uint32",
            id: 4
          },
          brandID: {
            type: "uint32",
            id: 5
          },
          skc: {
            type: "string",
            id: 6
          },
          price: {
            type: "uint32",
            id: 7
          }
        }
      },
      TSConsignAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          genuine: {
            type: "bool",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          }
        }
      },
      TSConsignGenOrderRequest: {
        fields: {
          newOldID: {
            type: "uint32",
            id: 1,
            options: {
              deprecated: true
            }
          },
          kindID: {
            type: "uint32",
            id: 2,
            options: {
              deprecated: true
            }
          },
          skc: {
            type: "string",
            id: 3,
            options: {
              deprecated: true
            }
          },
          sku: {
            type: "string",
            id: 4
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 5
          }
        }
      },
      TSConsignGenOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSConsignOrderListRequest: {
        fields: {
          pageNum: {
            type: "uint32",
            id: 1
          },
          pageSize: {
            type: "uint32",
            id: 2
          },
          state: {
            type: "ConsignOrderStateEnum",
            id: 3
          }
        }
      },
      TSConsignOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfos: {
            rule: "repeated",
            type: "ConsignOrderInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSConsignOrderDetailInfoRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSConsignOrderDetailInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderDetailInfo: {
            type: "ConsignOrderDetailInfo",
            id: 3
          }
        }
      },
      TSConsignEditRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TSConsignEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSConsignWannaDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          expressNo: {
            type: "string",
            id: 2
          },
          addressID: {
            type: "uint32",
            id: 3
          }
        }
      },
      TSConsignWannaDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSConsignCancelDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSConsignCancelDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSConsignAcceptPriceRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          accept: {
            type: "bool",
            id: 2
          }
        }
      },
      TSConsignAcceptPriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSConsignQueryExpressRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSConsignQueryExpressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressItems: {
            rule: "repeated",
            type: "ExpressItem",
            id: 3
          }
        }
      },
      TSConsignConfirmListRequest: {
        fields: {}
      },
      TSConsignConfirmListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          confirmList: {
            rule: "repeated",
            type: "ConfirmItem",
            id: 3
          }
        },
        nested: {
          ConfirmItem: {
            fields: {
              seconds: {
                type: "uint32",
                id: 1
              },
              price: {
                type: "uint32",
                id: 2
              },
              orderNo: {
                type: "string",
                id: 3
              },
              image: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      ExchangeProductItem: {
        fields: {
          productId: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          productImgUrl: {
            type: "string",
            id: 3
          },
          newsName: {
            type: "string",
            id: 4
          },
          color: {
            type: "string",
            id: 5
          },
          size: {
            type: "string",
            id: 6
          },
          measurement: {
            type: "string",
            id: 7
          },
          evaluatePrice: {
            type: "uint32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          sendWord: {
            type: "string",
            id: 10
          },
          userName: {
            type: "string",
            id: 11
          },
          material: {
            type: "string",
            id: 12
          },
          releasePrice: {
            type: "string",
            id: 13
          },
          releaseDate: {
            type: "string",
            id: 14
          },
          productCode: {
            type: "string",
            id: 15
          },
          exchangeType: {
            type: "string",
            id: 16
          },
          productImgUrlList: {
            rule: "repeated",
            type: "string",
            id: 17
          }
        }
      },
      ExchangeImageInfo: {
        fields: {
          position: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          required: {
            type: "bool",
            id: 3
          },
          pointId: {
            type: "int32",
            id: 4
          },
          imageType: {
            type: "string",
            id: 5
          },
          exampleImg: {
            type: "string",
            id: 6
          }
        }
      },
      ExchangeMyProductItem: {
        fields: {
          productId: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          productImgUrl: {
            type: "string",
            id: 3
          },
          exchangeType: {
            type: "string",
            id: 4
          },
          color: {
            type: "string",
            id: 5
          },
          size: {
            type: "string",
            id: 6
          },
          measurement: {
            type: "string",
            id: 7
          },
          statusName: {
            type: "string",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          sendWord: {
            type: "string",
            id: 10
          },
          userName: {
            type: "string",
            id: 11
          },
          status: {
            type: "ExchangeProductStatusEnum",
            id: 12
          },
          productImgList: {
            rule: "repeated",
            type: "ExchangeImageInfo",
            id: 13
          },
          aiNewsId: {
            type: "string",
            id: 14
          },
          aiNewsName: {
            type: "string",
            id: 15
          },
          gradeDes: {
            type: "string",
            id: 16
          },
          evaluatePrice: {
            type: "uint32",
            id: 17
          },
          evaluateNewsId: {
            type: "string",
            id: 18
          },
          kindId: {
            type: "int32",
            id: 19
          },
          newsName: {
            type: "string",
            id: 20
          },
          preShelveStatus: {
            type: "PreShelveStatus",
            id: 21
          }
        }
      },
      ExchangePageItem: {
        fields: {
          productItem: {
            type: "Product",
            id: 10
          },
          userInfo: {
            type: "User",
            id: 11
          },
          isExchange: {
            type: "bool",
            id: 12
          }
        },
        nested: {
          User: {
            fields: {
              nickname: {
                type: "string",
                id: 1
              },
              avatar: {
                type: "string",
                id: 2
              },
              sex: {
                type: "string",
                id: 3
              },
              address: {
                type: "string",
                id: 4
              }
            }
          },
          Product: {
            fields: {
              productId: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              productImgUrl: {
                type: "string",
                id: 3
              },
              productImageCount: {
                type: "int32",
                id: 4
              },
              newsName: {
                type: "string",
                id: 5
              },
              brandName: {
                type: "string",
                id: 6
              },
              evaluatePrice: {
                type: "uint32",
                id: 7
              },
              exchangeType: {
                type: "string",
                id: 8
              },
              productImgList: {
                rule: "repeated",
                type: "string",
                id: 9
              }
            }
          }
        }
      },
      TSExchangeCreateMatchOrderRequest: {
        fields: {
          isThreeMatchOrder: {
            type: "bool",
            id: 1
          }
        }
      },
      TSExchangeCreateMatchOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeCreateOrderRequest: {
        fields: {
          matchUuid: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeCreateOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeFindMatchProductRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeFindMatchProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeQuestionnaireRequest: {
        fields: {
          forPeople: {
            type: "string",
            id: 1
          },
          brandId: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeQuestionnaireResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeQuestionnaireJoinRequest: {
        fields: {}
      },
      TSExchangeQuestionnaireJoinResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isJoin: {
            type: "bool",
            id: 3
          }
        }
      },
      TSExchangeProductSlipRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSExchangeProductSlipResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exchangeProductList: {
            rule: "repeated",
            type: "ExchangePageItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSExchangeProductMatchCountRequest: {
        fields: {}
      },
      TSExchangeProductMatchCountResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchCount: {
            type: "int32",
            id: 3
          }
        }
      },
      TSExchangeProductSlipDetailRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeProductSlipDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exchangeProductDetail: {
            type: "ExchangeProductItem",
            id: 3
          },
          userInfo: {
            type: "UserInfo",
            id: 4
          },
          isOwner: {
            type: "bool",
            id: 5
          }
        },
        nested: {
          UserInfo: {
            fields: {
              avatar: {
                type: "string",
                id: 1
              },
              nickName: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSExchangeProductLikeListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSExchangeProductLikeListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "ExchangeProductItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSExchangeBroadcastRequest: {
        fields: {}
      },
      TSExchangeBroadcastResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          msg: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      TSExchangeAppraisalPointsRequest: {
        fields: {
          categoryEnum: {
            type: "CategoryEnum",
            id: 1
          },
          categoryID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSExchangeAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageinfo: {
            rule: "repeated",
            type: "ExchangeImageInfo",
            id: 3
          }
        }
      },
      TSExchangeProductAddRequest: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ExchangeImageInfo",
            id: 3
          }
        }
      },
      TSExchangeProductAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          newsName: {
            type: "string",
            id: 3
          },
          result: {
            type: "string",
            id: 4
          }
        }
      },
      TSExchangeProductCanAddRequest: {
        fields: {}
      },
      TSExchangeProductCanAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          result: {
            type: "bool",
            id: 3
          }
        }
      },
      TSExchangeMyProductDetailRequest: {
        fields: {
          productId: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeMyProductDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exchangeProductDetail: {
            type: "ExchangeMyProductItem",
            id: 3
          }
        }
      },
      TSExchangeProductListRequest: {
        fields: {}
      },
      MatchOrderItem: {
        fields: {
          productId: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          productImgUrl: {
            type: "string",
            id: 3
          },
          newsName: {
            type: "string",
            id: 4
          },
          color: {
            type: "string",
            id: 5
          },
          size: {
            type: "string",
            id: 6
          },
          measurement: {
            type: "string",
            id: 7
          },
          evaluatePrice: {
            type: "uint32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          status: {
            type: "MatchOrderStatusEnum",
            id: 10
          },
          waitPayAmount: {
            type: "int32",
            id: 16
          },
          matchNo: {
            type: "string",
            id: 17
          },
          diffFee: {
            type: "int32",
            id: 19
          },
          transferFee: {
            type: "int32",
            id: 20
          },
          matchEndTime: {
            type: "int32",
            id: 21
          }
        }
      },
      ExchangeItem: {
        fields: {
          exchangeStatus: {
            type: "ExchangeStatus",
            id: 1
          },
          product: {
            type: "ExchangeMyProductItem",
            id: 2
          },
          myOrder: {
            type: "OrderItem",
            id: 3
          },
          otherOrder: {
            type: "OrderItem",
            id: 4
          },
          matchCount: {
            type: "int32",
            id: 6
          },
          otherMatchOrder: {
            type: "MatchOrderItem",
            id: 7
          },
          bigOrderStatus: {
            type: "ExchangeOrderBigStatusEnum",
            id: 8
          },
          bigOrderStatusName: {
            type: "string",
            id: 9
          },
          matchBigOrderStatusEnum: {
            type: "MatchBigOrderStatusEnum",
            id: 10
          },
          matchBigOrderStatusName: {
            type: "string",
            id: 11
          }
        },
        nested: {
          OrderItem: {
            fields: {
              productId: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              productImgUrl: {
                type: "string",
                id: 3
              },
              newsName: {
                type: "string",
                id: 4
              },
              color: {
                type: "string",
                id: 5
              },
              size: {
                type: "string",
                id: 6
              },
              measurement: {
                type: "string",
                id: 7
              },
              evaluatePrice: {
                type: "uint32",
                id: 8
              },
              brandName: {
                type: "string",
                id: 9
              },
              status: {
                type: "ExchangeSbOrderStatusEnum",
                id: 10
              },
              subOrderStatusName: {
                type: "string",
                id: 11
              },
              exchangeType: {
                type: "string",
                id: 12
              },
              expressFee: {
                type: "int32",
                id: 14
              },
              transferFee: {
                type: "int32",
                id: 15
              },
              waitPayAmount: {
                type: "int32",
                id: 16
              },
              orderNo: {
                type: "string",
                id: 17
              },
              parentOrderId: {
                type: "string",
                id: 18
              },
              diffFee: {
                type: "int32",
                id: 19
              },
              payStatus: {
                type: "bool",
                id: 20
              },
              failReason: {
                type: "string",
                id: 21
              }
            }
          }
        }
      },
      TSExchangeProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "ExchangeItem",
            id: 3
          }
        }
      },
      TSExchangePidMatchListRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangePidMatchListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchProductList: {
            rule: "repeated",
            type: "MatchOrderItem",
            id: 3
          }
        }
      },
      OverViewExchangeItem: {
        fields: {
          productName: {
            type: "string",
            id: 1
          },
          productImgUrl: {
            type: "string",
            id: 2
          },
          newsName: {
            type: "string",
            id: 3
          },
          evaluatePrice: {
            type: "uint32",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          waitPayAmount: {
            type: "int32",
            id: 6
          },
          orderNo: {
            type: "string",
            id: 7
          },
          payStatus: {
            type: "bool",
            id: 8
          },
          matchEndTime: {
            type: "int32",
            id: 9
          }
        }
      },
      TSExchangeProductMatchListRequest: {
        fields: {}
      },
      TSExchangeProductMatchListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchProductList: {
            rule: "repeated",
            type: "OverViewExchangeItem",
            id: 3
          }
        }
      },
      TSExchangeProductUpdateRequest: {
        fields: {
          productId: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ExchangeImageInfo",
            id: 3
          }
        }
      },
      TSExchangeProductUpdateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeProductDelRequest: {
        fields: {
          productId: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeProductDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeProductLikeRequest: {
        fields: {
          productId: {
            type: "string",
            id: 1
          },
          like: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeProductLikeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isAdd: {
            type: "bool",
            id: 3
          }
        }
      },
      TSExchangeAcceptRequest: {
        fields: {
          matchNo: {
            type: "string",
            id: 1
          },
          accept: {
            type: "bool",
            id: 2
          }
        }
      },
      TSExchangeAcceptResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeAcceptEvaluatePriceRequest: {
        fields: {
          productId: {
            type: "string",
            id: 1
          },
          accept: {
            type: "bool",
            id: 2
          }
        }
      },
      TSExchangeAcceptEvaluatePriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeOrdePageRequest: {
        fields: {
          otherMatchNo: {
            type: "string",
            id: 1
          },
          addressId: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeOrdePageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "ExchangeProductItem",
            id: 3
          },
          transferFee: {
            type: "int32",
            id: 4
          },
          diffFee: {
            type: "int32",
            id: 5
          },
          expressFee: {
            type: "int32",
            id: 6
          },
          price: {
            type: "int32",
            id: 7
          },
          orderNo: {
            type: "string",
            id: 8
          },
          isPayMoney: {
            type: "bool",
            id: 9
          }
        }
      },
      TSExchangePayOrderRequest: {
        fields: {
          otherMatchNo: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangePayOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSExchangeConfirmOrderRequest: {
        fields: {
          otherMatchNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeConfirmOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          expressNumber: {
            type: "string",
            id: 2
          },
          backAddressId: {
            type: "string",
            id: 3
          }
        }
      },
      TSExchangeDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeConfirmReceiveRequest: {
        fields: {
          otherOrderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeConfirmReceiveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeMoneyProductRequest: {
        fields: {
          price: {
            type: "uint32",
            id: 1
          }
        }
      },
      TSExchangeMoneyProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExpertAppraisalKindsRequest: {
        fields: {}
      },
      TSExpertAppraisalKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSExpertAppraisalBrandsRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSExpertAppraisalBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotBrands: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSExpertAppraisalSeriesRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSExpertAppraisalSeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotSeries: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSExpertPriceDetailRequest: {
        fields: {
          categoryEnum: {
            type: "CategoryEnum",
            id: 1
          },
          categoryID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSExpertPriceDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          price: {
            type: "int32",
            id: 3
          },
          text: {
            type: "string",
            id: 4
          }
        }
      },
      TSGenExpertAppraisalOrderRequest: {
        fields: {
          image: {
            type: "string",
            id: 1
          },
          addressID: {
            type: "int32",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          recycle: {
            type: "bool",
            id: 4
          },
          categoryEnum: {
            type: "CategoryEnum",
            id: 5
          },
          categoryID: {
            type: "int32",
            id: 6
          },
          kindCategory: {
            type: "string",
            id: 7
          },
          membershipPay: {
            type: "bool",
            id: 8
          }
        }
      },
      TSGenExpertAppraisalOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          }
        }
      },
      TSExpertAppraisalOrderPayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TSExpertAppraisalOrderPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSExpertAppraisalOrderUserSentRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          expressNumber: {
            type: "string",
            id: 2
          },
          expressCompany: {
            type: "string",
            id: 3
          },
          addressId: {
            type: "int32",
            id: 4
          }
        }
      },
      TSExpertAppraisalOrderUserSentResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExpertAppraisalOrderUserListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          state: {
            type: "ExpertAppraisalOrderStateEnum",
            id: 3
          }
        }
      },
      TSExpertAppraisalOrderUserListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderList: {
            rule: "repeated",
            type: "UserExpertAppraisalOrder",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSExpertAppraisalOrderUserCheckProcessRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          }
        }
      },
      TSExpertAppraisalOrderUserCheckProcessResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          flowItems: {
            rule: "repeated",
            type: "FlowItem",
            id: 3
          }
        }
      },
      FLowRecord: {
        fields: {
          updateTime: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          isRecycle: {
            type: "bool",
            id: 3
          },
          recycleDetail: {
            type: "RecycleDetail",
            id: 4
          },
          comment: {
            type: "string",
            id: 5
          }
        }
      },
      RecycleDetail: {
        fields: {
          seconds: {
            type: "int32",
            id: 1
          },
          price: {
            type: "int32",
            id: 2
          },
          reportID: {
            type: "string",
            id: 3
          },
          orderNumber: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          image: {
            type: "string",
            id: 8
          }
        }
      },
      FlowItem: {
        fields: {
          itemTitle: {
            type: "string",
            id: 1
          },
          itemState: {
            type: "bool",
            id: 2
          },
          hasDetail: {
            type: "bool",
            id: 3
          },
          expressCompany: {
            type: "string",
            id: 4
          },
          expressNumber: {
            type: "string",
            id: 5
          },
          records: {
            rule: "repeated",
            type: "FLowRecord",
            id: 6
          },
          flowType: {
            type: "string",
            id: 7
          },
          itemTitleHide: {
            type: "bool",
            id: 8
          }
        }
      },
      TSExpertAppraisalReportRequest: {
        fields: {
          reportID: {
            type: "string",
            id: 1
          }
        }
      },
      TSExpertAppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          report: {
            type: "ExpertAppraisalReport",
            id: 3
          }
        }
      },
      TSExpertAppraisalRecycleListRequest: {
        fields: {}
      },
      TSExpertAppraisalRecycleListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recycleList: {
            rule: "repeated",
            type: "RecycleDetail",
            id: 3
          }
        }
      },
      TSExpertAppraisalRecycleAcceptRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          isAccept: {
            type: "bool",
            id: 2
          }
        }
      },
      TSExpertAppraisalRecycleAcceptResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      UserExpertAppraisalOrder: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          seriesName: {
            type: "string",
            id: 5
          },
          price: {
            type: "int32",
            id: 6
          },
          payWay: {
            type: "string",
            id: 7
          },
          status: {
            type: "int32",
            id: 8
          },
          statusName: {
            type: "string",
            id: 9
          },
          createTime: {
            type: "string",
            id: 10
          },
          result: {
            type: "string",
            id: 11
          },
          EAReportID: {
            type: "string",
            id: 12
          },
          appraisalType: {
            type: "ExpertAppraisalType",
            id: 13
          },
          sender: {
            type: "string",
            id: 14
          },
          detailAddress: {
            type: "string",
            id: 15
          }
        }
      },
      ExpertAppraisalReport: {
        fields: {
          ID: {
            type: "uint32",
            id: 1
          },
          EAReportID: {
            type: "string",
            id: 2
          },
          image: {
            type: "string",
            id: 3
          },
          result: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          productID: {
            type: "string",
            id: 8
          },
          appraiser: {
            type: "string",
            id: 9
          },
          genuine: {
            type: "bool",
            id: 10
          },
          createTime: {
            type: "string",
            id: 11
          },
          appraiserSign: {
            type: "string",
            id: 12
          },
          resultText: {
            type: "string",
            id: 13
          },
          orderNumber: {
            type: "string",
            id: 14
          },
          appraisalTime: {
            type: "string",
            id: 15
          },
          createTimeStamp: {
            type: "string",
            id: 16
          },
          appraisalTimeStamp: {
            type: "string",
            id: 17
          }
        }
      },
      TSExpertAppraisalReportTypeRequest: {
        fields: {
          reportID: {
            type: "string",
            id: 1
          }
        }
      },
      TSExpertAppraisalReportTypeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          reportType: {
            type: "int32",
            id: 3
          }
        }
      },
      TSSubscribeExpertAppraisalResultRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          }
        }
      },
      TSSubscribeExpertAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSFakeInfoCollectRequest: {
        fields: {
          channelName: {
            type: "string",
            id: 1
          },
          merchantName: {
            type: "string",
            id: 2
          },
          description: {
            type: "string",
            id: 3
          },
          img: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          oaid: {
            type: "string",
            id: 5
          },
          otherChannelName: {
            type: "string",
            id: 6
          }
        }
      },
      TSFakeInfoCollectResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSFakeInfoCollectChannelRequest: {
        fields: {}
      },
      TSFakeInfoCollectChannelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          channelInfo: {
            rule: "repeated",
            type: "ChannelInfo",
            id: 3
          }
        },
        nested: {
          ChannelInfo: {
            fields: {
              channelName: {
                type: "string",
                id: 1
              },
              channelImg: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSFakeInfoCollectClickRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          }
        }
      },
      TSFakeInfoCollectClickResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hasCommit: {
            type: "bool",
            id: 3
          }
        }
      },
      TSFamilyCardListRequest: {
        fields: {}
      },
      TSFamilyCardListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cards: {
            rule: "repeated",
            type: "FamilyCard",
            id: 3
          }
        },
        nested: {
          FamilyCard: {
            fields: {
              cardType: {
                type: "FamilyCardType",
                id: 1
              },
              price: {
                type: "int32",
                id: 2
              },
              originPrice: {
                type: "int32",
                id: 3
              },
              rightsImage: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSFamilyCardOrderCreateRequest: {
        fields: {
          cardType: {
            type: "FamilyCardType",
            id: 1
          }
        }
      },
      TSFamilyCardOrderCreateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          cardNo: {
            type: "string",
            id: 4
          }
        }
      },
      TSFamilyCardOrderInfoRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSFamilyCardOrderInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          nickName: {
            type: "string",
            id: 4
          },
          cardType: {
            type: "FamilyCardType",
            id: 5
          },
          payAmount: {
            type: "int32",
            id: 6
          },
          orderTime: {
            type: "string",
            id: 7
          }
        }
      },
      TSFamilyCardOrderWechatPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TSFamilyCardOrderWechatPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSMyFamilyCardListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          cardStatus: {
            type: "FamilyCardStatus",
            id: 3
          }
        }
      },
      TSMyFamilyCardListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cards: {
            rule: "repeated",
            type: "FamilyCard",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          FamilyCard: {
            fields: {
              cardNo: {
                type: "string",
                id: 1
              },
              cardImage: {
                type: "string",
                id: 2
              },
              cardType: {
                type: "FamilyCardType",
                id: 3
              },
              cardStatus: {
                type: "FamilyCardStatus",
                id: 4
              },
              expireTime: {
                type: "string",
                id: 6
              },
              used: {
                type: "int32",
                id: 7
              },
              remaining: {
                type: "int32",
                id: 8
              },
              description: {
                type: "string",
                id: 9
              },
              users: {
                rule: "repeated",
                type: "BindUser",
                id: 10
              },
              ownership: {
                type: "FamilyCardOwnership",
                id: 11
              },
              canShare: {
                type: "bool",
                id: 12
              }
            }
          },
          BindUser: {
            fields: {
              nickName: {
                type: "string",
                id: 1
              },
              avatar: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSFamilyCardExchangeRequest: {
        fields: {
          exchangeCode: {
            type: "string",
            id: 1
          }
        }
      },
      TSFamilyCardExchangeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSFamilyCardShareRequest: {
        fields: {
          cardNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSFamilyCardShareResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          shareCode: {
            type: "string",
            id: 3
          }
        }
      },
      TSFamilyCardAcceptRequest: {
        fields: {
          shareCode: {
            type: "string",
            id: 1
          }
        }
      },
      TSFamilyCardAcceptResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      QueryStrategyRequest: {
        fields: {
          configKey: {
            type: "string",
            id: 1
          }
        }
      },
      QueryStrategyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          data: {
            type: "StrategyResult",
            id: 3
          }
        }
      },
      StrategyResult: {
        fields: {
          strategyCode: {
            type: "string",
            id: 1
          }
        }
      },
      TSKuaiShouMiniAppHomePageTipRequest: {
        fields: {}
      },
      TSKuaiShouMiniAppHomePageTipResponse: {
        fields: {
          tipText: {
            type: "string",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          }
        }
      },
      TSKuaiShouMiniAppPageConfigRequest: {
        fields: {}
      },
      TSKuaiShouMiniAppPageConfigResponse: {
        fields: {
          btnText: {
            type: "string",
            id: 1
          },
          timesUseUp: {
            type: "bool",
            id: 2
          },
          errorCode: {
            type: "int32",
            id: 3
          },
          errorMsg: {
            type: "string",
            id: 4
          }
        }
      },
      TSKuaiShouMiniAppAppraisalResultRequest: {
        fields: {
          saidList: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          payType: {
            type: "int32",
            id: 4
          },
          CardOrderId: {
            type: "int32",
            id: 5
          },
          CardOrderDetailId: {
            type: "int32",
            id: 6
          },
          appraisalType: {
            type: "int32",
            id: 7
          },
          couponChannel: {
            type: "CouponChannel",
            id: 8
          }
        }
      },
      TSKuaiShouMiniAppAppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          needPay: {
            type: "bool",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          }
        }
      },
      TSLiveInfoListRequest: {
        fields: {
          start: {
            type: "int32",
            id: 1
          },
          limit: {
            type: "int32",
            id: 2
          }
        }
      },
      TSLiveInfoListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          liveRoomList: {
            rule: "repeated",
            type: "RoomInfo",
            id: 3
          },
          subscribeRoomList: {
            rule: "repeated",
            type: "RoomInfo",
            id: 4
          },
          replayRoomList: {
            rule: "repeated",
            type: "RoomInfo",
            id: 5
          }
        },
        nested: {
          Goods: {
            fields: {
              coverImage: {
                type: "string",
                id: 1
              },
              url: {
                type: "string",
                id: 2
              },
              price: {
                type: "string",
                id: 3
              },
              name: {
                type: "string",
                id: 4
              }
            }
          },
          RoomInfo: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              roomId: {
                type: "int32",
                id: 2
              },
              coverImg: {
                type: "string",
                id: 3
              },
              anchorName: {
                type: "string",
                id: 4
              },
              goods: {
                rule: "repeated",
                type: "Goods",
                id: 5
              },
              liveStatus: {
                type: "int32",
                id: 6
              },
              startTime: {
                type: "string",
                id: 7
              },
              endTime: {
                type: "string",
                id: 8
              },
              productCount: {
                type: "int32",
                id: 9
              }
            }
          }
        }
      },
      TSDrawLotteryPoolInfoListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          lotteryStatus: {
            type: "string",
            id: 4
          },
          status: {
            type: "string",
            id: 5
          }
        }
      },
      TSDrawLotteryPoolInfoListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          lotteryPoolInfo: {
            rule: "repeated",
            type: "LotteryPoolItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSDrawLotteryInfoRequest: {
        fields: {
          activityName: {
            type: "string",
            id: 1
          },
          lotteryPic: {
            type: "string",
            id: 2
          },
          lotteryStartTime: {
            type: "string",
            id: 3
          },
          lotteryEndTime: {
            type: "string",
            id: 4
          },
          lotteryNum: {
            type: "int32",
            id: 5
          },
          lotteryUserStr: {
            type: "string",
            id: 6
          }
        }
      },
      TSDrawLotteryInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSDrawLotteryPoolInfoRequest: {
        fields: {
          Id: {
            type: "int32",
            id: 1
          }
        }
      },
      TSDrawLotteryPoolInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          lotteryPoolInfo: {
            type: "LotteryPoolItem",
            id: 3
          }
        }
      },
      TSDrawLotteryUserInfoRequest: {
        fields: {
          lotteryPoolId: {
            type: "int32",
            id: 1
          },
          lotteryUserStr: {
            type: "string",
            id: 2
          }
        }
      },
      TSDrawLotteryUserInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSDrawLotteryUserInfoListRequest: {
        fields: {
          lotteryPoolId: {
            type: "int32",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          pageNum: {
            type: "int32",
            id: 4
          },
          pageSize: {
            type: "int32",
            id: 5
          },
          status: {
            type: "string",
            id: 6
          }
        }
      },
      TSDrawLotteryUserInfoListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          userPoolInfo: {
            rule: "repeated",
            type: "UserPoolItem",
            id: 4
          },
          totalCount: {
            type: "int32",
            id: 5
          }
        }
      },
      TSDrawLotteryRequest: {
        fields: {
          lotteryPoolId: {
            type: "int32",
            id: 1
          },
          newStatus: {
            type: "string",
            id: 2
          }
        }
      },
      TSDrawLotteryResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSDrawLotteryUserRequest: {
        fields: {
          lotteryPoolId: {
            type: "int32",
            id: 1
          }
        }
      },
      TSDrawLotteryUserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          }
        }
      },
      TSDeleteDrawLotteryRequest: {
        fields: {
          lotteryPoolId: {
            type: "int32",
            id: 1
          }
        }
      },
      TSDeleteDrawLotteryResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSManualAppraiserLoginRequest: {
        fields: {
          appraiserName: {
            type: "string",
            id: 1
          },
          moaid: {
            type: "string",
            id: 2
          }
        }
      },
      TSManualAppraiserLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          }
        }
      },
      TSManualAppraiserResultRequest: {
        fields: {
          moaid: {
            type: "string",
            id: 1
          },
          appraiserDetailInfo: {
            type: "ManualAppraiserDetailInfos",
            id: 2
          }
        }
      },
      TSManualAppraiserResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      ManualAppraiserPointItem: {
        fields: {
          image: {
            type: "string",
            id: 1
          },
          grade: {
            type: "int32",
            id: 2
          },
          pointId: {
            type: "int32",
            id: 3
          },
          pointname: {
            type: "string",
            id: 4
          },
          commentId: {
            type: "int32",
            id: 5
          },
          commentList: {
            rule: "repeated",
            type: "PointComment",
            id: 6
          },
          comment: {
            type: "string",
            id: 7
          }
        }
      },
      ManualAppraiserDetailInfos: {
        fields: {
          appraisalResult: {
            type: "DBAppraisalResultEnum",
            id: 1
          },
          appraisalDesc: {
            rule: "repeated",
            type: "ManualAppraiserPointItem",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          image: {
            type: "string",
            id: 5
          },
          appraisalType: {
            type: "int32",
            id: 6
          },
          h5source: {
            type: "AIServiceAppraisalSourceH5Enum",
            id: 7
          },
          suggestion: {
            type: "string",
            id: 8
          }
        }
      },
      DoubleCheckAIAppraisalInfo: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          appraisalTime: {
            type: "string",
            id: 2
          },
          genuine: {
            type: "int32",
            id: 3
          },
          description: {
            type: "string",
            id: 4
          },
          grade: {
            type: "int32",
            id: 5
          }
        }
      },
      TSManualAppraiserDetailRequest: {
        fields: {
          moaid: {
            type: "string",
            id: 1
          }
        }
      },
      TSManualAppraiserDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraiserDetailInfo: {
            type: "ManualAppraiserDetailInfos",
            id: 3
          },
          aiOrderDetailInfo: {
            type: "DoubleCheckAIAppraisalInfo",
            id: 4
          }
        }
      },
      TSAppraisalAppraiserDetailRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalAppraiserDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraiserDetailInfo: {
            type: "AIAppraiserDetailInfos",
            id: 3
          }
        },
        nested: {
          AIAppraiserDetailInfos: {
            fields: {
              genuine: {
                type: "int32",
                id: 1
              },
              appraisalDesc: {
                rule: "repeated",
                type: "ManualAppraiserPointItem",
                id: 2
              },
              kindName: {
                type: "string",
                id: 3
              },
              brandName: {
                type: "string",
                id: 4
              },
              image: {
                type: "string",
                id: 5
              },
              reAppraisalResult: {
                type: "uint32",
                id: 6
              },
              suggestion: {
                type: "string",
                id: 7
              },
              isFinalResult: {
                type: "bool",
                id: 8
              }
            }
          }
        }
      },
      TSAppraisalAppraiserRecheckRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          reAppraisalResult: {
            type: "uint32",
            id: 2
          },
          suggestion: {
            type: "string",
            id: 3
          }
        }
      },
      TSAppraisalAppraiserRecheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsMembershipInfoRequest: {
        fields: {}
      },
      TsMembershipInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isMembership: {
            type: "bool",
            id: 3
          },
          userName: {
            type: "string",
            id: 4
          },
          expiredAt: {
            type: "string",
            id: 5
          },
          surplusCount: {
            type: "int32",
            id: 6
          },
          cardType: {
            type: "MembershipCardType",
            id: 7
          },
          totalSaving: {
            type: "int32",
            id: 8
          },
          renewWay: {
            type: "MembershipRenewWay",
            id: 9
          }
        }
      },
      TsMembershipCardListRequest: {
        fields: {}
      },
      TsMembershipCardListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cards: {
            rule: "repeated",
            type: "MembershipCard",
            id: 3
          }
        },
        nested: {
          MembershipCard: {
            fields: {
              mcId: {
                type: "string",
                id: 1
              },
              cardName: {
                type: "string",
                id: 2
              },
              price: {
                type: "int32",
                id: 3
              },
              scribingPrice: {
                type: "int32",
                id: 4
              },
              icon: {
                type: "string",
                id: 5
              },
              image: {
                type: "string",
                id: 6
              },
              validityPeriod: {
                type: "int32",
                id: 7
              },
              remark: {
                type: "string",
                id: 8
              }
            }
          }
        }
      },
      TsMembershipCardOrderRequest: {
        fields: {
          mcId: {
            type: "string",
            id: 1
          }
        }
      },
      TsMembershipCardOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNumber: {
            type: "string",
            id: 3
          }
        }
      },
      TsMembershipCardOrderPayByWechatRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TsMembershipCardOrderPayByWechatResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TsMembershipCardOrderCancelRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsMembershipCardOrderCancelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsMyMembershipCardsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          payState: {
            type: "PayState",
            id: 3
          },
          cardState: {
            type: "MembershipCardState",
            id: 4
          }
        }
      },
      TsMyMembershipCardsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isEnd: {
            type: "bool",
            id: 3
          },
          orders: {
            rule: "repeated",
            type: "MembershipCardOrder",
            id: 4
          }
        },
        nested: {
          MembershipCardOrder: {
            fields: {
              orderNo: {
                type: "string",
                id: 1
              },
              cardName: {
                type: "string",
                id: 2
              },
              orderTime: {
                type: "string",
                id: 3
              },
              cancelTime: {
                type: "string",
                id: 4
              },
              payTime: {
                type: "string",
                id: 5
              },
              payState: {
                type: "PayState",
                id: 6
              },
              cardState: {
                type: "MembershipCardState",
                id: 7
              }
            }
          }
        }
      },
      TSConfirmOrderPageRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          addrId: {
            type: "int32",
            id: 2
          },
          pageType: {
            type: "string",
            id: 3
          }
        }
      },
      TSConfirmOrderPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          product: {
            type: "ConfirmOrderProduct",
            id: 3
          },
          expressFee: {
            type: "int32",
            id: 4
          },
          totalAmount: {
            type: "int32",
            id: 5
          },
          isPostage: {
            type: "bool",
            id: 6
          }
        }
      },
      TSGenProductOrderRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          addressID: {
            type: "int32",
            id: 2
          },
          source: {
            type: "string",
            id: 3
          },
          pageType: {
            type: "string",
            id: 4
          }
        }
      },
      TSGenProductOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSProductPayOnWechatRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductPayOnWechatResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appid: {
            type: "string",
            id: 3
          },
          partnerid: {
            type: "string",
            id: 4
          },
          prepayid: {
            type: "string",
            id: 5
          },
          "package": {
            type: "string",
            id: 6
          },
          nonceStr: {
            type: "string",
            id: 7
          },
          timestamp: {
            type: "string",
            id: 8
          },
          sign: {
            type: "string",
            id: 9
          }
        }
      },
      TSWechatProductPayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TSWechatProductPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSProductPayOnAliPayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductPayOnAliPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          paySign: {
            type: "string",
            id: 3
          }
        }
      },
      TSByteDancePayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          orderType: {
            type: "OrderType",
            id: 2
          }
        }
      },
      TSByteDancePayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfo: {
            type: "OrderInfo",
            id: 3
          }
        },
        nested: {
          OrderInfo: {
            fields: {
              merchantId: {
                type: "string",
                id: 1
              },
              appId: {
                type: "string",
                id: 2
              },
              signType: {
                type: "string",
                id: 3
              },
              timestamp: {
                type: "string",
                id: 4
              },
              version: {
                type: "string",
                id: 5
              },
              tradeType: {
                type: "string",
                id: 6
              },
              sign: {
                type: "string",
                id: 7
              },
              productCode: {
                type: "string",
                id: 8
              },
              paymentType: {
                type: "string",
                id: 9
              },
              outOrderNo: {
                type: "string",
                id: 10
              },
              uid: {
                type: "string",
                id: 11
              },
              totalAmount: {
                type: "int32",
                id: 12
              },
              currency: {
                type: "string",
                id: 13
              },
              subject: {
                type: "string",
                id: 14
              },
              body: {
                type: "string",
                id: 15
              },
              tradeTime: {
                type: "string",
                id: 16
              },
              validTime: {
                type: "string",
                id: 17
              },
              notifyUrl: {
                type: "string",
                id: 18
              },
              alipayUrl: {
                type: "string",
                id: 19
              },
              wxUrl: {
                type: "string",
                id: 20
              },
              wxType: {
                type: "string",
                id: 21
              },
              riskInfo: {
                type: "string",
                id: 22
              }
            }
          }
        }
      },
      TSOrderPayStatusRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          orderType: {
            type: "OrderType",
            id: 2
          }
        }
      },
      TSOrderPayStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cost: {
            type: "int32",
            id: 3
          },
          isWaitPay: {
            type: "bool",
            id: 4
          }
        }
      },
      TSPayOnWebRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          orderType: {
            type: "OrderType",
            id: 2
          },
          quitUrl: {
            type: "string",
            id: 3
          },
          payWay: {
            type: "string",
            id: 4
          }
        }
      },
      TSPayOnWebResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          alipayUrl: {
            type: "string",
            id: 3
          },
          wxUrl: {
            type: "string",
            id: 4
          }
        }
      },
      TSPayOnWxBrowserRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          orderType: {
            type: "OrderType",
            id: 2
          },
          openid: {
            type: "string",
            id: 3
          }
        }
      },
      TSPayOnWxBrowserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          },
          appid: {
            type: "string",
            id: 8
          }
        }
      },
      TSQueryOrderStateV2Request: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          orderType: {
            type: "OrderType",
            id: 2
          }
        }
      },
      TSQueryOrderStateV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          success: {
            type: "bool",
            id: 3
          }
        }
      },
      TSQueryProductPayResultRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          }
        }
      },
      TSQueryProductPayResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          state: {
            type: "BuyerOrderStateEnum",
            id: 3
          },
          listState: {
            type: "BuyerOrderListStateEnum",
            id: 4
          }
        }
      },
      TSSellerQueryOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          sellerOrderState: {
            type: "SellerOrderStateEnum",
            id: 3
          }
        }
      },
      TSSellerQueryOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfos: {
            rule: "repeated",
            type: "SellerBriefOrderInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSSellerQueryOrderDetailInfoRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerQueryOrderDetailInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderDetailInfo: {
            type: "SellerOrderDetailInfo",
            id: 3
          }
        }
      },
      TSSellerWannaDeliverInfoRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerWannaDeliverInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          addressTitle: {
            type: "string",
            id: 3
          },
          WarehouseAddress: {
            type: "UserAddress",
            id: 4
          },
          expressCompany: {
            type: "string",
            id: 5
          }
        }
      },
      TSSellerWannaDeliverRequest: {
        fields: {
          expressNumber: {
            type: "string",
            id: 1
          },
          orderID: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerWannaDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerNotSellRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerNotSellResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerQueryExpressRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerQueryExpressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressItems: {
            rule: "repeated",
            type: "ExpressItem",
            id: 3
          }
        }
      },
      TSSellerDeleteOrderRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerDeleteOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBuyerQueryOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          buyerOrderState: {
            type: "BuyerOrderStateEnum",
            id: 3
          }
        }
      },
      TSBuyerQueryOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfos: {
            rule: "repeated",
            type: "BuyerBriefOrderInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSBuyerQueryOrderDetailInfoRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSBuyerQueryOrderDetailInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderDetailInfo: {
            type: "BuyerOrderDetailInfo",
            id: 3
          }
        }
      },
      TSBuyerCancelOrderRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSBuyerCancelOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBuyerChangeReceivingAddressRequest: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          },
          orderID: {
            type: "string",
            id: 2
          }
        }
      },
      TSBuyerChangeReceivingAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBuyerQueryExpressRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSBuyerQueryExpressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressItems: {
            rule: "repeated",
            type: "ExpressItem",
            id: 3
          }
        }
      },
      TSBuyerDeleteOrderRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSBuyerDeleteOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBuyerConfirmReceivedRequest: {
        fields: {
          orderID: {
            type: "string",
            id: 1
          }
        }
      },
      TSBuyerConfirmReceivedResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSTradeOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          buyerPhone: {
            type: "string",
            id: 4
          },
          sellerPhone: {
            type: "string",
            id: 5
          },
          state: {
            type: "string",
            id: 6
          },
          sellerExpressNo: {
            type: "string",
            id: 7
          },
          isSeckill: {
            type: "IsSeckill",
            id: 8
          },
          skc: {
            type: "string",
            id: 9
          }
        }
      },
      TSTradeOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          itemList: {
            rule: "repeated",
            type: "OrderBrief",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          BaoOrderButton: {
            fields: {
              buttonText: {
                type: "string",
                id: 1
              },
              buttonEnum: {
                type: "BaoOrderButtonEnum",
                id: 2
              }
            }
          },
          OrderBrief: {
            fields: {
              orderNo: {
                type: "string",
                id: 1
              },
              buyerPhone: {
                type: "string",
                id: 2
              },
              buyerNickname: {
                type: "string",
                id: 3
              },
              pid: {
                type: "string",
                id: 4
              },
              productName: {
                type: "string",
                id: 5
              },
              productPrice: {
                type: "int32",
                id: 6
              },
              actualPrice: {
                type: "int32",
                id: 7
              },
              state: {
                type: "string",
                id: 8
              },
              orderTime: {
                type: "string",
                id: 9
              },
              sellerExpressNo: {
                type: "string",
                id: 10
              },
              stateText: {
                type: "string",
                id: 11
              },
              buttonList: {
                rule: "repeated",
                type: "BaoOrderButton",
                id: 12
              },
              isSeckill: {
                type: "bool",
                id: 13
              },
              avatarHDImage: {
                type: "string",
                id: 14
              },
              newsName: {
                type: "string",
                id: 15
              },
              appSource: {
                type: "AppSource",
                id: 16
              },
              orderType: {
                type: "string",
                id: 17
              }
            }
          }
        }
      },
      TSPublishProductInfoRequest: {
        fields: {}
      },
      TSPublishProductInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          serviceCharge: {
            type: "string",
            id: 3
          },
          transferFeeRate: {
            type: "string",
            id: 4
          },
          categoryInfo: {
            rule: "repeated",
            type: "CategoryInfo",
            id: 5
          },
          pointInfo: {
            rule: "repeated",
            type: "PointInfo",
            id: 6
          },
          userAddress: {
            type: "UserAddress",
            id: 7
          }
        }
      },
      TSProductImageUploadRequest: {
        fields: {
          imgB64: {
            type: "string",
            id: 1
          },
          appId: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductImageUploadResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSProductEvaluateRequest: {
        fields: {
          sku: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductEvaluateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          skuList: {
            rule: "repeated",
            type: "ProductEvaluateInfo",
            id: 3
          }
        },
        nested: {
          ProductEvaluateInfo: {
            fields: {
              newsName: {
                type: "string",
                id: 1
              },
              evaluateMin: {
                type: "int32",
                id: 2
              },
              evaluateMax: {
                type: "int32",
                id: 3
              },
              source: {
                type: "string",
                id: 4
              },
              sysEvaluateMin: {
                type: "int32",
                id: 5
              },
              sysEvaluateMax: {
                type: "int32",
                id: 6
              },
              cloudstorageEvaluateMin: {
                type: "int32",
                id: 7
              },
              cloudstorageEvaluateMax: {
                type: "int32",
                id: 8
              }
            }
          }
        }
      },
      TSProductKindListRequest: {
        fields: {}
      },
      TSProductKindListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindList: {
            rule: "repeated",
            type: "KindInfo",
            id: 3
          }
        }
      },
      TSProductBrandRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSProductBrandResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInitial: {
            rule: "repeated",
            type: "BrandInitial",
            id: 3
          },
          hotBrandList: {
            rule: "repeated",
            type: "HotBrandInfo",
            id: 4
          }
        }
      },
      TSProductNewsRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSProductNewsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          news: {
            rule: "repeated",
            type: "NewsInfo",
            id: 3
          }
        }
      },
      TSProductSizeListRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSProductSizeListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          sizeList: {
            rule: "repeated",
            type: "SizeInfo",
            id: 3
          }
        }
      },
      TSProductColorListRequest: {
        fields: {}
      },
      TSProductColorListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          colorList: {
            rule: "repeated",
            type: "ColorInfo",
            id: 3
          }
        }
      },
      TSProductHolmesRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          },
          exteriorUrl: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductHolmesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          objects: {
            rule: "repeated",
            type: "ClassifiedObject",
            id: 3
          }
        }
      },
      TSProductListRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          brandID: {
            type: "int32",
            id: 2
          },
          pageSize: {
            type: "int32",
            id: 3
          },
          pageNum: {
            type: "int32",
            id: 4
          }
        }
      },
      TSProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          objects: {
            rule: "repeated",
            type: "ClassifiedObject",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSBaoermosFeedbackRequest: {
        fields: {
          productName: {
            type: "string",
            id: 1
          },
          productItemID: {
            type: "string",
            id: 2
          }
        }
      },
      TSBaoermosFeedbackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPublishProductRequest: {
        fields: {
          newsName: {
            type: "string",
            id: 1
          },
          newsID: {
            type: "int32",
            id: 2
          },
          sendWord: {
            type: "string",
            id: 3
          },
          sellPrice: {
            type: "int32",
            id: 4
          },
          returnAddressID: {
            type: "int32",
            id: 5
          },
          sku: {
            type: "string",
            id: 6
          },
          productName: {
            type: "string",
            id: 7
          },
          attribute: {
            type: "string",
            id: 8
          },
          imageList: {
            rule: "repeated",
            type: "ShootImageInfo",
            id: 9
          },
          kindID: {
            type: "int32",
            id: 10
          },
          brandID: {
            type: "int32",
            id: 11
          }
        }
      },
      TSPublishProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          }
        }
      },
      TSProductBindOAIDRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          oaid: {
            type: "string",
            id: 2
          },
          appraisalType: {
            type: "AppraisalType",
            id: 3
          }
        }
      },
      TSProductBindOAIDResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSelectedPageRequest: {
        fields: {}
      },
      TSSelectedPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          items: {
            rule: "repeated",
            type: "CarouselItem",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          }
        }
      },
      TSProductDetailPageRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductDetailPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productUserUpload: {
            type: "ProductUserUpload",
            id: 3
          },
          productBasicInfo: {
            type: "ProductBasicInfo",
            id: 4
          },
          nickName: {
            type: "string",
            id: 5
          },
          avatar: {
            type: "string",
            id: 6
          },
          hasCollected: {
            type: "bool",
            id: 7
          },
          sellState: {
            type: "string",
            id: 8
          },
          sellerId: {
            type: "int32",
            id: 9
          },
          onSaleCount: {
            type: "int32",
            id: 10
          },
          tradeCount: {
            type: "int32",
            id: 11
          },
          skcInfo: {
            type: "SkcInfo",
            id: 13
          },
          productList: {
            rule: "repeated",
            type: "RecommendProduct",
            id: 12
          },
          button: {
            type: "ProductDetailButton",
            id: 15
          },
          subscribed: {
            type: "SubscribeState",
            id: 16
          },
          seckillCard: {
            type: "string",
            id: 17
          },
          typeProduct: {
            type: "ProductOriginalType",
            id: 18
          },
          selfRun: {
            type: "bool",
            id: 19
          }
        },
        nested: {
          RecommendProduct: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              cover: {
                type: "string",
                id: 2
              },
              newDegree: {
                type: "string",
                id: 3
              },
              sellPrice: {
                type: "int32",
                id: 4
              },
              releasePrice: {
                type: "int32",
                id: 5
              },
              title: {
                type: "string",
                id: 6
              },
              relatedOAID: {
                type: "string",
                id: 7
              },
              isSeckillProduct: {
                type: "bool",
                id: 8
              },
              seckillPrice: {
                type: "uint32",
                id: 9
              },
              seckillState: {
                type: "TimeState",
                id: 10
              },
              seckillEndLeft: {
                type: "string",
                id: 11
              },
              bargainPrice: {
                type: "uint32",
                id: 12
              },
              typeProduct: {
                type: "ProductOriginalType",
                id: 13
              },
              selfRun: {
                type: "bool",
                id: 14
              }
            }
          }
        }
      },
      TSCollectProductRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          changeMode: {
            type: "string",
            id: 2
          }
        }
      },
      TSCollectProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCollectProductListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          }
        }
      },
      TSCollectProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          selectedProductInfo: {
            rule: "repeated",
            type: "SelectedProductInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSProductConfirmOrderPageRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductConfirmOrderPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          address: {
            type: "UserAddress",
            id: 3
          },
          productBasicInfo: {
            type: "ProductBasicInfo",
            id: 4
          },
          expressFee: {
            type: "int32",
            id: 5
          }
        }
      },
      TSQueryExpressChargeRequest: {
        fields: {
          province: {
            type: "string",
            id: 1
          }
        }
      },
      TSQueryExpressChargeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressFee: {
            type: "int32",
            id: 3
          }
        }
      },
      TSSellerQueryProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSSellerQueryProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productInfos: {
            rule: "repeated",
            type: "SellerBriefProductInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSSellerBidDetailRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerBidDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productInfo: {
            type: "SellerProductDetailInfo",
            id: 3
          }
        }
      },
      TSProductOnSalePublishInfoRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductOnSalePublishInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          publishInfo: {
            type: "ProductOnSalePublishInfo",
            id: 3
          }
        }
      },
      TSEditProductOnSaleRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          imageList: {
            rule: "repeated",
            type: "ShootImageInfo",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          newDegreeID: {
            type: "int32",
            id: 4
          },
          sendWord: {
            type: "string",
            id: 5
          },
          sellPrice: {
            type: "int32",
            id: 6
          },
          backAddressID: {
            type: "int32",
            id: 7
          }
        }
      },
      TSEditProductOnSaleResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerBidInfoRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerBidInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          serviceChargeRate: {
            type: "string",
            id: 3
          },
          transferFeeRate: {
            type: "string",
            id: 4
          },
          returnAddress: {
            type: "UserAddress",
            id: 5
          }
        }
      },
      TSSellerBidRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          returnAddressID: {
            type: "int32",
            id: 2
          },
          price: {
            type: "int32",
            id: 3
          }
        }
      },
      TSSellerBidResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerTakeProductOffShelvesRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerTakeProductOffShelvesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerUpProductRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerUpProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerChangeReturnAddressRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          addressID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSSellerChangeReturnAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSellerDeleteProductRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSSellerDeleteProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductNewHolmesRequest: {
        fields: {
          imgB64: {
            type: "string",
            id: 1
          },
          brandId: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductNewHolmesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          objects: {
            type: "NewClassifiedObject",
            id: 3
          },
          productInfo: {
            rule: "repeated",
            type: "ProductPidObject",
            id: 4
          },
          hasMatch: {
            type: "bool",
            id: 5
          },
          logId: {
            type: "int32",
            id: 6
          }
        }
      },
      ProductFeedbackQuestionRequest: {
        fields: {
          logId: {
            type: "int32",
            id: 1
          },
          feedback: {
            type: "string",
            id: 2
          }
        }
      },
      ProductFeedbackQuestionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLimitTimeSeckillRequest: {
        fields: {}
      },
      TSLimitTimeSeckillResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isSeckillOpen: {
            type: "bool",
            id: 3
          },
          todaySeckill: {
            type: "DaySeckill",
            id: 4
          },
          tomorrowSeckill: {
            type: "DaySeckill",
            id: 5
          }
        },
        nested: {
          DaySeckill: {
            fields: {
              multipleRound: {
                type: "bool",
                id: 1
              },
              roundList: {
                rule: "repeated",
                type: "SeckillSingleRound",
                id: 2
              }
            }
          }
        }
      },
      TSSeckillRoundRequest: {
        fields: {
          roundId: {
            type: "uint32",
            id: 1
          }
        }
      },
      TSSeckillRoundResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          round: {
            type: "SeckillSingleRound",
            id: 3
          }
        }
      },
      TSSeckillSubscribeRequest: {
        fields: {
          seckillProductId: {
            type: "uint32",
            id: 1
          },
          subscribe: {
            type: "bool",
            id: 2
          },
          code: {
            type: "string",
            id: 3
          }
        }
      },
      TSSeckillSubscribeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductPoolListRequest: {
        fields: {
          pageSize: {
            type: "uint32",
            id: 1
          },
          pageNum: {
            type: "uint32",
            id: 2
          },
          poolId: {
            type: "string",
            id: 3
          },
          poolName: {
            type: "string",
            id: 4
          },
          state: {
            type: "EnableState",
            id: 5
          },
          poolType: {
            type: "string",
            id: 6
          }
        }
      },
      TSAdminProductPoolListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          itemList: {
            rule: "repeated",
            type: "PoolListItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          PoolListItem: {
            fields: {
              recordId: {
                type: "uint32",
                id: 1
              },
              poolId: {
                type: "string",
                id: 2
              },
              poolName: {
                type: "string",
                id: 3
              },
              totalStock: {
                type: "uint32",
                id: 4
              },
              sellStock: {
                type: "uint32",
                id: 5
              },
              state: {
                type: "bool",
                id: 6
              },
              poolType: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSAdminProductPoolEnableRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          enabled: {
            type: "bool",
            id: 2
          }
        }
      },
      TSAdminProductPoolEnableResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductPoolAddRequest: {
        fields: {
          poolName: {
            type: "string",
            id: 1
          },
          poolType: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductPoolAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductPoolModifyRequest: {
        fields: {
          poolName: {
            type: "string",
            id: 1
          },
          recordId: {
            type: "uint32",
            id: 2
          }
        }
      },
      TSAdminProductPoolModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductPoolOperationRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          }
        }
      },
      TSAdminProductPoolOperationResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recordList: {
            rule: "repeated",
            type: "OperateRecord",
            id: 3
          },
          totalCount: {
            type: "uint32",
            id: 4
          }
        },
        nested: {
          OperateRecord: {
            fields: {
              operateTime: {
                type: "string",
                id: 1
              },
              operator: {
                type: "string",
                id: 2
              },
              event: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      TSSeckillChannelStateRequest: {
        fields: {}
      },
      TSSeckillChannelStateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          on: {
            type: "bool",
            id: 3
          }
        }
      },
      TSAdminSeckillEnableRequest: {
        fields: {
          enable: {
            type: "bool",
            id: 1
          }
        }
      },
      TSAdminSeckillEnableResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminSeckillActivityListRequest: {
        fields: {
          pageSize: {
            type: "uint32",
            id: 1
          },
          pageNum: {
            type: "uint32",
            id: 2
          },
          startTime: {
            type: "string",
            id: 3
          },
          endTime: {
            type: "string",
            id: 4
          },
          state: {
            type: "string",
            id: 5
          },
          on: {
            type: "EnableState",
            id: 6
          }
        }
      },
      TSAdminSeckillActivityListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          itemList: {
            rule: "repeated",
            type: "ListItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          ListItem: {
            fields: {
              recordId: {
                type: "uint32",
                id: 1
              },
              seckillDate: {
                type: "string",
                id: 2
              },
              startTime: {
                type: "string",
                id: 3
              },
              endTime: {
                type: "string",
                id: 4
              },
              totalProduct: {
                type: "uint32",
                id: 5
              },
              sellProduct: {
                type: "uint32",
                id: 6
              },
              state: {
                type: "string",
                id: 7
              },
              enabled: {
                type: "bool",
                id: 8
              }
            }
          }
        }
      },
      TSAdminSeckillActivityEnableRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          enable: {
            type: "bool",
            id: 2
          }
        }
      },
      TSAdminSeckillActivityEnableResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminSeckillActivityOperationRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          pageSize: {
            type: "uint32",
            id: 2
          },
          pageNum: {
            type: "uint32",
            id: 3
          }
        }
      },
      TSAdminSeckillActivityOperationResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recordList: {
            rule: "repeated",
            type: "OperateRecord",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          OperateRecord: {
            fields: {
              operateTime: {
                type: "string",
                id: 1
              },
              operator: {
                type: "string",
                id: 2
              },
              event: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      TSAdminSeckillActivityAddRequest: {
        fields: {
          createDate: {
            type: "string",
            id: 1
          },
          startTime: {
            type: "string",
            id: 2
          },
          endTime: {
            type: "string",
            id: 3
          }
        }
      },
      TSAdminSeckillActivityAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminSeckillProductListRequest: {
        fields: {
          seckillId: {
            type: "uint32",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          },
          state: {
            type: "string",
            id: 4
          },
          pageSize: {
            type: "uint32",
            id: 5
          },
          pageNum: {
            type: "uint32",
            id: 6
          }
        }
      },
      TSAdminSeckillProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pList: {
            rule: "repeated",
            type: "SeckillProduct",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          },
          seckillDate: {
            type: "string",
            id: 5
          },
          startTime: {
            type: "string",
            id: 6
          },
          endTime: {
            type: "string",
            id: 7
          },
          totalProduct: {
            type: "uint32",
            id: 8
          },
          sellProduct: {
            type: "uint32",
            id: 9
          }
        },
        nested: {
          SeckillProduct: {
            fields: {
              recordId: {
                type: "uint32",
                id: 1
              },
              pid: {
                type: "string",
                id: 2
              },
              productName: {
                type: "string",
                id: 3
              },
              cover: {
                type: "string",
                id: 4
              },
              size: {
                type: "string",
                id: 5
              },
              newDegree: {
                type: "string",
                id: 6
              },
              sellPrice: {
                type: "uint32",
                id: 7
              },
              seckillPrice: {
                type: "uint32",
                id: 8
              },
              state: {
                type: "string",
                id: 9
              },
              sequence: {
                type: "int32",
                id: 10
              }
            }
          }
        }
      },
      TSAdminSeckillProductAddRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          },
          sequence: {
            type: "int32",
            id: 3
          },
          seckillPrice: {
            type: "uint32",
            id: 4
          }
        }
      },
      TSAdminSeckillProductAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminSeckillProductModifyRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          sequence: {
            type: "int32",
            id: 2
          },
          seckillPrice: {
            type: "uint32",
            id: 3
          }
        }
      },
      TSAdminSeckillProductModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminSeckillProductDelRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          }
        }
      },
      TSAdminSeckillProductDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBrandVenueHotRequest: {
        fields: {}
      },
      TSBrandVenueHotResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfoList: {
            rule: "repeated",
            type: "BrandInfoItem",
            id: 3
          }
        },
        nested: {
          BrandInfoItem: {
            fields: {
              brandID: {
                type: "int32",
                id: 1
              },
              coverImage: {
                type: "string",
                id: 2
              },
              logoImage: {
                type: "string",
                id: 3
              },
              name: {
                type: "string",
                id: 4
              },
              productList: {
                rule: "repeated",
                type: "string",
                id: 5
              },
              kindID: {
                type: "int32",
                id: 6
              }
            }
          }
        }
      },
      TSBrandVenueBrandPagePageRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSBrandVenueBrandPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandID: {
            type: "int32",
            id: 3
          },
          coverImage: {
            type: "string",
            id: 4
          },
          logoImage: {
            type: "string",
            id: 5
          },
          enName: {
            type: "string",
            id: 6
          },
          introduction: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          cnName: {
            type: "string",
            id: 9
          },
          onSaleCount: {
            type: "uint32",
            id: 10
          },
          liked: {
            type: "bool",
            id: 11
          }
        }
      },
      TSLikeBrandRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          },
          like: {
            type: "bool",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          }
        }
      },
      TSLikeBrandResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLikedBrandListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          }
        }
      },
      TSLikedBrandListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          likedBrandList: {
            rule: "repeated",
            type: "LikedBrandItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          LikedBrandItem: {
            fields: {
              brandID: {
                type: "int32",
                id: 1
              },
              enName: {
                type: "string",
                id: 2
              },
              onSaleCount: {
                type: "uint32",
                id: 3
              },
              newCount: {
                type: "uint32",
                id: 4
              },
              kindID: {
                type: "int32",
                id: 5
              },
              logoImage: {
                type: "string",
                id: 6
              },
              cnName: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSMarketEncyclopediaRequest: {
        fields: {
          skc: {
            type: "string",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          brandID: {
            type: "int32",
            id: 3
          }
        }
      },
      TSMarketEncyclopediaResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          holmesResult: {
            rule: "repeated",
            type: "HolmesResult",
            id: 3
          }
        }
      },
      TSMarketNewEncyclopediaRequest: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          brandID: {
            type: "int32",
            id: 3
          }
        }
      },
      TSMarketNewEncyclopediaResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          holmesResult: {
            rule: "repeated",
            type: "HolmesResult",
            id: 3
          }
        }
      },
      TSAdminSecKillAndBargainLimitRequest: {
        fields: {}
      },
      TSAdminSecKillAndBargainLimitResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          BargainInfo: {
            rule: "repeated",
            type: "BargainBasicItem",
            id: 3
          },
          SecKillInfo: {
            rule: "repeated",
            type: "BargainBasicItem",
            id: 4
          },
          isActOpen: {
            type: "IsActEnum",
            id: 5
          },
          endTime: {
            type: "string",
            id: 6
          },
          countDown: {
            type: "int32",
            id: 7
          }
        }
      },
      TSBargainProductLimitRequest: {
        fields: {}
      },
      TSBargainProductLimitResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          BargainProduct: {
            rule: "repeated",
            type: "BargainBasicItem",
            id: 3
          }
        }
      },
      TSMyBargainProductLimitRequest: {
        fields: {}
      },
      TSMyBargainProductLimitResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          MyBargainProduct: {
            rule: "repeated",
            type: "BargainBasicItem",
            id: 6
          }
        }
      },
      TSBargainDetailRequest: {
        fields: {
          activityId: {
            type: "uint32",
            id: 1
          },
          uid: {
            type: "int32",
            id: 2
          }
        }
      },
      TSBargainDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          BargainDetailInfo: {
            type: "BargainDetailItem",
            id: 3
          },
          helpBargain: {
            rule: "repeated",
            type: "HelpBargainItem",
            id: 4
          },
          MyBargainOrder: {
            rule: "repeated",
            type: "BargainBasicItem",
            id: 5
          },
          sharingCard: {
            type: "string",
            id: 7
          },
          isFrame: {
            type: "bool",
            id: 8
          }
        }
      },
      TSBargainRequest: {
        fields: {
          activityId: {
            type: "uint32",
            id: 1
          },
          bargainMethods: {
            type: "BargainOpMethods",
            id: 2
          },
          uid: {
            type: "uint32",
            id: 3
          }
        }
      },
      TSBargainResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          baoPrice: {
            type: "int32",
            id: 3
          },
          distancePrice: {
            type: "int32",
            id: 4
          },
          reductionPrice: {
            type: "int32",
            id: 5
          },
          newPrice: {
            type: "int32",
            id: 6
          }
        }
      },
      TSBargainPromptMessageRequest: {
        fields: {}
      },
      TSBargainPromptMessageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          promptMessage: {
            type: "PromptMessageItem",
            id: 3
          },
          message: {
            type: "BargainMessage",
            id: 4
          }
        }
      },
      TSBargainCardShareRequest: {
        fields: {
          activityId: {
            type: "uint32",
            id: 1
          },
          bargainOpShare: {
            type: "BargainOpShare",
            id: 2
          },
          uid: {
            type: "int32",
            id: 3
          }
        }
      },
      TSBargainCardShareResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLikeBargainRequest: {
        fields: {
          like: {
            type: "bool",
            id: 1
          },
          bargainInfoId: {
            type: "uint32",
            id: 2
          }
        }
      },
      TSLikeBargainResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLikeBargainAddProRequest: {
        fields: {
          like: {
            type: "bool",
            id: 1
          },
          bargainInfoId: {
            type: "uint32",
            id: 2
          }
        }
      },
      TSLikeBargainAddProResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLikeBargainPageRequest: {
        fields: {
          type: {
            type: "int32",
            id: 1
          }
        }
      },
      TSLikeBargainPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isMessage: {
            type: "bool",
            id: 3
          }
        }
      },
      UploadFileResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          fileUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSErrorResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPublicWXAppletCodeRequest: {
        fields: {
          scene: {
            type: "string",
            id: 1
          },
          page: {
            type: "string",
            id: 2
          }
        }
      },
      TSPublicWXAppletCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appletCode: {
            type: "bytes",
            id: 3
          }
        }
      },
      TSPublicWechatProductPayRequest: {
        fields: {
          orderNumber: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          },
          orderType: {
            type: "string",
            id: 3
          }
        }
      },
      TSPublicWechatProductPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSFullscreenPosterRequest: {
        fields: {
          pageID: {
            type: "string",
            id: 1
          }
        }
      },
      TSFullscreenPosterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          show: {
            type: "bool",
            id: 3
          },
          imageUrl: {
            type: "string",
            id: 4
          },
          path: {
            type: "string",
            id: 5
          },
          type: {
            type: "int32",
            id: 6
          }
        }
      },
      TSCenterAddressRequest: {
        fields: {}
      },
      TSCenterAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          addressTitle: {
            type: "string",
            id: 3
          },
          address: {
            type: "UserAddress",
            id: 4
          },
          expressCompany: {
            type: "string",
            id: 5
          }
        }
      },
      TSV2CenterAddressRequest: {
        fields: {
          centerAddressType: {
            type: "CenterAddressType",
            id: 1
          }
        }
      },
      TSV2CenterAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          addressTitle: {
            type: "string",
            id: 3
          },
          address: {
            type: "UserAddress",
            id: 4
          },
          expressCompany: {
            type: "string",
            id: 5
          }
        }
      },
      TSGetTop20AppraisalReportRequest: {
        fields: {}
      },
      TSGetTop20AppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          reports: {
            rule: "repeated",
            type: "BulletinReport",
            id: 3
          }
        }
      },
      TSGetRotationRecordRequest: {
        fields: {}
      },
      TSGetRotationRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          reports: {
            rule: "repeated",
            type: "BulletinReport",
            id: 3
          },
          bagsReports: {
            rule: "repeated",
            type: "BulletinReport",
            id: 4
          },
          cosmeticsReports: {
            rule: "repeated",
            type: "BulletinReport",
            id: 5
          },
          shoesReports: {
            rule: "repeated",
            type: "BulletinReport",
            id: 6
          },
          clothesReports: {
            rule: "repeated",
            type: "BulletinReport",
            id: 7
          }
        }
      },
      TSGetDefaultAddressRequest: {
        fields: {}
      },
      TSGetDefaultAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hasDefaultAddress: {
            type: "bool",
            id: 3
          },
          address: {
            type: "UserAddress",
            id: 4
          }
        }
      },
      TSPublicKindsRequest: {
        fields: {
          serviceType: {
            type: "ServiceTypeEnum",
            id: 1
          },
          appraisalListReqEnum: {
            type: "AppraisalListReqEnum",
            id: 3
          }
        }
      },
      TSPublicKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSPublicBrandsRequest: {
        fields: {
          serviceType: {
            type: "ServiceTypeEnum",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          appraisalListReqEnum: {
            type: "AppraisalListReqEnum",
            id: 3
          },
          isFastAIAppraisal: {
            type: "bool",
            id: 4
          }
        }
      },
      TSPublicBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotBrands: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          },
          tagBrands: {
            rule: "repeated",
            type: "AIServiceTagCategoryItem",
            id: 5
          }
        }
      },
      TSPublicV2BrandsRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          appraisalListReqEnum: {
            type: "AppraisalListReqEnum",
            id: 2
          },
          brandName: {
            type: "string",
            id: 3
          }
        }
      },
      TSPublicV2BrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSPublicTaggedKindsRequest: {
        fields: {
          appraisalType: {
            type: "int32",
            id: 1
          }
        }
      },
      TSPublicTaggedKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 3
          }
        }
      },
      TSPublicSeriesRequest: {
        fields: {
          serviceType: {
            type: "ServiceTypeEnum",
            id: 1
          },
          brandID: {
            type: "int32",
            id: 2
          },
          appraisalListReqEnum: {
            type: "AppraisalListReqEnum",
            id: 3
          },
          isFastAIAppraisal: {
            type: "bool",
            id: 4
          }
        }
      },
      TSPublicSeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotSeries: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSPublicV2SeriesRequest: {
        fields: {
          serviceType: {
            type: "ServiceTypeEnum",
            id: 1
          },
          brandID: {
            type: "int32",
            id: 2
          },
          appraisalListReqEnum: {
            type: "AppraisalListReqEnum",
            id: 3
          },
          isFastAIAppraisal: {
            type: "bool",
            id: 4
          }
        }
      },
      TSPublicV2SeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesInfos: {
            rule: "repeated",
            type: "AIServiceCategoryInitial",
            id: 3
          },
          hotSeries: {
            rule: "repeated",
            type: "AIServiceCategoryInfo",
            id: 4
          }
        }
      },
      TSPublicAreaRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          level: {
            type: "int32",
            id: 3
          },
          pcode: {
            type: "string",
            id: 4
          }
        }
      },
      TSPublicAreaResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          areaList: {
            rule: "repeated",
            type: "AreaInfo",
            id: 3
          }
        },
        nested: {
          AreaInfo: {
            fields: {
              code: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              level: {
                type: "int32",
                id: 3
              },
              pcode: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSPublicEvaluatePriceRequest: {
        fields: {
          newOldID: {
            type: "uint32",
            id: 1
          },
          kindID: {
            type: "uint32",
            id: 2,
            options: {
              deprecated: true
            }
          },
          skc: {
            type: "string",
            id: 3,
            options: {
              deprecated: true
            }
          },
          serviceType: {
            type: "ServiceTypeEnum",
            id: 4
          },
          sku: {
            type: "string",
            id: 5
          }
        }
      },
      TSPublicEvaluatePriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          price: {
            type: "uint32",
            id: 3
          },
          floorPrice: {
            type: "uint32",
            id: 4
          },
          canEvaluate: {
            type: "bool",
            id: 5
          },
          advancePayment: {
            type: "uint32",
            id: 6
          },
          balancePayment: {
            type: "uint32",
            id: 7
          }
        }
      },
      TSPublicBroadcastRequest: {
        fields: {
          page: {
            type: "PageEnum",
            id: 1
          }
        }
      },
      TSPublicBroadcastResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          broadcastList: {
            rule: "repeated",
            type: "BroadcastItem",
            id: 3
          }
        }
      },
      TSXianYuDataRequest: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          startTime: {
            type: "string",
            id: 2
          },
          endTime: {
            type: "string",
            id: 3
          },
          pageNum: {
            type: "uint32",
            id: 4
          },
          pageSize: {
            type: "uint32",
            id: 5
          },
          mesoid: {
            type: "YesOrNoChoice",
            id: 6
          },
          rare: {
            type: "YesOrNoChoice",
            id: 7
          },
          classic: {
            type: "YesOrNoChoice",
            id: 8
          },
          extra: {
            type: "YesOrNoChoice",
            id: 9
          }
        }
      },
      TSXianYuDataResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          dataList: {
            rule: "repeated",
            type: "XianYuData",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          XianYuData: {
            fields: {
              title: {
                type: "string",
                id: 1
              },
              sellerName: {
                type: "string",
                id: 2
              },
              publishPlace: {
                type: "string",
                id: 3
              },
              price: {
                type: "string",
                id: 4
              },
              wantNum: {
                type: "string",
                id: 5
              },
              readNum: {
                type: "string",
                id: 6
              },
              number: {
                type: "string",
                id: 7
              },
              publishTime: {
                type: "string",
                id: 8
              },
              image: {
                type: "string",
                id: 9
              },
              instoreTime: {
                type: "string",
                id: 10
              },
              recordId: {
                type: "uint32",
                id: 11
              },
              mesoid: {
                type: "bool",
                id: 12
              },
              rare: {
                type: "bool",
                id: 13
              },
              classic: {
                type: "bool",
                id: 14
              },
              extra: {
                type: "bool",
                id: 15
              }
            }
          }
        }
      },
      TSXianYuDataModifyRequest: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          mesoid: {
            type: "bool",
            id: 2
          },
          rare: {
            type: "bool",
            id: 3
          },
          classic: {
            type: "bool",
            id: 4
          },
          extra: {
            type: "bool",
            id: 5
          }
        }
      },
      TSXianYuDataModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSResourceBannerRequest: {
        fields: {
          pageId: {
            type: "string",
            id: 1
          }
        }
      },
      TSResourceBannerResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          bannerList: {
            rule: "repeated",
            type: "Banner",
            id: 3
          }
        },
        nested: {
          Banner: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              jumpType: {
                type: "string",
                id: 2
              },
              jumpLink: {
                type: "string",
                id: 3
              },
              appId: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSUploadEnterpriseWechatRequest: {
        fields: {
          imageB64: {
            type: "string",
            id: 1
          }
        }
      },
      TSUploadEnterpriseWechatResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSGetEnterpriseWechatRequest: {
        fields: {}
      },
      TSGetEnterpriseWechatResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSGetProductListRequest: {
        fields: {
          spu: {
            type: "string",
            id: 1
          },
          skc: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          },
          pageSize: {
            type: "int32",
            id: 5
          },
          pageNum: {
            type: "int32",
            id: 6
          }
        }
      },
      TSGetProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "Product",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Product: {
            fields: {
              recordId: {
                type: "uint32",
                id: 1
              },
              pid: {
                type: "string",
                id: 2
              },
              name: {
                type: "string",
                id: 3
              },
              cover: {
                type: "string",
                id: 4
              },
              color: {
                type: "string",
                id: 5
              },
              size: {
                type: "string",
                id: 6
              },
              selfRun: {
                type: "bool",
                id: 7,
                options: {
                  deprecated: true
                }
              },
              sellerPhone: {
                type: "string",
                id: 8
              },
              newDegree: {
                type: "string",
                id: 9
              },
              price: {
                type: "uint32",
                id: 10
              },
              state: {
                type: "ProductSaleState",
                id: 11
              },
              kind: {
                type: "string",
                id: 12
              },
              sku: {
                type: "string",
                id: 13
              },
              cost: {
                type: "uint32",
                id: 14
              }
            }
          }
        }
      },
      TSSpikeGoodsBannerListRequest: {
        fields: {
          regionBelong: {
            type: "int32",
            id: 1
          }
        }
      },
      TSSpikeGoodsBannerListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          bannerList: {
            rule: "repeated",
            type: "Banner",
            id: 3
          }
        },
        nested: {
          Banner: {
            fields: {
              imageUrl: {
                type: "string",
                id: 1
              },
              jumpType: {
                type: "string",
                id: 2
              },
              jumpLink: {
                type: "string",
                id: 3
              },
              appId: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSInviteNewPopUpsRequest: {
        fields: {}
      },
      TSInviteNewPopUpsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          inviteNewNum: {
            type: "int32",
            id: 3
          },
          isDailyUseUp: {
            type: "bool",
            id: 4
          },
          isUseUp: {
            type: "bool",
            id: 5
          }
        }
      },
      TSInviteUserGiftStatusRequest: {
        fields: {}
      },
      TSInviteUserGiftStatusResponse: {
        fields: {
          isOn: {
            type: "bool",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          },
          invitedUserNum: {
            type: "int32",
            id: 4
          }
        }
      },
      TSDailyAppraisalStatisticsRequest: {
        fields: {}
      },
      TSDailyAppraisalStatisticsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalOrderNum: {
            type: "int32",
            id: 3
          },
          appraisalValue: {
            type: "int32",
            id: 4
          }
        }
      },
      TSDailyAppraisalStatisticsV2Request: {
        fields: {}
      },
      TSDailyAppraisalStatisticsV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalOrderNum: {
            type: "int32",
            id: 3
          },
          appraisalValue: {
            type: "string",
            id: 4
          }
        }
      },
      TSAppraisalReportPostageRequest: {
        fields: {}
      },
      TSAppraisalReportPostageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          postage: {
            type: "int32",
            id: 3
          },
          status: {
            type: "bool",
            id: 4
          }
        }
      },
      TSAppraisalBindGeTuiCidRequest: {
        fields: {
          cid: {
            type: "string",
            id: 1
          }
        }
      },
      TSAppraisalBindGeTuiCidResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCountryCodeRequest: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pageSize: {
            type: "int32",
            id: 3
          }
        }
      },
      TSCountryCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          sortInfo: {
            rule: "repeated",
            type: "SortInfo",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          CountryInfo: {
            fields: {
              code: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              enName: {
                type: "string",
                id: 3
              }
            }
          },
          SortInfo: {
            fields: {
              letter: {
                type: "string",
                id: 1
              },
              countryInfo: {
                rule: "repeated",
                type: "CountryInfo",
                id: 2
              }
            }
          }
        }
      },
      TSGetBasicInfoByCodeRequest: {
        fields: {
          productCode: {
            type: "string",
            id: 1
          }
        }
      },
      TSGetBasicInfoByCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kind: {
            type: "CategoryInfo",
            id: 3
          },
          brand: {
            type: "CategoryInfo",
            id: 4
          },
          series: {
            type: "CategoryInfo",
            id: 5
          }
        },
        nested: {
          CategoryInfo: {
            fields: {
              id: {
                type: "int32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              enName: {
                type: "string",
                id: 3
              },
              image: {
                type: "string",
                id: 4
              },
              serviceAi: {
                type: "bool",
                id: 5
              },
              serviceManual: {
                type: "bool",
                id: 6
              }
            }
          }
        }
      },
      TSImageCollectRequest: {
        fields: {
          hierarchy: {
            type: "string",
            id: 1
          },
          categoryId: {
            type: "int32",
            id: 2
          },
          customBrandName: {
            type: "string",
            id: 3
          },
          result: {
            type: "int32",
            id: 4
          },
          images: {
            rule: "repeated",
            type: "string",
            id: 5
          }
        }
      },
      TSImageCollectResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      GetHomepagePopupsRequest: {
        fields: {}
      },
      GetHomepagePopupsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          enable: {
            type: "bool",
            id: 3
          },
          popupId: {
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          imageUrl: {
            type: "string",
            id: 6
          },
          link: {
            type: "string",
            id: 7
          }
        }
      },
      HomepagePopupDisableRequest: {
        fields: {
          popupId: {
            type: "string",
            id: 1
          }
        }
      },
      HomepagePopupDisableResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBase64PDFUploadRequest: {
        fields: {
          pdfBase64: {
            type: "string",
            id: 1
          }
        }
      },
      TSBase64PDFUploadResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pdfURL: {
            type: "string",
            id: 3
          }
        }
      },
      TSDeepSeekChatResquest: {
        fields: {
          message: {
            type: "string",
            id: 1
          }
        }
      },
      TSDeepSeekChatResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          messageResponse: {
            type: "string",
            id: 3
          }
        }
      },
      GetSecretResquest: {
        fields: {}
      },
      GetSecretResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          dir: {
            type: "string",
            id: 3
          },
          host: {
            type: "string",
            id: 4
          },
          policy: {
            type: "string",
            id: 5
          },
          securityToken: {
            type: "string",
            id: 6
          },
          signature: {
            type: "string",
            id: 7
          },
          xOssCredential: {
            type: "string",
            id: 8
          },
          xOssDate: {
            type: "string",
            id: 9
          },
          xOssSignatureVersion: {
            type: "string",
            id: 10
          },
          updateAccelerate: {
            type: "string",
            id: 11
          }
        }
      },
      RecognitionRecord: {
        fields: {
          recordId: {
            type: "string",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          species: {
            type: "string",
            id: 3
          },
          totalWeight: {
            type: "int32",
            id: 4
          },
          price: {
            type: "int32",
            id: 5
          },
          img: {
            type: "string",
            id: 6
          }
        }
      },
      TsAiRecognitionRequest: {
        fields: {
          imgUrl: {
            type: "string",
            id: 1
          }
        }
      },
      TsAiRecognitionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recordId: {
            type: "string",
            id: 3
          },
          result: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          species: {
            type: "string",
            id: 6
          },
          origin: {
            type: "string",
            id: 7
          },
          averageWeight: {
            type: "int32",
            id: 8
          },
          marketPrice: {
            type: "int32",
            id: 9
          },
          unitPrice: {
            type: "int32",
            id: 10
          },
          img: {
            type: "string",
            id: 11
          }
        }
      },
      TsAiRecognitionPublishRequest: {
        fields: {
          count: {
            type: "int32",
            id: 1
          },
          recordId: {
            type: "string",
            id: 2
          }
        }
      },
      TsAiRecognitionPublishResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAiRecognitionRecordsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TsAiRecognitionRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "RecognitionRecord",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TsAiFingerRecognitionRequest: {
        fields: {
          imgUrl: {
            type: "string",
            id: 1
          }
        }
      },
      TsAiFingerRecognitionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          result: {
            type: "int32",
            id: 3
          },
          detectionBox: {
            type: "string",
            id: 4
          },
          originalBox: {
            type: "string",
            id: 5
          },
          grade: {
            type: "string",
            id: 6
          }
        }
      },
      RecycleOrderStateEnum: {
        values: {
          ROS_Default: 0,
          ROS_ToBeDelivered: 1,
          ROS_HadDelivered: 2,
          ROS_Check: 3,
          ROS_ConfirmPrice: 4,
          ROS_SuccessfulTrade: 5,
          ROS_FailedTrade: 6
        }
      },
      RecycleOrderListStateEnum: {
        values: {
          ROLS_Default: 0,
          ROLS_ToBeDeliver: 1,
          ROLS_DeliverToPlatform: 2,
          ROLS_ToCheck: 3,
          ROLS_Checking: 4,
          ROLS_CheckNo: 5,
          ROLS_ToEvaluatePrice: 6,
          ROLS_ToConfirmPrice: 7,
          ROLS_ConfirmNo: 8,
          ROLS_ConfirmOutTime: 9,
          ROLS_AcceptRecycle: 11,
          ROLS_RefuseRecycle: 12,
          ROLS_HasSendBack: 13,
          ROLS_RecycleToConsign: 14,
          ROLS_CancelDeliver: 15,
          ROLS_ToEvaluate: 16,
          ROLS_DeliverOutTime: 17,
          ROLS_IsNotStandard: 18
        }
      },
      RecycleOrderButtonEnum: {
        values: {
          ROB_Default: 0,
          ROB_Deliver: 1,
          ROB_Detail: 2,
          ROB_AcceptPrice: 3,
          ROB_RefusePrice: 4,
          ROB_CancelDeliver: 5,
          ROB_Edit: 6,
          ROB_Details: 7
        }
      },
      RecycleOrderButton: {
        fields: {
          buttonEnum: {
            type: "RecycleOrderButtonEnum",
            id: 1
          },
          buttonTitle: {
            type: "string",
            id: 2
          }
        }
      },
      RecycleOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          recycleOrderListStateEnum: {
            type: "RecycleOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          productTitle: {
            type: "string",
            id: 4
          },
          image: {
            type: "string",
            id: 5
          },
          price: {
            type: "uint32",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          measurement: {
            type: "string",
            id: 9
          },
          news: {
            type: "string",
            id: 10
          },
          orderButton: {
            rule: "repeated",
            type: "RecycleOrderButton",
            id: 11
          },
          confirmTimeLeft: {
            type: "uint32",
            id: 12
          },
          finalPrice: {
            type: "uint32",
            id: 13
          },
          finalNews: {
            type: "string",
            id: 14
          },
          advancePayment: {
            type: "uint32",
            id: 15
          },
          balancePayment: {
            type: "uint32",
            id: 16
          },
          deliverTimeLeft: {
            type: "uint32",
            id: 17
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 18
          }
        }
      },
      RecycleOrderDetailInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          recycleOrderListStateEnum: {
            type: "RecycleOrderListStateEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          stateIntroduction: {
            type: "string",
            id: 4
          },
          creatTime: {
            type: "string",
            id: 5
          },
          productTitle: {
            type: "string",
            id: 6
          },
          image: {
            type: "string",
            id: 7
          },
          price: {
            type: "uint32",
            id: 8
          },
          color: {
            type: "string",
            id: 9
          },
          size: {
            type: "string",
            id: 10
          },
          measurement: {
            type: "string",
            id: 11
          },
          news: {
            type: "string",
            id: 12
          },
          returnAddress: {
            type: "UserAddress",
            id: 13
          },
          record: {
            type: "ExpressRecord",
            id: 14
          },
          expressNo: {
            type: "string",
            id: 15
          },
          finalPrice: {
            type: "uint32",
            id: 16
          },
          finalNews: {
            type: "string",
            id: 17
          },
          confirmTimeLeft: {
            type: "uint32",
            id: 18
          },
          orderButton: {
            rule: "repeated",
            type: "RecycleOrderButton",
            id: 19
          },
          advancePayment: {
            type: "uint32",
            id: 20
          },
          balancePayment: {
            type: "uint32",
            id: 21
          },
          deliverTimeLeft: {
            type: "uint32",
            id: 22
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 23
          },
          description: {
            type: "string",
            id: 24
          }
        }
      },
      TSRecycleGenOrderRequest: {
        fields: {
          newOldID: {
            type: "uint32",
            id: 1,
            options: {
              deprecated: true
            }
          },
          kindID: {
            type: "uint32",
            id: 2,
            options: {
              deprecated: true
            }
          },
          skc: {
            type: "string",
            id: 3,
            options: {
              deprecated: true
            }
          },
          sku: {
            type: "string",
            id: 4
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 5
          }
        }
      },
      TSRecycleGenOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSRecycleOrderListRequest: {
        fields: {
          pageNum: {
            type: "uint32",
            id: 1
          },
          pageSize: {
            type: "uint32",
            id: 2
          },
          state: {
            type: "RecycleOrderStateEnum",
            id: 3
          }
        }
      },
      TSRecycleOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfos: {
            rule: "repeated",
            type: "RecycleOrderInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSRecycleOrderDetailInfoRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSRecycleOrderDetailInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderDetailInfo: {
            type: "RecycleOrderDetailInfo",
            id: 3
          }
        }
      },
      TSRecycleEditRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TSRecycleEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSRecycleWannaDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          expressNo: {
            type: "string",
            id: 2
          },
          addressID: {
            type: "uint32",
            id: 3
          }
        }
      },
      TSRecycleWannaDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSRecycleCancelDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSRecycleCancelDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSRecycleAcceptPriceRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          accept: {
            type: "bool",
            id: 2
          }
        }
      },
      TSRecycleAcceptPriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSRecycleQueryExpressRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSRecycleQueryExpressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressItems: {
            rule: "repeated",
            type: "ExpressItem",
            id: 3
          }
        }
      },
      TSRecycleConfirmListRequest: {
        fields: {}
      },
      TSRecycleConfirmListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          confirmList: {
            rule: "repeated",
            type: "ConfirmItem",
            id: 3
          }
        },
        nested: {
          ConfirmItem: {
            fields: {
              seconds: {
                type: "uint32",
                id: 1
              },
              price: {
                type: "uint32",
                id: 2
              },
              orderNo: {
                type: "string",
                id: 3
              },
              image: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSPublicRecycleRegisterRequest: {
        fields: {
          registerType: {
            type: "RecycleRegisterType",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          brandID: {
            type: "int32",
            id: 3
          },
          psychologyPrice: {
            type: "uint32",
            id: 4
          },
          productImage: {
            type: "string",
            id: 5
          },
          contactTime: {
            type: "ContactTime",
            id: 6
          }
        }
      },
      TSPublicRecycleRegisterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSHotListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          hotName: {
            type: "string",
            id: 3
          },
          state: {
            type: "int32",
            id: 4
          },
          isDefault: {
            type: "string",
            id: 5
          },
          type: {
            type: "string",
            id: 6
          }
        }
      },
      TSHotListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          HotList: {
            rule: "repeated",
            type: "HotItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSHotPostRequest: {
        fields: {
          hotName: {
            type: "string",
            id: 1
          },
          sequence: {
            type: "int32",
            id: 2
          },
          startTime: {
            type: "string",
            id: 3
          },
          endTime: {
            type: "string",
            id: 4
          },
          isDefault: {
            type: "string",
            id: 5
          },
          type: {
            type: "string",
            id: 6
          }
        }
      },
      TSHotPostResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSHotPutRequest: {
        fields: {
          hotName: {
            type: "string",
            id: 1
          },
          sequence: {
            type: "int32",
            id: 2
          },
          startTime: {
            type: "string",
            id: 3
          },
          endTime: {
            type: "string",
            id: 4
          },
          isDefault: {
            type: "string",
            id: 5
          },
          hotID: {
            type: "int32",
            id: 6
          },
          type: {
            type: "string",
            id: 7
          }
        }
      },
      TSHotPutResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSHotDeleteRequest: {
        fields: {
          hotID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSHotDeleteResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSHotStopRequest: {
        fields: {
          hotID: {
            type: "int32",
            id: 1
          },
          state: {
            type: "int32",
            id: 2
          }
        }
      },
      TSHotStopResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSHotGetRequest: {
        fields: {}
      },
      TSHotGetResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hotWord: {
            type: "string",
            id: 3
          }
        }
      },
      TSMallSearchRequest: {
        fields: {
          brandStr: {
            type: "string",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          sizeStr: {
            type: "string",
            id: 3
          },
          newsStr: {
            type: "string",
            id: 4
          },
          actualMinPrice: {
            type: "int32",
            id: 5
          },
          actualMaxPrice: {
            type: "int32",
            id: 6
          },
          pageNum: {
            type: "int32",
            id: 7
          },
          pageSize: {
            type: "int32",
            id: 8
          },
          searchQuery: {
            type: "string",
            id: 9
          },
          sort: {
            type: "string",
            id: 10
          },
          colorStr: {
            type: "string",
            id: 11
          },
          skc: {
            type: "string",
            id: 12
          }
        }
      },
      TSMallSearchResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          searchInfo: {
            rule: "repeated",
            type: "SearchItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          },
          total: {
            type: "int32",
            id: 5
          }
        }
      },
      TSMallRecommendProductListRequest: {
        fields: {
          productName: {
            type: "string",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          state: {
            type: "string",
            id: 4
          },
          pageSize: {
            type: "int32",
            id: 5
          },
          pageNum: {
            type: "int32",
            id: 6
          },
          recordId: {
            type: "uint32",
            id: 7
          }
        }
      },
      TSMallRecommendProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productItem: {
            rule: "repeated",
            type: "RecommendProductItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          RecommendProductItem: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              size: {
                type: "string",
                id: 3
              },
              newDegree: {
                type: "string",
                id: 4
              },
              phone: {
                type: "string",
                id: 5
              },
              state: {
                type: "string",
                id: 6
              },
              ranking: {
                type: "int32",
                id: 7
              },
              image: {
                type: "string",
                id: 8
              }
            }
          }
        }
      },
      TSMallRecommendProductItemDetailRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallRecommendProductItemDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productName: {
            type: "string",
            id: 3
          },
          size: {
            type: "string",
            id: 4
          },
          newDegree: {
            type: "string",
            id: 5
          },
          phone: {
            type: "string",
            id: 6
          },
          state: {
            type: "string",
            id: 7
          },
          image: {
            type: "string",
            id: 8
          },
          price: {
            type: "uint32",
            id: 9
          },
          sku: {
            type: "string",
            id: 10
          },
          selfRun: {
            type: "bool",
            id: 11
          },
          actualPrice: {
            type: "int32",
            id: 12
          }
        }
      },
      TSMallRecommendProductRegisterRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          ranking: {
            type: "int32",
            id: 2
          },
          recordId: {
            type: "uint32",
            id: 3
          }
        }
      },
      TSMallRecommendProductRegisterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallRecommendProductModifyOrderRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          ranking: {
            type: "int32",
            id: 2
          }
        }
      },
      TSMallRecommendProductModifyOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallRecommendProductItemDelRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallRecommendProductItemDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallPublishSearchRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          searchQuery: {
            type: "string",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          },
          brandID: {
            type: "int32",
            id: 5
          },
          serviceType: {
            type: "ServiceTypeEnum",
            id: 6
          }
        }
      },
      TSMallPublishSearchResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          searchMallPublishInfo: {
            rule: "repeated",
            type: "SearchMallPublishItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSMallSearchDropDownRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          searchQuery: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallSearchDropDownResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          suggestions: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          requestID: {
            type: "string",
            id: 4
          }
        }
      },
      SkinCheckRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          }
        }
      },
      SkinCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          checkId: {
            type: "string",
            id: 3
          },
          faceNum: {
            type: "int32",
            id: 4
          },
          croppedImage: {
            type: "string",
            id: 5
          },
          showBox: {
            type: "string",
            id: 6
          },
          grade: {
            type: "string",
            id: 7
          },
          detectGlasses: {
            type: "bool",
            id: 8
          }
        }
      },
      GetSkinCheckReportRequest: {
        fields: {
          checkId: {
            type: "string",
            id: 1
          }
        }
      },
      GetSkinCheckReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          },
          points: {
            rule: "repeated",
            type: "Point",
            id: 4
          },
          showBox: {
            type: "string",
            id: 5
          },
          faceNum: {
            type: "int32",
            id: 6
          },
          croppedImage: {
            type: "string",
            id: 7
          },
          grade: {
            type: "string",
            id: 8
          },
          detectGlasses: {
            type: "bool",
            id: 9
          }
        },
        nested: {
          Point: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              grade: {
                type: "string",
                id: 2
              },
              coordinates: {
                type: "Coordinates",
                id: 3
              },
              description: {
                type: "string",
                id: 4
              },
              suggestion: {
                type: "string",
                id: 5
              },
              productName: {
                type: "string",
                id: 6
              },
              productImage: {
                type: "string",
                id: 7
              },
              link: {
                type: "string",
                id: 8
              },
              appId: {
                type: "string",
                id: 9
              },
              linkType: {
                type: "ExternalLinkType",
                id: 10
              },
              key: {
                type: "string",
                id: 11
              },
              icon: {
                type: "string",
                id: 12
              }
            }
          },
          Coordinates: {
            fields: {
              x: {
                type: "int32",
                id: 1
              },
              y: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      },
      GetMySkinCheckRecordsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      GetMySkinCheckRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "SkinCheckRecord",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          SkinCheckRecord: {
            fields: {
              checkId: {
                type: "string",
                id: 1
              },
              imageUrl: {
                type: "string",
                id: 3
              },
              last3Points: {
                rule: "repeated",
                type: "string",
                id: 4
              },
              checkResult: {
                type: "bool",
                id: 5
              },
              createTime: {
                type: "string",
                id: 6
              },
              grade: {
                type: "string",
                id: 7
              },
              detectGlasses: {
                type: "bool",
                id: 8
              }
            }
          }
        }
      },
      DeleteMySkinCheckRecordRequest: {
        fields: {
          checkId: {
            type: "string",
            id: 1
          }
        }
      },
      DeleteMySkinCheckRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      UrgeMonadicListRequest: {
        fields: {}
      },
      UrgeMonadicListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          enable: {
            type: "bool",
            id: 3
          },
          urgeMonadicItemList: {
            rule: "repeated",
            type: "UrgeMonadicItem",
            id: 4
          }
        }
      },
      UrgeMonadicItem: {
        fields: {
          configId: {
            type: "int32",
            id: 1
          },
          level: {
            type: "UrgeMonadicLevel",
            id: 2
          },
          remindersFeedbackText: {
            type: "string",
            id: 3
          }
        }
      },
      UrgeMonadicLevel: {
        values: {
          UrgeMonadicLevelDefault: 1,
          UrgeMonadicLevelThreeToTenMinute: 2,
          UrgeMonadicLevelTenToFourHour: 3,
          UrgeMonadicLevelFourToTwentyFourHour: 4,
          UrgeMonadicLevelTwentyFourHour: 5,
          UrgeMonadicLevelNoNetworkSignal: 6,
          UrgeMonadicLevelMultipleClicks: 7
        }
      },
      KnowFrom: {
        values: {
          Close: 0,
          Xiaohongshu: 1,
          Weixin: 2,
          Baidu: 3,
          Weibo: 4,
          Douyin: 5,
          Zhihu: 6,
          Hupu: 7,
          Friend: 8,
          Other: 9,
          Kuaishou: 10,
          XianiaHuodong: 11,
          Taobao: 12,
          BozhuTuijian: 13,
          Pdd: 14,
          BusinessRecommendation: 15,
          JinDong: 16,
          GongZhongHao: 17,
          TieBa: 18,
          TaoTe: 19,
          Unknow: 99
        }
      },
      TSSetUserFromRequest: {
        fields: {
          knowFrom: {
            type: "KnowFrom",
            id: 1
          }
        }
      },
      TSSetUserFromResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLogInRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          },
          inviteKey: {
            type: "string",
            id: 3
          },
          activityOrigin: {
            type: "string",
            id: 4
          }
        }
      },
      TSLogInResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          isSelected: {
            type: "bool",
            id: 5
          }
        }
      },
      TSCode2SessionRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          }
        }
      },
      TSCode2SessionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          openid: {
            type: "string",
            id: 3
          },
          sessionKey: {
            type: "string",
            id: 4
          },
          unionid: {
            type: "string",
            id: 5
          }
        }
      },
      TSMiniProgramGetUnionIDRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          },
          encryptedData: {
            type: "string",
            id: 2
          },
          iv: {
            type: "string",
            id: 3
          }
        }
      },
      TSMiniProgramGetUnionIDResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          unionid: {
            type: "string",
            id: 3
          }
        }
      },
      TSMiniProgramLogInRequest: {
        fields: {
          unionID: {
            type: "string",
            id: 1
          }
        }
      },
      TSMiniProgramLogInResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          isSelected: {
            type: "bool",
            id: 5
          }
        }
      },
      TSMicroAppLoginRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          },
          encryptedData: {
            type: "string",
            id: 2
          },
          iv: {
            type: "string",
            id: 3
          },
          avatar: {
            type: "string",
            id: 4
          },
          nickname: {
            type: "string",
            id: 5
          }
        }
      },
      TSMicroAppLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          unionId: {
            type: "string",
            id: 5
          }
        }
      },
      TSMiniProgramGetPhoneRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          },
          encryptedData: {
            type: "string",
            id: 2
          },
          iv: {
            type: "string",
            id: 3
          }
        }
      },
      TSMiniProgramGetPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          }
        }
      },
      TSMiniProgramRegisterRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          unionID: {
            type: "string",
            id: 2
          },
          bussinessType: {
            type: "RegisterType",
            id: 3
          },
          inviteKey: {
            type: "string",
            id: 4
          },
          avatar: {
            type: "string",
            id: 5
          },
          nickname: {
            type: "string",
            id: 6
          }
        }
      },
      TSMiniProgramRegisterResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          isSelected: {
            type: "bool",
            id: 5
          }
        }
      },
      TSLogOffRequest: {
        fields: {}
      },
      TTSLogOffResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSLogOutRequest: {
        fields: {}
      },
      TSLogOutResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSTokenRenewRequest: {
        fields: {}
      },
      TSTokenRenewResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          }
        }
      },
      TSSendSmsCodeRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          }
        }
      },
      TSSendSmsCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSThirdPartyLoginRequest: {
        fields: {
          loginType: {
            type: "LoginType",
            id: 1
          },
          bindID: {
            type: "string",
            id: 2
          }
        }
      },
      TSThirdPartyLoginResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          isSelected: {
            type: "bool",
            id: 5
          }
        }
      },
      TSBindPhoneRequest: {
        fields: {
          loginType: {
            type: "LoginType",
            id: 1
          },
          bindID: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          sms: {
            type: "string",
            id: 4
          },
          nickname: {
            type: "string",
            id: 5
          },
          avatar: {
            type: "string",
            id: 6
          }
        }
      },
      TSBindPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          isSelected: {
            type: "bool",
            id: 5
          }
        }
      },
      TSAccountSecurityPageRequest: {
        fields: {}
      },
      TSAccountSecurityPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          wechatBound: {
            type: "bool",
            id: 4
          },
          weiboBound: {
            type: "bool",
            id: 5
          },
          appleBound: {
            type: "bool",
            id: 6
          }
        }
      },
      TSThirdPartyBindRequest: {
        fields: {
          loginType: {
            type: "LoginType",
            id: 1
          },
          bindID: {
            type: "string",
            id: 2
          },
          changeMode: {
            type: "string",
            id: 3
          }
        }
      },
      TSThirdPartyBindResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSVerifyPhoneSMSCodeRequest: {
        fields: {}
      },
      TSVerifyPhoneSMSCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSVerifyEmailCodeRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          }
        }
      },
      TSVerifyEmailCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSVerifyEmailSmsCodeRequest: {
        fields: {
          smsCode: {
            type: "string",
            id: 1
          },
          email: {
            type: "string",
            id: 2
          }
        }
      },
      TSVerifyEmailSmsCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSEmailRegisterRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          smsCode: {
            type: "string",
            id: 2
          },
          passWord: {
            type: "string",
            id: 3
          }
        }
      },
      TSEmailRegisterReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          }
        }
      },
      TSEmailLoginRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          passWord: {
            type: "string",
            id: 2
          }
        }
      },
      TSEmailLoginReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          },
          isNewUser: {
            type: "bool",
            id: 5
          }
        }
      },
      TSEmailSmsCodeRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          smsCode: {
            type: "string",
            id: 2
          }
        }
      },
      TSEmailSmsCodeReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          token: {
            type: "string",
            id: 3
          },
          user: {
            type: "UserInfo",
            id: 4
          }
        }
      },
      TSUserFeedbackCollectAddRequest: {
        fields: {
          feedbackQuestion: {
            type: "int32",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          },
          FeedbackScreenshot: {
            type: "string",
            id: 3
          },
          email: {
            type: "string",
            id: 4
          }
        }
      },
      TSUserFeedbackCollectAddReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSUserFeedbackCollectListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          FeedbackQuestion: {
            type: "FeedbackQuestionTypeEnum",
            id: 3
          },
          FeedbackStartTime: {
            type: "string",
            id: 4
          },
          FeedbackEndTime: {
            type: "string",
            id: 5
          }
        }
      },
      TSUserFeedbackCollectListReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          UserFeedbackCollectList: {
            rule: "repeated",
            type: "UserFeedbackCollectItem",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        }
      },
      TSUserFeedbackRemarkUpdateRequest: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TSUserFeedbackRemarkUpdateReponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSVerifyPhoneRequest: {
        fields: {
          sms: {
            type: "string",
            id: 1
          }
        }
      },
      TSVerifyPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSCheckNewPhoneRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          }
        }
      },
      TSCheckNewPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSBindNewPhoneRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          sms: {
            type: "string",
            id: 2
          },
          countryCode: {
            type: "string",
            id: 3
          }
        }
      },
      TSBindNewPhoneResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSUserInfoSetRequest: {
        fields: {
          avatar: {
            type: "string",
            id: 1
          },
          nickname: {
            type: "string",
            id: 2
          },
          location: {
            type: "string",
            id: 3
          },
          sex: {
            type: "string",
            id: 4
          }
        }
      },
      TSUserInfoSetResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          }
        }
      },
      TSPersonCenterPageRequest: {
        fields: {}
      },
      TSPersonCenterPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          orderIcons: {
            rule: "repeated",
            type: "PersonCenterIcon",
            id: 4
          },
          sellIcons: {
            rule: "repeated",
            type: "PersonCenterIcon",
            id: 5
          },
          toolIcons: {
            rule: "repeated",
            type: "PersonCenterIcon",
            id: 6
          },
          collectedProductCount: {
            type: "uint32",
            id: 7
          },
          likedBrandCount: {
            type: "uint32",
            id: 8
          }
        }
      },
      TSAccountBaseInfoRequest: {
        fields: {}
      },
      TSAccountBaseInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          }
        }
      },
      TSPersonCenterPageV2Request: {
        fields: {}
      },
      TSPersonCenterPageV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          user: {
            type: "User",
            id: 3
          },
          buyOrderList: {
            rule: "repeated",
            type: "BuyOrderItem",
            id: 4
          },
          recycleOrderList: {
            rule: "repeated",
            type: "RecycleOrderItem",
            id: 5
          },
          consignOrderList: {
            rule: "repeated",
            type: "ConsignOrderItem",
            id: 6
          },
          saleOrderList: {
            rule: "repeated",
            type: "SaleOrderItem",
            id: 7
          },
          collectedProductCount: {
            type: "uint32",
            id: 8
          },
          likedBrandCount: {
            type: "uint32",
            id: 9
          }
        },
        nested: {
          BuyOrderItem: {
            fields: {
              state: {
                type: "PersonalBuyState",
                id: 1
              },
              number: {
                type: "int32",
                id: 2
              }
            }
          },
          RecycleOrderItem: {
            fields: {
              state: {
                type: "PersonalRecycleState",
                id: 1
              },
              number: {
                type: "int32",
                id: 2
              }
            }
          },
          ConsignOrderItem: {
            fields: {
              state: {
                type: "PersonalConsignState",
                id: 1
              },
              number: {
                type: "int32",
                id: 2
              }
            }
          },
          SaleOrderItem: {
            fields: {
              state: {
                type: "PersonalSaleState",
                id: 1
              },
              number: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      },
      TSUserAddressListRequest: {
        fields: {}
      },
      TSUserAddressListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          userAddress: {
            rule: "repeated",
            type: "UserAddress",
            id: 3
          }
        }
      },
      TSAddUserAddressRequest: {
        fields: {
          userAddress: {
            type: "UserAddress",
            id: 1
          },
          changeMode: {
            type: "string",
            id: 2
          }
        }
      },
      TSAddUserAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSDeleteUserAddressRequest: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSDeleteUserAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSSetUserDefaultAddressRequest: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSSetUserDefaultAddressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSWalletMainInfoRequest: {
        fields: {}
      },
      TSWalletMainInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          balance: {
            type: "int32",
            id: 3
          },
          alipayAccount: {
            type: "string",
            id: 4
          },
          singleDayWithdrawMax: {
            type: "int32",
            id: 5
          },
          singleDayWithdrawRest: {
            type: "int32",
            id: 6
          },
          isAlipayAccountBound: {
            type: "bool",
            id: 7
          }
        }
      },
      TSWalletBindAlipayAccountRequest: {
        fields: {
          alipayAccount: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      TSWalletBindAlipayAccountResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSWalletWithdrawVerificationCodeRequest: {
        fields: {}
      },
      TSWalletWithdrawVerificationCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          prompt: {
            type: "string",
            id: 3
          }
        }
      },
      TSWalletWithdrawRequest: {
        fields: {
          amount: {
            type: "int32",
            id: 1
          },
          verificationCode: {
            type: "string",
            id: 2
          }
        }
      },
      TSWalletWithdrawResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSWalletRunningCountRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          dateMonth: {
            type: "string",
            id: 3
          },
          flowType: {
            type: "WalletRunningCountTypeEnum",
            id: 4
          }
        }
      },
      TSWalletRunningCountResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          flowList: {
            rule: "repeated",
            type: "RunningCount",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSWebPageOpenidRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          }
        }
      },
      TSWebPageOpenidResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          openid: {
            type: "string",
            id: 3
          }
        }
      },
      TSWxacodeunlimitRequest: {
        fields: {
          scene: {
            type: "string",
            id: 1
          },
          page: {
            type: "string",
            id: 2
          }
        }
      },
      TSWxacodeunlimitResponse: {
        fields: {
          imgData: {
            type: "bytes",
            id: 1
          }
        }
      },
      TSVemobilehdamageRecordRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 3
          },
          reqSource: {
            type: "string",
            id: 5
          }
        }
      },
      TSVehdamageRecordResponse: {
        fields: {
          errCode: {
            type: "int32",
            id: 1
          },
          id: {
            type: "int32",
            id: 2
          },
          errMsg: {
            type: "string",
            id: 3
          }
        }
      },
      TSCommitRecordRequest: {
        fields: {
          url: {
            type: "string",
            id: 1
          },
          id: {
            type: "int32",
            id: 2
          }
        }
      },
      TSCommitRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPsAppraisalPsVerifyCategoryOperateRequest: {
        fields: {
          operateType: {
            type: "int32",
            id: 1
          },
          psVerifyCategory: {
            type: "TSAdminAppraisalPsVerifyCategory",
            id: 2
          }
        }
      },
      TSPsAppraisalPsVerifyCategoryOperateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          psVerifyCategories: {
            rule: "repeated",
            type: "TSAdminAppraisalPsVerifyCategory",
            id: 3
          }
        }
      },
      TSPsAppraisalPSVerifyTypeOperateRequest: {
        fields: {
          operateType: {
            type: "int32",
            id: 1
          },
          psVerifyType: {
            type: "TSAdminAppraisalPsVerifyType",
            id: 2
          }
        }
      },
      TSPsAppraisalPSVerifyTypeOperateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          psVerifyTypes: {
            rule: "repeated",
            type: "TSAdminAppraisalPsVerifyType",
            id: 3
          }
        }
      },
      TSPsAppraisalPSVerifyRequest: {
        fields: {
          verifyParam: {
            type: "TSAdminAppraisalPSVerifyRecord",
            id: 1
          }
        }
      },
      TSPsAppraisalPSVerifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          psVerifyRecord: {
            type: "TSAdminAppraisalPSVerifyRecord",
            id: 3
          }
        }
      },
      TSAdminAppraisalKindListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindList: {
            rule: "repeated",
            type: "AppraisalKindItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminAppraisalBrandListRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminAppraisalBrandListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brandList: {
            rule: "repeated",
            type: "AppraisalBrandItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminAppraisalSeriesListRequest: {
        fields: {
          brandID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminAppraisalSeriesListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          seriesList: {
            rule: "repeated",
            type: "AppraisalSeriesItem",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminPointListRequest: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          important: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          pageNum: {
            type: "int32",
            id: 8
          },
          pageSize: {
            type: "int32",
            id: 9
          },
          pointID: {
            type: "int32",
            id: 10
          },
          must: {
            type: "int32",
            id: 11
          },
          pointType: {
            type: "int32",
            id: 12
          },
          seriousType: {
            type: "int32",
            id: 13
          }
        }
      },
      TSAdminPointListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          pointList: {
            rule: "repeated",
            type: "PointItem",
            id: 4
          }
        }
      },
      TSAdminPointListV2Request: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          important: {
            type: "string",
            id: 6
          },
          status: {
            type: "string",
            id: 7
          },
          pageNum: {
            type: "int32",
            id: 8
          },
          pageSize: {
            type: "int32",
            id: 9
          },
          pointID: {
            type: "int32",
            id: 10
          },
          must: {
            type: "int32",
            id: 11
          },
          pointType: {
            type: "int32",
            id: 12
          },
          seriousType: {
            type: "int32",
            id: 13
          }
        }
      },
      TSAdminPointListV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          pointList: {
            rule: "repeated",
            type: "PointItem",
            id: 4
          }
        }
      },
      TSAdminPointAddRequest: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          pointKey: {
            type: "string",
            id: 6
          },
          singleKey: {
            type: "string",
            id: 7
          },
          description: {
            type: "string",
            id: 8
          },
          sequence: {
            type: "int32",
            id: 9
          },
          important: {
            type: "string",
            id: 10
          },
          stickFigureUrl: {
            type: "string",
            id: 11
          },
          bigStickFigureUrl: {
            type: "string",
            id: 12
          },
          exampleImage: {
            type: "string",
            id: 13
          },
          must: {
            type: "int32",
            id: 14
          },
          pointType: {
            type: "int32",
            id: 15
          },
          applyScene: {
            rule: "repeated",
            type: "int32",
            id: 16
          },
          enName: {
            type: "string",
            id: 17
          },
          enDescription: {
            type: "string",
            id: 18
          },
          seriousType: {
            type: "int32",
            id: 19
          }
        }
      },
      TSAdminPointAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointID: {
            type: "int32",
            id: 3
          }
        }
      },
      TSAdminPointEditRequest: {
        fields: {
          pointName: {
            type: "string",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          pointKey: {
            type: "string",
            id: 6
          },
          singleKey: {
            type: "string",
            id: 7
          },
          description: {
            type: "string",
            id: 8
          },
          sequence: {
            type: "int32",
            id: 9
          },
          important: {
            type: "string",
            id: 10
          },
          stickFigureUrl: {
            type: "string",
            id: 11
          },
          bigStickFigureUrl: {
            type: "string",
            id: 12
          },
          exampleImage: {
            type: "string",
            id: 13
          },
          pointID: {
            type: "int32",
            id: 14
          },
          must: {
            type: "int32",
            id: 15
          },
          pointType: {
            type: "int32",
            id: 16
          },
          applyScene: {
            rule: "repeated",
            type: "int32",
            id: 17
          },
          enName: {
            type: "string",
            id: 18
          },
          enDescription: {
            type: "string",
            id: 19
          },
          seriousType: {
            type: "int32",
            id: 20
          }
        }
      },
      TSAdminPointEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointID: {
            type: "int32",
            id: 3
          }
        }
      },
      TSAdminPointDetailRequest: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminPointDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointID: {
            type: "int32",
            id: 3
          },
          pointName: {
            type: "string",
            id: 4
          },
          hierarchy: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          brandID: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesID: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          },
          sequence: {
            type: "int32",
            id: 12
          },
          important: {
            type: "string",
            id: 13
          },
          status: {
            type: "string",
            id: 14
          },
          pointKey: {
            type: "string",
            id: 15
          },
          singleKey: {
            type: "string",
            id: 16
          },
          stickFigureUrl: {
            type: "string",
            id: 17
          },
          bigStickFigureUrl: {
            type: "string",
            id: 18
          },
          exampleImage: {
            type: "string",
            id: 19
          },
          description: {
            type: "string",
            id: 20
          },
          must: {
            type: "int32",
            id: 21
          },
          pointType: {
            type: "int32",
            id: 22
          },
          applyScene: {
            rule: "repeated",
            type: "int32",
            id: 23
          },
          enName: {
            type: "string",
            id: 24
          },
          enDescription: {
            type: "string",
            id: 25
          },
          seriousType: {
            type: "int32",
            id: 26
          }
        }
      },
      TSAdminPointStatusRequest: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          status: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminPointStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          success: {
            type: "bool",
            id: 3
          }
        }
      },
      TSAdminOverallAppraisalRecordListRequest: {
        fields: {
          startTime: {
            type: "string",
            id: 1
          },
          endTime: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          pageNum: {
            type: "int32",
            id: 7
          },
          pageSize: {
            type: "int32",
            id: 8
          },
          source: {
            type: "string",
            id: 9
          },
          oaid: {
            type: "string",
            id: 10
          },
          aiSource: {
            type: "AIServiceAppraisalSourceEnum",
            id: 11
          },
          reAppraisalResult: {
            type: "int32",
            id: 12
          },
          needCheck: {
            type: "NeedCheckOverallAppraisal",
            id: 13
          },
          manualAppraisalStatus: {
            type: "AIToManualAppraisalStatus",
            id: 14
          },
          manualEvaluateStatus: {
            type: "ManualEvaluateStatus",
            id: 15
          },
          classifyCheckResult: {
            type: "TSClassifyCheckResult",
            id: 16
          },
          minGrade: {
            type: "string",
            id: 17
          },
          maxGrade: {
            type: "string",
            id: 18
          },
          isFinalResult: {
            type: "OverallAppraisalReviewFinalResult",
            id: 19
          },
          skcMatchStatus: {
            type: "SkcMatchStatus",
            id: 20
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 21
          },
          appraisalSource: {
            type: "int32",
            id: 22
          }
        }
      },
      TSAdminOverallAppraisalRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          OARecordList: {
            rule: "repeated",
            type: "OverallAppraisalRecordItem",
            id: 4
          },
          kindList: {
            rule: "repeated",
            type: "AppraisalKindItem",
            id: 5
          },
          brandList: {
            rule: "repeated",
            type: "AppraisalBrandItem",
            id: 6
          },
          seriesList: {
            rule: "repeated",
            type: "AppraisalSeriesItem",
            id: 7
          }
        }
      },
      TSAdminOverallAppraisalAI2ManualRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          manualAppraisalResult: {
            type: "AIToManualAppraisalResult",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalAI2ManualResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalAI2ManualOPRecordRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminOverallAppraisalAI2ManualOPRecordResponse: {
        fields: {
          recordList: {
            rule: "repeated",
            type: "OpRecord",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          }
        },
        nested: {
          OpRecord: {
            fields: {
              opTime: {
                type: "string",
                id: 1
              },
              opUser: {
                type: "string",
                id: 2
              },
              event: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      Ai2ManualConf: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          source: {
            type: "AIServiceAppraisalSourceEnum",
            id: 2
          },
          hierarchy: {
            type: "string",
            id: 3
          },
          kindID: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesID: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          disablePeriod: {
            type: "string",
            id: 10
          },
          createTime: {
            type: "string",
            id: 11
          },
          status: {
            type: "bool",
            id: 12
          },
          seriousType: {
            type: "int32",
            id: 13
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          source: {
            type: "AIServiceAppraisalSourceEnum",
            id: 3
          },
          hierarchy: {
            type: "string",
            id: 4
          },
          kindID: {
            type: "int32",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          seriesID: {
            type: "int32",
            id: 7
          },
          status: {
            type: "int32",
            id: 8
          },
          seriousType: {
            type: "int32",
            id: 9
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          ai2ManualConfs: {
            rule: "repeated",
            type: "Ai2ManualConf",
            id: 4
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfAddRequest: {
        fields: {
          source: {
            type: "AIServiceAppraisalSourceEnum",
            id: 1
          },
          hierarchy: {
            type: "string",
            id: 2
          },
          kindID: {
            rule: "repeated",
            type: "int32",
            id: 3
          },
          brandID: {
            rule: "repeated",
            type: "int32",
            id: 4
          },
          seriesID: {
            rule: "repeated",
            type: "int32",
            id: 5
          },
          disableBegin: {
            type: "string",
            id: 6
          },
          disableEnd: {
            type: "string",
            id: 7
          },
          seriousType: {
            type: "int32",
            id: 8
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfEditRequest: {
        fields: {
          cid: {
            type: "int32",
            id: 1
          },
          disableBegin: {
            type: "string",
            id: 2
          },
          disableEnd: {
            type: "string",
            id: 3
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfOptRequest: {
        fields: {
          cid: {
            type: "int32",
            id: 1
          },
          opt: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisal2ManualConfOptResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalCheckRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          reAppraisalResult: {
            type: "uint32",
            id: 2
          },
          classifyCheckResult: {
            type: "TSClassifyCheckResult",
            id: 3
          },
          suggestion: {
            type: "string",
            id: 4
          }
        }
      },
      TSAdminOverallAppraisalCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalUpdateNoteRequest: {
        fields: {
          oaid: {
            type: "string",
            id: 1
          },
          note: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalUpdateNoteResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalRecordDetailRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminOverallAppraisalRecordDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ID: {
            type: "int32",
            id: 3
          },
          OAID: {
            type: "string",
            id: 4
          },
          genuine: {
            type: "string",
            id: 5
          },
          hierarchy: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          },
          kindName: {
            type: "string",
            id: 8
          },
          brandID: {
            type: "int32",
            id: 9
          },
          brandName: {
            type: "string",
            id: 10
          },
          seriesID: {
            type: "int32",
            id: 11
          },
          seriesName: {
            type: "string",
            id: 12
          },
          appraisalTime: {
            type: "string",
            id: 13
          },
          description: {
            type: "string",
            id: 14
          },
          grade: {
            type: "string",
            id: 15
          },
          SARecordList: {
            rule: "repeated",
            type: "SingleAppraisalRecordItem",
            id: 16
          },
          NSARecordList: {
            rule: "repeated",
            type: "SingleAppraisalRecordItem",
            id: 17
          },
          reAppraisalResult: {
            type: "int32",
            id: 18
          },
          aiToManualAppraisalStatus: {
            type: "AIToManualAppraisalStatus",
            id: 19
          },
          price: {
            type: "int32",
            id: 20
          },
          classifyCheckResult: {
            type: "TSClassifyCheckResult",
            id: 21
          },
          reAppraisalRecords: {
            rule: "repeated",
            type: "ReAppraisalRecordItem",
            id: 22
          },
          suggestion: {
            type: "string",
            id: 23
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 24
          },
          complementImagePoints: {
            rule: "repeated",
            type: "ComplementImagePoint",
            id: 25
          }
        },
        nested: {
          SingleAppraisalRecordItem: {
            fields: {
              SAID: {
                type: "string",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              },
              pointName: {
                type: "string",
                id: 3
              },
              grade: {
                type: "string",
                id: 4
              }
            }
          },
          ReAppraisalRecordItem: {
            fields: {
              appraiserName: {
                type: "string",
                id: 1
              },
              createTime: {
                type: "string",
                id: 2
              },
              reAppraisalResult: {
                type: "int32",
                id: 3
              },
              suggestion: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSAdminOverallAppraisalReAppraisalRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          },
          reAppraisalResult: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAdminOverallAppraisalReAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      SingleAppraisalRecordItem: {
        fields: {
          OAID: {
            type: "string",
            id: 1
          },
          kindID: {
            type: "int32",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          seriesID: {
            type: "int32",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          pointName: {
            type: "string",
            id: 8
          },
          imageUrl: {
            type: "string",
            id: 9
          },
          grade: {
            type: "string",
            id: 10
          },
          genuine: {
            type: "string",
            id: 11
          },
          appraisalTime: {
            type: "string",
            id: 12
          },
          source: {
            type: "string",
            id: 13
          },
          aiSource: {
            type: "AIServiceAppraisalSourceEnum",
            id: 14
          },
          pointType: {
            type: "int32",
            id: 15
          },
          refuse: {
            type: "bool",
            id: 16
          },
          refuseGrade: {
            type: "string",
            id: 17
          },
          definition: {
            type: "int32",
            id: 18
          },
          said: {
            type: "string",
            id: 19
          },
          appraisalSourceName: {
            type: "string",
            id: 20
          }
        }
      },
      TSAdminSingleAppraisalRecordListRequest: {
        fields: {
          startTime: {
            type: "string",
            id: 1
          },
          endTime: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          pageNum: {
            type: "int32",
            id: 7
          },
          pageSize: {
            type: "int32",
            id: 8
          },
          source: {
            type: "string",
            id: 9
          },
          oaid: {
            type: "string",
            id: 10
          },
          aiSource: {
            type: "AIServiceAppraisalSourceEnum",
            id: 11
          },
          pointType: {
            type: "int32",
            id: 12
          },
          isRefuse: {
            type: "int32",
            id: 13
          },
          definition: {
            type: "int32",
            id: 14
          },
          appraisalSource: {
            type: "int32",
            id: 15
          }
        }
      },
      TSAdminSingleAppraisalRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          SARecordList: {
            rule: "repeated",
            type: "SingleAppraisalRecordItem",
            id: 4
          },
          kindList: {
            rule: "repeated",
            type: "AppraisalKindItem",
            id: 5
          },
          brandList: {
            rule: "repeated",
            type: "AppraisalBrandItem",
            id: 6
          },
          seriesList: {
            rule: "repeated",
            type: "AppraisalSeriesItem",
            id: 7
          }
        }
      },
      TSAdminSingleAppraisalRecordDefinitionRequest: {
        fields: {
          said: {
            type: "string",
            id: 1
          },
          definition: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAdminSingleAppraisalRecordDefinitionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      SingleAppraisalRecordDefinitionOperations: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          event: {
            type: "string",
            id: 2
          },
          said: {
            type: "string",
            id: 3
          },
          createTime: {
            type: "string",
            id: 4
          },
          account: {
            type: "string",
            id: 5
          }
        }
      },
      TSAdminSingleAppraisalRecordDefinitionOperationsRequest: {
        fields: {
          said: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminSingleAppraisalRecordDefinitionOperationsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          operations: {
            rule: "repeated",
            type: "SingleAppraisalRecordDefinitionOperations",
            id: 3
          }
        }
      },
      TSAdminTicketActivityStatusRequest: {
        fields: {
          appSource: {
            type: "Source",
            id: 1
          }
        }
      },
      TSAdminTicketActivityStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalActivityList: {
            rule: "repeated",
            type: "AppraisalActivityItem",
            id: 3
          }
        }
      },
      TSAdminTicketActivityStatusEditRequest: {
        fields: {
          jumpURL: {
            type: "string",
            id: 2
          },
          imageURL: {
            type: "string",
            id: 3
          },
          status: {
            type: "string",
            id: 4
          },
          activityID: {
            type: "int32",
            id: 5
          },
          description: {
            type: "string",
            id: 6
          },
          appSource: {
            type: "Source",
            id: 7
          }
        },
        reserved: [
          [
            1,
            1
          ]
        ]
      },
      TSAdminTicketActivityStatusEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalPriceListRequest: {
        fields: {
          appSource: {
            type: "Source",
            id: 1
          }
        }
      },
      TSAdminAppraisalPriceListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalPriceList: {
            rule: "repeated",
            type: "AppraisalPriceItem",
            id: 3
          }
        }
      },
      TSAdminAppraisalPriceEditRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          price: {
            type: "int32",
            id: 2
          },
          buttonText: {
            type: "string",
            id: 3
          },
          appSource: {
            type: "Source",
            id: 4
          }
        }
      },
      TSAdminAppraisalPriceEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminCCICAppraisalPriceListRequest: {
        fields: {}
      },
      TSAdminCCICAppraisalPriceListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalPriceList: {
            rule: "repeated",
            type: "AppraisalPriceItem",
            id: 3
          }
        }
      },
      TSAdminCCICAppraisalPriceEditRequest: {
        fields: {
          kindID: {
            type: "int32",
            id: 1
          },
          price: {
            type: "int32",
            id: 2
          },
          buttonText: {
            type: "string",
            id: 3
          }
        }
      },
      TSAdminCCICAppraisalPriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSDailyFreeApprailListRequest: {
        fields: {}
      },
      TSDailyFreeApprailListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          configs: {
            rule: "repeated",
            type: "TSDailyFreeConfig",
            id: 3
          }
        }
      },
      TSDailyFreeApprailEditRequest: {
        fields: {
          config: {
            type: "TSDailyFreeConfig",
            id: 1
          }
        }
      },
      TSDailyFreeApprailEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSDailyFreeApprailStatusChangeRequest: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          enable: {
            type: "bool",
            id: 2
          },
          source: {
            type: "Source",
            id: 3
          }
        }
      },
      TSDailyFreeApprailStatusChangeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          OAID: {
            type: "string",
            id: 3
          },
          userAccount: {
            type: "string",
            id: 4
          },
          kindID: {
            type: "int32",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          seriesID: {
            type: "int32",
            id: 7
          },
          result: {
            type: "string",
            id: 8
          },
          startTime: {
            type: "string",
            id: 9
          },
          endTime: {
            type: "string",
            id: 10
          },
          source: {
            type: "string",
            id: 11
          },
          registerStartTime: {
            type: "string",
            id: 12
          },
          registerEndTime: {
            type: "string",
            id: 13
          },
          appraisalSource: {
            type: "Source",
            id: 14
          },
          appSource: {
            type: "AppSource",
            id: 15
          },
          CardNo: {
            type: "string",
            id: 16
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 17
          },
          hasFeedBack: {
            type: "int32",
            id: 18
          },
          rating: {
            type: "int32",
            id: 19
          },
          commentary: {
            type: "string",
            id: 20
          },
          payWay: {
            type: "TSAppraisalPayWay",
            id: 21
          },
          orderNo: {
            type: "string",
            id: 22
          },
          manualAppraisalStatus: {
            type: "AIToManualAppraisalStatus",
            id: 23
          },
          serviceSatisfaction: {
            type: "TSServiceSatisfaction",
            id: 24
          },
          feedBackStartTime: {
            type: "string",
            id: 25
          },
          feedBackEndTime: {
            type: "string",
            id: 26
          },
          payState: {
            type: "string",
            id: 27
          },
          countryCode: {
            type: "string",
            id: 28
          },
          isArtificialFakeDisplay: {
            type: "ArtificialFakeDisplayEnum",
            id: 29
          },
          email: {
            type: "string",
            id: 30
          },
          chooseToManual: {
            type: "UserChooseToManualStatus",
            id: 31
          }
        }
      },
      TSAdminAppraisalOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          appraisalOrderList: {
            rule: "repeated",
            type: "AppraisalOrderItem",
            id: 4
          }
        }
      },
      TSAdminTagAppraisalOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          appSource: {
            type: "AppSource",
            id: 3
          },
          oaid: {
            type: "string",
            id: 4
          },
          phone: {
            type: "string",
            id: 5
          },
          kindID: {
            type: "int32",
            id: 6
          },
          brandID: {
            type: "int32",
            id: 7
          },
          seriesID: {
            type: "int32",
            id: 8
          },
          genuine: {
            type: "string",
            id: 9
          },
          serialNum: {
            type: "string",
            id: 10
          },
          appraisalStartTime: {
            type: "string",
            id: 11
          },
          appraisalEndTime: {
            type: "string",
            id: 12
          },
          registerStartTime: {
            type: "string",
            id: 13
          },
          registerEndTime: {
            type: "string",
            id: 14
          },
          tagType: {
            type: "TSTagType",
            id: 15
          },
          payWay: {
            type: "TSAppraisalPayWay",
            id: 16
          },
          manualCheckStatus: {
            type: "AIToManualAppraisalStatus",
            id: 17
          },
          bindPlatform: {
            type: "string",
            id: 18
          },
          manualResult: {
            type: "int32",
            id: 19
          }
        }
      },
      TSAdminTagAppraisalOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          tagAppraisalOrders: {
            rule: "repeated",
            type: "TagAppraisalOrder",
            id: 4
          }
        }
      },
      TSAdminCICCAppraisalOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          startTime: {
            type: "string",
            id: 3
          },
          endTime: {
            type: "string",
            id: 4
          }
        }
      },
      TSAdminCICCAppraisalOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          appraisalOrderList: {
            rule: "repeated",
            type: "AppraisalOrderItem",
            id: 4
          }
        }
      },
      TSAdminAppraisalOrderRemarkRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalOrderRemarkResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalOrderDetailRequest: {
        fields: {
          orderID: {
            type: "int32",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderID: {
            type: "int32",
            id: 3
          },
          appraisalTime: {
            type: "string",
            id: 4
          },
          orderNo: {
            type: "string",
            id: 5
          },
          OAID: {
            type: "string",
            id: 6
          },
          userAccount: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          exteriorImg: {
            type: "string",
            id: 14
          },
          totalAmount: {
            type: "int32",
            id: 15
          },
          payWay: {
            type: "string",
            id: 16
          },
          payState: {
            type: "string",
            id: 17
          },
          result: {
            type: "string",
            id: 18
          },
          feedback: {
            type: "string",
            id: 19
          },
          SARecordList: {
            rule: "repeated",
            type: "AdminSingleAppraisalRecordItem",
            id: 20
          },
          crouponNo: {
            type: "string",
            id: 21
          },
          description: {
            type: "string",
            id: 22
          },
          grade: {
            type: "string",
            id: 23
          },
          aiJadeItem: {
            type: "AIJadeAppraisalItem",
            id: 24
          },
          manualAppraisalStatus: {
            type: "AIToManualAppraisalStatus",
            id: 25
          },
          postStatus: {
            type: "int32",
            id: 26
          },
          expressDeliveryNo: {
            type: "string",
            id: 27
          },
          screenCapUrl: {
            type: "string",
            id: 28
          },
          isArtificialFakeDisplay: {
            type: "ArtificialFakeDisplayEnum",
            id: 29
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 30
          },
          complementImagePoints: {
            rule: "repeated",
            type: "ComplementImagePoint",
            id: 31
          },
          chooseToManual: {
            type: "UserChooseToManualStatus",
            id: 32
          },
          appSource: {
            type: "AppSource",
            id: 33
          },
          items: {
            rule: "repeated",
            type: "AdminAppraisalAttributeDetail",
            id: 34
          }
        }
      },
      TSAdminTagAppraisalOrderDetailRequest: {
        fields: {
          orderID: {
            type: "int32",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminTagAppraisalOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderID: {
            type: "int32",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          oaid: {
            type: "string",
            id: 5
          },
          phone: {
            type: "string",
            id: 6
          },
          kindID: {
            type: "int32",
            id: 7
          },
          kindName: {
            type: "string",
            id: 8
          },
          brandID: {
            type: "int32",
            id: 9
          },
          brandName: {
            type: "string",
            id: 10
          },
          seriesID: {
            type: "int32",
            id: 11
          },
          seriesName: {
            type: "string",
            id: 12
          },
          payWay: {
            type: "string",
            id: 13
          },
          payState: {
            type: "string",
            id: 14
          },
          totalAmount: {
            type: "int32",
            id: 15
          },
          appraisalTime: {
            type: "string",
            id: 16
          },
          genuine: {
            type: "string",
            id: 17
          },
          serialNum: {
            type: "string",
            id: 18
          },
          bindPlatform: {
            type: "string",
            id: 19
          },
          feedback: {
            type: "string",
            id: 20
          },
          tagType: {
            type: "TSTagType",
            id: 21
          },
          grade: {
            type: "string",
            id: 22
          },
          manualResult: {
            type: "int32",
            id: 23
          },
          SARecordList: {
            rule: "repeated",
            type: "AdminSingleAppraisalRecordItem",
            id: 24
          },
          complementImagePoints: {
            rule: "repeated",
            type: "ComplementImagePoint",
            id: 25
          }
        }
      },
      TSAdminAppraisalCouponOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          phoneNum: {
            type: "string",
            id: 4
          },
          status: {
            type: "string",
            id: 5
          }
        }
      },
      TSAdminAppraisalCouponOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          appraisalCouponOrderList: {
            rule: "repeated",
            type: "AppraisalCouponOrderItem",
            id: 4
          }
        }
      },
      TSAdminAppraisalWhiteListListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          phoneNum: {
            type: "string",
            id: 3
          },
          status: {
            type: "string",
            id: 4
          },
          whiteListType: {
            type: "int32",
            id: 5
          }
        }
      },
      TSAdminAppraisalWhiteListListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          appraisalWhiteListList: {
            rule: "repeated",
            type: "AppraisalWhiteListItem",
            id: 4
          }
        },
        nested: {
          AppraisalWhiteListItem: {
            fields: {
              whiteListID: {
                type: "int32",
                id: 1
              },
              phoneNum: {
                type: "string",
                id: 2
              },
              nickName: {
                type: "string",
                id: 3
              },
              appraisalCount: {
                type: "string",
                id: 4
              },
              status: {
                type: "string",
                id: 5
              },
              validTerm: {
                type: "string",
                id: 6
              },
              whiteListType: {
                type: "int32",
                id: 7
              }
            }
          }
        }
      },
      TSAdminAppraisalWhiteListAddRequest: {
        fields: {
          phoneNum: {
            type: "string",
            id: 1
          },
          startTime: {
            type: "string",
            id: 2
          },
          endTime: {
            type: "string",
            id: 3
          },
          whiteListType: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminAppraisalWhiteListAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalWhiteListStatusEditRequest: {
        fields: {
          whiteListID: {
            type: "int32",
            id: 1
          },
          onStatus: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalWhiteListStatusEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalWhiteListDeleteRequest: {
        fields: {
          whiteListID: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminAppraisalWhiteListDeleteResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalCouponRequest: {
        fields: {
          phoneNum: {
            type: "string",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pageSize: {
            type: "int32",
            id: 3
          }
        }
      },
      TSAdminAppraisalCouponResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          uid: {
            type: "int32",
            id: 3
          },
          phoneNum: {
            type: "string",
            id: 4
          },
          nickname: {
            type: "string",
            id: 5
          },
          currentCount: {
            type: "int32",
            id: 6
          },
          appraisalCouponList: {
            rule: "repeated",
            type: "AppraisalCouponItem",
            id: 7
          },
          totalCount: {
            type: "int32",
            id: 8
          }
        },
        nested: {
          AppraisalCouponItem: {
            fields: {
              itemID: {
                type: "int32",
                id: 1
              },
              createTime: {
                type: "string",
                id: 2
              },
              operateType: {
                type: "string",
                id: 3
              },
              couponNo: {
                type: "string",
                id: 4
              },
              validTerm: {
                type: "string",
                id: 5
              },
              changeCount: {
                type: "string",
                id: 6
              },
              state: {
                type: "string",
                id: 7
              },
              orderID: {
                type: "int32",
                id: 8
              }
            }
          }
        }
      },
      TSAdminAppraisalCouponDetailRequest: {
        fields: {
          couponId: {
            type: "uint32",
            id: 1
          }
        }
      },
      TSAdminAppraisalCouponDetailResponse: {
        fields: {
          errorCode: {
            type: "uint32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          couponNo: {
            type: "string",
            id: 3
          },
          validTerm: {
            type: "string",
            id: 4
          },
          phoneNum: {
            type: "string",
            id: 5
          },
          nickname: {
            type: "string",
            id: 6
          },
          operateType: {
            type: "string",
            id: 7
          },
          state: {
            type: "string",
            id: 8
          },
          eventList: {
            rule: "repeated",
            type: "CouponEvent",
            id: 9
          }
        },
        nested: {
          CouponEvent: {
            fields: {
              eventName: {
                type: "string",
                id: 1
              },
              eventTime: {
                type: "string",
                id: 2
              },
              orderId: {
                type: "int32",
                id: 3
              }
            }
          }
        }
      },
      TSCCICAppraisalButtonClickRequest: {
        fields: {}
      },
      TSCCICAppraisalButtonClickResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminTagItem: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          },
          isUsed: {
            type: "bool",
            id: 2
          },
          firstBindTime: {
            type: "string",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          serialNum: {
            type: "string",
            id: 5
          },
          bindUrl: {
            type: "string",
            id: 6
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 7
          },
          isBind: {
            type: "bool",
            id: 8
          },
          oaid: {
            type: "string",
            id: 9
          }
        }
      },
      TSAdminTagListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          startTime: {
            type: "string",
            id: 4
          },
          endTime: {
            type: "string",
            id: 5
          },
          serialNum: {
            type: "string",
            id: 6
          },
          state: {
            type: "TSAdminTagUseState",
            id: 7
          }
        }
      },
      TSAdminTagListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          tagList: {
            rule: "repeated",
            type: "TSAdminTagItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        }
      },
      TSAdminTagDetailRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminTagDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          serialNum: {
            type: "string",
            id: 3
          },
          queryCount: {
            type: "int32",
            id: 4
          },
          bindUrl: {
            type: "string",
            id: 5
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          oaid: {
            type: "string",
            id: 7
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 8
          }
        }
      },
      TSAdminTagCreateRequest: {
        fields: {
          createCount: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminTagCreateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalPointListRequest: {
        fields: {
          categoryEnum: {
            type: "CategoryEnum",
            id: 1
          },
          categoryID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAdminAppraisalPointListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointInfos: {
            rule: "repeated",
            type: "AIServicePointInfo",
            id: 3
          }
        }
      },
      TSAdminSingleAppraisalRequest: {
        fields: {
          pointID: {
            type: "int32",
            id: 1
          },
          imgUrl: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminSingleAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          said: {
            type: "string",
            id: 3
          }
        }
      },
      TSAdminTaggedOrderItem: {
        fields: {
          orderId: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          phoneNum: {
            type: "string",
            id: 3
          },
          appraisalTime: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          mainPicUrl: {
            type: "string",
            id: 8
          },
          result: {
            type: "TSAdminTaggedOrderResult",
            id: 9
          },
          operator: {
            type: "string",
            id: 10
          },
          isBind: {
            type: "bool",
            id: 11
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 12
          },
          bindTime: {
            type: "string",
            id: 13
          },
          serialNum: {
            type: "string",
            id: 14
          },
          appraisalId: {
            type: "string",
            id: 15
          }
        }
      },
      TaggedOrderImage: {
        fields: {
          imgUrl: {
            type: "string",
            id: 1
          },
          pointID: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAIServiceAppraisalReportRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          }
        }
      },
      TSAIServiceAppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exteriorUrl: {
            type: "string",
            id: 3
          },
          orderNo: {
            type: "string",
            id: 4
          },
          OAID: {
            type: "string",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          hierarchy: {
            type: "string",
            id: 7
          },
          kindID: {
            type: "int32",
            id: 8
          },
          kindName: {
            type: "string",
            id: 9
          },
          brandID: {
            type: "int32",
            id: 10
          },
          brandName: {
            type: "string",
            id: 11
          },
          seriesID: {
            type: "int32",
            id: 12
          },
          seriesName: {
            type: "string",
            id: 13
          },
          appraisalTime: {
            type: "string",
            id: 14
          },
          description: {
            type: "string",
            id: 15
          },
          grade: {
            type: "string",
            id: 16
          },
          SARecordList: {
            rule: "repeated",
            type: "AIServiceAppraisalReportSAItem",
            id: 17
          },
          originalBox: {
            type: "AIServiceAppraisalBox",
            id: 18
          },
          detectionBox: {
            type: "AIServiceAppraisalBox",
            id: 19
          },
          rating: {
            type: "int32",
            id: 20
          }
        }
      },
      TSAITaggedOrderBindRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          },
          OAID: {
            type: "string",
            id: 2
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 3
          },
          adminName: {
            type: "string",
            id: 4
          }
        }
      },
      TSAITaggedOrderBindResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAITaggedOrderUndoRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          },
          adminName: {
            type: "string",
            id: 2
          }
        }
      },
      TSAITaggedOrderUndoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAITagCreateRequest: {
        fields: {
          createCount: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAITagCreateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAITagListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          startTime: {
            type: "string",
            id: 4
          },
          endTime: {
            type: "string",
            id: 5
          },
          serialNum: {
            type: "string",
            id: 6
          },
          state: {
            type: "TSAdminTagUseState",
            id: 7
          }
        }
      },
      TSAITagListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          tagList: {
            rule: "repeated",
            type: "TSAdminTagItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        }
      },
      TSAITagDetailRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          }
        }
      },
      TSAITagDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          serialNum: {
            type: "string",
            id: 3
          },
          queryCount: {
            type: "int32",
            id: 4
          },
          bindUrl: {
            type: "string",
            id: 5
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          oaid: {
            type: "string",
            id: 7
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 8
          }
        }
      },
      TSAdminTaggedOrderListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          source: {
            type: "TSAdminTaggedOrderSource",
            id: 3
          },
          seriesID: {
            type: "int32",
            id: 4
          },
          kindID: {
            type: "int32",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          bindState: {
            type: "TSAdminTaggedOrderBindState",
            id: 7
          },
          operator: {
            type: "string",
            id: 8
          },
          result: {
            type: "TSAdminTaggedOrderResult",
            id: 9
          },
          appraisalId: {
            type: "string",
            id: 10
          },
          phoneNum: {
            type: "string",
            id: 11
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 12
          },
          startTime: {
            type: "string",
            id: 13
          },
          endTime: {
            type: "string",
            id: 14
          },
          oaid: {
            type: "string",
            id: 15
          }
        }
      },
      TSAdminTaggedOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderList: {
            rule: "repeated",
            type: "TSAdminTaggedOrderItem",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        }
      },
      TSAdminTaggedOrderSaveRequest: {
        fields: {
          phoneNum: {
            type: "string",
            id: 1
          },
          isPass: {
            type: "bool",
            id: 2,
            options: {
              deprecated: true
            }
          },
          source: {
            type: "TSAdminTaggedOrderSource",
            id: 3
          },
          seriesID: {
            type: "int32",
            id: 4
          },
          kindID: {
            type: "int32",
            id: 5
          },
          brandID: {
            type: "int32",
            id: 6
          },
          saidList: {
            rule: "repeated",
            type: "string",
            id: 7
          },
          orderId: {
            type: "string",
            id: 8
          },
          exteriorUrl: {
            type: "string",
            id: 9
          },
          appraisalType: {
            type: "OnlineAppraisalType",
            id: 10
          },
          serialNum: {
            type: "string",
            id: 11
          },
          actionType: {
            type: "string",
            id: 12
          }
        }
      },
      TSAdminTaggedOrderSaveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          result: {
            type: "TSAdminTaggedOrderResult",
            id: 3
          }
        }
      },
      TSAdminTaggedOrderDetailRequest: {
        fields: {
          orderId: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminTaggedOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          taggedOrder: {
            type: "TSAdminTaggedOrderItem",
            id: 3
          },
          queryCount: {
            type: "int32",
            id: 4
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 5
          }
        }
      },
      TSAdminTaggedOrderBindRequest: {
        fields: {
          orderId: {
            type: "string",
            id: 1
          },
          serialNum: {
            type: "string",
            id: 2
          },
          adminName: {
            type: "string",
            id: 3
          }
        }
      },
      TSAdminTaggedOrderBindResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminTaggedOrderUndoRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          },
          adminName: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminTaggedOrderUndoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminNewcomerGiftChangeRequest: {
        fields: {
          isOn: {
            type: "bool",
            id: 1
          }
        }
      },
      TSAdminNewcomerGiftChangeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminAppraisalPsVerifyCategory: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          iconUrl: {
            type: "string",
            id: 3
          },
          order: {
            type: "int32",
            id: 4
          },
          verifyCode: {
            type: "string",
            id: 5
          },
          status: {
            type: "int32",
            id: 6
          },
          createTime: {
            type: "string",
            id: 7
          },
          updateTime: {
            type: "string",
            id: 8
          },
          createUser: {
            type: "int32",
            id: 9
          },
          updateUser: {
            type: "int32",
            id: 10
          }
        }
      },
      TSAdminAppraisalPsVerifyType: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          categoryId: {
            type: "int32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          iconUrl: {
            type: "string",
            id: 4
          },
          order: {
            type: "int32",
            id: 5
          },
          verifyCode: {
            type: "string",
            id: 6
          },
          status: {
            type: "int32",
            id: 7
          },
          createTime: {
            type: "string",
            id: 8
          },
          updateTime: {
            type: "string",
            id: 9
          },
          createUser: {
            type: "int32",
            id: 10
          },
          updateUser: {
            type: "int32",
            id: 11
          }
        }
      },
      TSAdminAppraisalPsVerifyCategoryOperateRequest: {
        fields: {
          operateType: {
            type: "int32",
            id: 1
          },
          psVerifyCategory: {
            type: "TSAdminAppraisalPsVerifyCategory",
            id: 2
          }
        }
      },
      TSAdminAppraisalPsVerifyCategoryOperateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          psVerifyCategories: {
            rule: "repeated",
            type: "TSAdminAppraisalPsVerifyCategory",
            id: 3
          }
        }
      },
      TSAdminAppraisalPSVerifyTypeOperateRequest: {
        fields: {
          operateType: {
            type: "int32",
            id: 1
          },
          psVerifyType: {
            type: "TSAdminAppraisalPsVerifyType",
            id: 2
          }
        }
      },
      TSAdminAppraisalPSVerifyTypeOperateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          psVerifyTypes: {
            rule: "repeated",
            type: "TSAdminAppraisalPsVerifyType",
            id: 3
          }
        }
      },
      TSAdminAppraisalPSVerifyRecord: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          verifyCategory: {
            type: "int32",
            id: 2
          },
          verifyType: {
            type: "int32",
            id: 3
          },
          verifyCode: {
            type: "string",
            id: 4
          },
          verifySource: {
            type: "string",
            id: 5
          },
          userId: {
            type: "int32",
            id: 6
          },
          userPhone: {
            type: "string",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          },
          oriImgUrl: {
            type: "string",
            id: 9
          },
          resultImgUrl: {
            type: "string",
            id: 10
          },
          verifyResult: {
            type: "int32",
            id: 11
          },
          verifyComment: {
            type: "string",
            id: 12
          },
          createTime: {
            type: "string",
            id: 13
          },
          startTime: {
            type: "string",
            id: 14
          },
          endTime: {
            type: "string",
            id: 15
          },
          updateTime: {
            type: "string",
            id: 16
          },
          verifyCategoryName: {
            type: "string",
            id: 17
          },
          verifyTypeName: {
            type: "string",
            id: 18
          },
          suspectAreas: {
            type: "string",
            id: 19
          },
          width: {
            type: "int32",
            id: 20
          },
          height: {
            type: "int32",
            id: 21
          }
        }
      },
      TSAdminAppraisalPSVerifyRecordRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          queryParam: {
            type: "TSAdminAppraisalPSVerifyRecord",
            id: 3
          }
        }
      },
      TSAdminAppraisalPSVerifyRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          psVerifyRecords: {
            rule: "repeated",
            type: "TSAdminAppraisalPSVerifyRecord",
            id: 4
          }
        }
      },
      TSAdminAppraisalPSVerifyRecordEditRequest: {
        fields: {
          psVerifyRecord: {
            type: "TSAdminAppraisalPSVerifyRecord",
            id: 1
          }
        }
      },
      TSAdminAppraisalPSVerifyRecordEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          psVerifyRecord: {
            type: "TSAdminAppraisalPSVerifyRecord",
            id: 3
          }
        }
      },
      TSAdminOAReAppraisalRecordRequest: {
        fields: {
          startTime: {
            type: "string",
            id: 1
          },
          endTime: {
            type: "string",
            id: 2
          },
          kindID: {
            type: "int32",
            id: 3
          },
          brandID: {
            type: "int32",
            id: 4
          },
          seriesID: {
            type: "int32",
            id: 5
          },
          genuine: {
            type: "string",
            id: 6
          },
          pageNum: {
            type: "int32",
            id: 7
          },
          pageSize: {
            type: "int32",
            id: 8
          },
          oaid: {
            type: "string",
            id: 9
          },
          aiSource: {
            type: "AIServiceAppraisalSourceEnum",
            id: 10
          },
          reAppraisalResult: {
            type: "int32",
            id: 11
          },
          appraiserName: {
            type: "string",
            id: 12
          },
          oaReAppraisalResult: {
            type: "int32",
            id: 13
          },
          suggestion: {
            type: "string",
            id: 14
          },
          isConsistent: {
            type: "int32",
            id: 15
          },
          reAppraisalStartTime: {
            type: "string",
            id: 16
          },
          reAppraisalEndTime: {
            type: "string",
            id: 17
          },
          dataSource: {
            type: "int32",
            id: 18
          },
          createStartTime: {
            type: "string",
            id: 19
          },
          createEndTime: {
            type: "string",
            id: 20
          }
        }
      },
      TSAdminOAReAppraisalRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          oaReAppraisalList: {
            rule: "repeated",
            type: "OAReAppraisalList",
            id: 4
          }
        },
        nested: {
          OAReAppraisalList: {
            fields: {
              oaid: {
                type: "string",
                id: 1
              },
              aiSource: {
                type: "AIServiceAppraisalSourceEnum",
                id: 2
              },
              kindName: {
                type: "string",
                id: 3
              },
              brandName: {
                type: "string",
                id: 4
              },
              seriesName: {
                type: "string",
                id: 5
              },
              genuine: {
                type: "string",
                id: 6
              },
              appraisalTime: {
                type: "string",
                id: 7
              },
              reAppraisalResult: {
                type: "int32",
                id: 8
              },
              appraiserName: {
                type: "string",
                id: 9
              },
              oaReAppraisalResult: {
                type: "int32",
                id: 10
              },
              oaSuggestion: {
                type: "string",
                id: 11
              },
              isConsistent: {
                type: "bool",
                id: 12
              },
              reAppraisalTime: {
                type: "string",
                id: 13
              },
              id: {
                type: "int32",
                id: 14
              },
              suggestion: {
                type: "string",
                id: 15
              },
              grade: {
                type: "string",
                id: 16
              },
              appraisalDuration: {
                type: "string",
                id: 17
              },
              recheckH5Url: {
                type: "string",
                id: 18,
                options: {
                  deprecated: true
                }
              },
              dataSource: {
                type: "int32",
                id: 19
              },
              createTime: {
                type: "string",
                id: 20
              }
            }
          }
        }
      },
      TSAdminOAReAppraisalUpdateRequest: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          reAppraisalResult: {
            type: "int32",
            id: 2
          }
        }
      },
      TSAdminOAReAppraisalUpdateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminOAReAppraisalSetRequest: {
        fields: {
          rate: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminOAReAppraisalSetResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          rate: {
            type: "string",
            id: 3
          }
        }
      },
      TSAdminAppraisalProductLogRequest: {
        fields: {
          proId: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminAppraisalProductLogResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          logs: {
            rule: "repeated",
            type: "TSAdminAppraisalProductLog",
            id: 3
          }
        },
        nested: {
          TSAdminAppraisalProductLog: {
            fields: {
              id: {
                type: "int32",
                id: 1
              },
              event: {
                type: "string",
                id: 2
              },
              proId: {
                type: "string",
                id: 3
              },
              createTime: {
                type: "string",
                id: 4
              },
              account: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      LLMsClassifyRecordRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          kindId: {
            type: "int32",
            id: 2
          },
          brandId: {
            type: "int32",
            id: 3
          },
          seriesId: {
            type: "int32",
            id: 4
          },
          pageNum: {
            type: "int32",
            id: 5
          },
          pageSize: {
            type: "int32",
            id: 6
          }
        }
      },
      LLMsClassifyRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "ClassifyRecord",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          ClassifyRecord: {
            fields: {
              phone: {
                type: "string",
                id: 1
              },
              imageUrl: {
                type: "string",
                id: 2
              },
              classifyResult: {
                type: "string",
                id: 3
              },
              kindId: {
                type: "int32",
                id: 4
              },
              kindName: {
                type: "string",
                id: 5
              },
              brandId: {
                type: "int32",
                id: 6
              },
              brandName: {
                type: "string",
                id: 7
              },
              seriesId: {
                type: "int32",
                id: 8
              },
              seriesName: {
                type: "string",
                id: 9
              }
            }
          }
        }
      },
      LLMsClassifyCreateRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          classifyResult: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandId: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesId: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          }
        }
      },
      LLMsClassifyCreateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      }
    }
  },
  example: {
    options: {
      go_package: "github.com/tuRing/awesomeProject/example"
    },
    nested: {
      OperatorManagementOperationRecordListRequest: {
        fields: {
          Id: {
            type: "int32",
            id: 1
          }
        }
      },
      OperatorManagementOperationRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          operatorManagementOperationRecordListResponse: {
            rule: "repeated",
            type: "OperatorManagementOperationRecord",
            id: 3
          }
        }
      },
      OperatorManagementOperationRecord: {
        fields: {
          operator: {
            type: "string",
            id: 1
          },
          event: {
            type: "string",
            id: 2
          },
          operateTime: {
            type: "string",
            id: 3
          }
        }
      },
      OperatorManagementOperationLogs: {
        fields: {
          optNo: {
            type: "int32",
            id: 1
          },
          event: {
            type: "string",
            id: 2
          },
          operator: {
            type: "string",
            id: 3
          }
        }
      }
    }
  }
});

export { $root as default };
